import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AddBankLocationInput = {
  bankName: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  locationName: Scalars['String']['input'];
  routingNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressDto = {
  city?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInputDto = {
  city: Scalars['String']['input'];
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type Application = {
  __typename?: 'Application';
  /** Broker associated with the offer */
  broker?: Maybe<User>;
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currentUserRights: Array<Rights>;
  /** Funder associated with the offer */
  funder?: Maybe<User>;
  /** Funding amount for the offer */
  fundingAmount?: Maybe<Scalars['Float']['output']>;
  /** Unique offer identifier */
  id: Scalars['ID']['output'];
  latestStatusHistory?: Maybe<ApplicationStatusHistory>;
  linkToFiles?: Maybe<Scalars['String']['output']>;
  /** Manager associated with the offer */
  manager?: Maybe<User>;
  merchantBizEmails?: Maybe<Array<Scalars['String']['output']>>;
  merchantBizPhones?: Maybe<Array<Scalars['String']['output']>>;
  /** Merchant Company Website */
  merchantBizWeb?: Maybe<Scalars['String']['output']>;
  /** Merchant Company DBA */
  merchantCompanyDba?: Maybe<Scalars['String']['output']>;
  /** Merchant Company Legal Name */
  merchantCompanyLegalName?: Maybe<Scalars['String']['output']>;
  /** Merchant Tax ID */
  merchantTaxId?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<User>;
  /** Notes for the offer */
  notes?: Maybe<Scalars['String']['output']>;
  /** Unique incremental application number */
  number: Scalars['Float']['output'];
  /** Offer target date */
  offerDate: Scalars['Date']['output'];
  offers?: Maybe<Array<Offer>>;
  owners?: Maybe<Array<UserData>>;
  processor?: Maybe<ApplicationProcessor>;
  status?: Maybe<ApplicationStatus>;
  /** Term in days */
  term?: Maybe<Scalars['Float']['output']>;
  /** Total number of unique offers for this application */
  totalOffers: Scalars['Int']['output'];
  /** Last update date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicationExternalServiceConnection = {
  __typename?: 'ApplicationExternalServiceConnection';
  application: Application;
  applicationId: Scalars['ID']['output'];
  configuration: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  externalServiceConfiguration: ExternalServiceConfiguration;
  externalServiceConfigurationId: Scalars['ID']['output'];
  fetchedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
};

export type ApplicationExternalServiceConnectionDto = {
  __typename?: 'ApplicationExternalServiceConnectionDto';
  applicationId: Scalars['ID']['output'];
  configuration: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  externalServiceConfiguration?: Maybe<ExternalServiceConfiguration>;
  externalServiceConfigurationId: Scalars['ID']['output'];
  fetchedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['Date']['output']>;
};

export type ApplicationExternalServiceDataDto = {
  __typename?: 'ApplicationExternalServiceDataDto';
  connection?: Maybe<ApplicationExternalServiceConnectionDto>;
  connectionId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  data: Scalars['JSON']['output'];
  downloadCount?: Maybe<Scalars['Int']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isCacheValid: Scalars['Boolean']['output'];
  modifiedAt?: Maybe<Scalars['Date']['output']>;
  searchParams: Scalars['JSON']['output'];
  searchParamsHash: Scalars['String']['output'];
  validUntil: Scalars['Date']['output'];
};

export type ApplicationList = {
  __typename?: 'ApplicationList';
  data: Array<Application>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ApplicationProcessor = {
  __typename?: 'ApplicationProcessor';
  /** Unique application processor identifier */
  id: Scalars['ID']['output'];
  /** Application processor logo URL */
  logo?: Maybe<Scalars['String']['output']>;
  /** Application processor name */
  name: Scalars['String']['output'];
  /** Display order */
  order: Scalars['Float']['output'];
};

export type ApplicationStatus = {
  __typename?: 'ApplicationStatus';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  forApplication: Scalars['Boolean']['output'];
  forFundingPipeline: Scalars['Boolean']['output'];
  forOffer: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  orderForFundingPipeline: Scalars['Float']['output'];
};

export type ApplicationStatusHistory = {
  __typename?: 'ApplicationStatusHistory';
  createdAt: Scalars['Date']['output'];
  fromStatus: ApplicationStatus;
  toStatus: ApplicationStatus;
  user?: Maybe<User>;
};

export type ApplicationWithOffer = {
  __typename?: 'ApplicationWithOffer';
  application: Application;
  offer?: Maybe<Offer>;
};

export type ApplicationWithOfferList = {
  __typename?: 'ApplicationWithOfferList';
  data: Array<ApplicationWithOffer>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AuditEvent = {
  __typename?: 'AuditEvent';
  application?: Maybe<Application>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  mca?: Maybe<MerchantCashAdvance>;
  payload?: Maybe<Scalars['JSONObject']['output']>;
  type: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type AuditLogList = {
  __typename?: 'AuditLogList';
  data: Array<AuditEvent>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AvailableDocumentDto = {
  __typename?: 'AvailableDocumentDto';
  documentName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type BankInfo = {
  __typename?: 'BankInfo';
  bankName: Scalars['String']['output'];
  fdic?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<BankLocation>>;
  logo?: Maybe<Scalars['String']['output']>;
  web?: Maybe<Scalars['String']['output']>;
};

export type BankInfoByRoutingNumber = {
  __typename?: 'BankInfoByRoutingNumber';
  bankName: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
};

export type BankList = {
  __typename?: 'BankList';
  data: Array<BankInfo>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BankLocation = {
  __typename?: 'BankLocation';
  bank: BankInfo;
  bankName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  routingNumbers?: Maybe<Array<RoutingNumber>>;
};

export type BrokerDto = {
  dba: Scalars['String']['input'];
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legalName: Scalars['String']['input'];
  logoMediaFile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  www?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  allDay: Scalars['Boolean']['output'];
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  end: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  start: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export type CashTransactionDto = {
  amount: Scalars['Float']['input'];
  assignedToUserId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  type: TransactionType;
};

export type ChangePasswordDto = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type Chart = {
  __typename?: 'Chart';
  date: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type Commission = {
  __typename?: 'Commission';
  amount: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  config?: Maybe<ConfigFee>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** Unique fine identifier */
  id: Scalars['ID']['output'];
  isPaid: Scalars['Boolean']['output'];
  mca?: Maybe<MerchantCashAdvance>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  notes?: Maybe<Scalars['String']['output']>;
  paidOn?: Maybe<Scalars['DateTime']['output']>;
};

export type CommissionDto = {
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['String']['input']>;
  isPaid?: Scalars['Boolean']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  paidOn?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CompaniesList = {
  __typename?: 'CompaniesList';
  data: Array<Company>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  bankAccounts?: Maybe<Array<MerchantBankAccount>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  dba?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique merchant identifier */
  id?: Maybe<Scalars['ID']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkToFiles?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mcas?: Maybe<Array<MerchantCashAdvance>>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<User>;
  phone?: Maybe<Array<Scalars['String']['output']>>;
  taxId?: Maybe<Scalars['String']['output']>;
  totalUsers?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Array<CompanyType>>;
  users?: Maybe<Array<User>>;
  www?: Maybe<Scalars['String']['output']>;
};

export type CompanyDocumentDto = {
  __typename?: 'CompanyDocumentDto';
  createdAt: Scalars['DateTime']['output'];
  documentName: Scalars['String']['output'];
  documentOwner?: Maybe<Scalars['String']['output']>;
  documentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  webViewLink: Scalars['String']['output'];
};

export type CompanyDto = {
  dba: Scalars['String']['input'];
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legalName: Scalars['String']['input'];
  linkToFiles?: InputMaybe<Scalars['String']['input']>;
  logoMediaFile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  type: Array<CompanyType>;
  www?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyOwner = {
  __typename?: 'CompanyOwner';
  company: Company;
  createdBy: User;
  id: Scalars['ID']['output'];
  modifiedBy: User;
  owner: Owner;
};

export enum CompanyType {
  Broker = 'BROKER',
  Legal = 'LEGAL',
  Merchant = 'MERCHANT'
}

export type ConfigFee = {
  __typename?: 'ConfigFee';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  defaultAmount?: Maybe<Scalars['Float']['output']>;
  defaultComment?: Maybe<Scalars['String']['output']>;
  /** Unique fee config identifier */
  id: Scalars['ID']['output'];
  isCommission: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  isPostFunding: Scalars['Boolean']['output'];
  isPreFunding: Scalars['Boolean']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  name: ConfigFeeName;
  rank?: Maybe<Scalars['Float']['output']>;
};

export type ConfigFeeDto = {
  defaultAmount: Scalars['Float']['input'];
  defaultComment: Scalars['String']['input'];
  isCommission?: Scalars['Boolean']['input'];
  isPercentage?: Scalars['Boolean']['input'];
  isPostFunding?: Scalars['Boolean']['input'];
  isPreFunding?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  rank?: Scalars['Float']['input'];
};

export enum ConfigFeeName {
  AccountClosedFee = 'ACCOUNT_CLOSED_FEE',
  AccountFrozenFee = 'ACCOUNT_FROZEN_FEE',
  BrokerFee = 'BROKER_FEE',
  CrmFee = 'CRM_FEE',
  DefaultFee = 'DEFAULT_FEE',
  IsoFee = 'ISO_FEE',
  NsfFee = 'NSF_FEE',
  OriginationFee = 'ORIGINATION_FEE',
  OtherFee = 'OTHER_FEE',
  PayOff = 'PAY_OFF',
  StopPaymentFee = 'STOP_PAYMENT_FEE',
  WireFee = 'WIRE_FEE'
}

export type ConfigFeesList = {
  __typename?: 'ConfigFeesList';
  data: Array<ConfigFee>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ConsumerPiiInputDto = {
  currentAddress: AddressInputDto;
  dob?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationInput = {
  brokerId: Scalars['String']['input'];
  funderId?: InputMaybe<Scalars['String']['input']>;
  fundingAmount?: InputMaybe<Scalars['Float']['input']>;
  linkToFiles?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  merchantBizEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantBizPhones?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantBizWeb?: InputMaybe<Scalars['String']['input']>;
  merchantCompanyDba?: InputMaybe<Scalars['String']['input']>;
  merchantCompanyLegalName?: InputMaybe<Scalars['String']['input']>;
  merchantTaxId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offerDate: Scalars['DateTime']['input'];
  owners?: InputMaybe<Array<UserDataDto>>;
  processorId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOfferInput = {
  applicationId: Scalars['String']['input'];
  brokerId?: InputMaybe<Scalars['String']['input']>;
  commissions?: InputMaybe<Array<OfferFeeCommissionInput>>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  factorRate: Scalars['Float']['input'];
  funderId?: InputMaybe<Scalars['String']['input']>;
  fundingAmount?: InputMaybe<Scalars['Float']['input']>;
  fundingFees?: InputMaybe<Array<OfferFeeCommissionInput>>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  lineOrder?: InputMaybe<Scalars['Float']['input']>;
  linkToFiles?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offerDate?: InputMaybe<Scalars['Date']['input']>;
  rehabGroupId?: InputMaybe<Scalars['String']['input']>;
  rehabLineTitle?: InputMaybe<Scalars['String']['input']>;
  secondaryFunderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  stipulations?: InputMaybe<Array<Scalars['String']['input']>>;
  term?: InputMaybe<Scalars['Float']['input']>;
  type?: OfferType;
};

export type CreateStipulationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type DailyCollectionsChartPoint = {
  __typename?: 'DailyCollectionsChartPoint';
  date: Scalars['DateTime']['output'];
  series: Array<DailyCollectionsChartSeriesItem>;
};

export type DailyCollectionsChartSeriesItem = {
  __typename?: 'DailyCollectionsChartSeriesItem';
  seriesKey: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type ExternalServiceConfiguration = {
  __typename?: 'ExternalServiceConfiguration';
  company?: Maybe<InternalCompany>;
  configurationSchema: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy: User;
  dataSchema: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Unique external service configuration identifier */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  name: Scalars['String']['output'];
  secret: Scalars['JSON']['output'];
  settings: Scalars['JSON']['output'];
  type: ExternalServiceType;
};

export type ExternalServiceDto = {
  __typename?: 'ExternalServiceDto';
  company?: Maybe<InternalCompany>;
  /** Configuration schema for UI forms */
  configurationSchema: Scalars['JSON']['output'];
  /** Data schema for UI ag-grid */
  dataSchema: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  secret: Scalars['JSON']['output'];
  type: ExternalServiceType;
};

export type ExternalServiceInputDto = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  secret: Scalars['JSON']['input'];
  type: ExternalServiceType;
};

export enum ExternalServiceType {
  Clear = 'CLEAR',
  ExperianCreditProfile = 'EXPERIAN_CREDIT_PROFILE',
  SimplicityCollect = 'SIMPLICITY_COLLECT'
}

export type FeeDto = {
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['String']['input']>;
};

export type FineDto = {
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  configId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FineStatus>;
  transactionId: Scalars['String']['input'];
};

export enum FineStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type FunderPortFolioDto = {
  __typename?: 'FunderPortFolioDto';
  attorney?: Maybe<Scalars['Float']['output']>;
  collections?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Float']['output']>;
  funder?: Maybe<Underwriter>;
  inHouseLegal?: Maybe<Scalars['Float']['output']>;
  notPaying?: Maybe<Scalars['Float']['output']>;
  open?: Maybe<Scalars['Float']['output']>;
  poolGrossValue?: Maybe<Scalars['Float']['output']>;
  poolNetValue?: Maybe<Scalars['Float']['output']>;
  profitAndLoss?: Maybe<Scalars['Float']['output']>;
  settled?: Maybe<Scalars['Float']['output']>;
  slow?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalMcaCount?: Maybe<Scalars['Float']['output']>;
  totalPayback?: Maybe<Scalars['Float']['output']>;
  verySlow?: Maybe<Scalars['Float']['output']>;
  writtenOff?: Maybe<Scalars['Float']['output']>;
};

export type FundingFee = {
  __typename?: 'FundingFee';
  amount: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  config?: Maybe<ConfigFee>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** Unique fee identifier */
  id: Scalars['ID']['output'];
  mca?: Maybe<MerchantCashAdvance>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
};

export type FundingPipeLineOffersCount = {
  __typename?: 'FundingPipeLineOffersCount';
  statusCounts: Array<FundingPipelineStatusCount>;
};

export type FundingPipelineStatusCount = {
  __typename?: 'FundingPipelineStatusCount';
  count: Scalars['Int']['output'];
  statusId: Scalars['String']['output'];
};

export enum GridType {
  AllCompaniesListGrid = 'AllCompaniesListGrid',
  ApplicationRehabOffersGrid = 'ApplicationRehabOffersGrid',
  ApplicationsWithStatusesListGrid = 'ApplicationsWithStatusesListGrid',
  AuditListGrid = 'AuditListGrid',
  BankListGrid = 'BankListGrid',
  CompaniesListGrid = 'CompaniesListGrid',
  ConfigFeeListGrid = 'ConfigFeeListGrid',
  ExternalServiceConfigurationsListGrid = 'ExternalServiceConfigurationsListGrid',
  FundingPipelineGrid = 'FundingPipelineGrid',
  IntegerationsListGrid = 'IntegerationsListGrid',
  InvestorsListGrid = 'InvestorsListGrid',
  LedgerBalanceTrasactionsListGrid = 'LedgerBalanceTrasactionsListGrid',
  LenderListGrid = 'LenderListGrid',
  McaGrid = 'McaGrid',
  McaSyndicationsGrid = 'McaSyndicationsGrid',
  McaTransactionsGrid = 'McaTransactionsGrid',
  MerchantListGrid = 'MerchantListGrid',
  MulPortfolioGrid = 'MulPortfolioGrid',
  MyPortfolioGrid = 'MyPortfolioGrid',
  OffersListGrid = 'OffersListGrid',
  TransactionsGrid = 'TransactionsGrid',
  UsersListGrid = 'UsersListGrid'
}

export type ImportedStatsDto = {
  __typename?: 'ImportedStatsDto';
  deleted: Scalars['Float']['output'];
  imported: Scalars['Float']['output'];
  inserted: Scalars['Float']['output'];
  updated: Scalars['Float']['output'];
};

export type ImportedTransactionDto = {
  __typename?: 'ImportedTransactionDto';
  account: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  custom1?: Maybe<Scalars['String']['output']>;
  custom2?: Maybe<Scalars['String']['output']>;
  depositDate: Scalars['DateTime']['output'];
  effectiveDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  originationDate: Scalars['DateTime']['output'];
  recurrenceDescription?: Maybe<Scalars['String']['output']>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  to: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Integration = {
  __typename?: 'Integration';
  autostart: Scalars['Boolean']['output'];
  company?: Maybe<InternalCompany>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  environment: IntegrationEnvironment;
  /** Unique integration identifier */
  id: Scalars['ID']['output'];
  lastRefreshResult?: Maybe<IntegrationHealthMonitor>;
  logo?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  name: Scalars['String']['output'];
  schedule: Scalars['String']['output'];
  secret: IntegrationSecret;
  settings: Settings;
  type: IntegrationType;
};

export type IntegrationDto = {
  autostart: Scalars['Boolean']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<IntegrationEnvironment>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule: Scalars['String']['input'];
  secretAchProc?: InputMaybe<SecretAchProcDto>;
  secretClearAchBot?: InputMaybe<SecretClearAchBotDto>;
  secretGoAch?: InputMaybe<SecretGoAchDto>;
  secretGoAchBot?: InputMaybe<SecretGoAchBotDto>;
  secretLiftoffCard?: InputMaybe<SecretLiftoffCardDto>;
  settings?: InputMaybe<IntegrationSettingsDto>;
  type?: InputMaybe<IntegrationType>;
};

export enum IntegrationEnvironment {
  Prod = 'PROD',
  Stage = 'STAGE'
}

export type IntegrationHealthMonitor = {
  __typename?: 'IntegrationHealthMonitor';
  integrationId: Scalars['ID']['output'];
  lastImportedTransactionsDate: Scalars['String']['output'];
  lastImportedTransactionsStats: ImportedStatsDto;
};

export type IntegrationScheduleDto = {
  __typename?: 'IntegrationScheduleDto';
  id: Scalars['String']['output'];
  nextDate?: Maybe<Scalars['DateTime']['output']>;
  running?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationSecret = SecretAchProc | SecretClearAchBot | SecretDevNull | SecretGoAch | SecretGoAchBot | SecretLiftoffCard;

export type IntegrationSettingsDto = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  enableRefresh?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromChart?: InputMaybe<Scalars['Boolean']['input']>;
  loadTransactionsForLastDays?: InputMaybe<Scalars['Float']['input']>;
};

export enum IntegrationType {
  AchProc = 'ACH_PROC',
  ClearAchBot = 'CLEAR_ACH_BOT',
  DevNull = 'DEV_NULL',
  GoAch = 'GO_ACH',
  GoAchBot = 'GO_ACH_BOT',
  LiftoffCard = 'LIFTOFF_CARD'
}

export type IntegrationsList = {
  __typename?: 'IntegrationsList';
  data: Array<Integration>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InternalCompaniesList = {
  __typename?: 'InternalCompaniesList';
  data: Array<InternalCompany>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type InternalCompany = {
  __typename?: 'InternalCompany';
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dba?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<CompanyDocumentDto>;
  documentsInfo: InternalCompanyDocumentsInfo;
  email?: Maybe<Scalars['String']['output']>;
  /** Unique lender identifier */
  id: Scalars['ID']['output'];
  integrations?: Maybe<Array<Integration>>;
  isDefault: Scalars['Boolean']['output'];
  legalName?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  mcas?: Maybe<Array<MerchantCashAdvance>>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  phone?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
};

export type InternalCompanyDocumentsInfo = {
  __typename?: 'InternalCompanyDocumentsInfo';
  companyFolderConnected: Scalars['Boolean']['output'];
  companyFolderId?: Maybe<Scalars['String']['output']>;
  subfolderDocuments: Array<CompanyDocumentDto>;
  subfolderFiles: Array<SubfolderFileInfo>;
  subfolderId?: Maybe<Scalars['String']['output']>;
};

export type InternalCompanyDto = {
  dba: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legalName: Scalars['String']['input'];
  logoMediaFile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type InvestorBalanceDto = {
  __typename?: 'InvestorBalanceDto';
  balance: Scalars['Float']['output'];
};

export type InvestorBalanceSummaryDto = {
  __typename?: 'InvestorBalanceSummaryDto';
  credit?: Maybe<Scalars['Float']['output']>;
  debit?: Maybe<Scalars['Float']['output']>;
};

export type InvestorBalanceTransactionDto = {
  __typename?: 'InvestorBalanceTransactionDto';
  amount?: Maybe<Scalars['Float']['output']>;
  depositDate?: Maybe<Scalars['DateTime']['output']>;
  effectiveDate: Scalars['DateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mcaId?: Maybe<Scalars['String']['output']>;
  mcaNumber?: Maybe<Scalars['Float']['output']>;
  mcaStatus?: Maybe<MerchantCashAdvanceStatus>;
  merchantName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  number: Scalars['Float']['output'];
  originationDate: Scalars['DateTime']['output'];
  paymentMethodId?: Maybe<Scalars['ID']['output']>;
  runningBalance: Scalars['Float']['output'];
  runningCashInOutBalance?: Maybe<Scalars['Float']['output']>;
  status: TransactionStatus;
  type: TransactionType;
};

export type InvestorBalanceTransactionSummaryDto = {
  __typename?: 'InvestorBalanceTransactionSummaryDto';
  cashInTotal: Scalars['Float']['output'];
  cashOutTotal: Scalars['Float']['output'];
};

export type InvestorBalanceTransactionsList = {
  __typename?: 'InvestorBalanceTransactionsList';
  data: Array<InvestorBalanceTransactionDto>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  summary: InvestorBalanceSummaryDto;
  total: Scalars['Int']['output'];
};

export type InvestorPortFolioDto = {
  __typename?: 'InvestorPortFolioDto';
  activeReceivablesFunder?: Maybe<Scalars['Float']['output']>;
  activeReceivablesFunderCount?: Maybe<Scalars['Float']['output']>;
  activeReceivablesInvestor?: Maybe<Scalars['Float']['output']>;
  activeReceivablesInvestorCount?: Maybe<Scalars['Float']['output']>;
  attorney?: Maybe<Scalars['Float']['output']>;
  attorneyCount?: Maybe<Scalars['Float']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  collections?: Maybe<Scalars['Float']['output']>;
  collectionsCount?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  inHouseLegal?: Maybe<Scalars['Float']['output']>;
  inHouseLegalCount?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notPaying?: Maybe<Scalars['Float']['output']>;
  notPayingCount?: Maybe<Scalars['Float']['output']>;
  open?: Maybe<Scalars['Float']['output']>;
  openCount?: Maybe<Scalars['Float']['output']>;
  originationPerformanceAmount?: Maybe<Scalars['Float']['output']>;
  poolGrossValue?: Maybe<Scalars['Float']['output']>;
  poolNetValue?: Maybe<Scalars['Float']['output']>;
  portFolioCount?: Maybe<Scalars['Float']['output']>;
  portFolioValue?: Maybe<Scalars['Float']['output']>;
  profitAndLoss?: Maybe<Scalars['Float']['output']>;
  resumed?: Maybe<Scalars['Float']['output']>;
  resumedCount?: Maybe<Scalars['Float']['output']>;
  role?: Maybe<Array<Scalars['String']['output']>>;
  settled?: Maybe<Scalars['Float']['output']>;
  settledCount?: Maybe<Scalars['Float']['output']>;
  slow?: Maybe<Scalars['Float']['output']>;
  slowCount?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalAccumulated?: Maybe<Scalars['Float']['output']>;
  totalAccumulatedCount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalAmtPaidClr?: Maybe<Scalars['Float']['output']>;
  totalCompleted?: Maybe<Scalars['Float']['output']>;
  totalCompletedCount?: Maybe<Scalars['Float']['output']>;
  totalMcaCount?: Maybe<Scalars['Float']['output']>;
  totalPayback?: Maybe<Scalars['Float']['output']>;
  totalPortFolioCount?: Maybe<Scalars['Float']['output']>;
  totalPortFolioValue?: Maybe<Scalars['Float']['output']>;
  totalReceivables?: Maybe<Scalars['Float']['output']>;
  totalReceivablesCount?: Maybe<Scalars['Float']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  verySlow?: Maybe<Scalars['Float']['output']>;
  verySlowCount?: Maybe<Scalars['Float']['output']>;
  writtenOff?: Maybe<Scalars['Float']['output']>;
  writtenOffCount?: Maybe<Scalars['Float']['output']>;
};

export type InvestorReconciliationBalanceDto = {
  __typename?: 'InvestorReconciliationBalanceDto';
  amount: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  lastReconciliationAction?: Maybe<ReconciliationAction>;
  lastReconciliationAt?: Maybe<Scalars['DateTime']['output']>;
  lastReconciliationBy?: Maybe<User>;
  reconciliations?: Maybe<Array<Reconciliation>>;
  transactionsCount: Scalars['Float']['output'];
  type: ReconciliationType;
};

export type InvestorReconciliationBalanceList = {
  __typename?: 'InvestorReconciliationBalanceList';
  data: Array<InvestorReconciliationBalanceDto>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ManualTransactionDto = {
  amount: Scalars['Float']['input'];
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mcaId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  type: TransactionType;
};

export type McaAverageFundingTerms = {
  __typename?: 'McaAverageFundingTerms';
  amountAvg?: Maybe<Scalars['Float']['output']>;
  commissionPercentageAvg?: Maybe<Scalars['Float']['output']>;
  dailyPmtAvg?: Maybe<Scalars['Float']['output']>;
  factorRateAvg?: Maybe<Scalars['Float']['output']>;
  feesPercentageAvg?: Maybe<Scalars['Float']['output']>;
  netWireAvg?: Maybe<Scalars['Float']['output']>;
  paybackAvg?: Maybe<Scalars['Float']['output']>;
  payoffAvg?: Maybe<Scalars['Float']['output']>;
  termAvg?: Maybe<Scalars['Float']['output']>;
};

export type McaDisplayAttribute = {
  __typename?: 'McaDisplayAttribute';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum McaDynamicRole {
  McaSyndicationBroker = 'McaSyndicationBroker',
  McaSyndicationDr = 'McaSyndicationDR',
  McaSyndicationFunder = 'McaSyndicationFunder',
  McaSyndicationInvestor = 'McaSyndicationInvestor',
  McaUnderwriter = 'McaUnderwriter'
}

export type McaIntegrationsDto = {
  __typename?: 'McaIntegrationsDto';
  integration: Integration;
  transactionsCount: Scalars['Float']['output'];
};

export enum McaManagementType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type McaRefi = {
  __typename?: 'McaRefi';
  amount?: Maybe<Scalars['Float']['output']>;
  clearedBalance: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantLegalName?: Maybe<Scalars['String']['output']>;
  merchantLogo?: Maybe<Scalars['String']['output']>;
  number: Scalars['Float']['output'];
  pendingBalance: Scalars['Float']['output'];
  referenceMca?: Maybe<Scalars['String']['output']>;
  totalFees: Scalars['Float']['output'];
  type: McaRefiType;
};

export type McaRefiDto = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  clearedBalance: Scalars['Float']['input'];
  id: Scalars['String']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
  merchantLegalName?: InputMaybe<Scalars['String']['input']>;
  merchantLogo?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Float']['input'];
  pendingBalance: Scalars['Float']['input'];
  referenceMca?: InputMaybe<Scalars['String']['input']>;
  totalFees: Scalars['Float']['input'];
  type: McaRefiType;
};

export enum McaRefiType {
  ClearedBalance = 'CLEARED_BALANCE',
  ClearedBalanceWithFees = 'CLEARED_BALANCE_WITH_FEES',
  PendingBalance = 'PENDING_BALANCE',
  PendingBalanceWithFees = 'PENDING_BALANCE_WITH_FEES'
}

export type MerchantBankAccount = {
  __typename?: 'MerchantBankAccount';
  accountNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Unique merchant bank account identifier */
  id?: Maybe<Scalars['ID']['output']>;
  merchant?: Maybe<Company>;
  name?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
};

export type MerchantBankAccountDto = {
  accountNumber: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  routingNumber: Scalars['String']['input'];
};

export type MerchantCashAdvance = {
  __typename?: 'MerchantCashAdvance';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  amtpaidclr?: Maybe<Scalars['Float']['output']>;
  amtpaidpnd?: Maybe<Scalars['Float']['output']>;
  balanceClrWFees?: Maybe<Scalars['Float']['output']>;
  balancePnd?: Maybe<Scalars['Float']['output']>;
  balancePndWFees?: Maybe<Scalars['Float']['output']>;
  balanceclr?: Maybe<Scalars['Float']['output']>;
  broker?: Maybe<User>;
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  commissions?: Maybe<Array<Commission>>;
  company?: Maybe<InternalCompany>;
  completion?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  currentUserMcaRoles: Array<McaDynamicRole>;
  currentUserRights: Array<Rights>;
  description?: Maybe<Scalars['String']['output']>;
  displayAttributes: Array<Scalars['String']['output']>;
  documents: Array<AvailableDocumentDto>;
  endDate?: Maybe<Scalars['Date']['output']>;
  externalConnections?: Maybe<Array<MerchantCashAdvanceExternalServiceConnection>>;
  factorRate: Scalars['Float']['output'];
  funder?: Maybe<Underwriter>;
  fundingDate: Scalars['Date']['output'];
  fundingFee?: Maybe<Array<FundingFee>>;
  /** Unique cash advance identifier */
  id: Scalars['ID']['output'];
  integration?: Maybe<Integration>;
  lastPmtDay?: Maybe<Scalars['Date']['output']>;
  lastTransaction?: Maybe<Transaction>;
  legal?: Maybe<User>;
  manager?: Maybe<User>;
  merchant: Company;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  netWire?: Maybe<Scalars['Float']['output']>;
  /** Count of transactions where status of transaction is 'CLEARED' */
  nft?: Maybe<Scalars['Float']['output']>;
  /** Number of passed transactions where status of transaction is not 'PENDING' or 'DELETED' */
  npt?: Maybe<Scalars['Float']['output']>;
  /** Count of transactions where status of transaction is 'NSF' */
  nrt?: Maybe<Scalars['Float']['output']>;
  /** The cash advance number autogenerated */
  number: Scalars['Float']['output'];
  numberOfFeeTransactions?: Maybe<Scalars['Float']['output']>;
  numberOfInvestorTransactions?: Maybe<Scalars['Float']['output']>;
  payback: Scalars['Float']['output'];
  paybackWFee?: Maybe<Scalars['Float']['output']>;
  payoff?: Maybe<Scalars['Float']['output']>;
  perfEndDate?: Maybe<Scalars['Date']['output']>;
  perfTerm?: Maybe<Scalars['Float']['output']>;
  pmt?: Maybe<Scalars['Float']['output']>;
  pnlGross?: Maybe<Scalars['Float']['output']>;
  pnlNet?: Maybe<Scalars['Float']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  recurrencies?: Maybe<Array<Recurrency>>;
  referenceMca: Scalars['String']['output'];
  refis: Array<McaRefi>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  secondaryFunders?: Maybe<Array<Underwriter>>;
  startDate: Scalars['Date']['output'];
  status: MerchantCashAdvanceStatus;
  statusChangedAt: Scalars['DateTime']['output'];
  statusChangedBy: User;
  statusManagementType: McaManagementType;
  syndications?: Maybe<Array<Syndication>>;
  term: Scalars['Float']['output'];
  totalclrfines?: Maybe<Scalars['Float']['output']>;
  totalcommissions?: Maybe<Scalars['Float']['output']>;
  totalfees?: Maybe<Scalars['Float']['output']>;
  totalfines?: Maybe<Scalars['Float']['output']>;
  totalpendingfines?: Maybe<Scalars['Float']['output']>;
};

export type MerchantCashAdvanceDto = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  factorRate?: InputMaybe<Scalars['Float']['input']>;
  fundingDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  refis?: InputMaybe<Array<McaRefiDto>>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<MerchantCashAdvanceStatus>;
  term?: InputMaybe<Scalars['Float']['input']>;
};

export type MerchantCashAdvanceExternalServiceConnection = {
  __typename?: 'MerchantCashAdvanceExternalServiceConnection';
  configuration: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  externalServiceConfiguration: ExternalServiceConfiguration;
  externalServiceConfigurationId: Scalars['ID']['output'];
  fetchedAt?: Maybe<Scalars['Date']['output']>;
  /** Unique merchant cash advance external service connection identifier */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  mca: MerchantCashAdvance;
  mcaId: Scalars['ID']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
};

export type MerchantCashAdvanceExternalServiceConnectionDto = {
  __typename?: 'MerchantCashAdvanceExternalServiceConnectionDto';
  configuration: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  externalServiceConfiguration?: Maybe<ExternalServiceConfiguration>;
  externalServiceConfigurationId: Scalars['ID']['output'];
  fetchedAt?: Maybe<Scalars['Date']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  mcaId: Scalars['ID']['output'];
  modifiedAt?: Maybe<Scalars['Date']['output']>;
};

export type MerchantCashAdvanceExternalServiceDataDto = {
  __typename?: 'MerchantCashAdvanceExternalServiceDataDto';
  connection?: Maybe<MerchantCashAdvanceExternalServiceConnection>;
  connectionId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  data: Scalars['JSON']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum MerchantCashAdvanceStatus {
  Attorney = 'ATTORNEY',
  Collections = 'COLLECTIONS',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  InHouseLegal = 'IN_HOUSE_LEGAL',
  NotPaying = 'NOT_PAYING',
  Open = 'OPEN',
  Paused = 'PAUSED',
  PrepLegal = 'PREP_LEGAL',
  Resumed = 'RESUMED',
  Settled = 'SETTLED',
  Slow = 'SLOW',
  VerySlow = 'VERY_SLOW',
  WrittenOff = 'WRITTEN_OFF'
}

export type MerchantCashAdvanceStatusHistory = {
  __typename?: 'MerchantCashAdvanceStatusHistory';
  createdAt: Scalars['DateTime']['output'];
  fromStatus: MerchantCashAdvanceStatus;
  reason?: Maybe<Scalars['String']['output']>;
  toStatus: MerchantCashAdvanceStatus;
  user?: Maybe<User>;
};

export type MerchantCashAdvanceSummary = {
  __typename?: 'MerchantCashAdvanceSummary';
  amountSum?: Maybe<Scalars['Float']['output']>;
  amtPaidClrSum?: Maybe<Scalars['Float']['output']>;
  amtPaidPndSum?: Maybe<Scalars['Float']['output']>;
  commissionSum?: Maybe<Scalars['Float']['output']>;
  completionAvg?: Maybe<Scalars['Float']['output']>;
  factorRateAvg?: Maybe<Scalars['Float']['output']>;
  netWireSum?: Maybe<Scalars['Float']['output']>;
  paybackSum?: Maybe<Scalars['Float']['output']>;
  paybackWFeeSum?: Maybe<Scalars['Float']['output']>;
  payoffSum?: Maybe<Scalars['Float']['output']>;
  pmtSum?: Maybe<Scalars['Float']['output']>;
  pnlgrossSum?: Maybe<Scalars['Float']['output']>;
  pnlnetSum?: Maybe<Scalars['Float']['output']>;
  totalFeesSum?: Maybe<Scalars['Float']['output']>;
  totalPendingPostFundingFeesSum?: Maybe<Scalars['Float']['output']>;
  totalclrfines?: Maybe<Scalars['Float']['output']>;
  totalfines?: Maybe<Scalars['Float']['output']>;
};

export type MerchantCashAdvancesList = {
  __typename?: 'MerchantCashAdvancesList';
  data: Array<MerchantCashAdvance>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MerchantDto = {
  dba: Scalars['String']['input'];
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legalName: Scalars['String']['input'];
  logoMediaFile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Array<Scalars['String']['input']>>;
  taxId?: InputMaybe<Scalars['String']['input']>;
  www?: InputMaybe<Scalars['String']['input']>;
};

export type MfaSettingsDto = {
  accessTokenTtlHours: Scalars['Int']['input'];
  deviceRememberingDays: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  mfaDeviceRememberingEnabled: Scalars['Boolean']['input'];
  mfaEnabled: Scalars['Boolean']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addBankLocation: BankLocation;
  addUserToUnderwriter: UserFunderConnections;
  assignAccessToPortfolio: UserPortfolioConnections;
  assignExistingRecurrency: Recurrency;
  cancelTransaction: Scalars['Boolean']['output'];
  changeApplicationStatus: Application;
  changeMerchantCashAdvanceStatus: Scalars['Int']['output'];
  changePassword: User;
  createApplication: Application;
  createOffer: Offer;
  createStipulation: Stipulation;
  delete: Scalars['Float']['output'];
  deleteApplication: Scalars['Boolean']['output'];
  deleteApplicationExternalServiceConnection: Scalars['Boolean']['output'];
  deleteBank: Scalars['String']['output'];
  deleteBankLocation: Scalars['Int']['output'];
  deleteCashTransaction: Scalars['ID']['output'];
  deleteCommission: Scalars['ID']['output'];
  deleteCompany: Scalars['ID']['output'];
  deleteConfigFee?: Maybe<Scalars['Int']['output']>;
  /** Deletes an ExternalServiceConfiguration by ID */
  deleteExternalServiceConfiguration: Scalars['ID']['output'];
  deleteFee: Scalars['ID']['output'];
  deleteFine: Scalars['ID']['output'];
  deleteIntegration: Scalars['ID']['output'];
  deleteInternalCompany: Scalars['ID']['output'];
  deleteManualTransaction: Scalars['ID']['output'];
  deleteMerchant: Scalars['ID']['output'];
  deleteMerchantBankAccount: Scalars['ID']['output'];
  deleteMerchantCashAdvance: Scalars['ID']['output'];
  deleteMerchantCashAdvanceExternalServiceConnection: Scalars['Boolean']['output'];
  deleteOffer: Scalars['Boolean']['output'];
  deleteOffersByGroupId: Scalars['Boolean']['output'];
  deleteOwner: Scalars['ID']['output'];
  deleteRecurrencyWithError: Scalars['ID']['output'];
  deleteStipulation: Scalars['Boolean']['output'];
  deleteSyndication: Scalars['ID']['output'];
  deleteUnderwriter: Scalars['ID']['output'];
  deleteUserBankAccount: Scalars['ID']['output'];
  duplicateApplication: Application;
  importTransactions: Array<ImportedTransactionDto>;
  linkActiveOfferToMca: Scalars['Boolean']['output'];
  pauseRecurrency: Scalars['Int']['output'];
  pullClearPersonReport: PullCreditReportResultDto;
  pullExperianCreditReport: PullCreditReportResultDto;
  refreshMerchantCashAdvanceTransactions: Scalars['Int']['output'];
  refreshRecurrencyTransactions: Scalars['Int']['output'];
  refreshTransactions: IntegrationHealthMonitor;
  removeAccessToPortfolio: Scalars['Boolean']['output'];
  removeUserFromUnderwriter: Scalars['Boolean']['output'];
  resendInvitation: User;
  resumeRecurrency: Scalars['Int']['output'];
  saveAndInviteUser: User;
  saveApplicationExternalServiceConnection: ApplicationExternalServiceConnectionDto;
  saveBank: BankInfo;
  saveBankLocation: BankLocation;
  saveBroker: Company;
  saveCashTransaction: Transaction;
  saveCommission: Commission;
  saveCommissions: Array<Commission>;
  saveCompany: Company;
  saveCompanyOwners: Array<Owner>;
  saveConfigFee: ConfigFee;
  saveExternalServiceConfiguration: ExternalServiceDto;
  saveFee: FundingFee;
  saveFees: Array<FundingFee>;
  saveFine: PostFundingFee;
  saveFines: Array<PostFundingFee>;
  saveFundingPipelineMca: MerchantCashAdvance;
  saveIntegration: Integration;
  saveInternalCompany: InternalCompany;
  saveLocationRoutingNumbers: BankLocation;
  saveManualTransaction: Transaction;
  saveMerchant: Company;
  saveMerchantBankAccount: MerchantBankAccount;
  saveMerchantCashAdvance: MerchantCashAdvance;
  saveMerchantCashAdvanceExternalServiceConnection: MerchantCashAdvanceExternalServiceConnectionDto;
  saveOwner: Owner;
  savePreferences: User;
  saveProfile: User;
  saveReconciliation: Reconciliation;
  saveRecurrency: Recurrency;
  saveSyndication: Syndication;
  saveTransactionNote: Transaction;
  saveTransactionType: Transaction;
  saveUnderwriter: Underwriter;
  saveUnsentOfferEmail: Array<OfferEmail>;
  saveUser: User;
  saveUserBankAccount: UserBankAccount;
  scheduleIntegration?: Maybe<Scalars['ID']['output']>;
  sendCognitoSetup: User;
  sendOfferEmail: Array<OfferEmail>;
  setActiveOffer: Offer;
  setDefaultCompany: Scalars['ID']['output'];
  stopRecurrency: Scalars['Int']['output'];
  stopRecurrencyTransaction: Scalars['Int']['output'];
  stopTransaction: Scalars['Int']['output'];
  submitRecurrencyToProcessor: Recurrency;
  syncMerchantCashAdvanceExternalServiceConnection: Scalars['Boolean']['output'];
  toggleMcaManagementType: Scalars['ID']['output'];
  toggleUserActivation: User;
  unscheduleIntegration?: Maybe<Scalars['ID']['output']>;
  updateApplication: Application;
  updateApplicationExternalServiceConnection?: Maybe<ApplicationExternalServiceConnectionDto>;
  updateAutoStart: Integration;
  updateMerchantCashAdvanceExternalServiceConnection?: Maybe<MerchantCashAdvanceExternalServiceConnectionDto>;
  updateOffer: Offer;
  updatePermission: Permission;
  updateStipulation: Stipulation;
  updateUserMfaSettings: User;
};


export type MutationAddBankLocationArgs = {
  input: AddBankLocationInput;
};


export type MutationAddUserToUnderwriterArgs = {
  underwriterId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAssignAccessToPortfolioArgs = {
  sourceUserId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
};


export type MutationAssignExistingRecurrencyArgs = {
  integrationId: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  processorReference: Scalars['String']['input'];
};


export type MutationCancelTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeApplicationStatusArgs = {
  applicationId: Scalars['ID']['input'];
  statusId: Scalars['String']['input'];
};


export type MutationChangeMerchantCashAdvanceStatusArgs = {
  mcaId: Scalars['ID']['input'];
  status: MerchantCashAdvanceStatus;
};


export type MutationChangePasswordArgs = {
  changePasswordDto: ChangePasswordDto;
};


export type MutationCreateApplicationArgs = {
  createApplicationInput: CreateApplicationInput;
};


export type MutationCreateOfferArgs = {
  createOfferInput: CreateOfferInput;
};


export type MutationCreateStipulationArgs = {
  input: CreateStipulationInput;
};


export type MutationDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteApplicationExternalServiceConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBankArgs = {
  bankName: Scalars['String']['input'];
};


export type MutationDeleteBankLocationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteCashTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCommissionArgs = {
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteConfigFeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteExternalServiceConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeeArgs = {
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationDeleteFineArgs = {
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInternalCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManualTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMerchantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMerchantBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMerchantCashAdvanceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMerchantCashAdvanceExternalServiceConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOfferArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOffersByGroupIdArgs = {
  rehabGroupId: Scalars['ID']['input'];
};


export type MutationDeleteOwnerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRecurrencyWithErrorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStipulationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSyndicationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUnderwriterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserBankAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateApplicationArgs = {
  applicationId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
};


export type MutationImportTransactionsArgs = {
  dateEnd: Scalars['DateTime']['input'];
  dateStart: Scalars['DateTime']['input'];
  integrationId: Scalars['ID']['input'];
};


export type MutationLinkActiveOfferToMcaArgs = {
  applicationId: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationPauseRecurrencyArgs = {
  cancelTodayTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  recurrencyId: Scalars['ID']['input'];
};


export type MutationPullClearPersonReportArgs = {
  applicationId: Scalars['ID']['input'];
  consumerPii: ConsumerPiiInputDto;
  externalServiceConfigurationId: Scalars['ID']['input'];
};


export type MutationPullExperianCreditReportArgs = {
  applicationId: Scalars['ID']['input'];
  consumerPii: ConsumerPiiInputDto;
  externalServiceConfigurationId: Scalars['ID']['input'];
};


export type MutationRefreshMerchantCashAdvanceTransactionsArgs = {
  mcaId: Scalars['ID']['input'];
};


export type MutationRefreshRecurrencyTransactionsArgs = {
  recurrencyId: Scalars['ID']['input'];
};


export type MutationRefreshTransactionsArgs = {
  integrationId: Scalars['ID']['input'];
};


export type MutationRemoveAccessToPortfolioArgs = {
  sourceUserId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
};


export type MutationRemoveUserFromUnderwriterArgs = {
  underwriterId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationResendInvitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResumeRecurrencyArgs = {
  recurrencyId: Scalars['ID']['input'];
  tryCreateTodayTransaction?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSaveAndInviteUserArgs = {
  userDto: UserDto;
};


export type MutationSaveApplicationExternalServiceConnectionArgs = {
  applicationId: Scalars['ID']['input'];
  configuration: Scalars['JSON']['input'];
  externalServiceConfigurationId: Scalars['ID']['input'];
};


export type MutationSaveBankArgs = {
  input: SaveBankInput;
};


export type MutationSaveBankLocationArgs = {
  input: SaveBankLocationInput;
};


export type MutationSaveBrokerArgs = {
  broker: BrokerDto;
};


export type MutationSaveCashTransactionArgs = {
  dto: CashTransactionDto;
};


export type MutationSaveCommissionArgs = {
  commission: CommissionDto;
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationSaveCommissionsArgs = {
  commissions?: Array<CommissionDto>;
  mcaId: Scalars['ID']['input'];
};


export type MutationSaveCompanyArgs = {
  company: CompanyDto;
};


export type MutationSaveCompanyOwnersArgs = {
  companyId: Scalars['ID']['input'];
  owners: Array<OwnerDto>;
};


export type MutationSaveConfigFeeArgs = {
  configFee: ConfigFeeDto;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSaveExternalServiceConfigurationArgs = {
  externalServiceInputDto: ExternalServiceInputDto;
};


export type MutationSaveFeeArgs = {
  fee: FeeDto;
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationSaveFeesArgs = {
  fees?: Array<FeeDto>;
  mcaId: Scalars['ID']['input'];
};


export type MutationSaveFineArgs = {
  fine: FineDto;
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationSaveFinesArgs = {
  fines?: Array<FineDto>;
  mcaId: Scalars['ID']['input'];
};


export type MutationSaveFundingPipelineMcaArgs = {
  applicationId: Scalars['ID']['input'];
  brokerId?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  legalId?: InputMaybe<Scalars['ID']['input']>;
  lenderId?: InputMaybe<Scalars['ID']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  mca: MerchantCashAdvanceDto;
  merchantId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
  secondaryFunderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationSaveIntegrationArgs = {
  integration: IntegrationDto;
};


export type MutationSaveInternalCompanyArgs = {
  company: InternalCompanyDto;
};


export type MutationSaveLocationRoutingNumbersArgs = {
  input: SaveLocationRoutingNumbersInput;
};


export type MutationSaveManualTransactionArgs = {
  manualTransactionDto: ManualTransactionDto;
};


export type MutationSaveMerchantArgs = {
  merchant: MerchantDto;
};


export type MutationSaveMerchantBankAccountArgs = {
  bankAccount: MerchantBankAccountDto;
  merchantId: Scalars['ID']['input'];
};


export type MutationSaveMerchantCashAdvanceArgs = {
  brokerId?: InputMaybe<Scalars['ID']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  legalId?: InputMaybe<Scalars['ID']['input']>;
  lenderId?: InputMaybe<Scalars['ID']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  mca: MerchantCashAdvanceDto;
  merchantId: Scalars['ID']['input'];
  secondaryFunderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationSaveMerchantCashAdvanceExternalServiceConnectionArgs = {
  configuration: Scalars['JSON']['input'];
  externalServiceConfigurationId: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type MutationSaveOwnerArgs = {
  companyId: Scalars['ID']['input'];
  owner: OwnerDto;
};


export type MutationSavePreferencesArgs = {
  userPreferencesDto: UserPreferencesDto;
};


export type MutationSaveProfileArgs = {
  profileDto: ProfileDto;
};


export type MutationSaveReconciliationArgs = {
  acknowledged: Scalars['Boolean']['input'];
  investorId: Scalars['ID']['input'];
  reconciliationType: ReconciliationType;
};


export type MutationSaveRecurrencyArgs = {
  id: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  recurrency: RecurrencyDto;
};


export type MutationSaveSyndicationArgs = {
  syndication: SyndicationDto;
};


export type MutationSaveTransactionNoteArgs = {
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
};


export type MutationSaveTransactionTypeArgs = {
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  type: TransactionType;
};


export type MutationSaveUnderwriterArgs = {
  underwriter: UnderwriterDto;
};


export type MutationSaveUnsentOfferEmailArgs = {
  sendEmailInput: SendEmailInput;
};


export type MutationSaveUserArgs = {
  userDto: UserDto;
};


export type MutationSaveUserBankAccountArgs = {
  bankAccount: MerchantBankAccountDto;
  userId: Scalars['ID']['input'];
};


export type MutationScheduleIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendCognitoSetupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendOfferEmailArgs = {
  sendEmailInput: SendEmailInput;
};


export type MutationSetActiveOfferArgs = {
  offerId: Scalars['ID']['input'];
};


export type MutationSetDefaultCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type MutationStopRecurrencyArgs = {
  cancelTodayTransaction?: InputMaybe<Scalars['Boolean']['input']>;
  recurrencyId: Scalars['ID']['input'];
};


export type MutationStopRecurrencyTransactionArgs = {
  recurrencyId: Scalars['ID']['input'];
  transactionExternalId: Scalars['String']['input'];
};


export type MutationStopTransactionArgs = {
  transactionId: Scalars['ID']['input'];
};


export type MutationSubmitRecurrencyToProcessorArgs = {
  recurrencyId: Scalars['ID']['input'];
};


export type MutationSyncMerchantCashAdvanceExternalServiceConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationToggleMcaManagementTypeArgs = {
  mcaId: Scalars['ID']['input'];
};


export type MutationToggleUserActivationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnscheduleIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateApplicationArgs = {
  id: Scalars['ID']['input'];
  updateApplicationInput: UpdateApplicationInput;
};


export type MutationUpdateApplicationExternalServiceConnectionArgs = {
  configuration: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateAutoStartArgs = {
  autostart: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateMerchantCashAdvanceExternalServiceConnectionArgs = {
  configuration: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateOfferArgs = {
  id: Scalars['ID']['input'];
  updateOfferInput: UpdateOfferInput;
};


export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput;
  name: Scalars['String']['input'];
};


export type MutationUpdateStipulationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateStipulationInput;
};


export type MutationUpdateUserMfaSettingsArgs = {
  mfaSettingsDto: MfaSettingsDto;
};

export type NonWorkingDay = {
  __typename?: 'NonWorkingDay';
  date: Scalars['Date']['output'];
  description: Scalars['String']['output'];
};

export type Offer = {
  __typename?: 'Offer';
  application: Application;
  /** Broker associated with the offer */
  broker?: Maybe<User>;
  commissions?: Maybe<Array<OfferFeeCommissionJson>>;
  company?: Maybe<InternalCompany>;
  /** Creation date */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currentUserRights: Array<Rights>;
  factorRate: Scalars['Float']['output'];
  /** Funder associated with the offer */
  funder?: Maybe<Underwriter>;
  /** Funding amount for the offer */
  fundingAmount?: Maybe<Scalars['Float']['output']>;
  fundingFees?: Maybe<Array<OfferFeeCommissionJson>>;
  /** Unique offer identifier */
  id: Scalars['ID']['output'];
  integration?: Maybe<Integration>;
  /** Indicates if this offer group is the active group for the application */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if this line is currently selected in a rehab offer group */
  isSelected?: Maybe<Scalars['Boolean']['output']>;
  lineOrder?: Maybe<Scalars['Int']['output']>;
  linkToFilesData?: Maybe<OffersLinkToFiles>;
  manager?: Maybe<User>;
  mca?: Maybe<MerchantCashAdvance>;
  mcaId?: Maybe<Scalars['ID']['output']>;
  modifiedBy?: Maybe<User>;
  /** Notes for the offer */
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  /** Offer creation date */
  offerDate: Scalars['Date']['output'];
  offerEmails?: Maybe<Array<OfferEmail>>;
  rehabGroupId?: Maybe<Scalars['String']['output']>;
  rehabLineTitle?: Maybe<Scalars['String']['output']>;
  secondaryFunders?: Maybe<Array<Underwriter>>;
  /** Array of stipulation texts */
  stipulations?: Maybe<Array<Scalars['String']['output']>>;
  /** Term in days */
  term?: Maybe<Scalars['Float']['output']>;
  type: OfferType;
  /** Last update date */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OfferApplicationsCount = {
  __typename?: 'OfferApplicationsCount';
  countOfferApplications: Scalars['Int']['output'];
  countTodayOfferSentApplications: Scalars['Int']['output'];
};

export type OfferEmail = {
  __typename?: 'OfferEmail';
  /** Comment associated with the email */
  comment: Scalars['String']['output'];
  /** Date the email entry was created */
  createdAt: Scalars['DateTime']['output'];
  /** User who created the email record */
  createdBy: User;
  /** Error message if sending failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** HTML content of the sent email */
  htmlContent?: Maybe<Scalars['String']['output']>;
  /** Unique email record identifier */
  id: Scalars['ID']['output'];
  /** Send status of the email */
  isSent: Scalars['Boolean']['output'];
  /** User who last modified the email record */
  modifiedBy?: Maybe<User>;
  number?: Maybe<Scalars['Float']['output']>;
  /** Associated offer */
  offer: Offer;
  /** Recipient email address */
  recipient: Scalars['String']['output'];
  /** BCC Recipient email addresses */
  recipientBCC?: Maybe<Array<Scalars['String']['output']>>;
  /** CC Recipient email addresses */
  recipientCC?: Maybe<Array<Scalars['String']['output']>>;
  /** Date the email was sent */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of times this email has been sent */
  sentCount: Scalars['Float']['output'];
  /** Date the email entry was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type OfferFeeCommissionInput = {
  amount: Scalars['Float']['input'];
  comment: Scalars['String']['input'];
  configId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type OfferFeeCommissionJson = {
  __typename?: 'OfferFeeCommissionJson';
  amount: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  configId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type OfferList = {
  __typename?: 'OfferList';
  data: Array<Offer>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type OfferMerchantCashAdvanceDto = {
  __typename?: 'OfferMerchantCashAdvanceDto';
  amount?: Maybe<Scalars['Float']['output']>;
  broker?: Maybe<User>;
  commissionPercentage?: Maybe<Scalars['Float']['output']>;
  commissions?: Maybe<Array<OfferFeeCommissionJson>>;
  company?: Maybe<InternalCompany>;
  description?: Maybe<Scalars['String']['output']>;
  factorRate?: Maybe<Scalars['Float']['output']>;
  funder?: Maybe<Underwriter>;
  fundingDate?: Maybe<Scalars['Date']['output']>;
  fundingFee?: Maybe<Array<OfferFeeCommissionJson>>;
  id?: Maybe<Scalars['ID']['output']>;
  integration?: Maybe<Integration>;
  manager?: Maybe<User>;
  merchant?: Maybe<Company>;
  secondaryFunders?: Maybe<Array<Underwriter>>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<MerchantCashAdvanceStatus>;
  term?: Maybe<Scalars['Float']['output']>;
};

export enum OfferType {
  Refi = 'REFI',
  Regular = 'REGULAR',
  Rehab = 'REHAB'
}

export type OffersLinkToFiles = {
  __typename?: 'OffersLinkToFiles';
  linkToFiles?: Maybe<Scalars['String']['output']>;
  rehabGroupId: Scalars['String']['output'];
};

export type Owner = {
  __typename?: 'Owner';
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']['output']>;
  bizEmail?: Maybe<Scalars['String']['output']>;
  bizPhone?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  companyOwners: CompanyOwner;
  createdBy?: Maybe<User>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  modifiedBy?: Maybe<User>;
  ssn?: Maybe<Scalars['String']['output']>;
  ssnNormalized?: Maybe<Scalars['String']['output']>;
};

export type OwnerDto = {
  address?: InputMaybe<AddressDto>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bizEmail?: InputMaybe<Scalars['String']['input']>;
  bizPhone?: InputMaybe<Scalars['String']['input']>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  order: Scalars['Float']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  area: ProductArea;
  description: Scalars['String']['output'];
  mcaDynamicRoles: Array<McaDynamicRole>;
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roles: Array<Roles>;
};

export type PermissionsList = {
  __typename?: 'PermissionsList';
  data: Array<Permission>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PortFolioChartDto = {
  __typename?: 'PortFolioChartDto';
  activeReceivables?: Maybe<Scalars['Float']['output']>;
  activeReceivablesCount?: Maybe<Scalars['Float']['output']>;
  attorney?: Maybe<Scalars['Float']['output']>;
  attorneyCount?: Maybe<Scalars['Float']['output']>;
  collections?: Maybe<Scalars['Float']['output']>;
  collectionsCount?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTime']['output'];
  inHouseLegal?: Maybe<Scalars['Float']['output']>;
  inHouseLegalCount?: Maybe<Scalars['Float']['output']>;
  monthTotal?: Maybe<Scalars['Float']['output']>;
  notPaying?: Maybe<Scalars['Float']['output']>;
  notPayingCount?: Maybe<Scalars['Float']['output']>;
  open?: Maybe<Scalars['Float']['output']>;
  openCount?: Maybe<Scalars['Float']['output']>;
  originationPerformanceAmount?: Maybe<Scalars['Float']['output']>;
  portFolioCount?: Maybe<Scalars['Float']['output']>;
  portFolioValue?: Maybe<Scalars['Float']['output']>;
  profitAndLoss?: Maybe<Scalars['Float']['output']>;
  resumed?: Maybe<Scalars['Float']['output']>;
  resumedCount?: Maybe<Scalars['Float']['output']>;
  settled?: Maybe<Scalars['Float']['output']>;
  settledCount?: Maybe<Scalars['Float']['output']>;
  slow?: Maybe<Scalars['Float']['output']>;
  slowCount?: Maybe<Scalars['Float']['output']>;
  totalAccumulated?: Maybe<Scalars['Float']['output']>;
  totalAccumulatedCount?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
  totalAmtPaidClr?: Maybe<Scalars['Float']['output']>;
  totalCompleted?: Maybe<Scalars['Float']['output']>;
  totalCompletedCount?: Maybe<Scalars['Float']['output']>;
  totalMcaCount?: Maybe<Scalars['Float']['output']>;
  totalPayback?: Maybe<Scalars['Float']['output']>;
  totalPortFolio?: Maybe<Scalars['Float']['output']>;
  totalPortFolioCount?: Maybe<Scalars['Float']['output']>;
  totalReceivables?: Maybe<Scalars['Float']['output']>;
  totalReceivablesCount?: Maybe<Scalars['Float']['output']>;
  verySlow?: Maybe<Scalars['Float']['output']>;
  verySlowCount?: Maybe<Scalars['Float']['output']>;
  writtenOff?: Maybe<Scalars['Float']['output']>;
  writtenOffCount?: Maybe<Scalars['Float']['output']>;
};

export type PortFolioSummaryDto = {
  __typename?: 'PortFolioSummaryDto';
  activeReceivables?: Maybe<Scalars['Float']['output']>;
  activeReceivablesCount?: Maybe<Scalars['Float']['output']>;
  attorney?: Maybe<Scalars['Float']['output']>;
  attorneyCount?: Maybe<Scalars['Float']['output']>;
  collections?: Maybe<Scalars['Float']['output']>;
  collectionsCount?: Maybe<Scalars['Float']['output']>;
  completed?: Maybe<Scalars['Float']['output']>;
  completedCount?: Maybe<Scalars['Float']['output']>;
  inHouseLegal?: Maybe<Scalars['Float']['output']>;
  inHouseLegalCount?: Maybe<Scalars['Float']['output']>;
  notPaying?: Maybe<Scalars['Float']['output']>;
  notPayingCount?: Maybe<Scalars['Float']['output']>;
  open?: Maybe<Scalars['Float']['output']>;
  openCount?: Maybe<Scalars['Float']['output']>;
  portFolioCount?: Maybe<Scalars['Float']['output']>;
  portFolioValue?: Maybe<Scalars['Float']['output']>;
  profitAndLoss?: Maybe<Scalars['Float']['output']>;
  resumed?: Maybe<Scalars['Float']['output']>;
  resumedCount?: Maybe<Scalars['Float']['output']>;
  settled?: Maybe<Scalars['Float']['output']>;
  settledCount?: Maybe<Scalars['Float']['output']>;
  slow?: Maybe<Scalars['Float']['output']>;
  slowCount?: Maybe<Scalars['Float']['output']>;
  totalAccumulated?: Maybe<Scalars['Float']['output']>;
  totalAccumulatedCount?: Maybe<Scalars['Float']['output']>;
  totalCompleted?: Maybe<Scalars['Float']['output']>;
  totalCompletedCount?: Maybe<Scalars['Float']['output']>;
  totalPortFolio?: Maybe<Scalars['Float']['output']>;
  totalPortFolioCount?: Maybe<Scalars['Float']['output']>;
  totalReceivables?: Maybe<Scalars['Float']['output']>;
  totalReceivablesCount?: Maybe<Scalars['Float']['output']>;
  verySlow?: Maybe<Scalars['Float']['output']>;
  verySlowCount?: Maybe<Scalars['Float']['output']>;
  writtenOff?: Maybe<Scalars['Float']['output']>;
  writtenOffCount?: Maybe<Scalars['Float']['output']>;
};

export type PortfoliosCollectionsChartPoint = {
  __typename?: 'PortfoliosCollectionsChartPoint';
  date: Scalars['DateTime']['output'];
  series: Array<PortfoliosCollectionsChartSeriesItem>;
};

export type PortfoliosCollectionsChartSeriesItem = {
  __typename?: 'PortfoliosCollectionsChartSeriesItem';
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PostFundingFee = {
  __typename?: 'PostFundingFee';
  amount: Scalars['Float']['output'];
  comment: Scalars['String']['output'];
  config?: Maybe<ConfigFee>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** Unique fine identifier */
  id: Scalars['ID']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  status?: Maybe<FineStatus>;
  transactionId: Scalars['String']['output'];
};

export type PreferencesDto = {
  hidePerformanceChart: Scalars['Boolean']['input'];
  showTrailingZeros: Scalars['Boolean']['input'];
};

export enum ProductArea {
  App = 'APP',
  Company = 'COMPANY',
  Mca = 'MCA',
  Offer = 'OFFER',
  Other = 'OTHER',
  Platform = 'PLATFORM',
  Role = 'ROLE',
  Syndication = 'SYNDICATION',
  Transaction = 'TRANSACTION',
  User = 'USER'
}

export type ProfileDto = {
  avatarMediaFile?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<UserDataDto>;
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PullCreditReportResultDto = {
  __typename?: 'PullCreditReportResultDto';
  data?: Maybe<ApplicationExternalServiceDataDto>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  fromCache: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  accessiblePortfolios: Array<User>;
  /** Get all active external services available for MCA connections */
  activeExternalServices: Array<ExternalServiceDto>;
  allCompanies: CompaniesList;
  allSyndicationDetailsSummary: SyndicationDetailsSummaryDto;
  applicationExternalServiceConnection?: Maybe<ApplicationExternalServiceConnectionDto>;
  applicationExternalServiceConnections: Array<ApplicationExternalServiceConnectionDto>;
  applicationExternalServiceData?: Maybe<ApplicationExternalServiceDataDto>;
  applicationExternalServiceDataByApplication: Array<ApplicationExternalServiceDataDto>;
  applicationExternalServiceDataByConnection: Array<ApplicationExternalServiceDataDto>;
  applicationProcessorList: Array<ApplicationProcessor>;
  applicationStatusHistory: Array<ApplicationStatusHistory>;
  applicationStatusList: Array<ApplicationStatus>;
  applications: ApplicationList;
  applicationsForMerchant: Array<Application>;
  applicationsWithSelectedOffers: ApplicationWithOfferList;
  auditLogs: AuditLogList;
  availableExternalServices: Array<ExternalServiceType>;
  availableIntegrations: Array<IntegrationType>;
  bank?: Maybe<BankInfo>;
  bankByRoutingNumber?: Maybe<BankInfoByRoutingNumber>;
  banks: BankList;
  brokers: CompaniesList;
  calendarEvents: Array<CalendarEvent>;
  checkDuplicateRoutingNumbers: Array<RoutingNumberAssignment>;
  commission: Commission;
  commissionsForMca: Array<Commission>;
  companyOwners: Array<Owner>;
  configFee: ConfigFee;
  configFees: ConfigFeesList;
  countApplicationOfferStats: OfferApplicationsCount;
  countFundingPipelineOfferStats: FundingPipeLineOffersCount;
  countTodayMCAs: Scalars['Float']['output'];
  dailyCollectionsChart: Array<DailyCollectionsChartPoint>;
  /** Get an external service by ID */
  externalService?: Maybe<ExternalServiceDto>;
  fee: FundingFee;
  feesByMcaId: Array<FundingFee>;
  fine: PostFundingFee;
  finesByMcaId: Array<PostFundingFee>;
  fundersPortFolioSummary: Array<FunderPortFolioDto>;
  fundingPipelineStatus: Array<ApplicationStatus>;
  /** Get the logo mapping for all external service types. */
  getAllExternalServiceLogos: Scalars['JSON']['output'];
  /** Get all secret JSON schema definitions for all external service types. */
  getAllExternalServiceSecretSchemaDefinitions: Scalars['JSON']['output'];
  getAllUnderwriters: Array<Underwriter>;
  getApplication: Application;
  getMcaIntegrationsWithTransactionsCount: Array<McaIntegrationsDto>;
  getOffer: Offer;
  getRecurrencyAccountNumber?: Maybe<Scalars['String']['output']>;
  getRecurrencyProcessorData?: Maybe<RecurrencyProcessorData>;
  getRehabOffers: Array<Offer>;
  getUnderwriterMemberInfo: Array<UnderwriterMemberInfo>;
  getUsersForUnderwriter: Array<User>;
  getUsersWithAccessToPortfolio: Array<User>;
  getUsersWithAccessiblePortfolio: Array<User>;
  integration: Integration;
  integrations: IntegrationsList;
  integrationsSchedule?: Maybe<IntegrationScheduleDto>;
  internalCompanies: InternalCompaniesList;
  internalCompany: InternalCompany;
  investorAverageFundingTerms: McaAverageFundingTerms;
  investorBalance: InvestorBalanceDto;
  investorBalanceChart: Array<Chart>;
  investorBalanceTransactions: InvestorBalanceTransactionsList;
  investorCashTransactions: InvestorBalanceTransactionsList;
  investorCashTransactionsSummary: InvestorBalanceTransactionSummaryDto;
  investorPortFolioSummary: InvestorPortFolioDto;
  investorPortFolioSummaryChart: Array<InvestorPortFolioDto>;
  investorReconciliationBalances: InvestorReconciliationBalanceList;
  investorTotalDailyCollectionAmount: Scalars['Float']['output'];
  investorTransactions: Array<Chart>;
  investorTransactionsChart: Array<Chart>;
  investors: UsersList;
  investorsPortFolioSummary: Array<InvestorPortFolioDto>;
  isCompanyAdded: Scalars['Boolean']['output'];
  isEmailRegistered: Scalars['Boolean']['output'];
  isExisitingExternalService: Scalars['Boolean']['output'];
  isInternalCompanyAdded: Scalars['Boolean']['output'];
  listAllSyndicationDetails: SyndicationDetailsList;
  listSyndicationDetails: SyndicationDetailsList;
  listTransactions: TransactionsList;
  lookupSchedule: Array<RecurrencyProcessorData>;
  mapOfferToMCA: OfferMerchantCashAdvanceDto;
  mcaAverageFundingTerms: McaAverageFundingTerms;
  mcaDisplayAttributes: Array<McaDisplayAttribute>;
  mcaFeeTransactions: Array<Transaction>;
  mcaIntegrationTransactions: Array<Transaction>;
  mcaRecurrencies: Array<Recurrency>;
  mcaSyndication: Array<Syndication>;
  mcaTransactions: Array<Transaction>;
  merchant: Company;
  merchantBankAccounts: Array<MerchantBankAccount>;
  merchantCashAdvance: MerchantCashAdvance;
  merchantCashAdvanceExternalServiceConnection?: Maybe<MerchantCashAdvanceExternalServiceConnectionDto>;
  merchantCashAdvanceExternalServiceConnections: Array<MerchantCashAdvanceExternalServiceConnectionDto>;
  merchantCashAdvanceExternalServiceData?: Maybe<MerchantCashAdvanceExternalServiceDataDto>;
  merchantCashAdvanceExternalServiceDataByConnection: Array<MerchantCashAdvanceExternalServiceDataDto>;
  merchantCashAdvanceExternalServiceDataByMca: Array<MerchantCashAdvanceExternalServiceDataDto>;
  merchantCashAdvanceStatusHistory: Array<MerchantCashAdvanceStatusHistory>;
  merchantCashAdvances: MerchantCashAdvancesList;
  merchantCashAdvancesPreAggregated: MerchantCashAdvancesList;
  merchantCashAdvancesSummary: MerchantCashAdvanceSummary;
  merchants: CompaniesList;
  myPortFolioSummary: InvestorPortFolioDto;
  myPortFolioSummaryChart: Array<InvestorPortFolioDto>;
  myTransactions: Array<Chart>;
  myTransactionsChart: Array<Chart>;
  nonWorkingDays: Array<NonWorkingDay>;
  offerByMcaId?: Maybe<Offer>;
  offerStatusList: Array<ApplicationStatus>;
  offers: OfferList;
  offersForApplication: Array<Offer>;
  offersForFundingPipeline: OfferList;
  owner: Owner;
  paymentMethods: Array<PaymentMethod>;
  permission: Permission;
  permissions: PermissionsList;
  portFolioChart: Array<PortFolioChartDto>;
  portFolioSummary: PortFolioSummaryDto;
  portfolioMerchantCashAdvances: MerchantCashAdvancesList;
  portfoliosAverageFundingTerms: McaAverageFundingTerms;
  portfoliosCollectionsChart: Array<PortfoliosCollectionsChartPoint>;
  portfoliosTransactionsChart: Array<Chart>;
  previewOfferEmail: Scalars['String']['output'];
  profile: User;
  recurrency: Recurrency;
  recurrencyTransactions: Array<Transaction>;
  role: Role;
  roles: RolesList;
  rolesRightsMapping: Array<RoleRightsMapping>;
  stipulation: Stipulation;
  stipulations: Array<Stipulation>;
  syndication: Syndication;
  syndicationDetailsSummary: SyndicationDetailsSummaryDto;
  todaysCollection: TodaysCollectionDto;
  totalDailyCollectionAmount: Scalars['Float']['output'];
  transactionsChart: Array<Chart>;
  transactionsSummary: TransactionsSummaryDto;
  underwriter: Underwriter;
  underwriters: UnderwritersList;
  uptime: Scalars['Float']['output'];
  user: User;
  userBankAccounts: Array<UserBankAccount>;
  users: UsersList;
};


export type QueryAllCompaniesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  type?: InputMaybe<Array<CompanyType>>;
};


export type QueryAllSyndicationDetailsSummaryArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
};


export type QueryApplicationExternalServiceConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationExternalServiceConnectionsArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationExternalServiceDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationExternalServiceDataByApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryApplicationExternalServiceDataByConnectionArgs = {
  connectionId: Scalars['ID']['input'];
};


export type QueryApplicationStatusHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryApplicationsForMerchantArgs = {
  merchantLegalName: Scalars['String']['input'];
};


export type QueryApplicationsWithSelectedOffersArgs = {
  applicationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  funderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAuditLogsArgs = {
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBankArgs = {
  bankName: Scalars['String']['input'];
};


export type QueryBankByRoutingNumberArgs = {
  routingNumber: Scalars['String']['input'];
};


export type QueryBanksArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
};


export type QueryBrokersArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  type?: InputMaybe<Array<CompanyType>>;
};


export type QueryCalendarEventsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryCheckDuplicateRoutingNumbersArgs = {
  excludeLocationId?: InputMaybe<Scalars['Int']['input']>;
  routingNumbers: Array<Scalars['String']['input']>;
};


export type QueryCommissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommissionsForMcaArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryCompanyOwnersArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryConfigFeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDailyCollectionsChartArgs = {
  forLastMonths: Scalars['Int']['input'];
};


export type QueryExternalServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFeesByMcaIdArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryFineArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFinesByMcaIdArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryGetApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMcaIntegrationsWithTransactionsCountArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryGetOfferArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRecurrencyAccountNumberArgs = {
  recurrencyId: Scalars['ID']['input'];
};


export type QueryGetRecurrencyProcessorDataArgs = {
  recurrencyId: Scalars['ID']['input'];
};


export type QueryGetRehabOffersArgs = {
  rehabGroupId: Scalars['ID']['input'];
};


export type QueryGetUnderwriterMemberInfoArgs = {
  underwriterId: Scalars['ID']['input'];
};


export type QueryGetUsersForUnderwriterArgs = {
  underwriterId: Scalars['ID']['input'];
};


export type QueryGetUsersWithAccessToPortfolioArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryGetUsersWithAccessiblePortfolioArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationsScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInternalCompaniesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  type?: InputMaybe<Array<CompanyType>>;
};


export type QueryInternalCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvestorAverageFundingTermsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryInvestorBalanceArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryInvestorBalanceChartArgs = {
  forLastMonths: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryInvestorBalanceTransactionsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  investorId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<TransactionType>>;
};


export type QueryInvestorCashTransactionsArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  investorId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<TransactionType>>;
};


export type QueryInvestorCashTransactionsSummaryArgs = {
  fromDate?: InputMaybe<Scalars['String']['input']>;
  investorId: Scalars['ID']['input'];
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<TransactionType>>;
};


export type QueryInvestorPortFolioSummaryArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryInvestorPortFolioSummaryChartArgs = {
  months: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryInvestorReconciliationBalancesArgs = {
  investorId: Scalars['ID']['input'];
};


export type QueryInvestorTotalDailyCollectionAmountArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryInvestorTransactionsArgs = {
  forLastMonths: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryInvestorTransactionsChartArgs = {
  forLastMonths: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryInvestorsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  managerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: Scalars['Int']['input'];
  right?: InputMaybe<Rights>;
  rights?: InputMaybe<Array<Rights>>;
  role?: InputMaybe<Array<Roles>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
};


export type QueryInvestorsPortFolioSummaryArgs = {
  forAssignedPortfolios?: InputMaybe<Scalars['Boolean']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIsCompanyAddedArgs = {
  legalName: Scalars['String']['input'];
};


export type QueryIsEmailRegisteredArgs = {
  email: Scalars['String']['input'];
};


export type QueryIsExisitingExternalServiceArgs = {
  name: Scalars['String']['input'];
};


export type QueryIsInternalCompanyAddedArgs = {
  legalName: Scalars['String']['input'];
};


export type QueryListAllSyndicationDetailsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
};


export type QueryListSyndicationDetailsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
  userId: Scalars['ID']['input'];
};


export type QueryListTransactionsArgs = {
  fromDate: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  toDate: Scalars['String']['input'];
  types?: InputMaybe<Array<TransactionType>>;
};


export type QueryLookupScheduleArgs = {
  external: Scalars['String']['input'];
  integrationId: Scalars['ID']['input'];
};


export type QueryMapOfferToMcaArgs = {
  offerId: Scalars['ID']['input'];
};


export type QueryMcaFeeTransactionsArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryMcaIntegrationTransactionsArgs = {
  integrationId: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
};


export type QueryMcaRecurrenciesArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryMcaSyndicationArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryMcaTransactionsArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryMerchantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantBankAccountsArgs = {
  merchantId: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvanceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvanceExternalServiceConnectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvanceExternalServiceConnectionsArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvanceExternalServiceDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvanceExternalServiceDataByConnectionArgs = {
  connectionId: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvanceExternalServiceDataByMcaArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvanceStatusHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMerchantCashAdvancesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  excludeStatus?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
  funderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  lastTransactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  lastTransactionStatus?: InputMaybe<Array<TransactionStatus>>;
  limit?: Scalars['Int']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
};


export type QueryMerchantCashAdvancesPreAggregatedArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  excludeStatus?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
  funderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  lastTransactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  lastTransactionStatus?: InputMaybe<Array<TransactionStatus>>;
  limit?: Scalars['Int']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
};


export type QueryMerchantCashAdvancesSummaryArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  excludeStatus?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
  funderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  lastTransactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  lastTransactionStatus?: InputMaybe<Array<TransactionStatus>>;
  limit?: Scalars['Int']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
};


export type QueryMerchantsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  type?: InputMaybe<Array<CompanyType>>;
};


export type QueryMyPortFolioSummaryChartArgs = {
  months: Scalars['Int']['input'];
};


export type QueryMyTransactionsArgs = {
  forLastMonths: Scalars['Int']['input'];
};


export type QueryMyTransactionsChartArgs = {
  forLastMonths: Scalars['Int']['input'];
};


export type QueryOfferByMcaIdArgs = {
  mcaId: Scalars['ID']['input'];
};


export type QueryOffersArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
};


export type QueryOffersForApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type QueryOffersForFundingPipelineArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  offerId?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOwnerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionArgs = {
  name: Scalars['String']['input'];
};


export type QueryPermissionsArgs = {
  limit?: Scalars['Int']['input'];
  mcaDynamicRoleFilter?: InputMaybe<McaDynamicRole>;
  offset?: Scalars['Int']['input'];
  roleFilter?: InputMaybe<Roles>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortFolioChartArgs = {
  months?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryPortfolioMerchantCashAdvancesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  excludeStatus?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
  funderIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  lastTransactionDateFrom?: InputMaybe<Scalars['Date']['input']>;
  lastTransactionStatus?: InputMaybe<Array<TransactionStatus>>;
  limit?: Scalars['Int']['input'];
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
};


export type QueryPortfoliosCollectionsChartArgs = {
  forLastMonths: Scalars['Int']['input'];
};


export type QueryPortfoliosTransactionsChartArgs = {
  forLastMonths: Scalars['Int']['input'];
};


export type QueryPreviewOfferEmailArgs = {
  offerId: Scalars['String']['input'];
};


export type QueryRecurrencyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecurrencyTransactionsArgs = {
  recurrencyId: Scalars['ID']['input'];
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
};


export type QueryStipulationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStipulationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySyndicationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySyndicationDetailsSummaryArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus>>;
  userId: Scalars['ID']['input'];
};


export type QueryTransactionsChartArgs = {
  forLastMonths: Scalars['Int']['input'];
  integrationId?: InputMaybe<Scalars['String']['input']>;
  isManual?: Scalars['Boolean']['input'];
};


export type QueryTransactionsSummaryArgs = {
  fromDate: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
  statuses?: InputMaybe<Array<TransactionStatus>>;
  toDate: Scalars['String']['input'];
  types?: InputMaybe<Array<TransactionType>>;
};


export type QueryUnderwriterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUnderwritersArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserBankAccountsArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  managerId?: InputMaybe<Scalars['ID']['input']>;
  offset?: Scalars['Int']['input'];
  right?: InputMaybe<Rights>;
  rights?: InputMaybe<Array<Rights>>;
  role?: InputMaybe<Array<Roles>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: Array<SortArgs>;
};

export type Reconciliation = {
  __typename?: 'Reconciliation';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  investor: User;
  notes?: Maybe<Scalars['String']['output']>;
  reconciliationAction: ReconciliationAction;
  reconciliationType: ReconciliationType;
  transactionsCount: Scalars['Float']['output'];
};

export enum ReconciliationAction {
  Acknowledged = 'ACKNOWLEDGED',
  Unacknowledged = 'UNACKNOWLEDGED'
}

export enum ReconciliationType {
  BrkComm = 'BRK_COMM',
  CrmAccessFee = 'CRM_ACCESS_FEE',
  FundingWallet = 'FUNDING_WALLET',
  IsoComm = 'ISO_COMM',
  OrgFee = 'ORG_FEE',
  PaidCollected = 'PAID_COLLECTED',
  Remittance = 'REMITTANCE',
  RemittanceFee = 'REMITTANCE_FEE',
  ServiceFee = 'SERVICE_FEE',
  Syndication = 'SYNDICATION',
  Uncategorized = 'UNCATEGORIZED'
}

export type Recurrency = {
  __typename?: 'Recurrency';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  dailyPayment: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Unique id of integration linked to mca */
  id: Scalars['ID']['output'];
  integration: Integration;
  mca: MerchantCashAdvance;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  processorReference?: Maybe<Scalars['String']['output']>;
  recurrenceNumber?: Maybe<Scalars['Float']['output']>;
  referenceMca: Scalars['String']['output'];
  referenceRecurrence?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  state: RecurrencyState;
  stateNotes?: Maybe<Scalars['String']['output']>;
  term: Scalars['Float']['output'];
};

export type RecurrencyDto = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  dailyPayment?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  processorReference?: InputMaybe<Scalars['String']['input']>;
  referenceRecurrence?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  state?: InputMaybe<RecurrencyState>;
  term?: InputMaybe<Scalars['Float']['input']>;
};

export type RecurrencyProcessorData = {
  __typename?: 'RecurrencyProcessorData';
  accountNumber: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  bankAccountName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAssigned?: Maybe<Scalars['Boolean']['output']>;
  isPaused: Scalars['Boolean']['output'];
  isStopped: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paymentCount?: Maybe<Scalars['Float']['output']>;
  processedPaymentCount?: Maybe<Scalars['Float']['output']>;
  processorReference?: Maybe<Scalars['String']['output']>;
  routingNumber: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export enum RecurrencyState {
  Active = 'ACTIVE',
  Error = 'ERROR',
  New = 'NEW',
  Paused = 'PAUSED',
  Stopped = 'STOPPED'
}

export enum Rights {
  ChangeApplicationStatus = 'ChangeApplicationStatus',
  ChangeMcaStatus = 'ChangeMcaStatus',
  CreateAdminUser = 'CreateAdminUser',
  CreateApplication = 'CreateApplication',
  CreateBrokerUser = 'CreateBrokerUser',
  CreateFunderUser = 'CreateFunderUser',
  CreateGuestUser = 'CreateGuestUser',
  CreateInvestorUser = 'CreateInvestorUser',
  CreateIsoManagerUser = 'CreateIsoManagerUser',
  CreateLegalUser = 'CreateLegalUser',
  CreateMca = 'CreateMca',
  CreateMerchantUser = 'CreateMerchantUser',
  CreateOffer = 'CreateOffer',
  DeleteApplication = 'DeleteApplication',
  DeleteOffer = 'DeleteOffer',
  EditApplication = 'EditApplication',
  EditMca = 'EditMca',
  EditOffer = 'EditOffer',
  ExpandMcaRow = 'ExpandMcaRow',
  ExportApplicationsReport = 'ExportApplicationsReport',
  ExportMcaExcel = 'ExportMcaExcel',
  ExportTransactionsExcel = 'ExportTransactionsExcel',
  ExportsOffersReport = 'ExportsOffersReport',
  InitMcaUnderwritingChat = 'InitMcaUnderwritingChat',
  IsBroker = 'IsBroker',
  IsCollection = 'IsCollection',
  IsFunder = 'IsFunder',
  IsInvestor = 'IsInvestor',
  IsIsoManager = 'IsIsoManager',
  IsLegal = 'IsLegal',
  IsMerchant = 'IsMerchant',
  IsPreUnderwriter = 'IsPreUnderwriter',
  IsSubmission = 'IsSubmission',
  IsSubmissionAdmin = 'IsSubmissionAdmin',
  IsSuperAdmin = 'IsSuperAdmin',
  IsUnderwriter = 'IsUnderwriter',
  IsUser = 'IsUser',
  ListBrokerCompanies = 'ListBrokerCompanies',
  ListBrokerUser = 'ListBrokerUser',
  ListFunderUser = 'ListFunderUser',
  ListFundingCompanies = 'ListFundingCompanies',
  ListIntegrations = 'ListIntegrations',
  ListInvestorUser = 'ListInvestorUser',
  ListIsoManagerUser = 'ListIsoManagerUser',
  ListLegalCompanies = 'ListLegalCompanies',
  ListMerchantCompanies = 'ListMerchantCompanies',
  ListMerchantUser = 'ListMerchantUser',
  ListSubmissionTeam = 'ListSubmissionTeam',
  ListUnderwriters = 'ListUnderwriters',
  ListUsers = 'ListUsers',
  ManageBrokerCompanies = 'ManageBrokerCompanies',
  ManageFundingCompanies = 'ManageFundingCompanies',
  ManageIntegrations = 'ManageIntegrations',
  ManageLegalCompanies = 'ManageLegalCompanies',
  ManageMcaTransactions = 'ManageMcaTransactions',
  ManageMerchantCompanies = 'ManageMerchantCompanies',
  ManageMerchants = 'ManageMerchants',
  ManagePortfolioConnections = 'ManagePortfolioConnections',
  ManageSyndications = 'ManageSyndications',
  ManageUnderwriters = 'ManageUnderwriters',
  ManageUsers = 'ManageUsers',
  MenageSubmissionTeam = 'MenageSubmissionTeam',
  RequestClearReport = 'RequestClearReport',
  RequestExperianCreditReport = 'RequestExperianCreditReport',
  SendOfferEmail = 'SendOfferEmail',
  UpdateOfferUnderwriter = 'UpdateOfferUnderwriter',
  ViewAllApplications = 'ViewAllApplications',
  ViewAllOffers = 'ViewAllOffers',
  ViewApplicationOffers = 'ViewApplicationOffers',
  ViewCashAdvanceProfile = 'ViewCashAdvanceProfile',
  ViewClearReport = 'ViewClearReport',
  ViewExperianCreditReport = 'ViewExperianCreditReport',
  ViewFeeProfile = 'ViewFeeProfile',
  ViewMcaBalanceWithFees = 'ViewMcaBalanceWithFees',
  ViewMcaBroker = 'ViewMcaBroker',
  ViewMcaCommission = 'ViewMcaCommission',
  ViewMcaDetails = 'ViewMcaDetails',
  ViewMcaExternalServiceNotes = 'ViewMcaExternalServiceNotes',
  ViewMcaFees = 'ViewMcaFees',
  ViewMcaFunder = 'ViewMcaFunder',
  ViewMcaFundingCompany = 'ViewMcaFundingCompany',
  ViewMcaFundingFees = 'ViewMcaFundingFees',
  ViewMcaIsoManager = 'ViewMcaISOManager',
  ViewMcaIntegration = 'ViewMcaIntegration',
  ViewMcaLegal = 'ViewMcaLegal',
  ViewMcaLettersDocx = 'ViewMcaLettersDocx',
  ViewMcaLettersPdf = 'ViewMcaLettersPdf',
  ViewMcaNetWire = 'ViewMcaNetWire',
  ViewMcaPnl = 'ViewMcaPnl',
  ViewMcaTransactions = 'ViewMcaTransactions',
  ViewMcaUnderwriters = 'ViewMcaUnderwriters',
  ViewPerformanceProfile = 'ViewPerformanceProfile',
  ViewRecurrencyAccountNumber = 'ViewRecurrencyAccountNumber',
  ViewSyndications = 'ViewSyndications',
  ViewUnderwriters = 'ViewUnderwriters'
}

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['DateTime']['output'];
  createdBy: User;
  /** Unique role identifier */
  id: Scalars['ID']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy: User;
  name: Scalars['String']['output'];
  rights: Array<Rights>;
};

export type RoleRightsMapping = {
  __typename?: 'RoleRightsMapping';
  rights: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export enum Roles {
  Broker = 'Broker',
  Collections = 'Collections',
  Funder = 'Funder',
  Investor = 'Investor',
  IsoManager = 'IsoManager',
  Legal = 'Legal',
  Merchant = 'Merchant',
  PreUnderwriter = 'PreUnderwriter',
  Submission = 'Submission',
  SubmissionAdmin = 'SubmissionAdmin',
  SuperAdmin = 'SuperAdmin',
  Underwriter = 'Underwriter',
  User = 'User'
}

export type RolesList = {
  __typename?: 'RolesList';
  data: Array<Role>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RoutingNumber = {
  __typename?: 'RoutingNumber';
  location: BankLocation;
  locationId: Scalars['Int']['output'];
  routingNumber: Scalars['String']['output'];
};

export type RoutingNumberAssignment = {
  __typename?: 'RoutingNumberAssignment';
  bankName: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
};

export type SaveBankInput = {
  bankName: Scalars['String']['input'];
  fdic?: InputMaybe<Scalars['String']['input']>;
  logoMediaFile?: InputMaybe<Scalars['String']['input']>;
  newBankName?: InputMaybe<Scalars['String']['input']>;
  web?: InputMaybe<Scalars['String']['input']>;
};

export type SaveBankLocationInput = {
  id: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
};

export type SaveLocationRoutingNumbersInput = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
  routingNumbers: Array<Scalars['String']['input']>;
};

export type SecretAchProc = {
  __typename?: 'SecretAchProc';
  apikey: Scalars['String']['output'];
  customerInfoKey: Scalars['String']['output'];
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SecretAchProcDto = {
  apikey: Scalars['String']['input'];
  customerInfoKey: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SecretClearAchBot = {
  __typename?: 'SecretClearAchBot';
  apikey: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SecretClearAchBotDto = {
  apikey: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SecretDevNull = {
  __typename?: 'SecretDevNull';
  zero?: Maybe<Scalars['String']['output']>;
};

export type SecretGoAch = {
  __typename?: 'SecretGoAch';
  apikey: Scalars['String']['output'];
  vendorName?: Maybe<Scalars['String']['output']>;
};

export type SecretGoAchBot = {
  __typename?: 'SecretGoAchBot';
  originatorAccountId?: Maybe<Scalars['String']['output']>;
  originatorId?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SecretGoAchBotDto = {
  originatorAccountId?: InputMaybe<Scalars['String']['input']>;
  originatorId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SecretGoAchDto = {
  apikey: Scalars['String']['input'];
  vendorName?: InputMaybe<Scalars['String']['input']>;
};

export type SecretLiftoffCard = {
  __typename?: 'SecretLiftoffCard';
  bankAccountId: Scalars['String']['output'];
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type SecretLiftoffCardDto = {
  bankAccountId: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type SendEmailInput = {
  comment: Scalars['String']['input'];
  offerId: Scalars['ID']['input'];
  recipientBCC: Array<Scalars['String']['input']>;
  recipientCC: Array<Scalars['String']['input']>;
  recipients: Array<Scalars['String']['input']>;
};

export type Settings = {
  __typename?: 'Settings';
  colorCode?: Maybe<Scalars['String']['output']>;
  enableRefresh?: Maybe<Scalars['Boolean']['output']>;
  hideFromChart?: Maybe<Scalars['Boolean']['output']>;
  loadTransactionsForLastDays?: Maybe<Scalars['Float']['output']>;
};

export type SortArgs = {
  direction?: Scalars['String']['input'];
  field?: Scalars['String']['input'];
};

export type Stipulation = {
  __typename?: 'Stipulation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SubfolderFileInfo = {
  __typename?: 'SubfolderFileInfo';
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type Syndication = {
  __typename?: 'Syndication';
  amount: Scalars['Float']['output'];
  brkCommissionPercentage: Scalars['Float']['output'];
  calculationType: SyndicationCalculation;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  crmFee: Scalars['Float']['output'];
  /** Unique syndication identifier */
  id: Scalars['ID']['output'];
  isoCommissionPercentage: Scalars['Float']['output'];
  mca?: Maybe<Array<MerchantCashAdvance>>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  orgFeeCommissionPercentage: Scalars['Float']['output'];
  otherFee: Scalars['Float']['output'];
  serviceFeePercentage: Scalars['Float']['output'];
  syndicationPercentage: Scalars['Float']['output'];
  type: SyndicationType;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
  wireFee: Scalars['Float']['output'];
};

export enum SyndicationCalculation {
  Gross = 'GROSS',
  Net = 'NET'
}

export type SyndicationDetailsDto = {
  __typename?: 'SyndicationDetailsDto';
  amount: Scalars['Float']['output'];
  amtPaidClr: Scalars['Float']['output'];
  amtPaidPnd: Scalars['Float']['output'];
  balanceClr: Scalars['Float']['output'];
  balanceClrWFees: Scalars['Float']['output'];
  balancePnd: Scalars['Float']['output'];
  balancePndWFees: Scalars['Float']['output'];
  brkCommissionAmount: Scalars['Float']['output'];
  broker?: Maybe<User>;
  calculationType: SyndicationCalculation;
  completion: Scalars['Float']['output'];
  crmFee: Scalars['Float']['output'];
  externalConnections?: Maybe<Array<MerchantCashAdvanceExternalServiceConnection>>;
  funder?: Maybe<Underwriter>;
  fundingAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  integration: Integration;
  investorId: Scalars['ID']['output'];
  investorName: Scalars['ID']['output'];
  isoCommissionAmount: Scalars['Float']['output'];
  lastPmtDay?: Maybe<Scalars['DateTime']['output']>;
  legal?: Maybe<User>;
  manager?: Maybe<User>;
  mcaEndDate: Scalars['Date']['output'];
  mcaFactorRate: Scalars['Float']['output'];
  mcaFundingDate: Scalars['Date']['output'];
  mcaId: Scalars['ID']['output'];
  mcaLoanAmount: Scalars['Float']['output'];
  mcaNumber: Scalars['Float']['output'];
  mcaPerfEndDate: Scalars['Date']['output'];
  mcaStartDate: Scalars['Date']['output'];
  mcaStatus: MerchantCashAdvanceStatus;
  mcaTerm: Scalars['Float']['output'];
  merchant: Company;
  nrt: Scalars['Float']['output'];
  orgFeeAmount: Scalars['Float']['output'];
  otherFee: Scalars['Float']['output'];
  payback: Scalars['Float']['output'];
  perfTerm: Scalars['Float']['output'];
  pmt: Scalars['Float']['output'];
  serviceFeeAmount: Scalars['Float']['output'];
  serviceFeePercentage: Scalars['Float']['output'];
  syndicationAmtPaidClr: Scalars['Float']['output'];
  syndicationAmtPaidPnd: Scalars['Float']['output'];
  syndicationBalanceClr: Scalars['Float']['output'];
  syndicationBalanceClrWFees: Scalars['Float']['output'];
  syndicationBalancePnd: Scalars['Float']['output'];
  syndicationBalancePndWFees: Scalars['Float']['output'];
  syndicationGrossProfit: Scalars['Float']['output'];
  syndicationNetInvested: Scalars['Float']['output'];
  syndicationNetProfit: Scalars['Float']['output'];
  syndicationNetWire: Scalars['Float']['output'];
  syndicationPayback: Scalars['Float']['output'];
  syndicationPayoff: Scalars['Float']['output'];
  syndicationPercentage: Scalars['Float']['output'];
  syndicationPmt: Scalars['Float']['output'];
  syndicationPnL: Scalars['Float']['output'];
  syndicationPnlGross: Scalars['Float']['output'];
  syndicationPnlNet: Scalars['Float']['output'];
  syndicationType: Scalars['String']['output'];
  type: SyndicationType;
  wireFee: Scalars['Float']['output'];
};

export type SyndicationDetailsList = {
  __typename?: 'SyndicationDetailsList';
  data: Array<SyndicationDetailsDto>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SyndicationDetailsSummaryDto = {
  __typename?: 'SyndicationDetailsSummaryDto';
  SyndicationNetInvested?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amtPaidClr?: Maybe<Scalars['Float']['output']>;
  amtPaidPnd?: Maybe<Scalars['Float']['output']>;
  balanceClr?: Maybe<Scalars['Float']['output']>;
  balancePnd?: Maybe<Scalars['Float']['output']>;
  brkCommissionAmount?: Maybe<Scalars['Float']['output']>;
  completion?: Maybe<Scalars['Float']['output']>;
  crmFee?: Maybe<Scalars['Float']['output']>;
  fundingAmount?: Maybe<Scalars['Float']['output']>;
  isoCommissionAmount?: Maybe<Scalars['Float']['output']>;
  nrt?: Maybe<Scalars['Float']['output']>;
  orgFeeAmount?: Maybe<Scalars['Float']['output']>;
  otherFee?: Maybe<Scalars['Float']['output']>;
  payback?: Maybe<Scalars['Float']['output']>;
  serviceFeeAmount?: Maybe<Scalars['Float']['output']>;
  syndicationAmtPaidClr?: Maybe<Scalars['Float']['output']>;
  syndicationAmtPaidPnd?: Maybe<Scalars['Float']['output']>;
  syndicationBalanceClr?: Maybe<Scalars['Float']['output']>;
  syndicationBalanceClrWFees?: Maybe<Scalars['Float']['output']>;
  syndicationBalancePnd?: Maybe<Scalars['Float']['output']>;
  syndicationBalancePndWFees?: Maybe<Scalars['Float']['output']>;
  syndicationGrossProfit?: Maybe<Scalars['Float']['output']>;
  syndicationNetInvested?: Maybe<Scalars['Float']['output']>;
  syndicationNetProfit?: Maybe<Scalars['Float']['output']>;
  syndicationNetWire?: Maybe<Scalars['Float']['output']>;
  syndicationPayback?: Maybe<Scalars['Float']['output']>;
  syndicationPayoff?: Maybe<Scalars['Float']['output']>;
  syndicationPmt?: Maybe<Scalars['Float']['output']>;
  syndicationPnL?: Maybe<Scalars['Float']['output']>;
  wireFee?: Maybe<Scalars['Float']['output']>;
};

export type SyndicationDto = {
  amount: Scalars['Float']['input'];
  brkCommissionPercentage: Scalars['Float']['input'];
  calculationType: SyndicationCalculation;
  crmFee: Scalars['Float']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isoCommissionPercentage: Scalars['Float']['input'];
  mcaId: Scalars['String']['input'];
  orgFeeCommissionPercentage: Scalars['Float']['input'];
  otherFee: Scalars['Float']['input'];
  serviceFeePercentage: Scalars['Float']['input'];
  type: SyndicationType;
  userId: Scalars['String']['input'];
  wireFee: Scalars['Float']['input'];
};

export enum SyndicationType {
  Broker = 'BROKER',
  DirectRenewal = 'DIRECT_RENEWAL',
  Funder = 'FUNDER',
  PassiveInvestor = 'PASSIVE_INVESTOR'
}

export type TodaysCollectionDto = {
  __typename?: 'TodaysCollectionDto';
  date: Scalars['String']['output'];
  series: Array<TodaysCollectionSeriesItem>;
};

export type TodaysCollectionSeriesItem = {
  __typename?: 'TodaysCollectionSeriesItem';
  amount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  account: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  assignedToUser?: Maybe<User>;
  assignedToUserId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  depositDate?: Maybe<Scalars['Date']['output']>;
  effectiveDate?: Maybe<Scalars['Date']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  /** Unique transaction identifier */
  id: Scalars['ID']['output'];
  integration?: Maybe<Integration>;
  mca?: Maybe<MerchantCashAdvance>;
  modifiedAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
  originationDate?: Maybe<Scalars['Date']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  recurrenceDescription?: Maybe<Scalars['String']['output']>;
  recurrency?: Maybe<Recurrency>;
  returnCode?: Maybe<Scalars['String']['output']>;
  returnDate?: Maybe<Scalars['Date']['output']>;
  status: TransactionStatus;
  statusChangedAt: Scalars['DateTime']['output'];
  statusChangedBy?: Maybe<User>;
  to: Scalars['String']['output'];
  type: TransactionType;
};

export enum TransactionStatus {
  Cancelled = 'CANCELLED',
  Cleared = 'CLEARED',
  Deleted = 'DELETED',
  Nsf = 'NSF',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Returned = 'RETURNED'
}

export enum TransactionType {
  AchProgramFee = 'ACH_PROGRAM_FEE',
  Collection = 'COLLECTION',
  Credit = 'CREDIT',
  CrmAccessFee = 'CRM_ACCESS_FEE',
  Debit = 'DEBIT',
  DefaultFee = 'DEFAULT_FEE',
  Expense = 'EXPENSE',
  FundingWallet = 'FUNDING_WALLET',
  NsfFee = 'NSF_FEE',
  OtherFee = 'OTHER_FEE',
  Refund = 'REFUND',
  Remittance = 'REMITTANCE',
  RemittanceFee = 'REMITTANCE_FEE',
  ServiceFee = 'SERVICE_FEE',
  Syndication = 'SYNDICATION'
}

export type TransactionsList = {
  __typename?: 'TransactionsList';
  data: Array<Transaction>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TransactionsSummaryDto = {
  __typename?: 'TransactionsSummaryDto';
  amount: Scalars['Float']['output'];
};

export type Underwriter = {
  __typename?: 'Underwriter';
  code?: Maybe<Scalars['String']['output']>;
  connectedUsers?: Maybe<Array<UserFunderConnections>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Unique underwriter identifier */
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UnderwriterDto = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  logoMediaFile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UnderwriterMemberInfo = {
  __typename?: 'UnderwriterMemberInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  bizPhone?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type UnderwritersList = {
  __typename?: 'UnderwritersList';
  data: Array<Underwriter>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type UpdateApplicationInput = {
  brokerId?: InputMaybe<Scalars['String']['input']>;
  funderId?: InputMaybe<Scalars['String']['input']>;
  fundingAmount?: InputMaybe<Scalars['Float']['input']>;
  linkToFiles?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  merchantBizEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantBizPhones?: InputMaybe<Array<Scalars['String']['input']>>;
  merchantBizWeb?: InputMaybe<Scalars['String']['input']>;
  merchantCompanyDba?: InputMaybe<Scalars['String']['input']>;
  merchantCompanyLegalName?: InputMaybe<Scalars['String']['input']>;
  merchantTaxId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offerDate?: InputMaybe<Scalars['DateTime']['input']>;
  owners?: InputMaybe<Array<UserDataDto>>;
  processorId?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOfferInput = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  brokerId?: InputMaybe<Scalars['String']['input']>;
  commissions?: InputMaybe<Array<OfferFeeCommissionInput>>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  factorRate?: InputMaybe<Scalars['Float']['input']>;
  funderId?: InputMaybe<Scalars['String']['input']>;
  fundingAmount?: InputMaybe<Scalars['Float']['input']>;
  fundingFees?: InputMaybe<Array<OfferFeeCommissionInput>>;
  integrationId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  lineOrder?: InputMaybe<Scalars['Float']['input']>;
  linkToFiles?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  offerDate?: InputMaybe<Scalars['Date']['input']>;
  rehabGroupId?: InputMaybe<Scalars['String']['input']>;
  rehabLineTitle?: InputMaybe<Scalars['String']['input']>;
  secondaryFunderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  stipulations?: InputMaybe<Array<Scalars['String']['input']>>;
  term?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<OfferType>;
};

export type UpdatePermissionInput = {
  area: ProductArea;
  description?: InputMaybe<Scalars['String']['input']>;
  mcaDynamicRoles?: InputMaybe<Array<McaDynamicRole>>;
  roles?: InputMaybe<Array<Roles>>;
};

export type UpdateStipulationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  accessTokenTtlHours: Scalars['Float']['output'];
  balance?: Maybe<Scalars['Float']['output']>;
  bankAccounts?: Maybe<Array<UserBankAccount>>;
  cognitoSub?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  data?: Maybe<UserData>;
  deviceRememberingDays: Scalars['Float']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enableReturnedTransactionsReport: Scalars['Boolean']['output'];
  firstTransactionDate?: Maybe<Scalars['DateTime']['output']>;
  funderConnectedTo?: Maybe<Array<UserFunderConnections>>;
  fundingWallet?: Maybe<Scalars['Float']['output']>;
  gridPreferences?: Maybe<Array<UserGridPreferences>>;
  /** Unique client identifier */
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isEmailConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isLoginEnabled?: Maybe<Scalars['Boolean']['output']>;
  isOwner: Scalars['Boolean']['output'];
  isPhoneConfirmed?: Maybe<Scalars['Boolean']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<User>;
  mfaConfigured: Scalars['Boolean']['output'];
  mfaDeviceRememberingEnabled: Scalars['Boolean']['output'];
  mfaEnabled: Scalars['Boolean']['output'];
  modifiedAt: Scalars['DateTime']['output'];
  modifiedBy?: Maybe<User>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pnl?: Maybe<Scalars['Float']['output']>;
  portfolioConnectedTo?: Maybe<Array<UserPortfolioConnections>>;
  portfolioConnections?: Maybe<Array<UserPortfolioConnections>>;
  preferences?: Maybe<UserPreferences>;
  remittance?: Maybe<Scalars['Float']['output']>;
  remittanceFee?: Maybe<Scalars['Float']['output']>;
  rights?: Maybe<Array<Rights>>;
  role?: Maybe<Array<Roles>>;
  syndications?: Maybe<Array<Syndication>>;
};

export type UserBankAccount = {
  __typename?: 'UserBankAccount';
  accountNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Unique user bank account identifier */
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  routingNumber?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type UserData = {
  __typename?: 'UserData';
  address?: Maybe<Address>;
  avatar?: Maybe<Scalars['String']['output']>;
  bizEmail?: Maybe<Scalars['String']['output']>;
  bizPhone?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
};

export type UserDataDto = {
  address?: InputMaybe<AddressDto>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  bizEmail?: InputMaybe<Scalars['String']['input']>;
  bizPhone?: InputMaybe<Scalars['String']['input']>;
  cellPhone?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type UserDto = {
  avatarMediaFile?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<UserDataDto>;
  email: Scalars['String']['input'];
  enableReturnedTransactionsReport?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rights?: InputMaybe<Array<Rights>>;
  role?: InputMaybe<Array<Roles>>;
};

export type UserFunderConnections = {
  __typename?: 'UserFunderConnections';
  funder?: Maybe<Underwriter>;
  user?: Maybe<User>;
};

export type UserGridPreferences = {
  __typename?: 'UserGridPreferences';
  active: Scalars['Boolean']['output'];
  columnsState: Scalars['String']['output'];
  filterState: Scalars['String']['output'];
  key: GridType;
  name: Scalars['String']['output'];
  rowsPerPage?: Maybe<Scalars['Float']['output']>;
  useScroll?: Maybe<Scalars['Boolean']['output']>;
};

export type UserGridPreferencesDto = {
  active: Scalars['Boolean']['input'];
  columnsState: Scalars['String']['input'];
  filterState: Scalars['String']['input'];
  key: GridType;
  keyName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  rowsPerPage?: InputMaybe<Scalars['Float']['input']>;
  useScroll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPortfolioConnections = {
  __typename?: 'UserPortfolioConnections';
  sourceUser?: Maybe<User>;
  targetUser?: Maybe<User>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  hidePerformanceChart: Scalars['Boolean']['output'];
  showTrailingZeros: Scalars['Boolean']['output'];
};

export type UserPreferencesDto = {
  gridPreferences?: InputMaybe<Array<UserGridPreferencesDto>>;
  preferences?: InputMaybe<PreferencesDto>;
};

export type UsersList = {
  __typename?: 'UsersList';
  data: Array<User>;
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ApplicationStatusHistoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ApplicationStatusHistoryQuery = { __typename?: 'Query', applicationStatusHistory: Array<{ __typename?: 'ApplicationStatusHistory', createdAt: any, fromStatus: { __typename?: 'ApplicationStatus', id: string }, toStatus: { __typename?: 'ApplicationStatus', id: string }, user?: { __typename?: 'User', data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> };

export type CreateApplicationMutationVariables = Exact<{
  createApplicationInput: CreateApplicationInput;
}>;


export type CreateApplicationMutation = { __typename?: 'Mutation', createApplication: { __typename?: 'Application', id: string } };

export type UpdateApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateApplicationInput: UpdateApplicationInput;
}>;


export type UpdateApplicationMutation = { __typename?: 'Mutation', updateApplication: { __typename?: 'Application', id: string } };

export type DeleteApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteApplicationMutation = { __typename?: 'Mutation', deleteApplication: boolean };

export type CountApplicationOfferStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountApplicationOfferStatsQuery = { __typename?: 'Query', countApplicationOfferStats: { __typename?: 'OfferApplicationsCount', countOfferApplications: number, countTodayOfferSentApplications: number } };

export type GetApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetApplicationQuery = { __typename?: 'Query', getApplication: { __typename?: 'Application', id: string, number: number, currentUserRights: Array<Rights>, fundingAmount?: number | null, term?: number | null, totalOffers: number, linkToFiles?: string | null, merchantCompanyLegalName?: string | null, merchantBizEmails?: Array<string> | null, merchantCompanyDba?: string | null, merchantBizPhones?: Array<string> | null, merchantBizWeb?: string | null, merchantTaxId?: string | null, notes?: string | null, offerDate: any, createdAt: any, updatedAt?: any | null, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null, processor?: { __typename?: 'ApplicationProcessor', id: string, name: string, logo?: string | null, order: number } | null, owners?: Array<{ __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, funder?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, offers?: Array<{ __typename?: 'Offer', id: string, number?: number | null, type: OfferType, rehabLineTitle?: string | null, rehabGroupId?: string | null, lineOrder?: number | null, term?: number | null, offerDate: any, fundingAmount?: number | null, factorRate: number, createdAt: any, manager?: { __typename?: 'User', id: string } | null }> | null } };

export type ApplicationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type ApplicationsQuery = { __typename?: 'Query', applications: { __typename?: 'ApplicationList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Application', id: string, number: number, currentUserRights: Array<Rights>, fundingAmount?: number | null, term?: number | null, totalOffers: number, merchantCompanyLegalName?: string | null, merchantCompanyDba?: string | null, merchantBizWeb?: string | null, merchantBizEmails?: Array<string> | null, merchantTaxId?: string | null, merchantBizPhones?: Array<string> | null, notes?: string | null, linkToFiles?: string | null, offerDate: any, createdAt: any, updatedAt?: any | null, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null, processor?: { __typename?: 'ApplicationProcessor', id: string, name: string, logo?: string | null, order: number } | null, owners?: Array<{ __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, funder?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, offers?: Array<{ __typename?: 'Offer', id: string, number?: number | null, type: OfferType, rehabLineTitle?: string | null, rehabGroupId?: string | null, lineOrder?: number | null, term?: number | null, offerDate: any, fundingAmount?: number | null, factorRate: number }> | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null }> } };

export type ApplicationStatusListQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationStatusListQuery = { __typename?: 'Query', applicationStatusList: Array<{ __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null, order: number }> };

export type OfferStatusListQueryVariables = Exact<{ [key: string]: never; }>;


export type OfferStatusListQuery = { __typename?: 'Query', offerStatusList: Array<{ __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null, order: number }> };

export type ChangeApplicationStatusMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  statusId: Scalars['String']['input'];
}>;


export type ChangeApplicationStatusMutation = { __typename?: 'Mutation', changeApplicationStatus: { __typename?: 'Application', id: string } };

export type ApplicationsWithSelectedOffersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  applicationStatuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  funderIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type ApplicationsWithSelectedOffersQuery = { __typename?: 'Query', applicationsWithSelectedOffers: { __typename?: 'ApplicationWithOfferList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'ApplicationWithOffer', application: { __typename?: 'Application', id: string, number: number, currentUserRights: Array<Rights>, fundingAmount?: number | null, term?: number | null, totalOffers: number, merchantCompanyLegalName?: string | null, merchantCompanyDba?: string | null, merchantBizWeb?: string | null, merchantBizEmails?: Array<string> | null, merchantTaxId?: string | null, merchantBizPhones?: Array<string> | null, notes?: string | null, offerDate: any, createdAt: any, updatedAt?: any | null, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null, latestStatusHistory?: { __typename?: 'ApplicationStatusHistory', createdAt: any, fromStatus: { __typename?: 'ApplicationStatus', id: string }, toStatus: { __typename?: 'ApplicationStatus', id: string, description?: string | null }, user?: { __typename?: 'User', data?: { __typename?: 'UserData', firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, processor?: { __typename?: 'ApplicationProcessor', id: string, name: string, logo?: string | null, order: number } | null, owners?: Array<{ __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, funder?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null }, offer?: { __typename?: 'Offer', id: string, number?: number | null, currentUserRights: Array<Rights>, type: OfferType, fundingAmount?: number | null, factorRate: number, term?: number | null, offerDate: any, rehabGroupId?: string | null, rehabLineTitle?: string | null, lineOrder?: number | null, notes?: string | null, stipulations?: Array<string> | null, isSelected?: boolean | null, isActive?: boolean | null, createdAt: any, updatedAt?: any | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, linkToFilesData?: { __typename?: 'OffersLinkToFiles', linkToFiles?: string | null } | null } | null }> } };

export type ApplicationProcessorListQueryVariables = Exact<{ [key: string]: never; }>;


export type ApplicationProcessorListQuery = { __typename?: 'Query', applicationProcessorList: Array<{ __typename?: 'ApplicationProcessor', id: string, name: string, logo?: string | null, order: number }> };

export type ApplicationsForMerchantQueryVariables = Exact<{
  merchantLegalName: Scalars['String']['input'];
}>;


export type ApplicationsForMerchantQuery = { __typename?: 'Query', applicationsForMerchant: Array<{ __typename?: 'Application', id: string, number: number, offerDate: any, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null, offers?: Array<{ __typename?: 'Offer', id: string, mcaId?: string | null, isActive?: boolean | null, isSelected?: boolean | null, offerDate: any, fundingAmount?: number | null, factorRate: number, term?: number | null, rehabGroupId?: string | null, lineOrder?: number | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, integration?: { __typename?: 'Integration', id: string, name: string, type: IntegrationType, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null, email?: Array<string> | null, phone?: Array<string> | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, mca?: { __typename?: 'MerchantCashAdvance', number: number } | null }> | null }> };

export type AuditLogsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs: { __typename?: 'AuditLogList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'AuditEvent', type: string, description?: string | null, ipAddress?: string | null, payload?: any | null, createdAt: any, user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, role?: Array<Roles> | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, mca?: { __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus } | null, application?: { __typename?: 'Application', id: string, number: number, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null } | null }> } };

export type BankByRoutingNumberQueryVariables = Exact<{
  routingNumber: Scalars['String']['input'];
}>;


export type BankByRoutingNumberQuery = { __typename?: 'Query', bankByRoutingNumber?: { __typename?: 'BankInfoByRoutingNumber', bankName: string, logo?: string | null, locationName: string } | null };

export type BanksQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type BanksQuery = { __typename?: 'Query', banks: { __typename?: 'BankList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'BankInfo', bankName: string, logo?: string | null, web?: string | null, fdic?: string | null, locations?: Array<{ __typename?: 'BankLocation', id: number, locationName: string, routingNumbers?: Array<{ __typename?: 'RoutingNumber', routingNumber: string }> | null }> | null }> } };

export type BankQueryVariables = Exact<{
  bankName: Scalars['String']['input'];
}>;


export type BankQuery = { __typename?: 'Query', bank?: { __typename?: 'BankInfo', bankName: string, logo?: string | null, web?: string | null, fdic?: string | null, locations?: Array<{ __typename?: 'BankLocation', id: number, locationName: string, routingNumbers?: Array<{ __typename?: 'RoutingNumber', routingNumber: string }> | null }> | null } | null };

export type SaveBankMutationVariables = Exact<{
  input: SaveBankInput;
}>;


export type SaveBankMutation = { __typename?: 'Mutation', saveBank: { __typename?: 'BankInfo', bankName: string, logo?: string | null, web?: string | null, fdic?: string | null } };

export type SaveBankLocationMutationVariables = Exact<{
  input: SaveBankLocationInput;
}>;


export type SaveBankLocationMutation = { __typename?: 'Mutation', saveBankLocation: { __typename?: 'BankLocation', id: number, locationName: string, routingNumbers?: Array<{ __typename?: 'RoutingNumber', routingNumber: string }> | null } };

export type SaveLocationRoutingNumbersMutationVariables = Exact<{
  input: SaveLocationRoutingNumbersInput;
}>;


export type SaveLocationRoutingNumbersMutation = { __typename?: 'Mutation', saveLocationRoutingNumbers: { __typename?: 'BankLocation', id: number, locationName: string, routingNumbers?: Array<{ __typename?: 'RoutingNumber', routingNumber: string }> | null } };

export type AddBankLocationMutationVariables = Exact<{
  input: AddBankLocationInput;
}>;


export type AddBankLocationMutation = { __typename?: 'Mutation', addBankLocation: { __typename?: 'BankLocation', id: number, locationName: string, routingNumbers?: Array<{ __typename?: 'RoutingNumber', routingNumber: string }> | null } };

export type DeleteBankLocationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBankLocationMutation = { __typename?: 'Mutation', deleteBankLocation: number };

export type CheckDuplicateRoutingNumbersQueryVariables = Exact<{
  routingNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  excludeLocationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CheckDuplicateRoutingNumbersQuery = { __typename?: 'Query', checkDuplicateRoutingNumbers: Array<{ __typename?: 'RoutingNumberAssignment', routingNumber: string, locationId: number, locationName: string, bankName: string }> };

export type DeleteBankMutationVariables = Exact<{
  bankName: Scalars['String']['input'];
}>;


export type DeleteBankMutation = { __typename?: 'Mutation', deleteBank: string };

export type NonWorkingDaysQueryVariables = Exact<{ [key: string]: never; }>;


export type NonWorkingDaysQuery = { __typename?: 'Query', nonWorkingDays: Array<{ __typename?: 'NonWorkingDay', date: any, description: string }> };

export type SaveCommissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  commission: CommissionDto;
}>;


export type SaveCommissionMutation = { __typename?: 'Mutation', saveCommission: { __typename?: 'Commission', id: string } };

export type SaveCommissionsMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  commissions: Array<CommissionDto> | CommissionDto;
}>;


export type SaveCommissionsMutation = { __typename?: 'Mutation', saveCommissions: Array<{ __typename?: 'Commission', id: string }> };

export type DeleteCommissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
}>;


export type DeleteCommissionMutation = { __typename?: 'Mutation', deleteCommission: string };

export type CommissionsForMcaQueryVariables = Exact<{
  mcaId: Scalars['ID']['input'];
}>;


export type CommissionsForMcaQuery = { __typename?: 'Query', commissionsForMca: Array<{ __typename?: 'Commission', id: string, comment: string, amount: number, createdAt: any, modifiedAt: any, isPaid: boolean, paidOn?: any | null, notes?: string | null, config?: { __typename?: 'ConfigFee', name: ConfigFeeName, id: string } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, role?: Array<Roles> | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> };

export type InternalCompaniesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type InternalCompaniesQuery = { __typename?: 'Query', internalCompanies: { __typename?: 'InternalCompaniesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, phone?: string | null, email?: string | null, taxId?: string | null, logo?: string | null, signature?: string | null, createdAt: any, modifiedAt: any, isDefault: boolean, createdBy?: { __typename?: 'User', id: string, name?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type InternalCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalCompanyQuery = { __typename?: 'Query', internalCompany: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, phone?: string | null, email?: string | null, taxId?: string | null, logo?: string | null, signature?: string | null, isDefault: boolean } };

export type SaveInternalCompanyMutationVariables = Exact<{
  dto: InternalCompanyDto;
}>;


export type SaveInternalCompanyMutation = { __typename?: 'Mutation', saveInternalCompany: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, phone?: string | null, email?: string | null, taxId?: string | null, logo?: string | null, signature?: string | null } };

export type DeleteInternalCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInternalCompanyMutation = { __typename?: 'Mutation', deleteInternalCompany: string };

export type SetDefaultCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type SetDefaultCompanyMutation = { __typename?: 'Mutation', setDefaultCompany: string };

export type MerchantsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type MerchantsQuery = { __typename?: 'Query', merchants: { __typename?: 'CompaniesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, logo?: string | null, createdAt?: any | null, modifiedAt?: any | null, linkToFiles?: string | null, createdBy?: { __typename?: 'User', id: string, name?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null, mcas?: Array<{ __typename?: 'MerchantCashAdvance', id: string, number: number }> | null, bankAccounts?: Array<{ __typename?: 'MerchantBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null }> | null }> } };

export type AllCompaniesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<CompanyType> | CompanyType>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type AllCompaniesQuery = { __typename?: 'Query', allCompanies: { __typename?: 'CompaniesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, logo?: string | null, createdAt?: any | null, modifiedAt?: any | null, type?: Array<CompanyType> | null, www?: string | null, linkToFiles?: string | null, totalUsers?: number | null, createdBy?: { __typename?: 'User', id: string, name?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null, mcas?: Array<{ __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus, merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null } }> | null, bankAccounts?: Array<{ __typename?: 'MerchantBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null }> | null }> } };

export type IsCompanyAddedQueryVariables = Exact<{
  legalName: Scalars['String']['input'];
}>;


export type IsCompanyAddedQuery = { __typename?: 'Query', isCompanyAdded: boolean };

export type IsInternalCompanyAddedQueryVariables = Exact<{
  legalName: Scalars['String']['input'];
}>;


export type IsInternalCompanyAddedQuery = { __typename?: 'Query', isInternalCompanyAdded: boolean };

export type MerchantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantQuery = { __typename?: 'Query', merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, logo?: string | null, linkToFiles?: string | null, mcas?: Array<{ __typename?: 'MerchantCashAdvance', id: string, number: number }> | null, bankAccounts?: Array<{ __typename?: 'MerchantBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null }> | null } };

export type SaveMerchantMutationVariables = Exact<{
  dto: MerchantDto;
}>;


export type SaveMerchantMutation = { __typename?: 'Mutation', saveMerchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, linkToFiles?: string | null, logo?: string | null, www?: string | null } };

export type SaveCompanyMutationVariables = Exact<{
  dto: CompanyDto;
}>;


export type SaveCompanyMutation = { __typename?: 'Mutation', saveCompany: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, logo?: string | null, linkToFiles?: string | null, type?: Array<CompanyType> | null, www?: string | null } };

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: string };

export type DeleteMerchantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMerchantMutation = { __typename?: 'Mutation', deleteMerchant: string };

export type BrokersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type BrokersQuery = { __typename?: 'Query', brokers: { __typename?: 'CompaniesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, logo?: string | null, createdAt?: any | null, modifiedAt?: any | null, linkToFiles?: string | null, createdBy?: { __typename?: 'User', id: string, name?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null, mcas?: Array<{ __typename?: 'MerchantCashAdvance', id: string, number: number }> | null, bankAccounts?: Array<{ __typename?: 'MerchantBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null }> | null }> } };

export type SaveBrokerMutationVariables = Exact<{
  dto: BrokerDto;
}>;


export type SaveBrokerMutation = { __typename?: 'Mutation', saveBroker: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, logo?: string | null, linkToFiles?: string | null, www?: string | null } };

export type InternalCompanyDocumentsInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalCompanyDocumentsInfoQuery = { __typename?: 'Query', internalCompany: { __typename?: 'InternalCompany', id: string, legalName?: string | null, documentsInfo: { __typename?: 'InternalCompanyDocumentsInfo', companyFolderConnected: boolean, companyFolderId?: string | null, subfolderId?: string | null, subfolderDocuments: Array<{ __typename?: 'CompanyDocumentDto', id: string }>, subfolderFiles: Array<{ __typename?: 'SubfolderFileInfo', id: string, fileName: string }> } } };

export type ConfigFeesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigFeesQuery = { __typename?: 'Query', configFees: { __typename?: 'ConfigFeesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'ConfigFee', id: string, name: ConfigFeeName, defaultComment?: string | null, defaultAmount?: number | null, isPostFunding: boolean, isPercentage: boolean, isPreFunding: boolean, isCommission: boolean, rank?: number | null, createdAt: any, modifiedAt: any, createdBy: { __typename?: 'User', id: string, name?: string | null }, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type ConfigFeeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfigFeeQuery = { __typename?: 'Query', configFee: { __typename?: 'ConfigFee', id: string, name: ConfigFeeName, defaultComment?: string | null, defaultAmount?: number | null, isPostFunding: boolean, isPercentage: boolean, isPreFunding: boolean, isCommission: boolean, rank?: number | null } };

export type SaveConfigFeeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  dto: ConfigFeeDto;
}>;


export type SaveConfigFeeMutation = { __typename?: 'Mutation', saveConfigFee: { __typename?: 'ConfigFee', id: string } };

export type DeleteConfigFeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteConfigFeeMutation = { __typename?: 'Mutation', deleteConfigFee?: number | null };

export type SaveExternalServiceConfigurationMutationVariables = Exact<{
  dto: ExternalServiceInputDto;
}>;


export type SaveExternalServiceConfigurationMutation = { __typename?: 'Mutation', saveExternalServiceConfiguration: { __typename?: 'ExternalServiceDto', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, configurationSchema: any, dataSchema: any, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } };

export type DeleteExternalServiceConfigurationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteExternalServiceConfigurationMutation = { __typename?: 'Mutation', deleteExternalServiceConfiguration: string };

export type IsExisitingExternalServiceQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type IsExisitingExternalServiceQuery = { __typename?: 'Query', isExisitingExternalService: boolean };

export type GetAllExternalServiceSecretSchemaDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExternalServiceSecretSchemaDefinitionsQuery = { __typename?: 'Query', getAllExternalServiceSecretSchemaDefinitions: any };

export type GetAllExternalServiceLogosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllExternalServiceLogosQuery = { __typename?: 'Query', getAllExternalServiceLogos: any };

export type ActiveExternalServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveExternalServicesQuery = { __typename?: 'Query', activeExternalServices: Array<{ __typename?: 'ExternalServiceDto', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, configurationSchema: any, dataSchema: any, secret: any, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null }> };

export type MerchantCashAdvanceExternalServiceConnectionsQueryVariables = Exact<{
  mcaId: Scalars['ID']['input'];
}>;


export type MerchantCashAdvanceExternalServiceConnectionsQuery = { __typename?: 'Query', merchantCashAdvanceExternalServiceConnections: Array<{ __typename?: 'MerchantCashAdvanceExternalServiceConnectionDto', id?: string | null, mcaId: string, externalServiceConfigurationId: string, configuration: any, isActive: boolean, createdAt?: any | null, modifiedAt?: any | null, fetchedAt?: any | null, externalServiceConfiguration?: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, configurationSchema: any, dataSchema: any, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null }> };

export type SaveMerchantCashAdvanceExternalServiceConnectionMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  externalServiceConfigurationId: Scalars['ID']['input'];
  configuration: Scalars['JSON']['input'];
}>;


export type SaveMerchantCashAdvanceExternalServiceConnectionMutation = { __typename?: 'Mutation', saveMerchantCashAdvanceExternalServiceConnection: { __typename?: 'MerchantCashAdvanceExternalServiceConnectionDto', id?: string | null, mcaId: string, externalServiceConfigurationId: string, configuration: any, isActive: boolean, createdAt?: any | null, modifiedAt?: any | null, fetchedAt?: any | null, externalServiceConfiguration?: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, configurationSchema: any, dataSchema: any, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null } };

export type UpdateMerchantCashAdvanceExternalServiceConnectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  configuration: Scalars['JSON']['input'];
}>;


export type UpdateMerchantCashAdvanceExternalServiceConnectionMutation = { __typename?: 'Mutation', updateMerchantCashAdvanceExternalServiceConnection?: { __typename?: 'MerchantCashAdvanceExternalServiceConnectionDto', id?: string | null, mcaId: string, externalServiceConfigurationId: string, configuration: any, isActive: boolean, createdAt?: any | null, modifiedAt?: any | null, fetchedAt?: any | null, externalServiceConfiguration?: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, configurationSchema: any, dataSchema: any, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null } | null };

export type DeleteMerchantCashAdvanceExternalServiceConnectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMerchantCashAdvanceExternalServiceConnectionMutation = { __typename?: 'Mutation', deleteMerchantCashAdvanceExternalServiceConnection: boolean };

export type MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables = Exact<{
  connectionId: Scalars['ID']['input'];
}>;


export type MerchantCashAdvanceExternalServiceDataByConnectionQuery = { __typename?: 'Query', merchantCashAdvanceExternalServiceDataByConnection: Array<{ __typename?: 'MerchantCashAdvanceExternalServiceDataDto', id?: string | null, connectionId: string, data: any, externalId?: string | null }> };

export type SyncMerchantCashAdvanceExternalServiceConnectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncMerchantCashAdvanceExternalServiceConnectionMutation = { __typename?: 'Mutation', syncMerchantCashAdvanceExternalServiceConnection: boolean };

export type AvailableExternalServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableExternalServicesQuery = { __typename?: 'Query', availableExternalServices: Array<ExternalServiceType> };

export type ApplicationExternalServiceConnectionsQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type ApplicationExternalServiceConnectionsQuery = { __typename?: 'Query', applicationExternalServiceConnections: Array<{ __typename?: 'ApplicationExternalServiceConnectionDto', id?: string | null, applicationId: string, externalServiceConfigurationId: string, configuration: any, isActive: boolean, createdAt?: any | null, modifiedAt?: any | null, fetchedAt?: any | null, externalServiceConfiguration?: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, configurationSchema: any, dataSchema: any, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null }> };

export type SaveApplicationExternalServiceConnectionMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  externalServiceConfigurationId: Scalars['ID']['input'];
  configuration: Scalars['JSON']['input'];
}>;


export type SaveApplicationExternalServiceConnectionMutation = { __typename?: 'Mutation', saveApplicationExternalServiceConnection: { __typename?: 'ApplicationExternalServiceConnectionDto', id?: string | null, applicationId: string, externalServiceConfigurationId: string, configuration: any, isActive: boolean } };

export type ApplicationExternalServiceDataByApplicationQueryVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type ApplicationExternalServiceDataByApplicationQuery = { __typename?: 'Query', applicationExternalServiceDataByApplication: Array<{ __typename?: 'ApplicationExternalServiceDataDto', id?: string | null, connectionId: string, searchParamsHash: string, searchParams: any, externalId?: string | null, data: any, validUntil: any, createdAt?: any | null, modifiedAt?: any | null, isCacheValid: boolean, downloadCount?: number | null, connection?: { __typename?: 'ApplicationExternalServiceConnectionDto', id?: string | null, applicationId: string, externalServiceConfigurationId: string, externalServiceConfiguration?: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, logo?: string | null } | null } | null }> };

export type PullExperianCreditReportMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  externalServiceConfigurationId: Scalars['ID']['input'];
  consumerPii: ConsumerPiiInputDto;
}>;


export type PullExperianCreditReportMutation = { __typename?: 'Mutation', pullExperianCreditReport: { __typename?: 'PullCreditReportResultDto', success: boolean, fromCache: boolean, errors?: Array<string> | null, data?: { __typename?: 'ApplicationExternalServiceDataDto', id?: string | null, connectionId: string, searchParamsHash: string, searchParams: any, externalId?: string | null, data: any, validUntil: any, createdAt?: any | null, isCacheValid: boolean } | null } };

export type ExperianExternalServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExperianExternalServicesQuery = { __typename?: 'Query', activeExternalServices: Array<{ __typename?: 'ExternalServiceDto', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null }> };

export type PullClearPersonReportMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  externalServiceConfigurationId: Scalars['ID']['input'];
  consumerPii: ConsumerPiiInputDto;
}>;


export type PullClearPersonReportMutation = { __typename?: 'Mutation', pullClearPersonReport: { __typename?: 'PullCreditReportResultDto', success: boolean, fromCache: boolean, errors?: Array<string> | null, data?: { __typename?: 'ApplicationExternalServiceDataDto', id?: string | null, connectionId: string, searchParamsHash: string, searchParams: any, externalId?: string | null, data: any, validUntil: any, createdAt?: any | null, isCacheValid: boolean } | null } };

export type ClearExternalServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClearExternalServicesQuery = { __typename?: 'Query', activeExternalServices: Array<{ __typename?: 'ExternalServiceDto', id: string, name: string, type: ExternalServiceType, description?: string | null, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null }> };

export type SaveFeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  fee: FeeDto;
}>;


export type SaveFeeMutation = { __typename?: 'Mutation', saveFee: { __typename?: 'FundingFee', id: string } };

export type SaveFeesMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  fees: Array<FeeDto> | FeeDto;
}>;


export type SaveFeesMutation = { __typename?: 'Mutation', saveFees: Array<{ __typename?: 'FundingFee', id: string }> };

export type DeleteFeeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
}>;


export type DeleteFeeMutation = { __typename?: 'Mutation', deleteFee: string };

export type FinesByMcaIdQueryVariables = Exact<{
  mcaId: Scalars['ID']['input'];
}>;


export type FinesByMcaIdQuery = { __typename?: 'Query', finesByMcaId: Array<{ __typename?: 'PostFundingFee', id: string, comment: string, amount: number, status?: FineStatus | null, transactionId: string, createdAt: any, modifiedAt: any, config?: { __typename?: 'ConfigFee', name: ConfigFeeName, id: string } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, role?: Array<Roles> | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> };

export type SaveFineMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  fine: FineDto;
}>;


export type SaveFineMutation = { __typename?: 'Mutation', saveFine: { __typename?: 'PostFundingFee', id: string } };

export type SaveFinesMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  fines: Array<FineDto> | FineDto;
}>;


export type SaveFinesMutation = { __typename?: 'Mutation', saveFines: Array<{ __typename?: 'PostFundingFee', id: string }> };

export type DeleteFineMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
}>;


export type DeleteFineMutation = { __typename?: 'Mutation', deleteFine: string };

export type IntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsQuery = { __typename?: 'Query', integrations: { __typename?: 'IntegrationsList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Integration', id: string, name: string, type: IntegrationType, environment: IntegrationEnvironment, description?: string | null, schedule: string, autostart: boolean, logo?: string | null, createdAt: any, modifiedAt: any, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, secret: { __typename?: 'SecretAchProc', apikey: string, username: string, password: string, customerInfoKey: string } | { __typename?: 'SecretClearAchBot', apikey: string, username: string, password: string, companyId: string } | { __typename?: 'SecretDevNull', zero?: string | null } | { __typename?: 'SecretGoAch', apikey: string, vendorName?: string | null } | { __typename?: 'SecretGoAchBot', username: string, password: string, originatorId?: string | null, originatorAccountId?: string | null } | { __typename?: 'SecretLiftoffCard', bankAccountId: string, username: string, password: string }, settings: { __typename?: 'Settings', loadTransactionsForLastDays?: number | null, colorCode?: string | null, hideFromChart?: boolean | null, enableRefresh?: boolean | null }, lastRefreshResult?: { __typename?: 'IntegrationHealthMonitor', lastImportedTransactionsDate: string, lastImportedTransactionsStats: { __typename?: 'ImportedStatsDto', imported: number, deleted: number, updated: number, inserted: number } } | null, createdBy: { __typename?: 'User', id: string, name?: string | null }, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type IntegrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IntegrationQuery = { __typename?: 'Query', integration: { __typename?: 'Integration', id: string, name: string, type: IntegrationType, environment: IntegrationEnvironment, description?: string | null, schedule: string, autostart: boolean, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, secret: { __typename?: 'SecretAchProc', apikey: string, username: string, password: string, customerInfoKey: string } | { __typename?: 'SecretClearAchBot', apikey: string, username: string, password: string, companyId: string } | { __typename?: 'SecretDevNull', zero?: string | null } | { __typename?: 'SecretGoAch', apikey: string, vendorName?: string | null } | { __typename?: 'SecretGoAchBot', username: string, password: string, originatorId?: string | null, originatorAccountId?: string | null } | { __typename?: 'SecretLiftoffCard', bankAccountId: string, username: string, password: string }, settings: { __typename?: 'Settings', loadTransactionsForLastDays?: number | null, colorCode?: string | null, hideFromChart?: boolean | null, enableRefresh?: boolean | null }, lastRefreshResult?: { __typename?: 'IntegrationHealthMonitor', lastImportedTransactionsDate: string, lastImportedTransactionsStats: { __typename?: 'ImportedStatsDto', imported: number, deleted: number, updated: number, inserted: number } } | null } };

export type UpdateAutoStartMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  autostart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAutoStartMutation = { __typename?: 'Mutation', updateAutoStart: { __typename?: 'Integration', id: string, autostart: boolean } };

export type SaveIntegrationMutationVariables = Exact<{
  dto: IntegrationDto;
}>;


export type SaveIntegrationMutation = { __typename?: 'Mutation', saveIntegration: { __typename?: 'Integration', id: string, name: string, type: IntegrationType, environment: IntegrationEnvironment, description?: string | null, schedule: string, autostart: boolean, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, secret: { __typename?: 'SecretAchProc', apikey: string, username: string, password: string, customerInfoKey: string } | { __typename?: 'SecretClearAchBot', apikey: string, username: string, password: string, companyId: string } | { __typename?: 'SecretDevNull', zero?: string | null } | { __typename?: 'SecretGoAch', apikey: string, vendorName?: string | null } | { __typename?: 'SecretGoAchBot', username: string, password: string, originatorId?: string | null, originatorAccountId?: string | null } | { __typename?: 'SecretLiftoffCard', bankAccountId: string, username: string, password: string }, settings: { __typename?: 'Settings', loadTransactionsForLastDays?: number | null, colorCode?: string | null, hideFromChart?: boolean | null, enableRefresh?: boolean | null }, lastRefreshResult?: { __typename?: 'IntegrationHealthMonitor', lastImportedTransactionsDate: string, lastImportedTransactionsStats: { __typename?: 'ImportedStatsDto', imported: number, deleted: number, updated: number, inserted: number } } | null } };

export type ImportMutationVariables = Exact<{
  integrationId: Scalars['ID']['input'];
  dateStart: Scalars['DateTime']['input'];
  dateEnd: Scalars['DateTime']['input'];
}>;


export type ImportMutation = { __typename?: 'Mutation', importTransactions: Array<{ __typename?: 'ImportedTransactionDto', account: string, amount: number, depositDate: any, effectiveDate: any, externalId?: string | null, name: string, notes?: string | null, originationDate: any, returnCode?: string | null, returnDate?: any | null, status: string, to: string, type: string }> };

export type IntegrationScheduleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IntegrationScheduleQuery = { __typename?: 'Query', integrationsSchedule?: { __typename?: 'IntegrationScheduleDto', id: string, running?: boolean | null, nextDate?: any | null } | null };

export type ScheduleIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ScheduleIntegrationMutation = { __typename?: 'Mutation', scheduleIntegration?: string | null };

export type UnscheduleIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnscheduleIntegrationMutation = { __typename?: 'Mutation', unscheduleIntegration?: string | null };

export type RefreshTransactionsMutationVariables = Exact<{
  integrationId: Scalars['ID']['input'];
}>;


export type RefreshTransactionsMutation = { __typename?: 'Mutation', refreshTransactions: { __typename?: 'IntegrationHealthMonitor', integrationId: string, lastImportedTransactionsDate: string, lastImportedTransactionsStats: { __typename?: 'ImportedStatsDto', imported: number, deleted: number, updated: number, inserted: number } } };

export type RefreshMerchantCashAdvanceTransactionsMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
}>;


export type RefreshMerchantCashAdvanceTransactionsMutation = { __typename?: 'Mutation', refreshMerchantCashAdvanceTransactions: number };

export type LookupScheduleQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
  external: Scalars['String']['input'];
}>;


export type LookupScheduleQuery = { __typename?: 'Query', lookupSchedule: Array<{ __typename?: 'RecurrencyProcessorData', isStopped: boolean, isPaused: boolean, isActive: boolean, name: string, description?: string | null, startDate: any, accountNumber: string, routingNumber: string, amount: number, totalAmount?: number | null, processorReference?: string | null }> };

export type AvailableIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableIntegrationsQuery = { __typename?: 'Query', availableIntegrations: Array<IntegrationType> };

export type MerchantCashAdvanceStatusHistoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantCashAdvanceStatusHistoryQuery = { __typename?: 'Query', merchantCashAdvanceStatusHistory: Array<{ __typename?: 'MerchantCashAdvanceStatusHistory', fromStatus: MerchantCashAdvanceStatus, toStatus: MerchantCashAdvanceStatus, createdAt: any, reason?: string | null, user?: { __typename?: 'User', data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> };

export type MerchantCashAdvancesPreAggregatedQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  merchatId?: InputMaybe<Scalars['ID']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  funderIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type MerchantCashAdvancesPreAggregatedQuery = { __typename?: 'Query', merchantCashAdvancesPreAggregated: { __typename?: 'MerchantCashAdvancesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus, position?: number | null, referenceMca: string, amount: number, payback: number, paybackWFee?: number | null, createdAt: any, modifiedAt: any, factorRate: number, term: number, displayAttributes: Array<string>, commissionPercentage?: number | null, startDate: any, fundingDate: any, endDate?: any | null, routingNumber?: string | null, accountNumber?: string | null, amtpaidclr?: number | null, amtpaidpnd?: number | null, balanceclr?: number | null, npt?: number | null, nft?: number | null, pmt?: number | null, nrt?: number | null, perfTerm?: number | null, perfEndDate?: any | null, completion?: number | null, currentUserRights: Array<Rights>, statusManagementType: McaManagementType, statusChangedAt: any, balanceClrWFees?: number | null, balancePnd?: number | null, balancePndWFees?: number | null, totalfees?: number | null, totalfines?: number | null, totalclrfines?: number | null, payoff?: number | null, netWire?: number | null, pnlNet?: number | null, pnlGross?: number | null, lastPmtDay?: any | null, merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, logo?: string | null, phone?: Array<string> | null, email?: Array<string> | null, www?: string | null, linkToFiles?: string | null, taxId?: string | null }, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null, email?: Array<string> | null, phone?: Array<string> | null } | null } | null, legal?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, email?: Array<string> | null, phone?: Array<string> | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, syndications?: Array<{ __typename?: 'Syndication', userId?: string | null, amount: number, type: SyndicationType, calculationType: SyndicationCalculation, brkCommissionPercentage: number, isoCommissionPercentage: number, orgFeeCommissionPercentage: number, serviceFeePercentage: number, wireFee: number, crmFee: number, otherFee: number, syndicationPercentage: number }> | null, fundingFee?: Array<{ __typename?: 'FundingFee', id: string, comment: string, amount: number, config?: { __typename?: 'ConfigFee', id: string, name: ConfigFeeName, isPercentage: boolean } | null }> | null, commissions?: Array<{ __typename?: 'Commission', id: string, comment: string, isPaid: boolean, amount: number, config?: { __typename?: 'ConfigFee', id: string, name: ConfigFeeName, isPercentage: boolean } | null }> | null, recurrencies?: Array<{ __typename?: 'Recurrency', id: string, amount: number, routingNumber?: string | null, accountNumber?: string | null, startDate: any, term: number, referenceMca: string, referenceRecurrence?: string | null, recurrenceNumber?: number | null, stateNotes?: string | null, state: RecurrencyState }> | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, externalConnections?: Array<{ __typename?: 'MerchantCashAdvanceExternalServiceConnection', id: string, mcaId: string, isActive: boolean, configuration: any, externalServiceConfiguration: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, createdAt?: any | null, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } }> | null, refis: Array<{ __typename?: 'McaRefi', id: string, number: number, referenceMca?: string | null, pendingBalance: number, totalFees: number, clearedBalance: number, type: McaRefiType, merchantId?: string | null, merchantLogo?: string | null, merchantLegalName?: string | null, amount?: number | null }> }> } };

export type MerchantCashAdvancesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  merchatId?: InputMaybe<Scalars['ID']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type MerchantCashAdvancesQuery = { __typename?: 'Query', merchantCashAdvances: { __typename?: 'MerchantCashAdvancesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus, position?: number | null, referenceMca: string, amount: number, payback: number, createdAt: any, modifiedAt: any, factorRate: number, term: number, displayAttributes: Array<string>, commissionPercentage?: number | null, startDate: any, fundingDate: any, endDate?: any | null, routingNumber?: string | null, accountNumber?: string | null, amtpaidclr?: number | null, amtpaidpnd?: number | null, balanceclr?: number | null, npt?: number | null, nft?: number | null, pmt?: number | null, nrt?: number | null, perfTerm?: number | null, perfEndDate?: any | null, completion?: number | null, currentUserRights: Array<Rights>, statusManagementType: McaManagementType, statusChangedAt: any, balanceClrWFees?: number | null, balancePnd?: number | null, balancePndWFees?: number | null, totalfees?: number | null, totalfines?: number | null, totalclrfines?: number | null, pnlNet?: number | null, pnlGross?: number | null, netWire?: number | null, merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, logo?: string | null, linkToFiles?: string | null }, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null, broker?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, syndications?: Array<{ __typename?: 'Syndication', userId?: string | null, amount: number, type: SyndicationType, calculationType: SyndicationCalculation, brkCommissionPercentage: number, isoCommissionPercentage: number, orgFeeCommissionPercentage: number, serviceFeePercentage: number, wireFee: number, crmFee: number, otherFee: number, syndicationPercentage: number }> | null, fundingFee?: Array<{ __typename?: 'FundingFee', id: string, comment: string, amount: number, config?: { __typename?: 'ConfigFee', id: string, name: ConfigFeeName, isPercentage: boolean } | null }> | null, commissions?: Array<{ __typename?: 'Commission', id: string, comment: string, isPaid: boolean, amount: number, config?: { __typename?: 'ConfigFee', id: string, name: ConfigFeeName, isPercentage: boolean } | null }> | null, refis: Array<{ __typename?: 'McaRefi', id: string, number: number, pendingBalance: number, totalFees: number, clearedBalance: number, type: McaRefiType, merchantId?: string | null, merchantLogo?: string | null, merchantLegalName?: string | null, amount?: number | null }>, createdBy: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null }, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, recurrencies?: Array<{ __typename?: 'Recurrency', id: string, amount: number, routingNumber?: string | null, accountNumber?: string | null, startDate: any, term: number, referenceMca: string, referenceRecurrence?: string | null, state: RecurrencyState, integration: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, autostart: boolean, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } }> | null }> } };

export type MerchantCashAdvancesSummaryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  merchatId?: InputMaybe<Scalars['ID']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type MerchantCashAdvancesSummaryQuery = { __typename?: 'Query', merchantCashAdvancesSummary: { __typename?: 'MerchantCashAdvanceSummary', amountSum?: number | null, paybackSum?: number | null, paybackWFeeSum?: number | null, factorRateAvg?: number | null, pmtSum?: number | null, completionAvg?: number | null, amtPaidClrSum?: number | null, amtPaidPndSum?: number | null, pnlnetSum?: number | null, pnlgrossSum?: number | null, totalclrfines?: number | null, totalPendingPostFundingFeesSum?: number | null, totalFeesSum?: number | null, payoffSum?: number | null, netWireSum?: number | null, commissionSum?: number | null } };

export type MerchantCashAdvanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantCashAdvanceQuery = { __typename?: 'Query', merchantCashAdvance: { __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus, position?: number | null, referenceMca: string, amount: number, payback: number, paybackWFee?: number | null, createdAt: any, modifiedAt: any, factorRate: number, term: number, commissionPercentage?: number | null, startDate: any, fundingDate: any, endDate?: any | null, routingNumber?: string | null, accountNumber?: string | null, displayAttributes: Array<string>, numberOfFeeTransactions?: number | null, numberOfInvestorTransactions?: number | null, amtpaidclr?: number | null, amtpaidpnd?: number | null, balanceclr?: number | null, npt?: number | null, nft?: number | null, nrt?: number | null, pmt?: number | null, perfTerm?: number | null, perfEndDate?: any | null, completion?: number | null, currentUserRights: Array<Rights>, statusManagementType: McaManagementType, statusChangedAt: any, balanceClrWFees?: number | null, balancePnd?: number | null, balancePndWFees?: number | null, totalfees?: number | null, totalfines?: number | null, totalclrfines?: number | null, totalpendingfines?: number | null, pnlNet?: number | null, pnlGross?: number | null, netWire?: number | null, lastPmtDay?: any | null, merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, phone?: Array<string> | null, email?: Array<string> | null, taxId?: string | null, logo?: string | null, www?: string | null, linkToFiles?: string | null }, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, autostart: boolean, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, syndications?: Array<{ __typename?: 'Syndication', userId?: string | null, amount: number, type: SyndicationType, calculationType: SyndicationCalculation, brkCommissionPercentage: number, isoCommissionPercentage: number, orgFeeCommissionPercentage: number, serviceFeePercentage: number, wireFee: number, crmFee: number, otherFee: number, syndicationPercentage: number }> | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, email?: Array<string> | null, phone?: Array<string> | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, legal?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, email?: Array<string> | null, phone?: Array<string> | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, externalConnections?: Array<{ __typename?: 'MerchantCashAdvanceExternalServiceConnection', id: string, mcaId: string, isActive: boolean, configuration: any, externalServiceConfiguration: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, createdAt?: any | null, logo?: string | null } }> | null, fundingFee?: Array<{ __typename?: 'FundingFee', id: string, comment: string, amount: number, createdAt: any, modifiedAt: any, config?: { __typename?: 'ConfigFee', id: string, name: ConfigFeeName, isPercentage: boolean } | null }> | null, commissions?: Array<{ __typename?: 'Commission', id: string, comment: string, amount: number, isPaid: boolean, config?: { __typename?: 'ConfigFee', id: string, name: ConfigFeeName, isPercentage: boolean } | null }> | null, refis: Array<{ __typename?: 'McaRefi', id: string, number: number, pendingBalance: number, totalFees: number, clearedBalance: number, type: McaRefiType, merchantId?: string | null, merchantLogo?: string | null, merchantLegalName?: string | null, amount?: number | null }>, recurrencies?: Array<{ __typename?: 'Recurrency', id: string, amount: number, routingNumber?: string | null, accountNumber?: string | null, startDate: any, term: number, referenceMca: string, referenceRecurrence?: string | null, recurrenceNumber?: number | null, stateNotes?: string | null, state: RecurrencyState, integration: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, autostart: boolean, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } }> | null } };

export type MerchantCashAdvanceDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MerchantCashAdvanceDocumentsQuery = { __typename?: 'Query', merchantCashAdvance: { __typename?: 'MerchantCashAdvance', id: string, number: number, documents: Array<{ __typename?: 'AvailableDocumentDto', id: string, documentName: string }> } };

export type SaveMerchantCashAdvanceMutationVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  lenderId?: InputMaybe<Scalars['ID']['input']>;
  secondaryFunderIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  brokerId?: InputMaybe<Scalars['ID']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  legalId?: InputMaybe<Scalars['ID']['input']>;
  dto: MerchantCashAdvanceDto;
}>;


export type SaveMerchantCashAdvanceMutation = { __typename?: 'Mutation', saveMerchantCashAdvance: { __typename?: 'MerchantCashAdvance', id: string, status: MerchantCashAdvanceStatus, amount: number, factorRate: number, routingNumber?: string | null, accountNumber?: string | null, term: number, startDate: any, fundingDate: any, commissionPercentage?: number | null, payback: number } };

export type ChangeMerchantCashAdvanceStatusMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  status: MerchantCashAdvanceStatus;
}>;


export type ChangeMerchantCashAdvanceStatusMutation = { __typename?: 'Mutation', changeMerchantCashAdvanceStatus: number };

export type ToggleMcaManagementTypeMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
}>;


export type ToggleMcaManagementTypeMutation = { __typename?: 'Mutation', toggleMcaManagementType: string };

export type MerchantBankAccountsQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
}>;


export type MerchantBankAccountsQuery = { __typename?: 'Query', merchantBankAccounts: Array<{ __typename?: 'MerchantBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null }> };

export type SaveMerchantBankAccountMutationVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  dto: MerchantBankAccountDto;
}>;


export type SaveMerchantBankAccountMutation = { __typename?: 'Mutation', saveMerchantBankAccount: { __typename?: 'MerchantBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null } };

export type DeleteMerchantBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMerchantBankAccountMutation = { __typename?: 'Mutation', deleteMerchantBankAccount: string };

export type CountTodayMcasQueryVariables = Exact<{ [key: string]: never; }>;


export type CountTodayMcasQuery = { __typename?: 'Query', countTodayMCAs: number };

export type GetMerchantCashAdvanceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMerchantCashAdvanceQuery = { __typename?: 'Query', merchantCashAdvance: { __typename?: 'MerchantCashAdvance', documents: Array<{ __typename?: 'AvailableDocumentDto', id: string, documentName: string }> } };

export type McaDisplayAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type McaDisplayAttributesQuery = { __typename?: 'Query', mcaDisplayAttributes: Array<{ __typename?: 'McaDisplayAttribute', key: string, type: string, name: string, displayOrder: number, color: string, description?: string | null }> };

export type CreateOfferMutationVariables = Exact<{
  createOfferInput: CreateOfferInput;
}>;


export type CreateOfferMutation = { __typename?: 'Mutation', createOffer: { __typename?: 'Offer', id: string } };

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  updateOfferInput: UpdateOfferInput;
}>;


export type UpdateOfferMutation = { __typename?: 'Mutation', updateOffer: { __typename?: 'Offer', id: string } };

export type DeleteOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOfferMutation = { __typename?: 'Mutation', deleteOffer: boolean };

export type DeleteOffersByGroupIdMutationVariables = Exact<{
  rehabGroupId: Scalars['ID']['input'];
}>;


export type DeleteOffersByGroupIdMutation = { __typename?: 'Mutation', deleteOffersByGroupId: boolean };

export type SetActiveOfferMutationVariables = Exact<{
  offerId: Scalars['ID']['input'];
}>;


export type SetActiveOfferMutation = { __typename?: 'Mutation', setActiveOffer: { __typename?: 'Offer', id: string, isActive?: boolean | null } };

export type CountFundingPipelineOfferStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountFundingPipelineOfferStatsQuery = { __typename?: 'Query', countFundingPipelineOfferStats: { __typename?: 'FundingPipeLineOffersCount', statusCounts: Array<{ __typename?: 'FundingPipelineStatusCount', statusId: string, count: number }> } };

export type LinkActiveOfferToMcaMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  applicationId: Scalars['ID']['input'];
}>;


export type LinkActiveOfferToMcaMutation = { __typename?: 'Mutation', linkActiveOfferToMca: boolean };

export type DuplicateApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
}>;


export type DuplicateApplicationMutation = { __typename?: 'Mutation', duplicateApplication: { __typename?: 'Application', id: string, offers?: Array<{ __typename?: 'Offer', id: string, isSelected?: boolean | null }> | null } };

export type GetOfferQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOfferQuery = { __typename?: 'Query', getOffer: { __typename?: 'Offer', id: string, number?: number | null, currentUserRights: Array<Rights>, type: OfferType, fundingAmount?: number | null, factorRate: number, term?: number | null, offerDate: any, rehabGroupId?: string | null, rehabLineTitle?: string | null, lineOrder?: number | null, notes?: string | null, stipulations?: Array<string> | null, isSelected?: boolean | null, isActive?: boolean | null, createdAt: any, updatedAt?: any | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, linkToFilesData?: { __typename?: 'OffersLinkToFiles', linkToFiles?: string | null } | null, fundingFees?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null, commissions?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null, application: { __typename?: 'Application', id: string, number: number }, offerEmails?: Array<{ __typename?: 'OfferEmail', id: string, number?: number | null, recipient: string, recipientCC?: Array<string> | null, recipientBCC?: Array<string> | null, comment: string, sentAt?: any | null, isSent: boolean, createdBy: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } }> | null } };

export type OffersForApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OffersForApplicationQuery = { __typename?: 'Query', offersForApplication: Array<{ __typename?: 'Offer', id: string, number?: number | null, currentUserRights: Array<Rights>, type: OfferType, fundingAmount?: number | null, factorRate: number, term?: number | null, offerDate: any, rehabGroupId?: string | null, rehabLineTitle?: string | null, lineOrder?: number | null, notes?: string | null, stipulations?: Array<string> | null, isSelected?: boolean | null, isActive?: boolean | null, createdAt: any, updatedAt?: any | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, application: { __typename?: 'Application', merchantCompanyLegalName?: string | null, merchantCompanyDba?: string | null, merchantBizEmails?: Array<string> | null, merchantBizWeb?: string | null, merchantBizPhones?: Array<string> | null, merchantTaxId?: string | null }, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, linkToFilesData?: { __typename?: 'OffersLinkToFiles', linkToFiles?: string | null } | null, fundingFees?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null, commissions?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null }> };

export type GetRehabOffersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRehabOffersQuery = { __typename?: 'Query', getRehabOffers: Array<{ __typename?: 'Offer', id: string, number?: number | null, currentUserRights: Array<Rights>, type: OfferType, fundingAmount?: number | null, factorRate: number, term?: number | null, offerDate: any, rehabGroupId?: string | null, rehabLineTitle?: string | null, lineOrder?: number | null, notes?: string | null, stipulations?: Array<string> | null, isSelected?: boolean | null, isActive?: boolean | null, createdAt: any, updatedAt?: any | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, application: { __typename?: 'Application', merchantCompanyLegalName?: string | null, merchantCompanyDba?: string | null, merchantBizEmails?: Array<string> | null, merchantBizWeb?: string | null, merchantBizPhones?: Array<string> | null, merchantTaxId?: string | null }, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, linkToFilesData?: { __typename?: 'OffersLinkToFiles', linkToFiles?: string | null } | null, fundingFees?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null, commissions?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null }> };

export type OffersForFundingPipelineQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  applicationId?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type OffersForFundingPipelineQuery = { __typename?: 'Query', offersForFundingPipeline: { __typename?: 'OfferList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Offer', id: string, number?: number | null, currentUserRights: Array<Rights>, type: OfferType, fundingAmount?: number | null, factorRate: number, term?: number | null, offerDate: any, rehabGroupId?: string | null, rehabLineTitle?: string | null, lineOrder?: number | null, stipulations?: Array<string> | null, notes?: string | null, isSelected?: boolean | null, isActive?: boolean | null, createdAt: any, updatedAt?: any | null, linkToFilesData?: { __typename?: 'OffersLinkToFiles', linkToFiles?: string | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, application: { __typename?: 'Application', id: string, number: number, merchantCompanyLegalName?: string | null, merchantCompanyDba?: string | null, merchantBizEmails?: Array<string> | null, merchantBizWeb?: string | null, merchantBizPhones?: Array<string> | null, merchantTaxId?: string | null, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null, owners?: Array<{ __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> | null }, mca?: { __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus } | null }> } };

export type FundingPipelineStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type FundingPipelineStatusQuery = { __typename?: 'Query', fundingPipelineStatus: Array<{ __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null, order: number }> };

export type SendOfferEmailMutationVariables = Exact<{
  sendEmailInput: SendEmailInput;
}>;


export type SendOfferEmailMutation = { __typename?: 'Mutation', sendOfferEmail: Array<{ __typename?: 'OfferEmail', id: string, sentAt?: any | null }> };

export type SaveUnsentOfferEmailMutationVariables = Exact<{
  sendEmailInput: SendEmailInput;
}>;


export type SaveUnsentOfferEmailMutation = { __typename?: 'Mutation', saveUnsentOfferEmail: Array<{ __typename?: 'OfferEmail', id: string, sentAt?: any | null }> };

export type MapOfferToMcaQueryVariables = Exact<{
  offerId: Scalars['ID']['input'];
}>;


export type MapOfferToMcaQuery = { __typename?: 'Query', mapOfferToMCA: { __typename?: 'OfferMerchantCashAdvanceDto', id?: string | null, status?: MerchantCashAdvanceStatus | null, description?: string | null, amount?: number | null, factorRate?: number | null, term?: number | null, startDate?: any | null, fundingDate?: any | null, commissionPercentage?: number | null, merchant?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, taxId?: string | null, email?: Array<string> | null, phone?: Array<string> | null, www?: string | null, logo?: string | null, type?: Array<CompanyType> | null, linkToFiles?: string | null } | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null, signature?: string | null } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null }> | null, fundingFee?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null, commissions?: Array<{ __typename?: 'OfferFeeCommissionJson', id?: string | null, configId?: string | null, amount: number, comment: string }> | null } };

export type OffersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type OffersQuery = { __typename?: 'Query', offers: { __typename?: 'OfferList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Offer', id: string, number?: number | null, currentUserRights: Array<Rights>, type: OfferType, fundingAmount?: number | null, factorRate: number, term?: number | null, offerDate: any, rehabGroupId?: string | null, rehabLineTitle?: string | null, lineOrder?: number | null, notes?: string | null, stipulations?: Array<string> | null, isSelected?: boolean | null, isActive?: boolean | null, createdAt: any, updatedAt?: any | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null } | null, secondaryFunders?: Array<{ __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null }> | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, application: { __typename?: 'Application', id: string, number: number, merchantCompanyLegalName?: string | null, merchantCompanyDba?: string | null, merchantBizEmails?: Array<string> | null, merchantBizWeb?: string | null, merchantBizPhones?: Array<string> | null, merchantTaxId?: string | null, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null, owners?: Array<{ __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> | null, offers?: Array<{ __typename?: 'Offer', id: string, number?: number | null, type: OfferType, rehabLineTitle?: string | null, rehabGroupId?: string | null, lineOrder?: number | null, term?: number | null, offerDate: any, fundingAmount?: number | null, factorRate: number }> | null }, createdBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null }> } };

export type PreviewOfferEmailQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;


export type PreviewOfferEmailQuery = { __typename?: 'Query', previewOfferEmail: string };

export type SaveFundingPipelineMcaMutationVariables = Exact<{
  offerId: Scalars['ID']['input'];
  merchantId: Scalars['ID']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  lenderId?: InputMaybe<Scalars['ID']['input']>;
  secondaryFunderIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  brokerId?: InputMaybe<Scalars['ID']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  legalId?: InputMaybe<Scalars['ID']['input']>;
  applicationId: Scalars['ID']['input'];
  dto: MerchantCashAdvanceDto;
}>;


export type SaveFundingPipelineMcaMutation = { __typename?: 'Mutation', saveFundingPipelineMca: { __typename?: 'MerchantCashAdvance', id: string, status: MerchantCashAdvanceStatus, amount: number, factorRate: number, routingNumber?: string | null, accountNumber?: string | null, term: number, startDate: any, fundingDate: any, commissionPercentage?: number | null, payback: number } };

export type OfferByMcaIdQueryVariables = Exact<{
  mcaId: Scalars['ID']['input'];
}>;


export type OfferByMcaIdQuery = { __typename?: 'Query', offerByMcaId?: { __typename?: 'Offer', id: string, application: { __typename?: 'Application', id: string, number: number, status?: { __typename?: 'ApplicationStatus', id: string, color: string, description?: string | null } | null } } | null };

export type CompanyOwnersQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type CompanyOwnersQuery = { __typename?: 'Query', companyOwners: Array<{ __typename?: 'Owner', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, dateOfBirth?: string | null, ssn?: string | null, ssnNormalized?: string | null, description?: string | null, cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, avatar?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null }> };

export type OwnerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OwnerQuery = { __typename?: 'Query', owner: { __typename?: 'Owner', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, dateOfBirth?: string | null, ssn?: string | null, ssnNormalized?: string | null, description?: string | null, cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, avatar?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } };

export type SaveOwnerMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  owner: OwnerDto;
}>;


export type SaveOwnerMutation = { __typename?: 'Mutation', saveOwner: { __typename?: 'Owner', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, dateOfBirth?: string | null, ssn?: string | null, ssnNormalized?: string | null, description?: string | null, cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, avatar?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', firstName?: string | null, lastName?: string | null, avatar?: string | null } | null } | null } };

export type DeleteOwnerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOwnerMutation = { __typename?: 'Mutation', deleteOwner: string };

export type SaveCompanyOwnersMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  owners: Array<OwnerDto> | OwnerDto;
}>;


export type SaveCompanyOwnersMutation = { __typename?: 'Mutation', saveCompanyOwners: Array<{ __typename?: 'Owner', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, dateOfBirth?: string | null, ssn?: string | null, cellPhone?: string | null, bizPhone?: string | null, bizEmail?: string | null, address?: { __typename?: 'Address', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null }> };

export type PermissionsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  roleFilter?: InputMaybe<Roles>;
  mcaDynamicRoleFilter?: InputMaybe<McaDynamicRole>;
}>;


export type PermissionsQuery = { __typename?: 'Query', permissions: { __typename?: 'PermissionsList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Permission', name: string, area: ProductArea, description: string, roles: Array<Roles>, mcaDynamicRoles: Array<McaDynamicRole>, modifiedBy?: string | null, modifiedAt?: any | null }> } };

export type PermissionQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type PermissionQuery = { __typename?: 'Query', permission: { __typename?: 'Permission', name: string, area: ProductArea, description: string, roles: Array<Roles>, mcaDynamicRoles: Array<McaDynamicRole>, modifiedBy?: string | null, modifiedAt?: any | null } };

export type UpdatePermissionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  input: UpdatePermissionInput;
}>;


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'Permission', name: string, area: ProductArea, description: string, roles: Array<Roles>, mcaDynamicRoles: Array<McaDynamicRole>, modifiedBy?: string | null, modifiedAt?: any | null } };

export type PortFolioChartQueryVariables = Exact<{
  months?: InputMaybe<Scalars['Float']['input']>;
}>;


export type PortFolioChartQuery = { __typename?: 'Query', portFolioChart: Array<{ __typename?: 'PortFolioChartDto', attorney?: number | null, notPaying?: number | null, resumed?: number | null, inHouseLegal?: number | null, open?: number | null, slow?: number | null, collections?: number | null, verySlow?: number | null, completed?: number | null, writtenOff?: number | null, settled?: number | null, date: any, profitAndLoss?: number | null, totalMcaCount?: number | null, totalAmount?: number | null, totalPayback?: number | null, totalAmtPaidClr?: number | null, monthTotal?: number | null, originationPerformanceAmount?: number | null }> };

export type PortFolioSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type PortFolioSummaryQuery = { __typename?: 'Query', portFolioSummary: { __typename?: 'PortFolioSummaryDto', collections?: number | null, verySlow?: number | null, notPaying?: number | null, resumed?: number | null, resumedCount?: number | null, inHouseLegal?: number | null, open?: number | null, slow?: number | null, attorney?: number | null, verySlowCount?: number | null, openCount?: number | null, attorneyCount?: number | null, collectionsCount?: number | null, notPayingCount?: number | null, inHouseLegalCount?: number | null, slowCount?: number | null, portFolioValue?: number | null, totalPortFolio?: number | null, portFolioCount?: number | null, totalPortFolioCount?: number | null, activeReceivables?: number | null, activeReceivablesCount?: number | null, totalReceivables?: number | null, totalReceivablesCount?: number | null, totalCompleted?: number | null, totalCompletedCount?: number | null, totalAccumulated?: number | null, totalAccumulatedCount?: number | null, completed?: number | null, settled?: number | null, writtenOff?: number | null, completedCount?: number | null, writtenOffCount?: number | null, settledCount?: number | null } };

export type PortfolioMerchantCashAdvancesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  excludeStatus?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  lastTransactionStatus?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  merchatId?: InputMaybe<Scalars['ID']['input']>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type PortfolioMerchantCashAdvancesQuery = { __typename?: 'Query', portfolioMerchantCashAdvances: { __typename?: 'MerchantCashAdvancesList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus, amount: number, payback: number, factorRate: number, term: number, commissionPercentage?: number | null, startDate: any, fundingDate: any, endDate?: any | null, lastPmtDay?: any | null, completion?: number | null, amtpaidclr?: number | null, amtpaidpnd?: number | null, balanceclr?: number | null, merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, logo?: string | null }, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null, lastTransaction?: { __typename?: 'Transaction', status: TransactionStatus, type: TransactionType, originationDate?: any | null, effectiveDate?: any | null, depositDate?: any | null, returnDate?: any | null, returnCode?: string | null, amount: number } | null }> } };

export type FundersPortFolioSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type FundersPortFolioSummaryQuery = { __typename?: 'Query', fundersPortFolioSummary: Array<{ __typename?: 'FunderPortFolioDto', collections?: number | null, verySlow?: number | null, notPaying?: number | null, inHouseLegal?: number | null, open?: number | null, slow?: number | null, attorney?: number | null, completed?: number | null, writtenOff?: number | null, settled?: number | null, total?: number | null, totalMcaCount?: number | null, totalAmount?: number | null, totalPayback?: number | null, poolNetValue?: number | null, poolGrossValue?: number | null, profitAndLoss?: number | null, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null }> };

export type InvestorsPortFolioSummaryQueryVariables = Exact<{
  forAssignedPortfolios?: InputMaybe<Scalars['Boolean']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InvestorsPortFolioSummaryQuery = { __typename?: 'Query', investorsPortFolioSummary: Array<{ __typename?: 'InvestorPortFolioDto', collections?: number | null, verySlow?: number | null, notPaying?: number | null, inHouseLegal?: number | null, open?: number | null, slow?: number | null, attorney?: number | null, completed?: number | null, writtenOff?: number | null, resumed?: number | null, settled?: number | null, total?: number | null, userId?: string | null, name?: string | null, avatar?: string | null, role?: Array<string> | null, totalMcaCount?: number | null, totalAmount?: number | null, totalPayback?: number | null, totalAmtPaidClr?: number | null, poolNetValue?: number | null, poolGrossValue?: number | null, profitAndLoss?: number | null, originationPerformanceAmount?: number | null }> };

export type MyPortFolioSummaryChartQueryVariables = Exact<{
  months?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyPortFolioSummaryChartQuery = { __typename?: 'Query', myPortFolioSummaryChart: Array<{ __typename?: 'InvestorPortFolioDto', date?: any | null, collections?: number | null, verySlow?: number | null, notPaying?: number | null, inHouseLegal?: number | null, open?: number | null, slow?: number | null, attorney?: number | null, completed?: number | null, writtenOff?: number | null, settled?: number | null, total?: number | null, userId?: string | null, name?: string | null, avatar?: string | null, role?: Array<string> | null, totalMcaCount?: number | null, totalAmount?: number | null, totalPayback?: number | null, poolNetValue?: number | null, poolGrossValue?: number | null, profitAndLoss?: number | null }> };

export type MyPortFolioSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortFolioSummaryQuery = { __typename?: 'Query', myPortFolioSummary: { __typename?: 'InvestorPortFolioDto', name?: string | null, avatar?: string | null, role?: Array<string> | null, openCount?: number | null, slowCount?: number | null, verySlowCount?: number | null, attorneyCount?: number | null, notPayingCount?: number | null, inHouseLegalCount?: number | null, collectionsCount?: number | null, completedCount?: number | null, writtenOffCount?: number | null, settledCount?: number | null, open?: number | null, notPaying?: number | null, inHouseLegal?: number | null, attorney?: number | null, slow?: number | null, collections?: number | null, verySlow?: number | null, writtenOff?: number | null, completed?: number | null, settled?: number | null, totalMcaCount?: number | null, totalAmount?: number | null, totalPayback?: number | null, profitAndLoss?: number | null, total?: number | null, poolNetValue?: number | null, poolGrossValue?: number | null, portFolioCount?: number | null, portFolioValue?: number | null } };

export type InvestorPortFolioSummaryChartQueryVariables = Exact<{
  months?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
}>;


export type InvestorPortFolioSummaryChartQuery = { __typename?: 'Query', investorPortFolioSummaryChart: Array<{ __typename?: 'InvestorPortFolioDto', date?: any | null, collections?: number | null, verySlow?: number | null, notPaying?: number | null, inHouseLegal?: number | null, open?: number | null, slow?: number | null, attorney?: number | null, completed?: number | null, writtenOff?: number | null, settled?: number | null, resumed?: number | null, total?: number | null, userId?: string | null, name?: string | null, avatar?: string | null, role?: Array<string> | null, totalMcaCount?: number | null, totalAmount?: number | null, totalPayback?: number | null, totalAmtPaidClr?: number | null, poolNetValue?: number | null, poolGrossValue?: number | null, profitAndLoss?: number | null, originationPerformanceAmount?: number | null }> };

export type InvestorPortFolioSummaryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type InvestorPortFolioSummaryQuery = { __typename?: 'Query', investorPortFolioSummary: { __typename?: 'InvestorPortFolioDto', userId?: string | null, name?: string | null, avatar?: string | null, role?: Array<string> | null, openCount?: number | null, slowCount?: number | null, verySlowCount?: number | null, resumedCount?: number | null, attorneyCount?: number | null, notPayingCount?: number | null, inHouseLegalCount?: number | null, collectionsCount?: number | null, completedCount?: number | null, writtenOffCount?: number | null, settledCount?: number | null, open?: number | null, notPaying?: number | null, inHouseLegal?: number | null, attorney?: number | null, slow?: number | null, collections?: number | null, verySlow?: number | null, writtenOff?: number | null, completed?: number | null, settled?: number | null, resumed?: number | null, totalMcaCount?: number | null, totalAmount?: number | null, totalPayback?: number | null, profitAndLoss?: number | null, total?: number | null, poolNetValue?: number | null, poolGrossValue?: number | null, portFolioCount?: number | null, portFolioValue?: number | null, totalPortFolioCount?: number | null, totalPortFolioValue?: number | null, activeReceivablesFunder?: number | null, activeReceivablesFunderCount?: number | null, activeReceivablesInvestor?: number | null, activeReceivablesInvestorCount?: number | null, totalReceivables?: number | null, totalReceivablesCount?: number | null, totalCompleted?: number | null, totalCompletedCount?: number | null, totalAccumulated?: number | null, totalAccumulatedCount?: number | null } };

export type McaAverageFundingTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type McaAverageFundingTermsQuery = { __typename?: 'Query', mcaAverageFundingTerms: { __typename?: 'McaAverageFundingTerms', amountAvg?: number | null, factorRateAvg?: number | null, paybackAvg?: number | null, dailyPmtAvg?: number | null, termAvg?: number | null, payoffAvg?: number | null, netWireAvg?: number | null, feesPercentageAvg?: number | null, commissionPercentageAvg?: number | null } };

export type InvestorAverageFundingTermsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type InvestorAverageFundingTermsQuery = { __typename?: 'Query', investorAverageFundingTerms: { __typename?: 'McaAverageFundingTerms', amountAvg?: number | null, factorRateAvg?: number | null, paybackAvg?: number | null, dailyPmtAvg?: number | null, termAvg?: number | null, payoffAvg?: number | null, netWireAvg?: number | null, feesPercentageAvg?: number | null, commissionPercentageAvg?: number | null } };

export type PortfoliosAverageFundingTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type PortfoliosAverageFundingTermsQuery = { __typename?: 'Query', portfoliosAverageFundingTerms: { __typename?: 'McaAverageFundingTerms', amountAvg?: number | null, factorRateAvg?: number | null, paybackAvg?: number | null, dailyPmtAvg?: number | null, termAvg?: number | null, payoffAvg?: number | null, netWireAvg?: number | null, feesPercentageAvg?: number | null, commissionPercentageAvg?: number | null } };

export type ListSyndicationDetailsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
  userId: Scalars['ID']['input'];
}>;


export type ListSyndicationDetailsQuery = { __typename?: 'Query', listSyndicationDetails: { __typename?: 'SyndicationDetailsList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'SyndicationDetailsDto', id: string, mcaId: string, amount: number, fundingAmount: number, type: SyndicationType, mcaNumber: number, mcaStatus: MerchantCashAdvanceStatus, mcaLoanAmount: number, mcaFactorRate: number, mcaTerm: number, mcaStartDate: any, mcaFundingDate: any, mcaEndDate: any, completion: number, perfTerm: number, nrt: number, mcaPerfEndDate: any, syndicationPayback: number, syndicationPmt: number, syndicationPercentage: number, serviceFeePercentage: number, syndicationAmtPaidClr: number, syndicationBalanceClr: number, syndicationAmtPaidPnd: number, syndicationBalanceClrWFees: number, syndicationBalancePnd: number, syndicationBalancePndWFees: number, syndicationPnlNet: number, syndicationPnlGross: number, syndicationNetInvested: number, brkCommissionAmount: number, isoCommissionAmount: number, syndicationType: string, orgFeeAmount: number, serviceFeeAmount: number, wireFee: number, crmFee: number, otherFee: number, syndicationPayoff: number, syndicationNetWire: number, syndicationGrossProfit: number, syndicationNetProfit: number, syndicationPnL: number, pmt: number, lastPmtDay?: any | null, payback: number, amtPaidPnd: number, amtPaidClr: number, balanceClr: number, balanceClrWFees: number, balancePnd: number, balancePndWFees: number, integration: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null }, merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, logo?: string | null }, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, email?: Array<string> | null, phone?: Array<string> | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, legal?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, email?: Array<string> | null, phone?: Array<string> | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, externalConnections?: Array<{ __typename?: 'MerchantCashAdvanceExternalServiceConnection', id: string, isActive: boolean, configuration: any, externalServiceConfiguration: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, createdAt?: any | null, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } }> | null }> } };

export type SyndicationDetailsSummaryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
  userId: Scalars['ID']['input'];
}>;


export type SyndicationDetailsSummaryQuery = { __typename?: 'Query', syndicationDetailsSummary: { __typename?: 'SyndicationDetailsSummaryDto', amount?: number | null, syndicationAmtPaidClr?: number | null, syndicationBalanceClr?: number | null, syndicationAmtPaidPnd?: number | null, syndicationBalanceClrWFees?: number | null, syndicationBalancePnd?: number | null, syndicationBalancePndWFees?: number | null, syndicationPayback?: number | null, fundingAmount?: number | null, completion?: number | null, nrt?: number | null, syndicationNetInvested?: number | null, payback?: number | null, amtPaidPnd?: number | null, amtPaidClr?: number | null, balanceClr?: number | null, balancePnd?: number | null, syndicationPayoff?: number | null, syndicationNetWire?: number | null, brkCommissionAmount?: number | null, isoCommissionAmount?: number | null, orgFeeAmount?: number | null, wireFee?: number | null, crmFee?: number | null, otherFee?: number | null, syndicationGrossProfit?: number | null, syndicationNetProfit?: number | null, syndicationPnL?: number | null, SyndicationNetInvested?: number | null } };

export type ListAllSyndicationDetailsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  fundingDateTo?: InputMaybe<Scalars['Date']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListAllSyndicationDetailsQuery = { __typename?: 'Query', listAllSyndicationDetails: { __typename?: 'SyndicationDetailsList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'SyndicationDetailsDto', id: string, mcaId: string, investorId: string, amount: number, fundingAmount: number, type: SyndicationType, mcaNumber: number, mcaStatus: MerchantCashAdvanceStatus, mcaLoanAmount: number, mcaFactorRate: number, mcaTerm: number, mcaStartDate: any, mcaFundingDate: any, mcaEndDate: any, completion: number, perfTerm: number, nrt: number, amtPaidPnd: number, amtPaidClr: number, balanceClr: number, balancePnd: number, pmt: number, lastPmtDay?: any | null, payback: number, mcaPerfEndDate: any, syndicationPayback: number, syndicationPmt: number, syndicationPercentage: number, syndicationAmtPaidClr: number, syndicationBalanceClr: number, syndicationAmtPaidPnd: number, syndicationBalanceClrWFees: number, syndicationBalancePnd: number, syndicationBalancePndWFees: number, syndicationPnlNet: number, syndicationPnlGross: number, syndicationNetInvested: number, brkCommissionAmount: number, isoCommissionAmount: number, syndicationType: string, orgFeeAmount: number, serviceFeeAmount: number, serviceFeePercentage: number, wireFee: number, crmFee: number, otherFee: number, syndicationPayoff: number, syndicationNetWire: number, syndicationGrossProfit: number, syndicationNetProfit: number, syndicationPnL: number, integration: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null }, merchant: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, logo?: string | null }, funder?: { __typename?: 'Underwriter', id: string, code?: string | null, name?: string | null, logo?: string | null } | null, broker?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, email?: Array<string> | null, phone?: Array<string> | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, legal?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, email?: Array<string> | null, phone?: Array<string> | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, isActive?: boolean | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, externalConnections?: Array<{ __typename?: 'MerchantCashAdvanceExternalServiceConnection', id: string, isActive: boolean, configuration: any, externalServiceConfiguration: { __typename?: 'ExternalServiceConfiguration', id: string, name: string, type: ExternalServiceType, createdAt?: any | null, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } }> | null }> } };

export type AllSyndicationDetailsSummaryQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<MerchantCashAdvanceStatus> | MerchantCashAdvanceStatus>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
  investorId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllSyndicationDetailsSummaryQuery = { __typename?: 'Query', allSyndicationDetailsSummary: { __typename?: 'SyndicationDetailsSummaryDto', amount?: number | null, syndicationAmtPaidClr?: number | null, syndicationBalanceClr?: number | null, syndicationAmtPaidPnd?: number | null, syndicationBalanceClrWFees?: number | null, syndicationBalancePnd?: number | null, syndicationBalancePndWFees?: number | null, syndicationPayback?: number | null, fundingAmount?: number | null, payback?: number | null, amtPaidPnd?: number | null, amtPaidClr?: number | null, balanceClr?: number | null, balancePnd?: number | null, syndicationNetInvested?: number | null, completion?: number | null, nrt?: number | null, syndicationPayoff?: number | null, syndicationNetWire?: number | null, brkCommissionAmount?: number | null, isoCommissionAmount?: number | null, orgFeeAmount?: number | null, wireFee?: number | null, crmFee?: number | null, otherFee?: number | null, syndicationGrossProfit?: number | null, syndicationNetProfit?: number | null, syndicationPnL?: number | null } };

export type InvestorReconciliationBalancesQueryVariables = Exact<{
  investorId: Scalars['ID']['input'];
}>;


export type InvestorReconciliationBalancesQuery = { __typename?: 'Query', investorReconciliationBalances: { __typename?: 'InvestorReconciliationBalanceList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'InvestorReconciliationBalanceDto', type: ReconciliationType, label: string, amount: number, transactionsCount: number, lastReconciliationAt?: any | null, lastReconciliationAction?: ReconciliationAction | null, lastReconciliationBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, reconciliations?: Array<{ __typename?: 'Reconciliation', id: string, reconciliationAction: ReconciliationAction, transactionsCount: number, amount: number, createdAt: any, createdBy: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } }> | null }> } };

export type SaveReconciliationMutationVariables = Exact<{
  reconciliationType: ReconciliationType;
  investorId: Scalars['ID']['input'];
  acknowledged: Scalars['Boolean']['input'];
}>;


export type SaveReconciliationMutation = { __typename?: 'Mutation', saveReconciliation: { __typename?: 'Reconciliation', id: string, reconciliationType: ReconciliationType, amount: number, transactionsCount: number, createdAt: any, notes?: string | null, investor: { __typename?: 'User', id: string, email?: string | null }, createdBy: { __typename?: 'User', id: string, email?: string | null } } };

export type PauseRecurrencyMutationVariables = Exact<{
  recurrencyId: Scalars['ID']['input'];
  cancelTodayTransaction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PauseRecurrencyMutation = { __typename?: 'Mutation', pauseRecurrency: number };

export type ResumeRecurrencyMutationVariables = Exact<{
  recurrencyId: Scalars['ID']['input'];
  tryCreateTodayTransaction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ResumeRecurrencyMutation = { __typename?: 'Mutation', resumeRecurrency: number };

export type StopRecurrencyMutationVariables = Exact<{
  recurrencyId: Scalars['ID']['input'];
  cancelTodayTransaction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StopRecurrencyMutation = { __typename?: 'Mutation', stopRecurrency: number };

export type StopRecurrencyTransactionMutationVariables = Exact<{
  recurrencyId: Scalars['ID']['input'];
  transactionId: Scalars['String']['input'];
}>;


export type StopRecurrencyTransactionMutation = { __typename?: 'Mutation', stopRecurrencyTransaction: number };

export type GetRecurrencyProcessorDataQueryVariables = Exact<{
  recurrencyId: Scalars['ID']['input'];
}>;


export type GetRecurrencyProcessorDataQuery = { __typename?: 'Query', getRecurrencyProcessorData?: { __typename?: 'RecurrencyProcessorData', processorReference?: string | null, startDate: any, description?: string | null, amount: number, totalAmount?: number | null, routingNumber: string, accountNumber: string, isActive: boolean, isPaused: boolean, isStopped: boolean } | null };

export type GetRecurrencyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRecurrencyQuery = { __typename?: 'Query', recurrency: { __typename?: 'Recurrency', id: string, state: RecurrencyState, referenceMca: string, processorReference?: string | null, referenceRecurrence?: string | null, recurrenceNumber?: number | null, stateNotes?: string | null, description?: string | null, amount: number, dailyPayment: number, routingNumber?: string | null, accountNumber?: string | null, term: number, startDate: any, mca: { __typename?: 'MerchantCashAdvance', id: string }, integration: { __typename?: 'Integration', id: string, name: string, description?: string | null, autostart: boolean, type: IntegrationType, logo?: string | null } } };

export type SaveRecurrencyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  dto: RecurrencyDto;
}>;


export type SaveRecurrencyMutation = { __typename?: 'Mutation', saveRecurrency: { __typename?: 'Recurrency', id: string, state: RecurrencyState, referenceMca: string, processorReference?: string | null, referenceRecurrence?: string | null, recurrenceNumber?: number | null, stateNotes?: string | null, description?: string | null, amount: number, dailyPayment: number, routingNumber?: string | null, accountNumber?: string | null, term: number, startDate: any, integration: { __typename?: 'Integration', id: string, name: string, description?: string | null, autostart: boolean, type: IntegrationType, logo?: string | null } } };

export type SubmitRecurrencyToProcessorMutationVariables = Exact<{
  recurrencyId: Scalars['ID']['input'];
}>;


export type SubmitRecurrencyToProcessorMutation = { __typename?: 'Mutation', submitRecurrencyToProcessor: { __typename?: 'Recurrency', id: string, state: RecurrencyState, referenceMca: string, processorReference?: string | null, referenceRecurrence?: string | null, recurrenceNumber?: number | null, stateNotes?: string | null, description?: string | null, amount: number, dailyPayment: number, routingNumber?: string | null, accountNumber?: string | null, term: number, startDate: any, integration: { __typename?: 'Integration', id: string, name: string, description?: string | null, autostart: boolean, type: IntegrationType, logo?: string | null } } };

export type McaRecurrenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type McaRecurrenciesQuery = { __typename?: 'Query', mcaRecurrencies: Array<{ __typename?: 'Recurrency', id: string, state: RecurrencyState, referenceMca: string, processorReference?: string | null, referenceRecurrence?: string | null, recurrenceNumber?: number | null, stateNotes?: string | null, description?: string | null, amount: number, dailyPayment: number, routingNumber?: string | null, accountNumber?: string | null, term: number, startDate: any, integration: { __typename?: 'Integration', id: string, name: string, description?: string | null, autostart: boolean, type: IntegrationType, logo?: string | null, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } }> };

export type AssignExistingRecurrencyMutationVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  processorReference: Scalars['String']['input'];
}>;


export type AssignExistingRecurrencyMutation = { __typename?: 'Mutation', assignExistingRecurrency: { __typename?: 'Recurrency', id: string, state: RecurrencyState, referenceMca: string, processorReference?: string | null, referenceRecurrence?: string | null, recurrenceNumber?: number | null, stateNotes?: string | null, description?: string | null, amount: number, dailyPayment: number, routingNumber?: string | null, accountNumber?: string | null, term: number, startDate: any, integration: { __typename?: 'Integration', id: string, name: string, description?: string | null, autostart: boolean, type: IntegrationType, logo?: string | null } } };

export type DeleteRecurrencyWithErrorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRecurrencyWithErrorMutation = { __typename?: 'Mutation', deleteRecurrencyWithError: string };

export type GetRecurrencyAccountNumberQueryVariables = Exact<{
  recurrencyId: Scalars['ID']['input'];
}>;


export type GetRecurrencyAccountNumberQuery = { __typename?: 'Query', getRecurrencyAccountNumber?: string | null };

export type RolesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: { __typename?: 'RolesList', total: number, data: Array<{ __typename?: 'Role', id: string, name: string, createdAt: any, modifiedAt: any }> } };

export type RoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RoleQuery = { __typename?: 'Query', role: { __typename?: 'Role', id: string, name: string, createdAt: any, modifiedAt: any } };

export type RolesRightsMappingQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesRightsMappingQuery = { __typename?: 'Query', rolesRightsMapping: Array<{ __typename?: 'RoleRightsMapping', role: string, rights: Array<string> }> };

export type CreateStipulationMutationVariables = Exact<{
  input: CreateStipulationInput;
}>;


export type CreateStipulationMutation = { __typename?: 'Mutation', createStipulation: { __typename?: 'Stipulation', id: string, name: string, description?: string | null } };

export type UpdateStipulationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateStipulationInput;
}>;


export type UpdateStipulationMutation = { __typename?: 'Mutation', updateStipulation: { __typename?: 'Stipulation', id: string, name: string, description?: string | null } };

export type DeleteStipulationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStipulationMutation = { __typename?: 'Mutation', deleteStipulation: boolean };

export type GetStipulationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetStipulationQuery = { __typename?: 'Query', stipulation: { __typename?: 'Stipulation', id: string, name: string, description?: string | null } };

export type StipulationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type StipulationsQuery = { __typename?: 'Query', stipulations: Array<{ __typename?: 'Stipulation', id: string, name: string, description?: string | null }> };

export type McaSyndicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type McaSyndicationQuery = { __typename?: 'Query', mcaSyndication: Array<{ __typename?: 'Syndication', id: string, amount: number, type: SyndicationType, calculationType: SyndicationCalculation, brkCommissionPercentage: number, isoCommissionPercentage: number, orgFeeCommissionPercentage: number, serviceFeePercentage: number, wireFee: number, crmFee: number, otherFee: number, syndicationPercentage: number, user?: { __typename?: 'User', id: string, name?: string | null, isActive?: boolean | null, email?: string | null, role?: Array<Roles> | null, rights?: Array<Rights> | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> };

export type SaveSyndicationMutationVariables = Exact<{
  dto: SyndicationDto;
}>;


export type SaveSyndicationMutation = { __typename?: 'Mutation', saveSyndication: { __typename?: 'Syndication', id: string, amount: number } };

export type DeleteSyndicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSyndicationMutation = { __typename?: 'Mutation', deleteSyndication: string };

export type McaTransactionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type McaTransactionsQuery = { __typename?: 'Query', mcaTransactions: Array<{ __typename?: 'Transaction', id: string, externalId?: string | null, name: string, to: string, account: string, status: TransactionStatus, type: TransactionType, originationDate?: any | null, effectiveDate?: any | null, depositDate?: any | null, returnCode?: string | null, returnDate?: any | null, amount: number, notes?: string | null, recurrenceDescription?: string | null, createdAt: any, modifiedAt: any, number?: number | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, logo: string, description: string } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null }> };

export type McaFeeTransactionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type McaFeeTransactionsQuery = { __typename?: 'Query', mcaFeeTransactions: Array<{ __typename?: 'Transaction', id: string, externalId?: string | null, name: string, to: string, account: string, status: TransactionStatus, type: TransactionType, originationDate?: any | null, effectiveDate?: any | null, depositDate?: any | null, returnCode?: string | null, returnDate?: any | null, amount: number, notes?: string | null, recurrenceDescription?: string | null, createdAt: any, modifiedAt: any, number?: number | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, logo: string, description: string } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null }> };

export type GetMcaIntegrationsWithTransactionsCountQueryVariables = Exact<{
  mcaId: Scalars['ID']['input'];
}>;


export type GetMcaIntegrationsWithTransactionsCountQuery = { __typename?: 'Query', getMcaIntegrationsWithTransactionsCount: Array<{ __typename?: 'McaIntegrationsDto', transactionsCount: number, integration: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, autostart: boolean, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } }> };

export type SaveManualTransactionMutationVariables = Exact<{
  dto: ManualTransactionDto;
}>;


export type SaveManualTransactionMutation = { __typename?: 'Mutation', saveManualTransaction: { __typename?: 'Transaction', id: string, amount: number } };

export type DeleteManualTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteManualTransactionMutation = { __typename?: 'Mutation', deleteManualTransaction: string };

export type CancelTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelTransactionMutation = { __typename?: 'Mutation', cancelTransaction: boolean };

export type SaveTransactionNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}>;


export type SaveTransactionNoteMutation = { __typename?: 'Mutation', saveTransactionNote: { __typename?: 'Transaction', id: string, notes?: string | null } };

export type SaveTransactionTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  mcaId: Scalars['ID']['input'];
  type: TransactionType;
}>;


export type SaveTransactionTypeMutation = { __typename?: 'Mutation', saveTransactionType: { __typename?: 'Transaction', id: string, type: TransactionType, mca?: { __typename?: 'MerchantCashAdvance', id: string } | null } };

export type TodaysCollectionQueryVariables = Exact<{ [key: string]: never; }>;


export type TodaysCollectionQuery = { __typename?: 'Query', todaysCollection: { __typename?: 'TodaysCollectionDto', date: string, series: Array<{ __typename?: 'TodaysCollectionSeriesItem', name: string, amount: number }> } };

export type TransactionsChartQueryVariables = Exact<{
  forLastMonths: Scalars['Int']['input'];
  integrationId?: InputMaybe<Scalars['String']['input']>;
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TransactionsChartQuery = { __typename?: 'Query', transactionsChart: Array<{ __typename?: 'Chart', date: any, value: number }> };

export type MyTransactionsChartQueryVariables = Exact<{
  forLastMonths: Scalars['Int']['input'];
}>;


export type MyTransactionsChartQuery = { __typename?: 'Query', myTransactionsChart: Array<{ __typename?: 'Chart', date: any, value: number }> };

export type PortfoliosTransactionsChartQueryVariables = Exact<{
  forLastMonths: Scalars['Int']['input'];
}>;


export type PortfoliosTransactionsChartQuery = { __typename?: 'Query', portfoliosTransactionsChart: Array<{ __typename?: 'Chart', date: any, value: number }> };

export type InvestorTransactionsChartQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  forLastMonths: Scalars['Int']['input'];
}>;


export type InvestorTransactionsChartQuery = { __typename?: 'Query', investorTransactionsChart: Array<{ __typename?: 'Chart', date: any, value: number }> };

export type DailyCollectionsChartQueryVariables = Exact<{
  forLastMonths: Scalars['Int']['input'];
}>;


export type DailyCollectionsChartQuery = { __typename?: 'Query', dailyCollectionsChart: Array<{ __typename?: 'DailyCollectionsChartPoint', date: any, series: Array<{ __typename?: 'DailyCollectionsChartSeriesItem', seriesKey: string, value: number }> }> };

export type PortfoliosCollectionsChartQueryVariables = Exact<{
  forLastMonths: Scalars['Int']['input'];
}>;


export type PortfoliosCollectionsChartQuery = { __typename?: 'Query', portfoliosCollectionsChart: Array<{ __typename?: 'PortfoliosCollectionsChartPoint', date: any, series: Array<{ __typename?: 'PortfoliosCollectionsChartSeriesItem', userId: string, value: number }> }> };

export type RecurrencyTransactionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RecurrencyTransactionsQuery = { __typename?: 'Query', recurrencyTransactions: Array<{ __typename?: 'Transaction', id: string, externalId?: string | null, name: string, to: string, account: string, status: TransactionStatus, type: TransactionType, originationDate?: any | null, effectiveDate?: any | null, depositDate?: any | null, returnCode?: string | null, returnDate?: any | null, amount: number, notes?: string | null, recurrenceDescription?: string | null, createdAt: any, modifiedAt: any, number?: number | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, logo: string, description: string } | null }> };

export type McaIntegrationTransactionsQueryVariables = Exact<{
  mcaId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
}>;


export type McaIntegrationTransactionsQuery = { __typename?: 'Query', mcaIntegrationTransactions: Array<{ __typename?: 'Transaction', id: string, externalId?: string | null, name: string, to: string, account: string, status: TransactionStatus, type: TransactionType, originationDate?: any | null, effectiveDate?: any | null, depositDate?: any | null, returnCode?: string | null, returnDate?: any | null, amount: number, notes?: string | null, recurrenceDescription?: string | null, createdAt: any, modifiedAt: any, number?: number | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, logo: string, description: string } | null }> };

export type StopTransactionMutationVariables = Exact<{
  transactionId: Scalars['ID']['input'];
}>;


export type StopTransactionMutation = { __typename?: 'Mutation', stopTransaction: number };

export type ListTransactionsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  statuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  types?: InputMaybe<Array<TransactionType> | TransactionType>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type ListTransactionsQuery = { __typename?: 'Query', listTransactions: { __typename?: 'TransactionsList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Transaction', id: string, externalId?: string | null, name: string, to: string, account: string, status: TransactionStatus, type: TransactionType, originationDate?: any | null, effectiveDate?: any | null, depositDate?: any | null, returnCode?: string | null, returnDate?: any | null, amount: number, notes?: string | null, recurrenceDescription?: string | null, createdAt: any, modifiedAt: any, paymentMethod?: { __typename?: 'PaymentMethod', id: string, logo: string, description: string } | null, integration?: { __typename?: 'Integration', id: string, name: string, logo?: string | null, type: IntegrationType, company?: { __typename?: 'InternalCompany', id: string, legalName?: string | null, dba?: string | null, logo?: string | null } | null } | null, mca?: { __typename?: 'MerchantCashAdvance', id: string, number: number, status: MerchantCashAdvanceStatus, referenceMca: string } | null }> } };

export type TransactionsSummaryQueryVariables = Exact<{
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  statuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  types?: InputMaybe<Array<TransactionType> | TransactionType>;
}>;


export type TransactionsSummaryQuery = { __typename?: 'Query', transactionsSummary: { __typename?: 'TransactionsSummaryDto', amount: number } };

export type InvestorBalanceTransactionsQueryVariables = Exact<{
  investorId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  types?: InputMaybe<Array<TransactionType> | TransactionType>;
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type InvestorBalanceTransactionsQuery = { __typename?: 'Query', investorBalanceTransactions: { __typename?: 'InvestorBalanceTransactionsList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'InvestorBalanceTransactionDto', id: string, externalId?: string | null, name?: string | null, notes?: string | null, mcaId?: string | null, mcaNumber?: number | null, mcaStatus?: MerchantCashAdvanceStatus | null, merchantName?: string | null, originationDate: any, effectiveDate: any, depositDate?: any | null, status: TransactionStatus, type: TransactionType, number: number, amount?: number | null, runningBalance: number, paymentMethodId?: string | null }>, summary: { __typename?: 'InvestorBalanceSummaryDto', debit?: number | null, credit?: number | null } } };

export type InvestorCashTransactionsQueryVariables = Exact<{
  investorId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  types?: InputMaybe<Array<TransactionType> | TransactionType>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type InvestorCashTransactionsQuery = { __typename?: 'Query', investorCashTransactions: { __typename?: 'InvestorBalanceTransactionsList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'InvestorBalanceTransactionDto', id: string, name?: string | null, notes?: string | null, effectiveDate: any, depositDate?: any | null, status: TransactionStatus, type: TransactionType, number: number, amount?: number | null, runningCashInOutBalance?: number | null, paymentMethodId?: string | null }> } };

export type InvestorCashTransactionsSummaryQueryVariables = Exact<{
  investorId: Scalars['ID']['input'];
  statuses?: InputMaybe<Array<TransactionStatus> | TransactionStatus>;
  types?: InputMaybe<Array<TransactionType> | TransactionType>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type InvestorCashTransactionsSummaryQuery = { __typename?: 'Query', investorCashTransactionsSummary: { __typename?: 'InvestorBalanceTransactionSummaryDto', cashInTotal: number, cashOutTotal: number } };

export type SaveCashTransactionMutationVariables = Exact<{
  dto: CashTransactionDto;
}>;


export type SaveCashTransactionMutation = { __typename?: 'Mutation', saveCashTransaction: { __typename?: 'Transaction', id: string, amount: number } };

export type DeleteCashTransactionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCashTransactionMutation = { __typename?: 'Mutation', deleteCashTransaction: string };

export type InvestorBalanceQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type InvestorBalanceQuery = { __typename?: 'Query', investorBalance: { __typename?: 'InvestorBalanceDto', balance: number } };

export type InvestorBalanceChartQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  forLastMonths: Scalars['Int']['input'];
}>;


export type InvestorBalanceChartQuery = { __typename?: 'Query', investorBalanceChart: Array<{ __typename?: 'Chart', date: any, value: number }> };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethod', id: string, logo: string, description: string, order: number }> };

export type UnderwritersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type UnderwritersQuery = { __typename?: 'Query', underwriters: { __typename?: 'UnderwritersList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null, description?: string | null, createdAt: any, modifiedAt: any, createdBy?: { __typename?: 'User', id: string, name?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null }> } };

export type UnderwriterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnderwriterQuery = { __typename?: 'Query', underwriter: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null, createdAt: any, modifiedAt: any, createdBy?: { __typename?: 'User', id: string, name?: string | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null } | null } };

export type SaveUnderwriterMutationVariables = Exact<{
  dto: UnderwriterDto;
}>;


export type SaveUnderwriterMutation = { __typename?: 'Mutation', saveUnderwriter: { __typename?: 'Underwriter', id: string, name?: string | null, logo?: string | null, description?: string | null } };

export type DeleteUnderwriterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUnderwriterMutation = { __typename?: 'Mutation', deleteUnderwriter: string };

export type AddUserToUnderwriterMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  underwriterId: Scalars['ID']['input'];
}>;


export type AddUserToUnderwriterMutation = { __typename?: 'Mutation', addUserToUnderwriter: { __typename?: 'UserFunderConnections', user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, funder?: { __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null } | null } };

export type RemoveUserFromUnderwriterMutationVariables = Exact<{
  underwriterId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromUnderwriterMutation = { __typename?: 'Mutation', removeUserFromUnderwriter: boolean };

export type GetUsersForUnderwriterQueryVariables = Exact<{
  underwriterId: Scalars['ID']['input'];
}>;


export type GetUsersForUnderwriterQuery = { __typename?: 'Query', getUsersForUnderwriter: Array<{ __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null }> };

export type GetAllUnderwritersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUnderwritersQuery = { __typename?: 'Query', getAllUnderwriters: Array<{ __typename?: 'Underwriter', id: string, name?: string | null, code?: string | null, logo?: string | null, connectedUsers?: Array<{ __typename?: 'UserFunderConnections', user?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', avatar?: string | null } | null } | null }> | null }> };

export type GetUnderwriterMemberInfoQueryVariables = Exact<{
  underwriterId: Scalars['ID']['input'];
}>;


export type GetUnderwriterMemberInfoQuery = { __typename?: 'Query', getUnderwriterMemberInfo: Array<{ __typename?: 'UnderwriterMemberInfo', id: string, name?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, avatar?: string | null, description?: string | null, bizPhone?: string | null, cellPhone?: string | null }> };

export type UptimeQueryVariables = Exact<{ [key: string]: never; }>;


export type UptimeQuery = { __typename?: 'Query', uptime: number };

export type UsersQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<Rights>;
  role?: InputMaybe<Array<Roles> | Roles>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  rights?: InputMaybe<Array<Rights> | Rights>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'User', id: string, email?: string | null, name?: string | null, phone?: string | null, locale?: string | null, isEmailConfirmed?: boolean | null, isPhoneConfirmed?: boolean | null, createdAt: any, modifiedAt: any, isLoginEnabled?: boolean | null, isActive?: boolean | null, cognitoSub?: string | null, mfaConfigured: boolean, mfaEnabled: boolean, accessTokenTtlHours: number, mfaDeviceRememberingEnabled: boolean, deviceRememberingDays: number, enableReturnedTransactionsReport: boolean, isOwner: boolean, role?: Array<Roles> | null, rights?: Array<Rights> | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null }> } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: string | null, name?: string | null, phone?: string | null, locale?: string | null, isLoginEnabled?: boolean | null, enableReturnedTransactionsReport: boolean, isOwner: boolean, isEmailConfirmed?: boolean | null, isPhoneConfirmed?: boolean | null, createdAt: any, modifiedAt: any, isActive?: boolean | null, role?: Array<Roles> | null, rights?: Array<Rights> | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, createdBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, modifiedBy?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, portfolioConnections?: Array<{ __typename?: 'UserPortfolioConnections', targetUser?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> | null, portfolioConnectedTo?: Array<{ __typename?: 'UserPortfolioConnections', sourceUser?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> | null } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'User', id: string, email?: string | null, name?: string | null, phone?: string | null, locale?: string | null, isEmailConfirmed?: boolean | null, isPhoneConfirmed?: boolean | null, createdAt: any, modifiedAt: any, isLoginEnabled?: boolean | null, isActive?: boolean | null, role?: Array<Roles> | null, rights?: Array<Rights> | null, gridPreferences?: Array<{ __typename?: 'UserGridPreferences', key: GridType, active: boolean, name: string, columnsState: string, filterState: string, useScroll?: boolean | null, rowsPerPage?: number | null }> | null, preferences?: { __typename?: 'UserPreferences', showTrailingZeros: boolean, hidePerformanceChart: boolean } | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, dba?: string | null, type?: Array<CompanyType> | null, logo?: string | null } | null, portfolioConnections?: Array<{ __typename?: 'UserPortfolioConnections', targetUser?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> | null, portfolioConnectedTo?: Array<{ __typename?: 'UserPortfolioConnections', targetUser?: { __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null }> | null } };

export type IsEmailRegisteredQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type IsEmailRegisteredQuery = { __typename?: 'Query', isEmailRegistered: boolean };

export type SaveUserMutationVariables = Exact<{
  dto: UserDto;
}>;


export type SaveUserMutation = { __typename?: 'Mutation', saveUser: { __typename?: 'User', id: string, email?: string | null, role?: Array<Roles> | null, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, manager?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } | null } };

export type SaveAndInviteUserMutationVariables = Exact<{
  dto: UserDto;
}>;


export type SaveAndInviteUserMutation = { __typename?: 'Mutation', saveAndInviteUser: { __typename?: 'User', id: string, email?: string | null, role?: Array<Roles> | null, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null } };

export type SaveProfileMutationVariables = Exact<{
  dto: ProfileDto;
}>;


export type SaveProfileMutation = { __typename?: 'Mutation', saveProfile: { __typename?: 'User', id: string, email?: string | null, name?: string | null } };

export type ChangePasswordMutationVariables = Exact<{
  dto: ChangePasswordDto;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'User', id: string, email?: string | null, name?: string | null } };

export type ToggleUserActivationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ToggleUserActivationMutation = { __typename?: 'Mutation', toggleUserActivation: { __typename?: 'User', id: string, email?: string | null, name?: string | null } };

export type SavePreferencesMutationVariables = Exact<{
  dto: UserPreferencesDto;
}>;


export type SavePreferencesMutation = { __typename?: 'Mutation', savePreferences: { __typename?: 'User', gridPreferences?: Array<{ __typename?: 'UserGridPreferences', key: GridType, active: boolean, name: string, columnsState: string, filterState: string, useScroll?: boolean | null, rowsPerPage?: number | null }> | null, preferences?: { __typename?: 'UserPreferences', showTrailingZeros: boolean, hidePerformanceChart: boolean } | null } };

export type ResendInvitationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResendInvitationMutation = { __typename?: 'Mutation', resendInvitation: { __typename?: 'User', id: string } };

export type SendCognitoSetupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendCognitoSetupMutation = { __typename?: 'Mutation', sendCognitoSetup: { __typename?: 'User', id: string } };

export type UpdateUserMfaSettingsMutationVariables = Exact<{
  dto: MfaSettingsDto;
}>;


export type UpdateUserMfaSettingsMutation = { __typename?: 'Mutation', updateUserMfaSettings: { __typename?: 'User', id: string, mfaEnabled: boolean, mfaConfigured: boolean, accessTokenTtlHours: number, mfaDeviceRememberingEnabled: boolean, deviceRememberingDays: number } };

export type GetUsersWithAccessiblePortfolioQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUsersWithAccessiblePortfolioQuery = { __typename?: 'Query', getUsersWithAccessiblePortfolio: Array<{ __typename?: 'User', id: string, name?: string | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null }> };

export type AccessiblePortfoliosQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessiblePortfoliosQuery = { __typename?: 'Query', accessiblePortfolios: Array<{ __typename?: 'User', id: string, name?: string | null, rights?: Array<Rights> | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null }> };

export type AssignAccessToPortfolioMutationVariables = Exact<{
  sourceUserId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
}>;


export type AssignAccessToPortfolioMutation = { __typename?: 'Mutation', assignAccessToPortfolio: { __typename?: 'UserPortfolioConnections', sourceUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, targetUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } };

export type RemoveAccessToPortfolioMutationVariables = Exact<{
  sourceUserId: Scalars['ID']['input'];
  targetUserId: Scalars['ID']['input'];
}>;


export type RemoveAccessToPortfolioMutation = { __typename?: 'Mutation', removeAccessToPortfolio: boolean };

export type InvestorsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  right?: InputMaybe<Rights>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  rights?: InputMaybe<Array<Rights> | Rights>;
  sortArgs?: InputMaybe<Array<SortArgs> | SortArgs>;
}>;


export type InvestorsQuery = { __typename?: 'Query', investors: { __typename?: 'UsersList', total: number, offset: number, limit: number, data: Array<{ __typename?: 'User', id: string, email?: string | null, name?: string | null, phone?: string | null, locale?: string | null, isEmailConfirmed?: boolean | null, isPhoneConfirmed?: boolean | null, createdAt: any, modifiedAt: any, isLoginEnabled?: boolean | null, isActive?: boolean | null, role?: Array<Roles> | null, rights?: Array<Rights> | null, balance?: number | null, pnl?: number | null, fundingWallet?: number | null, remittance?: number | null, remittanceFee?: number | null, firstTransactionDate?: any | null, data?: { __typename?: 'UserData', cellPhone?: string | null, bizPhone?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, avatar?: string | null, description?: string | null, ssn?: string | null, address?: { __typename?: 'Address', line1?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, company?: { __typename?: 'Company', id?: string | null, legalName?: string | null, logo?: string | null } | null }> } };

export type UserBankAccountsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserBankAccountsQuery = { __typename?: 'Query', userBankAccounts: Array<{ __typename?: 'UserBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null, name?: string | null }> };

export type SaveUserBankAccountMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  dto: MerchantBankAccountDto;
}>;


export type SaveUserBankAccountMutation = { __typename?: 'Mutation', saveUserBankAccount: { __typename?: 'UserBankAccount', id?: string | null, routingNumber?: string | null, accountNumber?: string | null, name?: string | null } };

export type DeleteUserBankAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserBankAccountMutation = { __typename?: 'Mutation', deleteUserBankAccount: string };

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  IntegrationSecret: ( SecretAchProc ) | ( SecretClearAchBot ) | ( SecretDevNull ) | ( SecretGoAch ) | ( SecretGoAchBot ) | ( SecretLiftoffCard );
}>;


/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AddBankLocationInput: AddBankLocationInput;
  Address: ResolverTypeWrapper<Address>;
  AddressDto: AddressDto;
  AddressInputDto: AddressInputDto;
  Application: ResolverTypeWrapper<Omit<Application, 'broker' | 'createdBy' | 'funder' | 'latestStatusHistory' | 'manager' | 'modifiedBy' | 'offers' | 'status'> & { broker?: Maybe<ResolversTypes['User']>, createdBy?: Maybe<ResolversTypes['User']>, funder?: Maybe<ResolversTypes['User']>, latestStatusHistory?: Maybe<ResolversTypes['ApplicationStatusHistory']>, manager?: Maybe<ResolversTypes['User']>, modifiedBy?: Maybe<ResolversTypes['User']>, offers?: Maybe<Array<ResolversTypes['Offer']>>, status?: Maybe<ResolversTypes['ApplicationStatus']> }>;
  ApplicationExternalServiceConnection: ResolverTypeWrapper<Omit<ApplicationExternalServiceConnection, 'application' | 'createdBy' | 'externalServiceConfiguration' | 'modifiedBy'> & { application: ResolversTypes['Application'], createdBy: ResolversTypes['User'], externalServiceConfiguration: ResolversTypes['ExternalServiceConfiguration'], modifiedBy?: Maybe<ResolversTypes['User']> }>;
  ApplicationExternalServiceConnectionDto: ResolverTypeWrapper<Omit<ApplicationExternalServiceConnectionDto, 'externalServiceConfiguration'> & { externalServiceConfiguration?: Maybe<ResolversTypes['ExternalServiceConfiguration']> }>;
  ApplicationExternalServiceDataDto: ResolverTypeWrapper<Omit<ApplicationExternalServiceDataDto, 'connection'> & { connection?: Maybe<ResolversTypes['ApplicationExternalServiceConnectionDto']> }>;
  ApplicationList: ResolverTypeWrapper<Omit<ApplicationList, 'data'> & { data: Array<ResolversTypes['Application']> }>;
  ApplicationProcessor: ResolverTypeWrapper<ApplicationProcessor>;
  ApplicationStatus: ResolverTypeWrapper<ApplicationStatus>;
  ApplicationStatusHistory: ResolverTypeWrapper<Omit<ApplicationStatusHistory, 'fromStatus' | 'toStatus' | 'user'> & { fromStatus: ResolversTypes['ApplicationStatus'], toStatus: ResolversTypes['ApplicationStatus'], user?: Maybe<ResolversTypes['User']> }>;
  ApplicationWithOffer: ResolverTypeWrapper<Omit<ApplicationWithOffer, 'application' | 'offer'> & { application: ResolversTypes['Application'], offer?: Maybe<ResolversTypes['Offer']> }>;
  ApplicationWithOfferList: ResolverTypeWrapper<Omit<ApplicationWithOfferList, 'data'> & { data: Array<ResolversTypes['ApplicationWithOffer']> }>;
  AuditEvent: ResolverTypeWrapper<Omit<AuditEvent, 'application' | 'mca' | 'user'> & { application?: Maybe<ResolversTypes['Application']>, mca?: Maybe<ResolversTypes['MerchantCashAdvance']>, user?: Maybe<ResolversTypes['User']> }>;
  AuditLogList: ResolverTypeWrapper<Omit<AuditLogList, 'data'> & { data: Array<ResolversTypes['AuditEvent']> }>;
  AvailableDocumentDto: ResolverTypeWrapper<AvailableDocumentDto>;
  BankInfo: ResolverTypeWrapper<BankInfo>;
  BankInfoByRoutingNumber: ResolverTypeWrapper<BankInfoByRoutingNumber>;
  BankList: ResolverTypeWrapper<BankList>;
  BankLocation: ResolverTypeWrapper<BankLocation>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BrokerDto: BrokerDto;
  CalendarEvent: ResolverTypeWrapper<CalendarEvent>;
  CashTransactionDto: CashTransactionDto;
  ChangePasswordDto: ChangePasswordDto;
  Chart: ResolverTypeWrapper<Chart>;
  Commission: ResolverTypeWrapper<Omit<Commission, 'createdBy' | 'mca' | 'modifiedBy'> & { createdBy: ResolversTypes['User'], mca?: Maybe<ResolversTypes['MerchantCashAdvance']>, modifiedBy?: Maybe<ResolversTypes['User']> }>;
  CommissionDto: CommissionDto;
  CompaniesList: ResolverTypeWrapper<Omit<CompaniesList, 'data'> & { data: Array<ResolversTypes['Company']> }>;
  Company: ResolverTypeWrapper<Omit<Company, 'bankAccounts' | 'createdBy' | 'mcas' | 'modifiedBy' | 'users'> & { bankAccounts?: Maybe<Array<ResolversTypes['MerchantBankAccount']>>, createdBy?: Maybe<ResolversTypes['User']>, mcas?: Maybe<Array<ResolversTypes['MerchantCashAdvance']>>, modifiedBy?: Maybe<ResolversTypes['User']>, users?: Maybe<Array<ResolversTypes['User']>> }>;
  CompanyDocumentDto: ResolverTypeWrapper<CompanyDocumentDto>;
  CompanyDto: CompanyDto;
  CompanyOwner: ResolverTypeWrapper<Omit<CompanyOwner, 'company' | 'createdBy' | 'modifiedBy' | 'owner'> & { company: ResolversTypes['Company'], createdBy: ResolversTypes['User'], modifiedBy: ResolversTypes['User'], owner: ResolversTypes['Owner'] }>;
  CompanyType: CompanyType;
  ConfigFee: ResolverTypeWrapper<Omit<ConfigFee, 'createdBy' | 'modifiedBy'> & { createdBy: ResolversTypes['User'], modifiedBy?: Maybe<ResolversTypes['User']> }>;
  ConfigFeeDto: ConfigFeeDto;
  ConfigFeeName: ConfigFeeName;
  ConfigFeesList: ResolverTypeWrapper<ConfigFeesList>;
  ConsumerPiiInputDto: ConsumerPiiInputDto;
  CreateApplicationInput: CreateApplicationInput;
  CreateOfferInput: CreateOfferInput;
  CreateStipulationInput: CreateStipulationInput;
  DailyCollectionsChartPoint: ResolverTypeWrapper<DailyCollectionsChartPoint>;
  DailyCollectionsChartSeriesItem: ResolverTypeWrapper<DailyCollectionsChartSeriesItem>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  ExternalServiceConfiguration: ResolverTypeWrapper<Omit<ExternalServiceConfiguration, 'company' | 'createdBy' | 'modifiedBy'> & { company?: Maybe<ResolversTypes['InternalCompany']>, createdBy: ResolversTypes['User'], modifiedBy?: Maybe<ResolversTypes['User']> }>;
  ExternalServiceDto: ResolverTypeWrapper<Omit<ExternalServiceDto, 'company'> & { company?: Maybe<ResolversTypes['InternalCompany']> }>;
  ExternalServiceInputDto: ExternalServiceInputDto;
  ExternalServiceType: ExternalServiceType;
  FeeDto: FeeDto;
  FineDto: FineDto;
  FineStatus: FineStatus;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FunderPortFolioDto: ResolverTypeWrapper<FunderPortFolioDto>;
  FundingFee: ResolverTypeWrapper<Omit<FundingFee, 'createdBy' | 'mca' | 'modifiedBy'> & { createdBy: ResolversTypes['User'], mca?: Maybe<ResolversTypes['MerchantCashAdvance']>, modifiedBy?: Maybe<ResolversTypes['User']> }>;
  FundingPipeLineOffersCount: ResolverTypeWrapper<FundingPipeLineOffersCount>;
  FundingPipelineStatusCount: ResolverTypeWrapper<FundingPipelineStatusCount>;
  GridType: GridType;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  ImportedStatsDto: ResolverTypeWrapper<ImportedStatsDto>;
  ImportedTransactionDto: ResolverTypeWrapper<ImportedTransactionDto>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Integration: ResolverTypeWrapper<Omit<Integration, 'company' | 'createdBy' | 'modifiedBy' | 'secret'> & { company?: Maybe<ResolversTypes['InternalCompany']>, createdBy: ResolversTypes['User'], modifiedBy?: Maybe<ResolversTypes['User']>, secret: ResolversTypes['IntegrationSecret'] }>;
  IntegrationDto: IntegrationDto;
  IntegrationEnvironment: IntegrationEnvironment;
  IntegrationHealthMonitor: ResolverTypeWrapper<IntegrationHealthMonitor>;
  IntegrationScheduleDto: ResolverTypeWrapper<IntegrationScheduleDto>;
  IntegrationSecret: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['IntegrationSecret']>;
  IntegrationSettingsDto: IntegrationSettingsDto;
  IntegrationType: IntegrationType;
  IntegrationsList: ResolverTypeWrapper<Omit<IntegrationsList, 'data'> & { data: Array<ResolversTypes['Integration']> }>;
  InternalCompaniesList: ResolverTypeWrapper<Omit<InternalCompaniesList, 'data'> & { data: Array<ResolversTypes['InternalCompany']> }>;
  InternalCompany: ResolverTypeWrapper<Omit<InternalCompany, 'createdBy' | 'documents' | 'integrations' | 'mcas' | 'modifiedBy'> & { createdBy?: Maybe<ResolversTypes['User']>, documents: Array<ResolversTypes['CompanyDocumentDto']>, integrations?: Maybe<Array<ResolversTypes['Integration']>>, mcas?: Maybe<Array<ResolversTypes['MerchantCashAdvance']>>, modifiedBy?: Maybe<ResolversTypes['User']> }>;
  InternalCompanyDocumentsInfo: ResolverTypeWrapper<Omit<InternalCompanyDocumentsInfo, 'subfolderDocuments'> & { subfolderDocuments: Array<ResolversTypes['CompanyDocumentDto']> }>;
  InternalCompanyDto: InternalCompanyDto;
  InvestorBalanceDto: ResolverTypeWrapper<InvestorBalanceDto>;
  InvestorBalanceSummaryDto: ResolverTypeWrapper<InvestorBalanceSummaryDto>;
  InvestorBalanceTransactionDto: ResolverTypeWrapper<InvestorBalanceTransactionDto>;
  InvestorBalanceTransactionSummaryDto: ResolverTypeWrapper<InvestorBalanceTransactionSummaryDto>;
  InvestorBalanceTransactionsList: ResolverTypeWrapper<InvestorBalanceTransactionsList>;
  InvestorPortFolioDto: ResolverTypeWrapper<InvestorPortFolioDto>;
  InvestorReconciliationBalanceDto: ResolverTypeWrapper<Omit<InvestorReconciliationBalanceDto, 'lastReconciliationBy' | 'reconciliations'> & { lastReconciliationBy?: Maybe<ResolversTypes['User']>, reconciliations?: Maybe<Array<ResolversTypes['Reconciliation']>> }>;
  InvestorReconciliationBalanceList: ResolverTypeWrapper<Omit<InvestorReconciliationBalanceList, 'data'> & { data: Array<ResolversTypes['InvestorReconciliationBalanceDto']> }>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  ManualTransactionDto: ManualTransactionDto;
  McaAverageFundingTerms: ResolverTypeWrapper<McaAverageFundingTerms>;
  McaDisplayAttribute: ResolverTypeWrapper<McaDisplayAttribute>;
  McaDynamicRole: McaDynamicRole;
  McaIntegrationsDto: ResolverTypeWrapper<Omit<McaIntegrationsDto, 'integration'> & { integration: ResolversTypes['Integration'] }>;
  McaManagementType: McaManagementType;
  McaRefi: ResolverTypeWrapper<McaRefi>;
  McaRefiDto: McaRefiDto;
  McaRefiType: McaRefiType;
  MerchantBankAccount: ResolverTypeWrapper<Omit<MerchantBankAccount, 'merchant'> & { merchant?: Maybe<ResolversTypes['Company']> }>;
  MerchantBankAccountDto: MerchantBankAccountDto;
  MerchantCashAdvance: ResolverTypeWrapper<Omit<MerchantCashAdvance, 'broker' | 'company' | 'createdBy' | 'externalConnections' | 'fundingFee' | 'integration' | 'lastTransaction' | 'legal' | 'manager' | 'merchant' | 'modifiedBy' | 'recurrencies' | 'statusChangedBy' | 'syndications'> & { broker?: Maybe<ResolversTypes['User']>, company?: Maybe<ResolversTypes['InternalCompany']>, createdBy: ResolversTypes['User'], externalConnections?: Maybe<Array<ResolversTypes['MerchantCashAdvanceExternalServiceConnection']>>, fundingFee?: Maybe<Array<ResolversTypes['FundingFee']>>, integration?: Maybe<ResolversTypes['Integration']>, lastTransaction?: Maybe<ResolversTypes['Transaction']>, legal?: Maybe<ResolversTypes['User']>, manager?: Maybe<ResolversTypes['User']>, merchant: ResolversTypes['Company'], modifiedBy?: Maybe<ResolversTypes['User']>, recurrencies?: Maybe<Array<ResolversTypes['Recurrency']>>, statusChangedBy: ResolversTypes['User'], syndications?: Maybe<Array<ResolversTypes['Syndication']>> }>;
  MerchantCashAdvanceDto: MerchantCashAdvanceDto;
  MerchantCashAdvanceExternalServiceConnection: ResolverTypeWrapper<Omit<MerchantCashAdvanceExternalServiceConnection, 'createdBy' | 'externalServiceConfiguration' | 'mca' | 'modifiedBy'> & { createdBy: ResolversTypes['User'], externalServiceConfiguration: ResolversTypes['ExternalServiceConfiguration'], mca: ResolversTypes['MerchantCashAdvance'], modifiedBy?: Maybe<ResolversTypes['User']> }>;
  MerchantCashAdvanceExternalServiceConnectionDto: ResolverTypeWrapper<Omit<MerchantCashAdvanceExternalServiceConnectionDto, 'externalServiceConfiguration'> & { externalServiceConfiguration?: Maybe<ResolversTypes['ExternalServiceConfiguration']> }>;
  MerchantCashAdvanceExternalServiceDataDto: ResolverTypeWrapper<Omit<MerchantCashAdvanceExternalServiceDataDto, 'connection'> & { connection?: Maybe<ResolversTypes['MerchantCashAdvanceExternalServiceConnection']> }>;
  MerchantCashAdvanceStatus: MerchantCashAdvanceStatus;
  MerchantCashAdvanceStatusHistory: ResolverTypeWrapper<Omit<MerchantCashAdvanceStatusHistory, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  MerchantCashAdvanceSummary: ResolverTypeWrapper<MerchantCashAdvanceSummary>;
  MerchantCashAdvancesList: ResolverTypeWrapper<Omit<MerchantCashAdvancesList, 'data'> & { data: Array<ResolversTypes['MerchantCashAdvance']> }>;
  MerchantDto: MerchantDto;
  MfaSettingsDto: MfaSettingsDto;
  Mutation: ResolverTypeWrapper<{}>;
  NonWorkingDay: ResolverTypeWrapper<NonWorkingDay>;
  Offer: ResolverTypeWrapper<Omit<Offer, 'application' | 'broker' | 'company' | 'createdBy' | 'integration' | 'manager' | 'mca' | 'modifiedBy' | 'offerEmails'> & { application: ResolversTypes['Application'], broker?: Maybe<ResolversTypes['User']>, company?: Maybe<ResolversTypes['InternalCompany']>, createdBy?: Maybe<ResolversTypes['User']>, integration?: Maybe<ResolversTypes['Integration']>, manager?: Maybe<ResolversTypes['User']>, mca?: Maybe<ResolversTypes['MerchantCashAdvance']>, modifiedBy?: Maybe<ResolversTypes['User']>, offerEmails?: Maybe<Array<ResolversTypes['OfferEmail']>> }>;
  OfferApplicationsCount: ResolverTypeWrapper<OfferApplicationsCount>;
  OfferEmail: ResolverTypeWrapper<Omit<OfferEmail, 'createdBy' | 'modifiedBy' | 'offer'> & { createdBy: ResolversTypes['User'], modifiedBy?: Maybe<ResolversTypes['User']>, offer: ResolversTypes['Offer'] }>;
  OfferFeeCommissionInput: OfferFeeCommissionInput;
  OfferFeeCommissionJson: ResolverTypeWrapper<OfferFeeCommissionJson>;
  OfferList: ResolverTypeWrapper<Omit<OfferList, 'data'> & { data: Array<ResolversTypes['Offer']> }>;
  OfferMerchantCashAdvanceDto: ResolverTypeWrapper<Omit<OfferMerchantCashAdvanceDto, 'broker' | 'company' | 'integration' | 'manager' | 'merchant'> & { broker?: Maybe<ResolversTypes['User']>, company?: Maybe<ResolversTypes['InternalCompany']>, integration?: Maybe<ResolversTypes['Integration']>, manager?: Maybe<ResolversTypes['User']>, merchant?: Maybe<ResolversTypes['Company']> }>;
  OfferType: OfferType;
  OffersLinkToFiles: ResolverTypeWrapper<OffersLinkToFiles>;
  Owner: ResolverTypeWrapper<Omit<Owner, 'companyOwners' | 'createdBy' | 'modifiedBy'> & { companyOwners: ResolversTypes['CompanyOwner'], createdBy?: Maybe<ResolversTypes['User']>, modifiedBy?: Maybe<ResolversTypes['User']> }>;
  OwnerDto: OwnerDto;
  PaymentMethod: ResolverTypeWrapper<PaymentMethod>;
  Permission: ResolverTypeWrapper<Permission>;
  PermissionsList: ResolverTypeWrapper<PermissionsList>;
  PortFolioChartDto: ResolverTypeWrapper<PortFolioChartDto>;
  PortFolioSummaryDto: ResolverTypeWrapper<PortFolioSummaryDto>;
  PortfoliosCollectionsChartPoint: ResolverTypeWrapper<PortfoliosCollectionsChartPoint>;
  PortfoliosCollectionsChartSeriesItem: ResolverTypeWrapper<PortfoliosCollectionsChartSeriesItem>;
  PostFundingFee: ResolverTypeWrapper<Omit<PostFundingFee, 'createdBy' | 'modifiedBy'> & { createdBy?: Maybe<ResolversTypes['User']>, modifiedBy?: Maybe<ResolversTypes['User']> }>;
  PreferencesDto: PreferencesDto;
  ProductArea: ProductArea;
  ProfileDto: ProfileDto;
  PullCreditReportResultDto: ResolverTypeWrapper<Omit<PullCreditReportResultDto, 'data'> & { data?: Maybe<ResolversTypes['ApplicationExternalServiceDataDto']> }>;
  Query: ResolverTypeWrapper<{}>;
  Reconciliation: ResolverTypeWrapper<Omit<Reconciliation, 'createdBy' | 'investor'> & { createdBy: ResolversTypes['User'], investor: ResolversTypes['User'] }>;
  ReconciliationAction: ReconciliationAction;
  ReconciliationType: ReconciliationType;
  Recurrency: ResolverTypeWrapper<Omit<Recurrency, 'createdBy' | 'integration' | 'mca' | 'modifiedBy'> & { createdBy: ResolversTypes['User'], integration: ResolversTypes['Integration'], mca: ResolversTypes['MerchantCashAdvance'], modifiedBy?: Maybe<ResolversTypes['User']> }>;
  RecurrencyDto: RecurrencyDto;
  RecurrencyProcessorData: ResolverTypeWrapper<RecurrencyProcessorData>;
  RecurrencyState: RecurrencyState;
  Rights: Rights;
  Role: ResolverTypeWrapper<Omit<Role, 'createdBy' | 'modifiedBy'> & { createdBy: ResolversTypes['User'], modifiedBy: ResolversTypes['User'] }>;
  RoleRightsMapping: ResolverTypeWrapper<RoleRightsMapping>;
  Roles: Roles;
  RolesList: ResolverTypeWrapper<Omit<RolesList, 'data'> & { data: Array<ResolversTypes['Role']> }>;
  RoutingNumber: ResolverTypeWrapper<RoutingNumber>;
  RoutingNumberAssignment: ResolverTypeWrapper<RoutingNumberAssignment>;
  SaveBankInput: SaveBankInput;
  SaveBankLocationInput: SaveBankLocationInput;
  SaveLocationRoutingNumbersInput: SaveLocationRoutingNumbersInput;
  SecretAchProc: ResolverTypeWrapper<SecretAchProc>;
  SecretAchProcDto: SecretAchProcDto;
  SecretClearAchBot: ResolverTypeWrapper<SecretClearAchBot>;
  SecretClearAchBotDto: SecretClearAchBotDto;
  SecretDevNull: ResolverTypeWrapper<SecretDevNull>;
  SecretGoAch: ResolverTypeWrapper<SecretGoAch>;
  SecretGoAchBot: ResolverTypeWrapper<SecretGoAchBot>;
  SecretGoAchBotDto: SecretGoAchBotDto;
  SecretGoAchDto: SecretGoAchDto;
  SecretLiftoffCard: ResolverTypeWrapper<SecretLiftoffCard>;
  SecretLiftoffCardDto: SecretLiftoffCardDto;
  SendEmailInput: SendEmailInput;
  Settings: ResolverTypeWrapper<Settings>;
  SortArgs: SortArgs;
  Stipulation: ResolverTypeWrapper<Stipulation>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubfolderFileInfo: ResolverTypeWrapper<SubfolderFileInfo>;
  Syndication: ResolverTypeWrapper<Omit<Syndication, 'createdBy' | 'mca' | 'modifiedBy' | 'user'> & { createdBy?: Maybe<ResolversTypes['User']>, mca?: Maybe<Array<ResolversTypes['MerchantCashAdvance']>>, modifiedBy?: Maybe<ResolversTypes['User']>, user?: Maybe<ResolversTypes['User']> }>;
  SyndicationCalculation: SyndicationCalculation;
  SyndicationDetailsDto: ResolverTypeWrapper<Omit<SyndicationDetailsDto, 'broker' | 'externalConnections' | 'integration' | 'legal' | 'manager' | 'merchant'> & { broker?: Maybe<ResolversTypes['User']>, externalConnections?: Maybe<Array<ResolversTypes['MerchantCashAdvanceExternalServiceConnection']>>, integration: ResolversTypes['Integration'], legal?: Maybe<ResolversTypes['User']>, manager?: Maybe<ResolversTypes['User']>, merchant: ResolversTypes['Company'] }>;
  SyndicationDetailsList: ResolverTypeWrapper<Omit<SyndicationDetailsList, 'data'> & { data: Array<ResolversTypes['SyndicationDetailsDto']> }>;
  SyndicationDetailsSummaryDto: ResolverTypeWrapper<SyndicationDetailsSummaryDto>;
  SyndicationDto: SyndicationDto;
  SyndicationType: SyndicationType;
  TodaysCollectionDto: ResolverTypeWrapper<TodaysCollectionDto>;
  TodaysCollectionSeriesItem: ResolverTypeWrapper<TodaysCollectionSeriesItem>;
  Transaction: ResolverTypeWrapper<Omit<Transaction, 'assignedToUser' | 'integration' | 'mca' | 'recurrency' | 'statusChangedBy'> & { assignedToUser?: Maybe<ResolversTypes['User']>, integration?: Maybe<ResolversTypes['Integration']>, mca?: Maybe<ResolversTypes['MerchantCashAdvance']>, recurrency?: Maybe<ResolversTypes['Recurrency']>, statusChangedBy?: Maybe<ResolversTypes['User']> }>;
  TransactionStatus: TransactionStatus;
  TransactionType: TransactionType;
  TransactionsList: ResolverTypeWrapper<Omit<TransactionsList, 'data'> & { data: Array<ResolversTypes['Transaction']> }>;
  TransactionsSummaryDto: ResolverTypeWrapper<TransactionsSummaryDto>;
  Underwriter: ResolverTypeWrapper<Omit<Underwriter, 'createdBy' | 'modifiedBy'> & { createdBy?: Maybe<ResolversTypes['User']>, modifiedBy?: Maybe<ResolversTypes['User']> }>;
  UnderwriterDto: UnderwriterDto;
  UnderwriterMemberInfo: ResolverTypeWrapper<UnderwriterMemberInfo>;
  UnderwritersList: ResolverTypeWrapper<UnderwritersList>;
  UpdateApplicationInput: UpdateApplicationInput;
  UpdateOfferInput: UpdateOfferInput;
  UpdatePermissionInput: UpdatePermissionInput;
  UpdateStipulationInput: UpdateStipulationInput;
  User: ResolverTypeWrapper<Omit<User, 'bankAccounts' | 'company' | 'createdBy' | 'manager' | 'modifiedBy' | 'portfolioConnectedTo' | 'portfolioConnections' | 'syndications'> & { bankAccounts?: Maybe<Array<ResolversTypes['UserBankAccount']>>, company?: Maybe<ResolversTypes['Company']>, createdBy?: Maybe<ResolversTypes['User']>, manager?: Maybe<ResolversTypes['User']>, modifiedBy?: Maybe<ResolversTypes['User']>, portfolioConnectedTo?: Maybe<Array<ResolversTypes['UserPortfolioConnections']>>, portfolioConnections?: Maybe<Array<ResolversTypes['UserPortfolioConnections']>>, syndications?: Maybe<Array<ResolversTypes['Syndication']>> }>;
  UserBankAccount: ResolverTypeWrapper<Omit<UserBankAccount, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  UserData: ResolverTypeWrapper<UserData>;
  UserDataDto: UserDataDto;
  UserDto: UserDto;
  UserFunderConnections: ResolverTypeWrapper<Omit<UserFunderConnections, 'user'> & { user?: Maybe<ResolversTypes['User']> }>;
  UserGridPreferences: ResolverTypeWrapper<UserGridPreferences>;
  UserGridPreferencesDto: UserGridPreferencesDto;
  UserPortfolioConnections: ResolverTypeWrapper<Omit<UserPortfolioConnections, 'sourceUser' | 'targetUser'> & { sourceUser?: Maybe<ResolversTypes['User']>, targetUser?: Maybe<ResolversTypes['User']> }>;
  UserPreferences: ResolverTypeWrapper<UserPreferences>;
  UserPreferencesDto: UserPreferencesDto;
  UsersList: ResolverTypeWrapper<Omit<UsersList, 'data'> & { data: Array<ResolversTypes['User']> }>;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AddBankLocationInput: AddBankLocationInput;
  Address: Address;
  AddressDto: AddressDto;
  AddressInputDto: AddressInputDto;
  Application: Omit<Application, 'broker' | 'createdBy' | 'funder' | 'latestStatusHistory' | 'manager' | 'modifiedBy' | 'offers' | 'status'> & { broker?: Maybe<ResolversParentTypes['User']>, createdBy?: Maybe<ResolversParentTypes['User']>, funder?: Maybe<ResolversParentTypes['User']>, latestStatusHistory?: Maybe<ResolversParentTypes['ApplicationStatusHistory']>, manager?: Maybe<ResolversParentTypes['User']>, modifiedBy?: Maybe<ResolversParentTypes['User']>, offers?: Maybe<Array<ResolversParentTypes['Offer']>>, status?: Maybe<ResolversParentTypes['ApplicationStatus']> };
  ApplicationExternalServiceConnection: Omit<ApplicationExternalServiceConnection, 'application' | 'createdBy' | 'externalServiceConfiguration' | 'modifiedBy'> & { application: ResolversParentTypes['Application'], createdBy: ResolversParentTypes['User'], externalServiceConfiguration: ResolversParentTypes['ExternalServiceConfiguration'], modifiedBy?: Maybe<ResolversParentTypes['User']> };
  ApplicationExternalServiceConnectionDto: Omit<ApplicationExternalServiceConnectionDto, 'externalServiceConfiguration'> & { externalServiceConfiguration?: Maybe<ResolversParentTypes['ExternalServiceConfiguration']> };
  ApplicationExternalServiceDataDto: Omit<ApplicationExternalServiceDataDto, 'connection'> & { connection?: Maybe<ResolversParentTypes['ApplicationExternalServiceConnectionDto']> };
  ApplicationList: Omit<ApplicationList, 'data'> & { data: Array<ResolversParentTypes['Application']> };
  ApplicationProcessor: ApplicationProcessor;
  ApplicationStatus: ApplicationStatus;
  ApplicationStatusHistory: Omit<ApplicationStatusHistory, 'fromStatus' | 'toStatus' | 'user'> & { fromStatus: ResolversParentTypes['ApplicationStatus'], toStatus: ResolversParentTypes['ApplicationStatus'], user?: Maybe<ResolversParentTypes['User']> };
  ApplicationWithOffer: Omit<ApplicationWithOffer, 'application' | 'offer'> & { application: ResolversParentTypes['Application'], offer?: Maybe<ResolversParentTypes['Offer']> };
  ApplicationWithOfferList: Omit<ApplicationWithOfferList, 'data'> & { data: Array<ResolversParentTypes['ApplicationWithOffer']> };
  AuditEvent: Omit<AuditEvent, 'application' | 'mca' | 'user'> & { application?: Maybe<ResolversParentTypes['Application']>, mca?: Maybe<ResolversParentTypes['MerchantCashAdvance']>, user?: Maybe<ResolversParentTypes['User']> };
  AuditLogList: Omit<AuditLogList, 'data'> & { data: Array<ResolversParentTypes['AuditEvent']> };
  AvailableDocumentDto: AvailableDocumentDto;
  BankInfo: BankInfo;
  BankInfoByRoutingNumber: BankInfoByRoutingNumber;
  BankList: BankList;
  BankLocation: BankLocation;
  Boolean: Scalars['Boolean']['output'];
  BrokerDto: BrokerDto;
  CalendarEvent: CalendarEvent;
  CashTransactionDto: CashTransactionDto;
  ChangePasswordDto: ChangePasswordDto;
  Chart: Chart;
  Commission: Omit<Commission, 'createdBy' | 'mca' | 'modifiedBy'> & { createdBy: ResolversParentTypes['User'], mca?: Maybe<ResolversParentTypes['MerchantCashAdvance']>, modifiedBy?: Maybe<ResolversParentTypes['User']> };
  CommissionDto: CommissionDto;
  CompaniesList: Omit<CompaniesList, 'data'> & { data: Array<ResolversParentTypes['Company']> };
  Company: Omit<Company, 'bankAccounts' | 'createdBy' | 'mcas' | 'modifiedBy' | 'users'> & { bankAccounts?: Maybe<Array<ResolversParentTypes['MerchantBankAccount']>>, createdBy?: Maybe<ResolversParentTypes['User']>, mcas?: Maybe<Array<ResolversParentTypes['MerchantCashAdvance']>>, modifiedBy?: Maybe<ResolversParentTypes['User']>, users?: Maybe<Array<ResolversParentTypes['User']>> };
  CompanyDocumentDto: CompanyDocumentDto;
  CompanyDto: CompanyDto;
  CompanyOwner: Omit<CompanyOwner, 'company' | 'createdBy' | 'modifiedBy' | 'owner'> & { company: ResolversParentTypes['Company'], createdBy: ResolversParentTypes['User'], modifiedBy: ResolversParentTypes['User'], owner: ResolversParentTypes['Owner'] };
  ConfigFee: Omit<ConfigFee, 'createdBy' | 'modifiedBy'> & { createdBy: ResolversParentTypes['User'], modifiedBy?: Maybe<ResolversParentTypes['User']> };
  ConfigFeeDto: ConfigFeeDto;
  ConfigFeesList: ConfigFeesList;
  ConsumerPiiInputDto: ConsumerPiiInputDto;
  CreateApplicationInput: CreateApplicationInput;
  CreateOfferInput: CreateOfferInput;
  CreateStipulationInput: CreateStipulationInput;
  DailyCollectionsChartPoint: DailyCollectionsChartPoint;
  DailyCollectionsChartSeriesItem: DailyCollectionsChartSeriesItem;
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  ExternalServiceConfiguration: Omit<ExternalServiceConfiguration, 'company' | 'createdBy' | 'modifiedBy'> & { company?: Maybe<ResolversParentTypes['InternalCompany']>, createdBy: ResolversParentTypes['User'], modifiedBy?: Maybe<ResolversParentTypes['User']> };
  ExternalServiceDto: Omit<ExternalServiceDto, 'company'> & { company?: Maybe<ResolversParentTypes['InternalCompany']> };
  ExternalServiceInputDto: ExternalServiceInputDto;
  FeeDto: FeeDto;
  FineDto: FineDto;
  Float: Scalars['Float']['output'];
  FunderPortFolioDto: FunderPortFolioDto;
  FundingFee: Omit<FundingFee, 'createdBy' | 'mca' | 'modifiedBy'> & { createdBy: ResolversParentTypes['User'], mca?: Maybe<ResolversParentTypes['MerchantCashAdvance']>, modifiedBy?: Maybe<ResolversParentTypes['User']> };
  FundingPipeLineOffersCount: FundingPipeLineOffersCount;
  FundingPipelineStatusCount: FundingPipelineStatusCount;
  ID: Scalars['ID']['output'];
  ImportedStatsDto: ImportedStatsDto;
  ImportedTransactionDto: ImportedTransactionDto;
  Int: Scalars['Int']['output'];
  Integration: Omit<Integration, 'company' | 'createdBy' | 'modifiedBy' | 'secret'> & { company?: Maybe<ResolversParentTypes['InternalCompany']>, createdBy: ResolversParentTypes['User'], modifiedBy?: Maybe<ResolversParentTypes['User']>, secret: ResolversParentTypes['IntegrationSecret'] };
  IntegrationDto: IntegrationDto;
  IntegrationHealthMonitor: IntegrationHealthMonitor;
  IntegrationScheduleDto: IntegrationScheduleDto;
  IntegrationSecret: ResolversUnionTypes<ResolversParentTypes>['IntegrationSecret'];
  IntegrationSettingsDto: IntegrationSettingsDto;
  IntegrationsList: Omit<IntegrationsList, 'data'> & { data: Array<ResolversParentTypes['Integration']> };
  InternalCompaniesList: Omit<InternalCompaniesList, 'data'> & { data: Array<ResolversParentTypes['InternalCompany']> };
  InternalCompany: Omit<InternalCompany, 'createdBy' | 'documents' | 'integrations' | 'mcas' | 'modifiedBy'> & { createdBy?: Maybe<ResolversParentTypes['User']>, documents: Array<ResolversParentTypes['CompanyDocumentDto']>, integrations?: Maybe<Array<ResolversParentTypes['Integration']>>, mcas?: Maybe<Array<ResolversParentTypes['MerchantCashAdvance']>>, modifiedBy?: Maybe<ResolversParentTypes['User']> };
  InternalCompanyDocumentsInfo: Omit<InternalCompanyDocumentsInfo, 'subfolderDocuments'> & { subfolderDocuments: Array<ResolversParentTypes['CompanyDocumentDto']> };
  InternalCompanyDto: InternalCompanyDto;
  InvestorBalanceDto: InvestorBalanceDto;
  InvestorBalanceSummaryDto: InvestorBalanceSummaryDto;
  InvestorBalanceTransactionDto: InvestorBalanceTransactionDto;
  InvestorBalanceTransactionSummaryDto: InvestorBalanceTransactionSummaryDto;
  InvestorBalanceTransactionsList: InvestorBalanceTransactionsList;
  InvestorPortFolioDto: InvestorPortFolioDto;
  InvestorReconciliationBalanceDto: Omit<InvestorReconciliationBalanceDto, 'lastReconciliationBy' | 'reconciliations'> & { lastReconciliationBy?: Maybe<ResolversParentTypes['User']>, reconciliations?: Maybe<Array<ResolversParentTypes['Reconciliation']>> };
  InvestorReconciliationBalanceList: Omit<InvestorReconciliationBalanceList, 'data'> & { data: Array<ResolversParentTypes['InvestorReconciliationBalanceDto']> };
  JSON: Scalars['JSON']['output'];
  JSONObject: Scalars['JSONObject']['output'];
  ManualTransactionDto: ManualTransactionDto;
  McaAverageFundingTerms: McaAverageFundingTerms;
  McaDisplayAttribute: McaDisplayAttribute;
  McaIntegrationsDto: Omit<McaIntegrationsDto, 'integration'> & { integration: ResolversParentTypes['Integration'] };
  McaRefi: McaRefi;
  McaRefiDto: McaRefiDto;
  MerchantBankAccount: Omit<MerchantBankAccount, 'merchant'> & { merchant?: Maybe<ResolversParentTypes['Company']> };
  MerchantBankAccountDto: MerchantBankAccountDto;
  MerchantCashAdvance: Omit<MerchantCashAdvance, 'broker' | 'company' | 'createdBy' | 'externalConnections' | 'fundingFee' | 'integration' | 'lastTransaction' | 'legal' | 'manager' | 'merchant' | 'modifiedBy' | 'recurrencies' | 'statusChangedBy' | 'syndications'> & { broker?: Maybe<ResolversParentTypes['User']>, company?: Maybe<ResolversParentTypes['InternalCompany']>, createdBy: ResolversParentTypes['User'], externalConnections?: Maybe<Array<ResolversParentTypes['MerchantCashAdvanceExternalServiceConnection']>>, fundingFee?: Maybe<Array<ResolversParentTypes['FundingFee']>>, integration?: Maybe<ResolversParentTypes['Integration']>, lastTransaction?: Maybe<ResolversParentTypes['Transaction']>, legal?: Maybe<ResolversParentTypes['User']>, manager?: Maybe<ResolversParentTypes['User']>, merchant: ResolversParentTypes['Company'], modifiedBy?: Maybe<ResolversParentTypes['User']>, recurrencies?: Maybe<Array<ResolversParentTypes['Recurrency']>>, statusChangedBy: ResolversParentTypes['User'], syndications?: Maybe<Array<ResolversParentTypes['Syndication']>> };
  MerchantCashAdvanceDto: MerchantCashAdvanceDto;
  MerchantCashAdvanceExternalServiceConnection: Omit<MerchantCashAdvanceExternalServiceConnection, 'createdBy' | 'externalServiceConfiguration' | 'mca' | 'modifiedBy'> & { createdBy: ResolversParentTypes['User'], externalServiceConfiguration: ResolversParentTypes['ExternalServiceConfiguration'], mca: ResolversParentTypes['MerchantCashAdvance'], modifiedBy?: Maybe<ResolversParentTypes['User']> };
  MerchantCashAdvanceExternalServiceConnectionDto: Omit<MerchantCashAdvanceExternalServiceConnectionDto, 'externalServiceConfiguration'> & { externalServiceConfiguration?: Maybe<ResolversParentTypes['ExternalServiceConfiguration']> };
  MerchantCashAdvanceExternalServiceDataDto: Omit<MerchantCashAdvanceExternalServiceDataDto, 'connection'> & { connection?: Maybe<ResolversParentTypes['MerchantCashAdvanceExternalServiceConnection']> };
  MerchantCashAdvanceStatusHistory: Omit<MerchantCashAdvanceStatusHistory, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  MerchantCashAdvanceSummary: MerchantCashAdvanceSummary;
  MerchantCashAdvancesList: Omit<MerchantCashAdvancesList, 'data'> & { data: Array<ResolversParentTypes['MerchantCashAdvance']> };
  MerchantDto: MerchantDto;
  MfaSettingsDto: MfaSettingsDto;
  Mutation: {};
  NonWorkingDay: NonWorkingDay;
  Offer: Omit<Offer, 'application' | 'broker' | 'company' | 'createdBy' | 'integration' | 'manager' | 'mca' | 'modifiedBy' | 'offerEmails'> & { application: ResolversParentTypes['Application'], broker?: Maybe<ResolversParentTypes['User']>, company?: Maybe<ResolversParentTypes['InternalCompany']>, createdBy?: Maybe<ResolversParentTypes['User']>, integration?: Maybe<ResolversParentTypes['Integration']>, manager?: Maybe<ResolversParentTypes['User']>, mca?: Maybe<ResolversParentTypes['MerchantCashAdvance']>, modifiedBy?: Maybe<ResolversParentTypes['User']>, offerEmails?: Maybe<Array<ResolversParentTypes['OfferEmail']>> };
  OfferApplicationsCount: OfferApplicationsCount;
  OfferEmail: Omit<OfferEmail, 'createdBy' | 'modifiedBy' | 'offer'> & { createdBy: ResolversParentTypes['User'], modifiedBy?: Maybe<ResolversParentTypes['User']>, offer: ResolversParentTypes['Offer'] };
  OfferFeeCommissionInput: OfferFeeCommissionInput;
  OfferFeeCommissionJson: OfferFeeCommissionJson;
  OfferList: Omit<OfferList, 'data'> & { data: Array<ResolversParentTypes['Offer']> };
  OfferMerchantCashAdvanceDto: Omit<OfferMerchantCashAdvanceDto, 'broker' | 'company' | 'integration' | 'manager' | 'merchant'> & { broker?: Maybe<ResolversParentTypes['User']>, company?: Maybe<ResolversParentTypes['InternalCompany']>, integration?: Maybe<ResolversParentTypes['Integration']>, manager?: Maybe<ResolversParentTypes['User']>, merchant?: Maybe<ResolversParentTypes['Company']> };
  OffersLinkToFiles: OffersLinkToFiles;
  Owner: Omit<Owner, 'companyOwners' | 'createdBy' | 'modifiedBy'> & { companyOwners: ResolversParentTypes['CompanyOwner'], createdBy?: Maybe<ResolversParentTypes['User']>, modifiedBy?: Maybe<ResolversParentTypes['User']> };
  OwnerDto: OwnerDto;
  PaymentMethod: PaymentMethod;
  Permission: Permission;
  PermissionsList: PermissionsList;
  PortFolioChartDto: PortFolioChartDto;
  PortFolioSummaryDto: PortFolioSummaryDto;
  PortfoliosCollectionsChartPoint: PortfoliosCollectionsChartPoint;
  PortfoliosCollectionsChartSeriesItem: PortfoliosCollectionsChartSeriesItem;
  PostFundingFee: Omit<PostFundingFee, 'createdBy' | 'modifiedBy'> & { createdBy?: Maybe<ResolversParentTypes['User']>, modifiedBy?: Maybe<ResolversParentTypes['User']> };
  PreferencesDto: PreferencesDto;
  ProfileDto: ProfileDto;
  PullCreditReportResultDto: Omit<PullCreditReportResultDto, 'data'> & { data?: Maybe<ResolversParentTypes['ApplicationExternalServiceDataDto']> };
  Query: {};
  Reconciliation: Omit<Reconciliation, 'createdBy' | 'investor'> & { createdBy: ResolversParentTypes['User'], investor: ResolversParentTypes['User'] };
  Recurrency: Omit<Recurrency, 'createdBy' | 'integration' | 'mca' | 'modifiedBy'> & { createdBy: ResolversParentTypes['User'], integration: ResolversParentTypes['Integration'], mca: ResolversParentTypes['MerchantCashAdvance'], modifiedBy?: Maybe<ResolversParentTypes['User']> };
  RecurrencyDto: RecurrencyDto;
  RecurrencyProcessorData: RecurrencyProcessorData;
  Role: Omit<Role, 'createdBy' | 'modifiedBy'> & { createdBy: ResolversParentTypes['User'], modifiedBy: ResolversParentTypes['User'] };
  RoleRightsMapping: RoleRightsMapping;
  RolesList: Omit<RolesList, 'data'> & { data: Array<ResolversParentTypes['Role']> };
  RoutingNumber: RoutingNumber;
  RoutingNumberAssignment: RoutingNumberAssignment;
  SaveBankInput: SaveBankInput;
  SaveBankLocationInput: SaveBankLocationInput;
  SaveLocationRoutingNumbersInput: SaveLocationRoutingNumbersInput;
  SecretAchProc: SecretAchProc;
  SecretAchProcDto: SecretAchProcDto;
  SecretClearAchBot: SecretClearAchBot;
  SecretClearAchBotDto: SecretClearAchBotDto;
  SecretDevNull: SecretDevNull;
  SecretGoAch: SecretGoAch;
  SecretGoAchBot: SecretGoAchBot;
  SecretGoAchBotDto: SecretGoAchBotDto;
  SecretGoAchDto: SecretGoAchDto;
  SecretLiftoffCard: SecretLiftoffCard;
  SecretLiftoffCardDto: SecretLiftoffCardDto;
  SendEmailInput: SendEmailInput;
  Settings: Settings;
  SortArgs: SortArgs;
  Stipulation: Stipulation;
  String: Scalars['String']['output'];
  SubfolderFileInfo: SubfolderFileInfo;
  Syndication: Omit<Syndication, 'createdBy' | 'mca' | 'modifiedBy' | 'user'> & { createdBy?: Maybe<ResolversParentTypes['User']>, mca?: Maybe<Array<ResolversParentTypes['MerchantCashAdvance']>>, modifiedBy?: Maybe<ResolversParentTypes['User']>, user?: Maybe<ResolversParentTypes['User']> };
  SyndicationDetailsDto: Omit<SyndicationDetailsDto, 'broker' | 'externalConnections' | 'integration' | 'legal' | 'manager' | 'merchant'> & { broker?: Maybe<ResolversParentTypes['User']>, externalConnections?: Maybe<Array<ResolversParentTypes['MerchantCashAdvanceExternalServiceConnection']>>, integration: ResolversParentTypes['Integration'], legal?: Maybe<ResolversParentTypes['User']>, manager?: Maybe<ResolversParentTypes['User']>, merchant: ResolversParentTypes['Company'] };
  SyndicationDetailsList: Omit<SyndicationDetailsList, 'data'> & { data: Array<ResolversParentTypes['SyndicationDetailsDto']> };
  SyndicationDetailsSummaryDto: SyndicationDetailsSummaryDto;
  SyndicationDto: SyndicationDto;
  TodaysCollectionDto: TodaysCollectionDto;
  TodaysCollectionSeriesItem: TodaysCollectionSeriesItem;
  Transaction: Omit<Transaction, 'assignedToUser' | 'integration' | 'mca' | 'recurrency' | 'statusChangedBy'> & { assignedToUser?: Maybe<ResolversParentTypes['User']>, integration?: Maybe<ResolversParentTypes['Integration']>, mca?: Maybe<ResolversParentTypes['MerchantCashAdvance']>, recurrency?: Maybe<ResolversParentTypes['Recurrency']>, statusChangedBy?: Maybe<ResolversParentTypes['User']> };
  TransactionsList: Omit<TransactionsList, 'data'> & { data: Array<ResolversParentTypes['Transaction']> };
  TransactionsSummaryDto: TransactionsSummaryDto;
  Underwriter: Omit<Underwriter, 'createdBy' | 'modifiedBy'> & { createdBy?: Maybe<ResolversParentTypes['User']>, modifiedBy?: Maybe<ResolversParentTypes['User']> };
  UnderwriterDto: UnderwriterDto;
  UnderwriterMemberInfo: UnderwriterMemberInfo;
  UnderwritersList: UnderwritersList;
  UpdateApplicationInput: UpdateApplicationInput;
  UpdateOfferInput: UpdateOfferInput;
  UpdatePermissionInput: UpdatePermissionInput;
  UpdateStipulationInput: UpdateStipulationInput;
  User: Omit<User, 'bankAccounts' | 'company' | 'createdBy' | 'manager' | 'modifiedBy' | 'portfolioConnectedTo' | 'portfolioConnections' | 'syndications'> & { bankAccounts?: Maybe<Array<ResolversParentTypes['UserBankAccount']>>, company?: Maybe<ResolversParentTypes['Company']>, createdBy?: Maybe<ResolversParentTypes['User']>, manager?: Maybe<ResolversParentTypes['User']>, modifiedBy?: Maybe<ResolversParentTypes['User']>, portfolioConnectedTo?: Maybe<Array<ResolversParentTypes['UserPortfolioConnections']>>, portfolioConnections?: Maybe<Array<ResolversParentTypes['UserPortfolioConnections']>>, syndications?: Maybe<Array<ResolversParentTypes['Syndication']>> };
  UserBankAccount: Omit<UserBankAccount, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  UserData: UserData;
  UserDataDto: UserDataDto;
  UserDto: UserDto;
  UserFunderConnections: Omit<UserFunderConnections, 'user'> & { user?: Maybe<ResolversParentTypes['User']> };
  UserGridPreferences: UserGridPreferences;
  UserGridPreferencesDto: UserGridPreferencesDto;
  UserPortfolioConnections: Omit<UserPortfolioConnections, 'sourceUser' | 'targetUser'> & { sourceUser?: Maybe<ResolversParentTypes['User']>, targetUser?: Maybe<ResolversParentTypes['User']> };
  UserPreferences: UserPreferences;
  UserPreferencesDto: UserPreferencesDto;
  UsersList: Omit<UsersList, 'data'> & { data: Array<ResolversParentTypes['User']> };
}>;

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zip?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Application'] = ResolversParentTypes['Application']> = ResolversObject<{
  broker?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  currentUserRights?: Resolver<Array<ResolversTypes['Rights']>, ParentType, ContextType>;
  funder?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  fundingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latestStatusHistory?: Resolver<Maybe<ResolversTypes['ApplicationStatusHistory']>, ParentType, ContextType>;
  linkToFiles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  merchantBizEmails?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  merchantBizPhones?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  merchantBizWeb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantCompanyDba?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantCompanyLegalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantTaxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  offerDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  offers?: Resolver<Maybe<Array<ResolversTypes['Offer']>>, ParentType, ContextType>;
  owners?: Resolver<Maybe<Array<ResolversTypes['UserData']>>, ParentType, ContextType>;
  processor?: Resolver<Maybe<ResolversTypes['ApplicationProcessor']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['ApplicationStatus']>, ParentType, ContextType>;
  term?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalOffers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationExternalServiceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationExternalServiceConnection'] = ResolversParentTypes['ApplicationExternalServiceConnection']> = ResolversObject<{
  application?: Resolver<ResolversTypes['Application'], ParentType, ContextType>;
  applicationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  externalServiceConfiguration?: Resolver<ResolversTypes['ExternalServiceConfiguration'], ParentType, ContextType>;
  externalServiceConfigurationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  fetchedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationExternalServiceConnectionDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationExternalServiceConnectionDto'] = ResolversParentTypes['ApplicationExternalServiceConnectionDto']> = ResolversObject<{
  applicationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  configuration?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  externalServiceConfiguration?: Resolver<Maybe<ResolversTypes['ExternalServiceConfiguration']>, ParentType, ContextType>;
  externalServiceConfigurationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  fetchedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationExternalServiceDataDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationExternalServiceDataDto'] = ResolversParentTypes['ApplicationExternalServiceDataDto']> = ResolversObject<{
  connection?: Resolver<Maybe<ResolversTypes['ApplicationExternalServiceConnectionDto']>, ParentType, ContextType>;
  connectionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  data?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  downloadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isCacheValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  searchParams?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  searchParamsHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  validUntil?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationList'] = ResolversParentTypes['ApplicationList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Application']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationProcessorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationProcessor'] = ResolversParentTypes['ApplicationProcessor']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationStatus'] = ResolversParentTypes['ApplicationStatus']> = ResolversObject<{
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  forApplication?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  forFundingPipeline?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  forOffer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  orderForFundingPipeline?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationStatusHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationStatusHistory'] = ResolversParentTypes['ApplicationStatusHistory']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  fromStatus?: Resolver<ResolversTypes['ApplicationStatus'], ParentType, ContextType>;
  toStatus?: Resolver<ResolversTypes['ApplicationStatus'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationWithOfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationWithOffer'] = ResolversParentTypes['ApplicationWithOffer']> = ResolversObject<{
  application?: Resolver<ResolversTypes['Application'], ParentType, ContextType>;
  offer?: Resolver<Maybe<ResolversTypes['Offer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ApplicationWithOfferListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ApplicationWithOfferList'] = ResolversParentTypes['ApplicationWithOfferList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['ApplicationWithOffer']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuditEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditEvent'] = ResolversParentTypes['AuditEvent']> = ResolversObject<{
  application?: Resolver<Maybe<ResolversTypes['Application']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ipAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mca?: Resolver<Maybe<ResolversTypes['MerchantCashAdvance']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AuditLogListResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuditLogList'] = ResolversParentTypes['AuditLogList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['AuditEvent']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AvailableDocumentDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AvailableDocumentDto'] = ResolversParentTypes['AvailableDocumentDto']> = ResolversObject<{
  documentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankInfo'] = ResolversParentTypes['BankInfo']> = ResolversObject<{
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fdic?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locations?: Resolver<Maybe<Array<ResolversTypes['BankLocation']>>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  web?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankInfoByRoutingNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankInfoByRoutingNumber'] = ResolversParentTypes['BankInfoByRoutingNumber']> = ResolversObject<{
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankListResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankList'] = ResolversParentTypes['BankList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['BankInfo']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankLocation'] = ResolversParentTypes['BankLocation']> = ResolversObject<{
  bank?: Resolver<ResolversTypes['BankInfo'], ParentType, ContextType>;
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  locationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routingNumbers?: Resolver<Maybe<Array<ResolversTypes['RoutingNumber']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CalendarEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['CalendarEvent'] = ResolversParentTypes['CalendarEvent']> = ResolversObject<{
  allDay?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ChartResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chart'] = ResolversParentTypes['Chart']> = ResolversObject<{
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CommissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Commission'] = ResolversParentTypes['Commission']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  config?: Resolver<Maybe<ResolversTypes['ConfigFee']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPaid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mca?: Resolver<Maybe<ResolversTypes['MerchantCashAdvance']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paidOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompaniesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompaniesList'] = ResolversParentTypes['CompaniesList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Company']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = ResolversObject<{
  bankAccounts?: Resolver<Maybe<Array<ResolversTypes['MerchantBankAccount']>>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  dba?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  linkToFiles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mcas?: Resolver<Maybe<Array<ResolversTypes['MerchantCashAdvance']>>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalUsers?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<Maybe<Array<ResolversTypes['CompanyType']>>, ParentType, ContextType>;
  users?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  www?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyDocumentDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyDocumentDto'] = ResolversParentTypes['CompanyDocumentDto']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  documentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentOwner?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mimeType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  webViewLink?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CompanyOwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanyOwner'] = ResolversParentTypes['CompanyOwner']> = ResolversObject<{
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['Owner'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigFee'] = ResolversParentTypes['ConfigFee']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  defaultAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  defaultComment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCommission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPercentage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPostFunding?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPreFunding?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['ConfigFeeName'], ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ConfigFeesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConfigFeesList'] = ResolversParentTypes['ConfigFeesList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['ConfigFee']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DailyCollectionsChartPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['DailyCollectionsChartPoint'] = ResolversParentTypes['DailyCollectionsChartPoint']> = ResolversObject<{
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  series?: Resolver<Array<ResolversTypes['DailyCollectionsChartSeriesItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DailyCollectionsChartSeriesItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DailyCollectionsChartSeriesItem'] = ResolversParentTypes['DailyCollectionsChartSeriesItem']> = ResolversObject<{
  seriesKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type ExternalServiceConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalServiceConfiguration'] = ResolversParentTypes['ExternalServiceConfiguration']> = ResolversObject<{
  company?: Resolver<Maybe<ResolversTypes['InternalCompany']>, ParentType, ContextType>;
  configurationSchema?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  dataSchema?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secret?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ExternalServiceType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExternalServiceDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternalServiceDto'] = ResolversParentTypes['ExternalServiceDto']> = ResolversObject<{
  company?: Resolver<Maybe<ResolversTypes['InternalCompany']>, ParentType, ContextType>;
  configurationSchema?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  dataSchema?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secret?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ExternalServiceType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FunderPortFolioDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['FunderPortFolioDto'] = ResolversParentTypes['FunderPortFolioDto']> = ResolversObject<{
  attorney?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  collections?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  funder?: Resolver<Maybe<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  inHouseLegal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notPaying?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  open?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  poolGrossValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  poolNetValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profitAndLoss?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  settled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  slow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalMcaCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPayback?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  verySlow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writtenOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FundingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingFee'] = ResolversParentTypes['FundingFee']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  config?: Resolver<Maybe<ResolversTypes['ConfigFee']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mca?: Resolver<Maybe<ResolversTypes['MerchantCashAdvance']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FundingPipeLineOffersCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingPipeLineOffersCount'] = ResolversParentTypes['FundingPipeLineOffersCount']> = ResolversObject<{
  statusCounts?: Resolver<Array<ResolversTypes['FundingPipelineStatusCount']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FundingPipelineStatusCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['FundingPipelineStatusCount'] = ResolversParentTypes['FundingPipelineStatusCount']> = ResolversObject<{
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  statusId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImportedStatsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportedStatsDto'] = ResolversParentTypes['ImportedStatsDto']> = ResolversObject<{
  deleted?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  imported?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  inserted?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImportedTransactionDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImportedTransactionDto'] = ResolversParentTypes['ImportedTransactionDto']> = ResolversObject<{
  account?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  custom1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  custom2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  depositDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  recurrenceDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returnCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returnDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IntegrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Integration'] = ResolversParentTypes['Integration']> = ResolversObject<{
  autostart?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['InternalCompany']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  environment?: Resolver<ResolversTypes['IntegrationEnvironment'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastRefreshResult?: Resolver<Maybe<ResolversTypes['IntegrationHealthMonitor']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schedule?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  secret?: Resolver<ResolversTypes['IntegrationSecret'], ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['Settings'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['IntegrationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IntegrationHealthMonitorResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationHealthMonitor'] = ResolversParentTypes['IntegrationHealthMonitor']> = ResolversObject<{
  integrationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastImportedTransactionsDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastImportedTransactionsStats?: Resolver<ResolversTypes['ImportedStatsDto'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IntegrationScheduleDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationScheduleDto'] = ResolversParentTypes['IntegrationScheduleDto']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nextDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  running?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type IntegrationSecretResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationSecret'] = ResolversParentTypes['IntegrationSecret']> = ResolversObject<{
  __resolveType: TypeResolveFn<'SecretAchProc' | 'SecretClearAchBot' | 'SecretDevNull' | 'SecretGoAch' | 'SecretGoAchBot' | 'SecretLiftoffCard', ParentType, ContextType>;
}>;

export type IntegrationsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['IntegrationsList'] = ResolversParentTypes['IntegrationsList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Integration']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InternalCompaniesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalCompaniesList'] = ResolversParentTypes['InternalCompaniesList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['InternalCompany']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InternalCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalCompany'] = ResolversParentTypes['InternalCompany']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  dba?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['CompanyDocumentDto']>, ParentType, ContextType>;
  documentsInfo?: Resolver<ResolversTypes['InternalCompanyDocumentsInfo'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrations?: Resolver<Maybe<Array<ResolversTypes['Integration']>>, ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mcas?: Resolver<Maybe<Array<ResolversTypes['MerchantCashAdvance']>>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  signature?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InternalCompanyDocumentsInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InternalCompanyDocumentsInfo'] = ResolversParentTypes['InternalCompanyDocumentsInfo']> = ResolversObject<{
  companyFolderConnected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  companyFolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subfolderDocuments?: Resolver<Array<ResolversTypes['CompanyDocumentDto']>, ParentType, ContextType>;
  subfolderFiles?: Resolver<Array<ResolversTypes['SubfolderFileInfo']>, ParentType, ContextType>;
  subfolderId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorBalanceDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorBalanceDto'] = ResolversParentTypes['InvestorBalanceDto']> = ResolversObject<{
  balance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorBalanceSummaryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorBalanceSummaryDto'] = ResolversParentTypes['InvestorBalanceSummaryDto']> = ResolversObject<{
  credit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  debit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorBalanceTransactionDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorBalanceTransactionDto'] = ResolversParentTypes['InvestorBalanceTransactionDto']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  depositDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  effectiveDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mcaId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mcaNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mcaStatus?: Resolver<Maybe<ResolversTypes['MerchantCashAdvanceStatus']>, ParentType, ContextType>;
  merchantName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  originationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  paymentMethodId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  runningBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  runningCashInOutBalance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorBalanceTransactionSummaryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorBalanceTransactionSummaryDto'] = ResolversParentTypes['InvestorBalanceTransactionSummaryDto']> = ResolversObject<{
  cashInTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cashOutTotal?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorBalanceTransactionsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorBalanceTransactionsList'] = ResolversParentTypes['InvestorBalanceTransactionsList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['InvestorBalanceTransactionDto']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  summary?: Resolver<ResolversTypes['InvestorBalanceSummaryDto'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorPortFolioDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorPortFolioDto'] = ResolversParentTypes['InvestorPortFolioDto']> = ResolversObject<{
  activeReceivablesFunder?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  activeReceivablesFunderCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  activeReceivablesInvestor?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  activeReceivablesInvestorCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attorney?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attorneyCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collections?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  collectionsCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  inHouseLegal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inHouseLegalCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notPaying?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notPayingCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  open?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  openCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  originationPerformanceAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  poolGrossValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  poolNetValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  portFolioCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  portFolioValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profitAndLoss?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resumed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resumedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  role?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  settled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  settledCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  slow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  slowCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAccumulated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAccumulatedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAmtPaidClr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCompleted?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCompletedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalMcaCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPayback?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPortFolioCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPortFolioValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReceivables?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReceivablesCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  verySlow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  verySlowCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writtenOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writtenOffCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorReconciliationBalanceDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorReconciliationBalanceDto'] = ResolversParentTypes['InvestorReconciliationBalanceDto']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastReconciliationAction?: Resolver<Maybe<ResolversTypes['ReconciliationAction']>, ParentType, ContextType>;
  lastReconciliationAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastReconciliationBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  reconciliations?: Resolver<Maybe<Array<ResolversTypes['Reconciliation']>>, ParentType, ContextType>;
  transactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ReconciliationType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InvestorReconciliationBalanceListResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestorReconciliationBalanceList'] = ResolversParentTypes['InvestorReconciliationBalanceList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['InvestorReconciliationBalanceDto']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type McaAverageFundingTermsResolvers<ContextType = any, ParentType extends ResolversParentTypes['McaAverageFundingTerms'] = ResolversParentTypes['McaAverageFundingTerms']> = ResolversObject<{
  amountAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionPercentageAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  dailyPmtAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorRateAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feesPercentageAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  netWireAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paybackAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payoffAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  termAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type McaDisplayAttributeResolvers<ContextType = any, ParentType extends ResolversParentTypes['McaDisplayAttribute'] = ResolversParentTypes['McaDisplayAttribute']> = ResolversObject<{
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type McaIntegrationsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['McaIntegrationsDto'] = ResolversParentTypes['McaIntegrationsDto']> = ResolversObject<{
  integration?: Resolver<ResolversTypes['Integration'], ParentType, ContextType>;
  transactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type McaRefiResolvers<ContextType = any, ParentType extends ResolversParentTypes['McaRefi'] = ResolversParentTypes['McaRefi']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  clearedBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantLegalName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  merchantLogo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pendingBalance?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  referenceMca?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['McaRefiType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantBankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantBankAccount'] = ResolversParentTypes['MerchantBankAccount']> = ResolversObject<{
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCashAdvanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCashAdvance'] = ResolversParentTypes['MerchantCashAdvance']> = ResolversObject<{
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amtpaidclr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amtpaidpnd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceClrWFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balancePnd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balancePndWFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceclr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissions?: Resolver<Maybe<Array<ResolversTypes['Commission']>>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['InternalCompany']>, ParentType, ContextType>;
  completion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  currentUserMcaRoles?: Resolver<Array<ResolversTypes['McaDynamicRole']>, ParentType, ContextType>;
  currentUserRights?: Resolver<Array<ResolversTypes['Rights']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayAttributes?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  documents?: Resolver<Array<ResolversTypes['AvailableDocumentDto']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  externalConnections?: Resolver<Maybe<Array<ResolversTypes['MerchantCashAdvanceExternalServiceConnection']>>, ParentType, ContextType>;
  factorRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  funder?: Resolver<Maybe<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  fundingDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  fundingFee?: Resolver<Maybe<Array<ResolversTypes['FundingFee']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['Integration']>, ParentType, ContextType>;
  lastPmtDay?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  lastTransaction?: Resolver<Maybe<ResolversTypes['Transaction']>, ParentType, ContextType>;
  legal?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  merchant?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  netWire?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nft?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  npt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nrt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  numberOfFeeTransactions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfInvestorTransactions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payback?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  paybackWFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payoff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  perfEndDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  perfTerm?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pmt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pnlGross?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pnlNet?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  recurrencies?: Resolver<Maybe<Array<ResolversTypes['Recurrency']>>, ParentType, ContextType>;
  referenceMca?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refis?: Resolver<Array<ResolversTypes['McaRefi']>, ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryFunders?: Resolver<Maybe<Array<ResolversTypes['Underwriter']>>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['MerchantCashAdvanceStatus'], ParentType, ContextType>;
  statusChangedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  statusChangedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  statusManagementType?: Resolver<ResolversTypes['McaManagementType'], ParentType, ContextType>;
  syndications?: Resolver<Maybe<Array<ResolversTypes['Syndication']>>, ParentType, ContextType>;
  term?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  totalclrfines?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalcommissions?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalfees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalfines?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalpendingfines?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCashAdvanceExternalServiceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCashAdvanceExternalServiceConnection'] = ResolversParentTypes['MerchantCashAdvanceExternalServiceConnection']> = ResolversObject<{
  configuration?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  externalServiceConfiguration?: Resolver<ResolversTypes['ExternalServiceConfiguration'], ParentType, ContextType>;
  externalServiceConfigurationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  fetchedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mca?: Resolver<ResolversTypes['MerchantCashAdvance'], ParentType, ContextType>;
  mcaId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCashAdvanceExternalServiceConnectionDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCashAdvanceExternalServiceConnectionDto'] = ResolversParentTypes['MerchantCashAdvanceExternalServiceConnectionDto']> = ResolversObject<{
  configuration?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  externalServiceConfiguration?: Resolver<Maybe<ResolversTypes['ExternalServiceConfiguration']>, ParentType, ContextType>;
  externalServiceConfigurationId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  fetchedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mcaId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCashAdvanceExternalServiceDataDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCashAdvanceExternalServiceDataDto'] = ResolversParentTypes['MerchantCashAdvanceExternalServiceDataDto']> = ResolversObject<{
  connection?: Resolver<Maybe<ResolversTypes['MerchantCashAdvanceExternalServiceConnection']>, ParentType, ContextType>;
  connectionId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  data?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCashAdvanceStatusHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCashAdvanceStatusHistory'] = ResolversParentTypes['MerchantCashAdvanceStatusHistory']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fromStatus?: Resolver<ResolversTypes['MerchantCashAdvanceStatus'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toStatus?: Resolver<ResolversTypes['MerchantCashAdvanceStatus'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCashAdvanceSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCashAdvanceSummary'] = ResolversParentTypes['MerchantCashAdvanceSummary']> = ResolversObject<{
  amountSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amtPaidClrSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amtPaidPndSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissionSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completionAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  factorRateAvg?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  netWireSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paybackSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  paybackWFeeSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payoffSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pmtSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pnlgrossSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pnlnetSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalFeesSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPendingPostFundingFeesSum?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalclrfines?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalfines?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MerchantCashAdvancesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['MerchantCashAdvancesList'] = ResolversParentTypes['MerchantCashAdvancesList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['MerchantCashAdvance']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = ResolversObject<{
  addBankLocation?: Resolver<ResolversTypes['BankLocation'], ParentType, ContextType, RequireFields<MutationAddBankLocationArgs, 'input'>>;
  addUserToUnderwriter?: Resolver<ResolversTypes['UserFunderConnections'], ParentType, ContextType, RequireFields<MutationAddUserToUnderwriterArgs, 'underwriterId' | 'userId'>>;
  assignAccessToPortfolio?: Resolver<ResolversTypes['UserPortfolioConnections'], ParentType, ContextType, RequireFields<MutationAssignAccessToPortfolioArgs, 'sourceUserId' | 'targetUserId'>>;
  assignExistingRecurrency?: Resolver<ResolversTypes['Recurrency'], ParentType, ContextType, RequireFields<MutationAssignExistingRecurrencyArgs, 'integrationId' | 'mcaId' | 'processorReference'>>;
  cancelTransaction?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationCancelTransactionArgs, 'id'>>;
  changeApplicationStatus?: Resolver<ResolversTypes['Application'], ParentType, ContextType, RequireFields<MutationChangeApplicationStatusArgs, 'applicationId' | 'statusId'>>;
  changeMerchantCashAdvanceStatus?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationChangeMerchantCashAdvanceStatusArgs, 'mcaId' | 'status'>>;
  changePassword?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationChangePasswordArgs, 'changePasswordDto'>>;
  createApplication?: Resolver<ResolversTypes['Application'], ParentType, ContextType, RequireFields<MutationCreateApplicationArgs, 'createApplicationInput'>>;
  createOffer?: Resolver<ResolversTypes['Offer'], ParentType, ContextType, RequireFields<MutationCreateOfferArgs, 'createOfferInput'>>;
  createStipulation?: Resolver<ResolversTypes['Stipulation'], ParentType, ContextType, RequireFields<MutationCreateStipulationArgs, 'input'>>;
  delete?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<MutationDeleteArgs, 'id'>>;
  deleteApplication?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteApplicationArgs, 'id'>>;
  deleteApplicationExternalServiceConnection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteApplicationExternalServiceConnectionArgs, 'id'>>;
  deleteBank?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationDeleteBankArgs, 'bankName'>>;
  deleteBankLocation?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationDeleteBankLocationArgs, 'id'>>;
  deleteCashTransaction?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteCashTransactionArgs, 'id'>>;
  deleteCommission?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteCommissionArgs, 'id' | 'mcaId'>>;
  deleteCompany?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteCompanyArgs, 'id'>>;
  deleteConfigFee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType, RequireFields<MutationDeleteConfigFeeArgs, 'id'>>;
  deleteExternalServiceConfiguration?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteExternalServiceConfigurationArgs, 'id'>>;
  deleteFee?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteFeeArgs, 'id' | 'mcaId'>>;
  deleteFine?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteFineArgs, 'id' | 'mcaId'>>;
  deleteIntegration?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteIntegrationArgs, 'id'>>;
  deleteInternalCompany?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteInternalCompanyArgs, 'id'>>;
  deleteManualTransaction?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteManualTransactionArgs, 'id'>>;
  deleteMerchant?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteMerchantArgs, 'id'>>;
  deleteMerchantBankAccount?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteMerchantBankAccountArgs, 'id'>>;
  deleteMerchantCashAdvance?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteMerchantCashAdvanceArgs, 'id'>>;
  deleteMerchantCashAdvanceExternalServiceConnection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteMerchantCashAdvanceExternalServiceConnectionArgs, 'id'>>;
  deleteOffer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteOfferArgs, 'id'>>;
  deleteOffersByGroupId?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteOffersByGroupIdArgs, 'rehabGroupId'>>;
  deleteOwner?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteOwnerArgs, 'id'>>;
  deleteRecurrencyWithError?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteRecurrencyWithErrorArgs, 'id'>>;
  deleteStipulation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteStipulationArgs, 'id'>>;
  deleteSyndication?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteSyndicationArgs, 'id'>>;
  deleteUnderwriter?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteUnderwriterArgs, 'id'>>;
  deleteUserBankAccount?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteUserBankAccountArgs, 'id'>>;
  duplicateApplication?: Resolver<ResolversTypes['Application'], ParentType, ContextType, RequireFields<MutationDuplicateApplicationArgs, 'applicationId' | 'offerId'>>;
  importTransactions?: Resolver<Array<ResolversTypes['ImportedTransactionDto']>, ParentType, ContextType, RequireFields<MutationImportTransactionsArgs, 'dateEnd' | 'dateStart' | 'integrationId'>>;
  linkActiveOfferToMca?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationLinkActiveOfferToMcaArgs, 'applicationId' | 'mcaId'>>;
  pauseRecurrency?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationPauseRecurrencyArgs, 'cancelTodayTransaction' | 'recurrencyId'>>;
  pullClearPersonReport?: Resolver<ResolversTypes['PullCreditReportResultDto'], ParentType, ContextType, RequireFields<MutationPullClearPersonReportArgs, 'applicationId' | 'consumerPii' | 'externalServiceConfigurationId'>>;
  pullExperianCreditReport?: Resolver<ResolversTypes['PullCreditReportResultDto'], ParentType, ContextType, RequireFields<MutationPullExperianCreditReportArgs, 'applicationId' | 'consumerPii' | 'externalServiceConfigurationId'>>;
  refreshMerchantCashAdvanceTransactions?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationRefreshMerchantCashAdvanceTransactionsArgs, 'mcaId'>>;
  refreshRecurrencyTransactions?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationRefreshRecurrencyTransactionsArgs, 'recurrencyId'>>;
  refreshTransactions?: Resolver<ResolversTypes['IntegrationHealthMonitor'], ParentType, ContextType, RequireFields<MutationRefreshTransactionsArgs, 'integrationId'>>;
  removeAccessToPortfolio?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveAccessToPortfolioArgs, 'sourceUserId' | 'targetUserId'>>;
  removeUserFromUnderwriter?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemoveUserFromUnderwriterArgs, 'underwriterId' | 'userId'>>;
  resendInvitation?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationResendInvitationArgs, 'id'>>;
  resumeRecurrency?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationResumeRecurrencyArgs, 'recurrencyId' | 'tryCreateTodayTransaction'>>;
  saveAndInviteUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSaveAndInviteUserArgs, 'userDto'>>;
  saveApplicationExternalServiceConnection?: Resolver<ResolversTypes['ApplicationExternalServiceConnectionDto'], ParentType, ContextType, RequireFields<MutationSaveApplicationExternalServiceConnectionArgs, 'applicationId' | 'configuration' | 'externalServiceConfigurationId'>>;
  saveBank?: Resolver<ResolversTypes['BankInfo'], ParentType, ContextType, RequireFields<MutationSaveBankArgs, 'input'>>;
  saveBankLocation?: Resolver<ResolversTypes['BankLocation'], ParentType, ContextType, RequireFields<MutationSaveBankLocationArgs, 'input'>>;
  saveBroker?: Resolver<ResolversTypes['Company'], ParentType, ContextType, RequireFields<MutationSaveBrokerArgs, 'broker'>>;
  saveCashTransaction?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, RequireFields<MutationSaveCashTransactionArgs, 'dto'>>;
  saveCommission?: Resolver<ResolversTypes['Commission'], ParentType, ContextType, RequireFields<MutationSaveCommissionArgs, 'commission' | 'id' | 'mcaId'>>;
  saveCommissions?: Resolver<Array<ResolversTypes['Commission']>, ParentType, ContextType, RequireFields<MutationSaveCommissionsArgs, 'commissions' | 'mcaId'>>;
  saveCompany?: Resolver<ResolversTypes['Company'], ParentType, ContextType, RequireFields<MutationSaveCompanyArgs, 'company'>>;
  saveCompanyOwners?: Resolver<Array<ResolversTypes['Owner']>, ParentType, ContextType, RequireFields<MutationSaveCompanyOwnersArgs, 'companyId' | 'owners'>>;
  saveConfigFee?: Resolver<ResolversTypes['ConfigFee'], ParentType, ContextType, RequireFields<MutationSaveConfigFeeArgs, 'configFee'>>;
  saveExternalServiceConfiguration?: Resolver<ResolversTypes['ExternalServiceDto'], ParentType, ContextType, RequireFields<MutationSaveExternalServiceConfigurationArgs, 'externalServiceInputDto'>>;
  saveFee?: Resolver<ResolversTypes['FundingFee'], ParentType, ContextType, RequireFields<MutationSaveFeeArgs, 'fee' | 'id' | 'mcaId'>>;
  saveFees?: Resolver<Array<ResolversTypes['FundingFee']>, ParentType, ContextType, RequireFields<MutationSaveFeesArgs, 'fees' | 'mcaId'>>;
  saveFine?: Resolver<ResolversTypes['PostFundingFee'], ParentType, ContextType, RequireFields<MutationSaveFineArgs, 'fine' | 'id' | 'mcaId'>>;
  saveFines?: Resolver<Array<ResolversTypes['PostFundingFee']>, ParentType, ContextType, RequireFields<MutationSaveFinesArgs, 'fines' | 'mcaId'>>;
  saveFundingPipelineMca?: Resolver<ResolversTypes['MerchantCashAdvance'], ParentType, ContextType, RequireFields<MutationSaveFundingPipelineMcaArgs, 'applicationId' | 'mca' | 'merchantId' | 'offerId'>>;
  saveIntegration?: Resolver<ResolversTypes['Integration'], ParentType, ContextType, RequireFields<MutationSaveIntegrationArgs, 'integration'>>;
  saveInternalCompany?: Resolver<ResolversTypes['InternalCompany'], ParentType, ContextType, RequireFields<MutationSaveInternalCompanyArgs, 'company'>>;
  saveLocationRoutingNumbers?: Resolver<ResolversTypes['BankLocation'], ParentType, ContextType, RequireFields<MutationSaveLocationRoutingNumbersArgs, 'input'>>;
  saveManualTransaction?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, RequireFields<MutationSaveManualTransactionArgs, 'manualTransactionDto'>>;
  saveMerchant?: Resolver<ResolversTypes['Company'], ParentType, ContextType, RequireFields<MutationSaveMerchantArgs, 'merchant'>>;
  saveMerchantBankAccount?: Resolver<ResolversTypes['MerchantBankAccount'], ParentType, ContextType, RequireFields<MutationSaveMerchantBankAccountArgs, 'bankAccount' | 'merchantId'>>;
  saveMerchantCashAdvance?: Resolver<ResolversTypes['MerchantCashAdvance'], ParentType, ContextType, RequireFields<MutationSaveMerchantCashAdvanceArgs, 'mca' | 'merchantId'>>;
  saveMerchantCashAdvanceExternalServiceConnection?: Resolver<ResolversTypes['MerchantCashAdvanceExternalServiceConnectionDto'], ParentType, ContextType, RequireFields<MutationSaveMerchantCashAdvanceExternalServiceConnectionArgs, 'configuration' | 'externalServiceConfigurationId' | 'mcaId'>>;
  saveOwner?: Resolver<ResolversTypes['Owner'], ParentType, ContextType, RequireFields<MutationSaveOwnerArgs, 'companyId' | 'owner'>>;
  savePreferences?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSavePreferencesArgs, 'userPreferencesDto'>>;
  saveProfile?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSaveProfileArgs, 'profileDto'>>;
  saveReconciliation?: Resolver<ResolversTypes['Reconciliation'], ParentType, ContextType, RequireFields<MutationSaveReconciliationArgs, 'acknowledged' | 'investorId' | 'reconciliationType'>>;
  saveRecurrency?: Resolver<ResolversTypes['Recurrency'], ParentType, ContextType, RequireFields<MutationSaveRecurrencyArgs, 'id' | 'integrationId' | 'mcaId' | 'recurrency'>>;
  saveSyndication?: Resolver<ResolversTypes['Syndication'], ParentType, ContextType, RequireFields<MutationSaveSyndicationArgs, 'syndication'>>;
  saveTransactionNote?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, RequireFields<MutationSaveTransactionNoteArgs, 'id' | 'note'>>;
  saveTransactionType?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, RequireFields<MutationSaveTransactionTypeArgs, 'id' | 'mcaId' | 'type'>>;
  saveUnderwriter?: Resolver<ResolversTypes['Underwriter'], ParentType, ContextType, RequireFields<MutationSaveUnderwriterArgs, 'underwriter'>>;
  saveUnsentOfferEmail?: Resolver<Array<ResolversTypes['OfferEmail']>, ParentType, ContextType, RequireFields<MutationSaveUnsentOfferEmailArgs, 'sendEmailInput'>>;
  saveUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSaveUserArgs, 'userDto'>>;
  saveUserBankAccount?: Resolver<ResolversTypes['UserBankAccount'], ParentType, ContextType, RequireFields<MutationSaveUserBankAccountArgs, 'bankAccount' | 'userId'>>;
  scheduleIntegration?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationScheduleIntegrationArgs, 'id'>>;
  sendCognitoSetup?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSendCognitoSetupArgs, 'id'>>;
  sendOfferEmail?: Resolver<Array<ResolversTypes['OfferEmail']>, ParentType, ContextType, RequireFields<MutationSendOfferEmailArgs, 'sendEmailInput'>>;
  setActiveOffer?: Resolver<ResolversTypes['Offer'], ParentType, ContextType, RequireFields<MutationSetActiveOfferArgs, 'offerId'>>;
  setDefaultCompany?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationSetDefaultCompanyArgs, 'companyId'>>;
  stopRecurrency?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationStopRecurrencyArgs, 'cancelTodayTransaction' | 'recurrencyId'>>;
  stopRecurrencyTransaction?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationStopRecurrencyTransactionArgs, 'recurrencyId' | 'transactionExternalId'>>;
  stopTransaction?: Resolver<ResolversTypes['Int'], ParentType, ContextType, RequireFields<MutationStopTransactionArgs, 'transactionId'>>;
  submitRecurrencyToProcessor?: Resolver<ResolversTypes['Recurrency'], ParentType, ContextType, RequireFields<MutationSubmitRecurrencyToProcessorArgs, 'recurrencyId'>>;
  syncMerchantCashAdvanceExternalServiceConnection?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSyncMerchantCashAdvanceExternalServiceConnectionArgs, 'id'>>;
  toggleMcaManagementType?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationToggleMcaManagementTypeArgs, 'mcaId'>>;
  toggleUserActivation?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationToggleUserActivationArgs, 'id'>>;
  unscheduleIntegration?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationUnscheduleIntegrationArgs, 'id'>>;
  updateApplication?: Resolver<ResolversTypes['Application'], ParentType, ContextType, RequireFields<MutationUpdateApplicationArgs, 'id' | 'updateApplicationInput'>>;
  updateApplicationExternalServiceConnection?: Resolver<Maybe<ResolversTypes['ApplicationExternalServiceConnectionDto']>, ParentType, ContextType, RequireFields<MutationUpdateApplicationExternalServiceConnectionArgs, 'configuration' | 'id'>>;
  updateAutoStart?: Resolver<ResolversTypes['Integration'], ParentType, ContextType, RequireFields<MutationUpdateAutoStartArgs, 'autostart' | 'id'>>;
  updateMerchantCashAdvanceExternalServiceConnection?: Resolver<Maybe<ResolversTypes['MerchantCashAdvanceExternalServiceConnectionDto']>, ParentType, ContextType, RequireFields<MutationUpdateMerchantCashAdvanceExternalServiceConnectionArgs, 'configuration' | 'id'>>;
  updateOffer?: Resolver<ResolversTypes['Offer'], ParentType, ContextType, RequireFields<MutationUpdateOfferArgs, 'id' | 'updateOfferInput'>>;
  updatePermission?: Resolver<ResolversTypes['Permission'], ParentType, ContextType, RequireFields<MutationUpdatePermissionArgs, 'input' | 'name'>>;
  updateStipulation?: Resolver<ResolversTypes['Stipulation'], ParentType, ContextType, RequireFields<MutationUpdateStipulationArgs, 'id' | 'input'>>;
  updateUserMfaSettings?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUserMfaSettingsArgs, 'mfaSettingsDto'>>;
}>;

export type NonWorkingDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['NonWorkingDay'] = ResolversParentTypes['NonWorkingDay']> = ResolversObject<{
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OfferResolvers<ContextType = any, ParentType extends ResolversParentTypes['Offer'] = ResolversParentTypes['Offer']> = ResolversObject<{
  application?: Resolver<ResolversTypes['Application'], ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  commissions?: Resolver<Maybe<Array<ResolversTypes['OfferFeeCommissionJson']>>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['InternalCompany']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  currentUserRights?: Resolver<Array<ResolversTypes['Rights']>, ParentType, ContextType>;
  factorRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  funder?: Resolver<Maybe<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  fundingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fundingFees?: Resolver<Maybe<Array<ResolversTypes['OfferFeeCommissionJson']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['Integration']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSelected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lineOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  linkToFilesData?: Resolver<Maybe<ResolversTypes['OffersLinkToFiles']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  mca?: Resolver<Maybe<ResolversTypes['MerchantCashAdvance']>, ParentType, ContextType>;
  mcaId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offerDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  offerEmails?: Resolver<Maybe<Array<ResolversTypes['OfferEmail']>>, ParentType, ContextType>;
  rehabGroupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rehabLineTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryFunders?: Resolver<Maybe<Array<ResolversTypes['Underwriter']>>, ParentType, ContextType>;
  stipulations?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  term?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['OfferType'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OfferApplicationsCountResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferApplicationsCount'] = ResolversParentTypes['OfferApplicationsCount']> = ResolversObject<{
  countOfferApplications?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  countTodayOfferSentApplications?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OfferEmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferEmail'] = ResolversParentTypes['OfferEmail']> = ResolversObject<{
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  errorMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  htmlContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  offer?: Resolver<ResolversTypes['Offer'], ParentType, ContextType>;
  recipient?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  recipientBCC?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  recipientCC?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  sentAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  sentCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OfferFeeCommissionJsonResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferFeeCommissionJson'] = ResolversParentTypes['OfferFeeCommissionJson']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  configId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OfferListResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferList'] = ResolversParentTypes['OfferList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Offer']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OfferMerchantCashAdvanceDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['OfferMerchantCashAdvanceDto'] = ResolversParentTypes['OfferMerchantCashAdvanceDto']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  commissionPercentage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  commissions?: Resolver<Maybe<Array<ResolversTypes['OfferFeeCommissionJson']>>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['InternalCompany']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  factorRate?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  funder?: Resolver<Maybe<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  fundingDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  fundingFee?: Resolver<Maybe<Array<ResolversTypes['OfferFeeCommissionJson']>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['Integration']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  merchant?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  secondaryFunders?: Resolver<Maybe<Array<ResolversTypes['Underwriter']>>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['MerchantCashAdvanceStatus']>, ParentType, ContextType>;
  term?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OffersLinkToFilesResolvers<ContextType = any, ParentType extends ResolversParentTypes['OffersLinkToFiles'] = ResolversParentTypes['OffersLinkToFiles']> = ResolversObject<{
  linkToFiles?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rehabGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Owner'] = ResolversParentTypes['Owner']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bizEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bizPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  companyOwners?: Resolver<ResolversTypes['CompanyOwner'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  ssn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ssnNormalized?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentMethodResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentMethod'] = ResolversParentTypes['PaymentMethod']> = ResolversObject<{
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logo?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PermissionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Permission'] = ResolversParentTypes['Permission']> = ResolversObject<{
  area?: Resolver<ResolversTypes['ProductArea'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mcaDynamicRoles?: Resolver<Array<ResolversTypes['McaDynamicRole']>, ParentType, ContextType>;
  modifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['Roles']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PermissionsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['PermissionsList'] = ResolversParentTypes['PermissionsList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Permission']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortFolioChartDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortFolioChartDto'] = ResolversParentTypes['PortFolioChartDto']> = ResolversObject<{
  activeReceivables?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  activeReceivablesCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attorney?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attorneyCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  collections?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  collectionsCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  inHouseLegal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inHouseLegalCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  monthTotal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notPaying?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notPayingCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  open?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  openCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  originationPerformanceAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  portFolioCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  portFolioValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profitAndLoss?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resumed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resumedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  settled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  settledCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  slow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  slowCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAccumulated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAccumulatedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAmtPaidClr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCompleted?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCompletedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalMcaCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPayback?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPortFolio?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPortFolioCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReceivables?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReceivablesCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  verySlow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  verySlowCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writtenOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writtenOffCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortFolioSummaryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortFolioSummaryDto'] = ResolversParentTypes['PortFolioSummaryDto']> = ResolversObject<{
  activeReceivables?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  activeReceivablesCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attorney?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  attorneyCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  collections?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  collectionsCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inHouseLegal?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  inHouseLegalCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notPaying?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  notPayingCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  open?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  openCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  portFolioCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  portFolioValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  profitAndLoss?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resumed?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  resumedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  settled?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  settledCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  slow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  slowCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAccumulated?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalAccumulatedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCompleted?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalCompletedCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPortFolio?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalPortFolioCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReceivables?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  totalReceivablesCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  verySlow?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  verySlowCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writtenOff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  writtenOffCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfoliosCollectionsChartPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfoliosCollectionsChartPoint'] = ResolversParentTypes['PortfoliosCollectionsChartPoint']> = ResolversObject<{
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  series?: Resolver<Array<ResolversTypes['PortfoliosCollectionsChartSeriesItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PortfoliosCollectionsChartSeriesItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfoliosCollectionsChartSeriesItem'] = ResolversParentTypes['PortfoliosCollectionsChartSeriesItem']> = ResolversObject<{
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PostFundingFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PostFundingFee'] = ResolversParentTypes['PostFundingFee']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  comment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  config?: Resolver<Maybe<ResolversTypes['ConfigFee']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['FineStatus']>, ParentType, ContextType>;
  transactionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PullCreditReportResultDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PullCreditReportResultDto'] = ResolversParentTypes['PullCreditReportResultDto']> = ResolversObject<{
  data?: Resolver<Maybe<ResolversTypes['ApplicationExternalServiceDataDto']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  fromCache?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  accessiblePortfolios?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  activeExternalServices?: Resolver<Array<ResolversTypes['ExternalServiceDto']>, ParentType, ContextType>;
  allCompanies?: Resolver<ResolversTypes['CompaniesList'], ParentType, ContextType, RequireFields<QueryAllCompaniesArgs, 'limit' | 'offset' | 'sortArgs'>>;
  allSyndicationDetailsSummary?: Resolver<ResolversTypes['SyndicationDetailsSummaryDto'], ParentType, ContextType, RequireFields<QueryAllSyndicationDetailsSummaryArgs, 'limit' | 'offset' | 'sortArgs'>>;
  applicationExternalServiceConnection?: Resolver<Maybe<ResolversTypes['ApplicationExternalServiceConnectionDto']>, ParentType, ContextType, RequireFields<QueryApplicationExternalServiceConnectionArgs, 'id'>>;
  applicationExternalServiceConnections?: Resolver<Array<ResolversTypes['ApplicationExternalServiceConnectionDto']>, ParentType, ContextType, RequireFields<QueryApplicationExternalServiceConnectionsArgs, 'applicationId'>>;
  applicationExternalServiceData?: Resolver<Maybe<ResolversTypes['ApplicationExternalServiceDataDto']>, ParentType, ContextType, RequireFields<QueryApplicationExternalServiceDataArgs, 'id'>>;
  applicationExternalServiceDataByApplication?: Resolver<Array<ResolversTypes['ApplicationExternalServiceDataDto']>, ParentType, ContextType, RequireFields<QueryApplicationExternalServiceDataByApplicationArgs, 'applicationId'>>;
  applicationExternalServiceDataByConnection?: Resolver<Array<ResolversTypes['ApplicationExternalServiceDataDto']>, ParentType, ContextType, RequireFields<QueryApplicationExternalServiceDataByConnectionArgs, 'connectionId'>>;
  applicationProcessorList?: Resolver<Array<ResolversTypes['ApplicationProcessor']>, ParentType, ContextType>;
  applicationStatusHistory?: Resolver<Array<ResolversTypes['ApplicationStatusHistory']>, ParentType, ContextType, RequireFields<QueryApplicationStatusHistoryArgs, 'id'>>;
  applicationStatusList?: Resolver<Array<ResolversTypes['ApplicationStatus']>, ParentType, ContextType>;
  applications?: Resolver<ResolversTypes['ApplicationList'], ParentType, ContextType, RequireFields<QueryApplicationsArgs, 'limit' | 'offset' | 'sortArgs'>>;
  applicationsForMerchant?: Resolver<Array<ResolversTypes['Application']>, ParentType, ContextType, RequireFields<QueryApplicationsForMerchantArgs, 'merchantLegalName'>>;
  applicationsWithSelectedOffers?: Resolver<ResolversTypes['ApplicationWithOfferList'], ParentType, ContextType, RequireFields<QueryApplicationsWithSelectedOffersArgs, 'limit' | 'offset' | 'sortArgs'>>;
  auditLogs?: Resolver<ResolversTypes['AuditLogList'], ParentType, ContextType, RequireFields<QueryAuditLogsArgs, 'limit' | 'offset' | 'sortArgs'>>;
  availableExternalServices?: Resolver<Array<ResolversTypes['ExternalServiceType']>, ParentType, ContextType>;
  availableIntegrations?: Resolver<Array<ResolversTypes['IntegrationType']>, ParentType, ContextType>;
  bank?: Resolver<Maybe<ResolversTypes['BankInfo']>, ParentType, ContextType, RequireFields<QueryBankArgs, 'bankName'>>;
  bankByRoutingNumber?: Resolver<Maybe<ResolversTypes['BankInfoByRoutingNumber']>, ParentType, ContextType, RequireFields<QueryBankByRoutingNumberArgs, 'routingNumber'>>;
  banks?: Resolver<ResolversTypes['BankList'], ParentType, ContextType, RequireFields<QueryBanksArgs, 'limit' | 'offset' | 'sortArgs'>>;
  brokers?: Resolver<ResolversTypes['CompaniesList'], ParentType, ContextType, RequireFields<QueryBrokersArgs, 'limit' | 'offset' | 'sortArgs'>>;
  calendarEvents?: Resolver<Array<ResolversTypes['CalendarEvent']>, ParentType, ContextType, RequireFields<QueryCalendarEventsArgs, 'from' | 'to'>>;
  checkDuplicateRoutingNumbers?: Resolver<Array<ResolversTypes['RoutingNumberAssignment']>, ParentType, ContextType, RequireFields<QueryCheckDuplicateRoutingNumbersArgs, 'routingNumbers'>>;
  commission?: Resolver<ResolversTypes['Commission'], ParentType, ContextType, RequireFields<QueryCommissionArgs, 'id'>>;
  commissionsForMca?: Resolver<Array<ResolversTypes['Commission']>, ParentType, ContextType, RequireFields<QueryCommissionsForMcaArgs, 'mcaId'>>;
  companyOwners?: Resolver<Array<ResolversTypes['Owner']>, ParentType, ContextType, RequireFields<QueryCompanyOwnersArgs, 'companyId'>>;
  configFee?: Resolver<ResolversTypes['ConfigFee'], ParentType, ContextType, RequireFields<QueryConfigFeeArgs, 'id'>>;
  configFees?: Resolver<ResolversTypes['ConfigFeesList'], ParentType, ContextType>;
  countApplicationOfferStats?: Resolver<ResolversTypes['OfferApplicationsCount'], ParentType, ContextType>;
  countFundingPipelineOfferStats?: Resolver<ResolversTypes['FundingPipeLineOffersCount'], ParentType, ContextType>;
  countTodayMCAs?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  dailyCollectionsChart?: Resolver<Array<ResolversTypes['DailyCollectionsChartPoint']>, ParentType, ContextType, RequireFields<QueryDailyCollectionsChartArgs, 'forLastMonths'>>;
  externalService?: Resolver<Maybe<ResolversTypes['ExternalServiceDto']>, ParentType, ContextType, RequireFields<QueryExternalServiceArgs, 'id'>>;
  fee?: Resolver<ResolversTypes['FundingFee'], ParentType, ContextType, RequireFields<QueryFeeArgs, 'id'>>;
  feesByMcaId?: Resolver<Array<ResolversTypes['FundingFee']>, ParentType, ContextType, RequireFields<QueryFeesByMcaIdArgs, 'mcaId'>>;
  fine?: Resolver<ResolversTypes['PostFundingFee'], ParentType, ContextType, RequireFields<QueryFineArgs, 'id'>>;
  finesByMcaId?: Resolver<Array<ResolversTypes['PostFundingFee']>, ParentType, ContextType, RequireFields<QueryFinesByMcaIdArgs, 'mcaId'>>;
  fundersPortFolioSummary?: Resolver<Array<ResolversTypes['FunderPortFolioDto']>, ParentType, ContextType>;
  fundingPipelineStatus?: Resolver<Array<ResolversTypes['ApplicationStatus']>, ParentType, ContextType>;
  getAllExternalServiceLogos?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  getAllExternalServiceSecretSchemaDefinitions?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  getAllUnderwriters?: Resolver<Array<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  getApplication?: Resolver<ResolversTypes['Application'], ParentType, ContextType, RequireFields<QueryGetApplicationArgs, 'id'>>;
  getMcaIntegrationsWithTransactionsCount?: Resolver<Array<ResolversTypes['McaIntegrationsDto']>, ParentType, ContextType, RequireFields<QueryGetMcaIntegrationsWithTransactionsCountArgs, 'mcaId'>>;
  getOffer?: Resolver<ResolversTypes['Offer'], ParentType, ContextType, RequireFields<QueryGetOfferArgs, 'id'>>;
  getRecurrencyAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryGetRecurrencyAccountNumberArgs, 'recurrencyId'>>;
  getRecurrencyProcessorData?: Resolver<Maybe<ResolversTypes['RecurrencyProcessorData']>, ParentType, ContextType, RequireFields<QueryGetRecurrencyProcessorDataArgs, 'recurrencyId'>>;
  getRehabOffers?: Resolver<Array<ResolversTypes['Offer']>, ParentType, ContextType, RequireFields<QueryGetRehabOffersArgs, 'rehabGroupId'>>;
  getUnderwriterMemberInfo?: Resolver<Array<ResolversTypes['UnderwriterMemberInfo']>, ParentType, ContextType, RequireFields<QueryGetUnderwriterMemberInfoArgs, 'underwriterId'>>;
  getUsersForUnderwriter?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryGetUsersForUnderwriterArgs, 'underwriterId'>>;
  getUsersWithAccessToPortfolio?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryGetUsersWithAccessToPortfolioArgs, 'userId'>>;
  getUsersWithAccessiblePortfolio?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryGetUsersWithAccessiblePortfolioArgs, 'userId'>>;
  integration?: Resolver<ResolversTypes['Integration'], ParentType, ContextType, RequireFields<QueryIntegrationArgs, 'id'>>;
  integrations?: Resolver<ResolversTypes['IntegrationsList'], ParentType, ContextType>;
  integrationsSchedule?: Resolver<Maybe<ResolversTypes['IntegrationScheduleDto']>, ParentType, ContextType, RequireFields<QueryIntegrationsScheduleArgs, 'id'>>;
  internalCompanies?: Resolver<ResolversTypes['InternalCompaniesList'], ParentType, ContextType, RequireFields<QueryInternalCompaniesArgs, 'limit' | 'offset' | 'sortArgs'>>;
  internalCompany?: Resolver<ResolversTypes['InternalCompany'], ParentType, ContextType, RequireFields<QueryInternalCompanyArgs, 'id'>>;
  investorAverageFundingTerms?: Resolver<ResolversTypes['McaAverageFundingTerms'], ParentType, ContextType, RequireFields<QueryInvestorAverageFundingTermsArgs, 'userId'>>;
  investorBalance?: Resolver<ResolversTypes['InvestorBalanceDto'], ParentType, ContextType, RequireFields<QueryInvestorBalanceArgs, 'userId'>>;
  investorBalanceChart?: Resolver<Array<ResolversTypes['Chart']>, ParentType, ContextType, RequireFields<QueryInvestorBalanceChartArgs, 'forLastMonths' | 'userId'>>;
  investorBalanceTransactions?: Resolver<ResolversTypes['InvestorBalanceTransactionsList'], ParentType, ContextType, RequireFields<QueryInvestorBalanceTransactionsArgs, 'investorId' | 'limit' | 'offset' | 'sortArgs'>>;
  investorCashTransactions?: Resolver<ResolversTypes['InvestorBalanceTransactionsList'], ParentType, ContextType, RequireFields<QueryInvestorCashTransactionsArgs, 'investorId' | 'limit' | 'offset' | 'sortArgs'>>;
  investorCashTransactionsSummary?: Resolver<ResolversTypes['InvestorBalanceTransactionSummaryDto'], ParentType, ContextType, RequireFields<QueryInvestorCashTransactionsSummaryArgs, 'investorId' | 'limit' | 'offset' | 'sortArgs'>>;
  investorPortFolioSummary?: Resolver<ResolversTypes['InvestorPortFolioDto'], ParentType, ContextType, RequireFields<QueryInvestorPortFolioSummaryArgs, 'userId'>>;
  investorPortFolioSummaryChart?: Resolver<Array<ResolversTypes['InvestorPortFolioDto']>, ParentType, ContextType, RequireFields<QueryInvestorPortFolioSummaryChartArgs, 'months' | 'userId'>>;
  investorReconciliationBalances?: Resolver<ResolversTypes['InvestorReconciliationBalanceList'], ParentType, ContextType, RequireFields<QueryInvestorReconciliationBalancesArgs, 'investorId'>>;
  investorTotalDailyCollectionAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType, RequireFields<QueryInvestorTotalDailyCollectionAmountArgs, 'userId'>>;
  investorTransactions?: Resolver<Array<ResolversTypes['Chart']>, ParentType, ContextType, RequireFields<QueryInvestorTransactionsArgs, 'forLastMonths' | 'userId'>>;
  investorTransactionsChart?: Resolver<Array<ResolversTypes['Chart']>, ParentType, ContextType, RequireFields<QueryInvestorTransactionsChartArgs, 'forLastMonths' | 'userId'>>;
  investors?: Resolver<ResolversTypes['UsersList'], ParentType, ContextType, RequireFields<QueryInvestorsArgs, 'limit' | 'offset' | 'rights' | 'sortArgs'>>;
  investorsPortFolioSummary?: Resolver<Array<ResolversTypes['InvestorPortFolioDto']>, ParentType, ContextType, Partial<QueryInvestorsPortFolioSummaryArgs>>;
  isCompanyAdded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsCompanyAddedArgs, 'legalName'>>;
  isEmailRegistered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsEmailRegisteredArgs, 'email'>>;
  isExisitingExternalService?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsExisitingExternalServiceArgs, 'name'>>;
  isInternalCompanyAdded?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<QueryIsInternalCompanyAddedArgs, 'legalName'>>;
  listAllSyndicationDetails?: Resolver<ResolversTypes['SyndicationDetailsList'], ParentType, ContextType, RequireFields<QueryListAllSyndicationDetailsArgs, 'limit' | 'offset' | 'sortArgs'>>;
  listSyndicationDetails?: Resolver<ResolversTypes['SyndicationDetailsList'], ParentType, ContextType, RequireFields<QueryListSyndicationDetailsArgs, 'limit' | 'offset' | 'sortArgs' | 'userId'>>;
  listTransactions?: Resolver<ResolversTypes['TransactionsList'], ParentType, ContextType, RequireFields<QueryListTransactionsArgs, 'fromDate' | 'limit' | 'offset' | 'sortArgs' | 'toDate'>>;
  lookupSchedule?: Resolver<Array<ResolversTypes['RecurrencyProcessorData']>, ParentType, ContextType, RequireFields<QueryLookupScheduleArgs, 'external' | 'integrationId'>>;
  mapOfferToMCA?: Resolver<ResolversTypes['OfferMerchantCashAdvanceDto'], ParentType, ContextType, RequireFields<QueryMapOfferToMcaArgs, 'offerId'>>;
  mcaAverageFundingTerms?: Resolver<ResolversTypes['McaAverageFundingTerms'], ParentType, ContextType>;
  mcaDisplayAttributes?: Resolver<Array<ResolversTypes['McaDisplayAttribute']>, ParentType, ContextType>;
  mcaFeeTransactions?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<QueryMcaFeeTransactionsArgs, 'mcaId'>>;
  mcaIntegrationTransactions?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<QueryMcaIntegrationTransactionsArgs, 'integrationId' | 'mcaId'>>;
  mcaRecurrencies?: Resolver<Array<ResolversTypes['Recurrency']>, ParentType, ContextType, RequireFields<QueryMcaRecurrenciesArgs, 'mcaId'>>;
  mcaSyndication?: Resolver<Array<ResolversTypes['Syndication']>, ParentType, ContextType, RequireFields<QueryMcaSyndicationArgs, 'mcaId'>>;
  mcaTransactions?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<QueryMcaTransactionsArgs, 'mcaId'>>;
  merchant?: Resolver<ResolversTypes['Company'], ParentType, ContextType, RequireFields<QueryMerchantArgs, 'id'>>;
  merchantBankAccounts?: Resolver<Array<ResolversTypes['MerchantBankAccount']>, ParentType, ContextType, RequireFields<QueryMerchantBankAccountsArgs, 'merchantId'>>;
  merchantCashAdvance?: Resolver<ResolversTypes['MerchantCashAdvance'], ParentType, ContextType, RequireFields<QueryMerchantCashAdvanceArgs, 'id'>>;
  merchantCashAdvanceExternalServiceConnection?: Resolver<Maybe<ResolversTypes['MerchantCashAdvanceExternalServiceConnectionDto']>, ParentType, ContextType, RequireFields<QueryMerchantCashAdvanceExternalServiceConnectionArgs, 'id'>>;
  merchantCashAdvanceExternalServiceConnections?: Resolver<Array<ResolversTypes['MerchantCashAdvanceExternalServiceConnectionDto']>, ParentType, ContextType, RequireFields<QueryMerchantCashAdvanceExternalServiceConnectionsArgs, 'mcaId'>>;
  merchantCashAdvanceExternalServiceData?: Resolver<Maybe<ResolversTypes['MerchantCashAdvanceExternalServiceDataDto']>, ParentType, ContextType, RequireFields<QueryMerchantCashAdvanceExternalServiceDataArgs, 'id'>>;
  merchantCashAdvanceExternalServiceDataByConnection?: Resolver<Array<ResolversTypes['MerchantCashAdvanceExternalServiceDataDto']>, ParentType, ContextType, RequireFields<QueryMerchantCashAdvanceExternalServiceDataByConnectionArgs, 'connectionId'>>;
  merchantCashAdvanceExternalServiceDataByMca?: Resolver<Array<ResolversTypes['MerchantCashAdvanceExternalServiceDataDto']>, ParentType, ContextType, RequireFields<QueryMerchantCashAdvanceExternalServiceDataByMcaArgs, 'mcaId'>>;
  merchantCashAdvanceStatusHistory?: Resolver<Array<ResolversTypes['MerchantCashAdvanceStatusHistory']>, ParentType, ContextType, RequireFields<QueryMerchantCashAdvanceStatusHistoryArgs, 'id'>>;
  merchantCashAdvances?: Resolver<ResolversTypes['MerchantCashAdvancesList'], ParentType, ContextType, RequireFields<QueryMerchantCashAdvancesArgs, 'limit' | 'offset' | 'sortArgs'>>;
  merchantCashAdvancesPreAggregated?: Resolver<ResolversTypes['MerchantCashAdvancesList'], ParentType, ContextType, RequireFields<QueryMerchantCashAdvancesPreAggregatedArgs, 'limit' | 'offset' | 'sortArgs'>>;
  merchantCashAdvancesSummary?: Resolver<ResolversTypes['MerchantCashAdvanceSummary'], ParentType, ContextType, RequireFields<QueryMerchantCashAdvancesSummaryArgs, 'limit' | 'offset' | 'sortArgs'>>;
  merchants?: Resolver<ResolversTypes['CompaniesList'], ParentType, ContextType, RequireFields<QueryMerchantsArgs, 'limit' | 'offset' | 'sortArgs'>>;
  myPortFolioSummary?: Resolver<ResolversTypes['InvestorPortFolioDto'], ParentType, ContextType>;
  myPortFolioSummaryChart?: Resolver<Array<ResolversTypes['InvestorPortFolioDto']>, ParentType, ContextType, RequireFields<QueryMyPortFolioSummaryChartArgs, 'months'>>;
  myTransactions?: Resolver<Array<ResolversTypes['Chart']>, ParentType, ContextType, RequireFields<QueryMyTransactionsArgs, 'forLastMonths'>>;
  myTransactionsChart?: Resolver<Array<ResolversTypes['Chart']>, ParentType, ContextType, RequireFields<QueryMyTransactionsChartArgs, 'forLastMonths'>>;
  nonWorkingDays?: Resolver<Array<ResolversTypes['NonWorkingDay']>, ParentType, ContextType>;
  offerByMcaId?: Resolver<Maybe<ResolversTypes['Offer']>, ParentType, ContextType, RequireFields<QueryOfferByMcaIdArgs, 'mcaId'>>;
  offerStatusList?: Resolver<Array<ResolversTypes['ApplicationStatus']>, ParentType, ContextType>;
  offers?: Resolver<ResolversTypes['OfferList'], ParentType, ContextType, RequireFields<QueryOffersArgs, 'limit' | 'offset' | 'sortArgs'>>;
  offersForApplication?: Resolver<Array<ResolversTypes['Offer']>, ParentType, ContextType, RequireFields<QueryOffersForApplicationArgs, 'applicationId'>>;
  offersForFundingPipeline?: Resolver<ResolversTypes['OfferList'], ParentType, ContextType, RequireFields<QueryOffersForFundingPipelineArgs, 'limit' | 'offset' | 'sortArgs'>>;
  owner?: Resolver<ResolversTypes['Owner'], ParentType, ContextType, RequireFields<QueryOwnerArgs, 'id'>>;
  paymentMethods?: Resolver<Array<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['Permission'], ParentType, ContextType, RequireFields<QueryPermissionArgs, 'name'>>;
  permissions?: Resolver<ResolversTypes['PermissionsList'], ParentType, ContextType, RequireFields<QueryPermissionsArgs, 'limit' | 'offset'>>;
  portFolioChart?: Resolver<Array<ResolversTypes['PortFolioChartDto']>, ParentType, ContextType, Partial<QueryPortFolioChartArgs>>;
  portFolioSummary?: Resolver<ResolversTypes['PortFolioSummaryDto'], ParentType, ContextType>;
  portfolioMerchantCashAdvances?: Resolver<ResolversTypes['MerchantCashAdvancesList'], ParentType, ContextType, RequireFields<QueryPortfolioMerchantCashAdvancesArgs, 'limit' | 'offset' | 'sortArgs'>>;
  portfoliosAverageFundingTerms?: Resolver<ResolversTypes['McaAverageFundingTerms'], ParentType, ContextType>;
  portfoliosCollectionsChart?: Resolver<Array<ResolversTypes['PortfoliosCollectionsChartPoint']>, ParentType, ContextType, RequireFields<QueryPortfoliosCollectionsChartArgs, 'forLastMonths'>>;
  portfoliosTransactionsChart?: Resolver<Array<ResolversTypes['Chart']>, ParentType, ContextType, RequireFields<QueryPortfoliosTransactionsChartArgs, 'forLastMonths'>>;
  previewOfferEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryPreviewOfferEmailArgs, 'offerId'>>;
  profile?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  recurrency?: Resolver<ResolversTypes['Recurrency'], ParentType, ContextType, RequireFields<QueryRecurrencyArgs, 'id'>>;
  recurrencyTransactions?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType, RequireFields<QueryRecurrencyTransactionsArgs, 'recurrencyId'>>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType, RequireFields<QueryRoleArgs, 'id'>>;
  roles?: Resolver<ResolversTypes['RolesList'], ParentType, ContextType, RequireFields<QueryRolesArgs, 'limit' | 'offset' | 'sortArgs'>>;
  rolesRightsMapping?: Resolver<Array<ResolversTypes['RoleRightsMapping']>, ParentType, ContextType>;
  stipulation?: Resolver<ResolversTypes['Stipulation'], ParentType, ContextType, RequireFields<QueryStipulationArgs, 'id'>>;
  stipulations?: Resolver<Array<ResolversTypes['Stipulation']>, ParentType, ContextType, Partial<QueryStipulationsArgs>>;
  syndication?: Resolver<ResolversTypes['Syndication'], ParentType, ContextType, RequireFields<QuerySyndicationArgs, 'id'>>;
  syndicationDetailsSummary?: Resolver<ResolversTypes['SyndicationDetailsSummaryDto'], ParentType, ContextType, RequireFields<QuerySyndicationDetailsSummaryArgs, 'limit' | 'offset' | 'sortArgs' | 'userId'>>;
  todaysCollection?: Resolver<ResolversTypes['TodaysCollectionDto'], ParentType, ContextType>;
  totalDailyCollectionAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  transactionsChart?: Resolver<Array<ResolversTypes['Chart']>, ParentType, ContextType, RequireFields<QueryTransactionsChartArgs, 'forLastMonths' | 'isManual'>>;
  transactionsSummary?: Resolver<ResolversTypes['TransactionsSummaryDto'], ParentType, ContextType, RequireFields<QueryTransactionsSummaryArgs, 'fromDate' | 'limit' | 'offset' | 'sortArgs' | 'toDate'>>;
  underwriter?: Resolver<ResolversTypes['Underwriter'], ParentType, ContextType, RequireFields<QueryUnderwriterArgs, 'id'>>;
  underwriters?: Resolver<ResolversTypes['UnderwritersList'], ParentType, ContextType, RequireFields<QueryUnderwritersArgs, 'limit' | 'offset' | 'sortArgs'>>;
  uptime?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<QueryUserArgs, 'id'>>;
  userBankAccounts?: Resolver<Array<ResolversTypes['UserBankAccount']>, ParentType, ContextType, RequireFields<QueryUserBankAccountsArgs, 'userId'>>;
  users?: Resolver<ResolversTypes['UsersList'], ParentType, ContextType, RequireFields<QueryUsersArgs, 'limit' | 'offset' | 'rights' | 'sortArgs'>>;
}>;

export type ReconciliationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reconciliation'] = ResolversParentTypes['Reconciliation']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investor?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reconciliationAction?: Resolver<ResolversTypes['ReconciliationAction'], ParentType, ContextType>;
  reconciliationType?: Resolver<ResolversTypes['ReconciliationType'], ParentType, ContextType>;
  transactionsCount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecurrencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Recurrency'] = ResolversParentTypes['Recurrency']> = ResolversObject<{
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  dailyPayment?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integration?: Resolver<ResolversTypes['Integration'], ParentType, ContextType>;
  mca?: Resolver<ResolversTypes['MerchantCashAdvance'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  processorReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recurrenceNumber?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  referenceMca?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  referenceRecurrence?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['RecurrencyState'], ParentType, ContextType>;
  stateNotes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  term?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RecurrencyProcessorDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurrencyProcessorData'] = ResolversParentTypes['RecurrencyProcessorData']> = ResolversObject<{
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  bankAccountName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAssigned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPaused?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isStopped?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processedPaymentCount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  processorReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  totalAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rights?: Resolver<Array<ResolversTypes['Rights']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoleRightsMappingResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleRightsMapping'] = ResolversParentTypes['RoleRightsMapping']> = ResolversObject<{
  rights?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RolesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['RolesList'] = ResolversParentTypes['RolesList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Role']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoutingNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoutingNumber'] = ResolversParentTypes['RoutingNumber']> = ResolversObject<{
  location?: Resolver<ResolversTypes['BankLocation'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RoutingNumberAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoutingNumberAssignment'] = ResolversParentTypes['RoutingNumberAssignment']> = ResolversObject<{
  bankName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locationId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  locationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SecretAchProcResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecretAchProc'] = ResolversParentTypes['SecretAchProc']> = ResolversObject<{
  apikey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customerInfoKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SecretClearAchBotResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecretClearAchBot'] = ResolversParentTypes['SecretClearAchBot']> = ResolversObject<{
  apikey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SecretDevNullResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecretDevNull'] = ResolversParentTypes['SecretDevNull']> = ResolversObject<{
  zero?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SecretGoAchResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecretGoAch'] = ResolversParentTypes['SecretGoAch']> = ResolversObject<{
  apikey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vendorName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SecretGoAchBotResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecretGoAchBot'] = ResolversParentTypes['SecretGoAchBot']> = ResolversObject<{
  originatorAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originatorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SecretLiftoffCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecretLiftoffCard'] = ResolversParentTypes['SecretLiftoffCard']> = ResolversObject<{
  bankAccountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Settings'] = ResolversParentTypes['Settings']> = ResolversObject<{
  colorCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enableRefresh?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hideFromChart?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  loadTransactionsForLastDays?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StipulationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Stipulation'] = ResolversParentTypes['Stipulation']> = ResolversObject<{
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubfolderFileInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubfolderFileInfo'] = ResolversParentTypes['SubfolderFileInfo']> = ResolversObject<{
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SyndicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Syndication'] = ResolversParentTypes['Syndication']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  brkCommissionPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  calculationType?: Resolver<ResolversTypes['SyndicationCalculation'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  crmFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isoCommissionPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mca?: Resolver<Maybe<Array<ResolversTypes['MerchantCashAdvance']>>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  orgFeeCommissionPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  otherFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  serviceFeePercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SyndicationType'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wireFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SyndicationDetailsDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyndicationDetailsDto'] = ResolversParentTypes['SyndicationDetailsDto']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amtPaidClr?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  amtPaidPnd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balanceClr?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balanceClrWFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balancePnd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balancePndWFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  brkCommissionAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  broker?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  calculationType?: Resolver<ResolversTypes['SyndicationCalculation'], ParentType, ContextType>;
  completion?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  crmFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  externalConnections?: Resolver<Maybe<Array<ResolversTypes['MerchantCashAdvanceExternalServiceConnection']>>, ParentType, ContextType>;
  funder?: Resolver<Maybe<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  fundingAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integration?: Resolver<ResolversTypes['Integration'], ParentType, ContextType>;
  investorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investorName?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isoCommissionAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lastPmtDay?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  legal?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  mcaEndDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  mcaFactorRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mcaFundingDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  mcaId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  mcaLoanAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mcaNumber?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  mcaPerfEndDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  mcaStartDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  mcaStatus?: Resolver<ResolversTypes['MerchantCashAdvanceStatus'], ParentType, ContextType>;
  mcaTerm?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  merchant?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  nrt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  orgFeeAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  otherFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  payback?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  perfTerm?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  pmt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  serviceFeeAmount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  serviceFeePercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationAmtPaidClr?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationAmtPaidPnd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationBalanceClr?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationBalanceClrWFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationBalancePnd?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationBalancePndWFees?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationGrossProfit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationNetInvested?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationNetProfit?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationNetWire?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPayback?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPayoff?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPercentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPmt?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPnL?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPnlGross?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationPnlNet?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  syndicationType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SyndicationType'], ParentType, ContextType>;
  wireFee?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SyndicationDetailsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyndicationDetailsList'] = ResolversParentTypes['SyndicationDetailsList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['SyndicationDetailsDto']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SyndicationDetailsSummaryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SyndicationDetailsSummaryDto'] = ResolversParentTypes['SyndicationDetailsSummaryDto']> = ResolversObject<{
  SyndicationNetInvested?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amtPaidClr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  amtPaidPnd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balanceClr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  balancePnd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  brkCommissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  completion?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  crmFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fundingAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  isoCommissionAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  nrt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  orgFeeAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  otherFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  payback?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  serviceFeeAmount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationAmtPaidClr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationAmtPaidPnd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationBalanceClr?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationBalanceClrWFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationBalancePnd?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationBalancePndWFees?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationGrossProfit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationNetInvested?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationNetProfit?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationNetWire?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationPayback?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationPayoff?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationPmt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  syndicationPnL?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  wireFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TodaysCollectionDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TodaysCollectionDto'] = ResolversParentTypes['TodaysCollectionDto']> = ResolversObject<{
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  series?: Resolver<Array<ResolversTypes['TodaysCollectionSeriesItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TodaysCollectionSeriesItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TodaysCollectionSeriesItem'] = ResolversParentTypes['TodaysCollectionSeriesItem']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']> = ResolversObject<{
  account?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  assignedToUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  assignedToUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  depositDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  effectiveDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  externalId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integration?: Resolver<Maybe<ResolversTypes['Integration']>, ParentType, ContextType>;
  mca?: Resolver<Maybe<ResolversTypes['MerchantCashAdvance']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  originationDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  paymentMethod?: Resolver<Maybe<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  recurrenceDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recurrency?: Resolver<Maybe<ResolversTypes['Recurrency']>, ParentType, ContextType>;
  returnCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returnDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  statusChangedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  statusChangedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['TransactionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionsList'] = ResolversParentTypes['TransactionsList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Transaction']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionsSummaryDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionsSummaryDto'] = ResolversParentTypes['TransactionsSummaryDto']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnderwriterResolvers<ContextType = any, ParentType extends ResolversParentTypes['Underwriter'] = ResolversParentTypes['Underwriter']> = ResolversObject<{
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connectedUsers?: Resolver<Maybe<Array<ResolversTypes['UserFunderConnections']>>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnderwriterMemberInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnderwriterMemberInfo'] = ResolversParentTypes['UnderwriterMemberInfo']> = ResolversObject<{
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bizPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UnderwritersListResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnderwritersList'] = ResolversParentTypes['UnderwritersList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  accessTokenTtlHours?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  bankAccounts?: Resolver<Maybe<Array<ResolversTypes['UserBankAccount']>>, ParentType, ContextType>;
  cognitoSub?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['UserData']>, ParentType, ContextType>;
  deviceRememberingDays?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enableReturnedTransactionsReport?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  firstTransactionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  funderConnectedTo?: Resolver<Maybe<Array<ResolversTypes['UserFunderConnections']>>, ParentType, ContextType>;
  fundingWallet?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  gridPreferences?: Resolver<Maybe<Array<ResolversTypes['UserGridPreferences']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEmailConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLoginEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isOwner?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPhoneConfirmed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  locale?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  manager?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  mfaConfigured?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mfaDeviceRememberingEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mfaEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  modifiedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  modifiedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pnl?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  portfolioConnectedTo?: Resolver<Maybe<Array<ResolversTypes['UserPortfolioConnections']>>, ParentType, ContextType>;
  portfolioConnections?: Resolver<Maybe<Array<ResolversTypes['UserPortfolioConnections']>>, ParentType, ContextType>;
  preferences?: Resolver<Maybe<ResolversTypes['UserPreferences']>, ParentType, ContextType>;
  remittance?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  remittanceFee?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  rights?: Resolver<Maybe<Array<ResolversTypes['Rights']>>, ParentType, ContextType>;
  role?: Resolver<Maybe<Array<ResolversTypes['Roles']>>, ParentType, ContextType>;
  syndications?: Resolver<Maybe<Array<ResolversTypes['Syndication']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserBankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserBankAccount'] = ResolversParentTypes['UserBankAccount']> = ResolversObject<{
  accountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  routingNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserData'] = ResolversParentTypes['UserData']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bizEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bizPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cellPhone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateOfBirth?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ssn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserFunderConnectionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserFunderConnections'] = ResolversParentTypes['UserFunderConnections']> = ResolversObject<{
  funder?: Resolver<Maybe<ResolversTypes['Underwriter']>, ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserGridPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserGridPreferences'] = ResolversParentTypes['UserGridPreferences']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  columnsState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  filterState?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['GridType'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rowsPerPage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  useScroll?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserPortfolioConnectionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPortfolioConnections'] = ResolversParentTypes['UserPortfolioConnections']> = ResolversObject<{
  sourceUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  targetUser?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserPreferencesResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPreferences'] = ResolversParentTypes['UserPreferences']> = ResolversObject<{
  hidePerformanceChart?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  showTrailingZeros?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UsersListResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsersList'] = ResolversParentTypes['UsersList']> = ResolversObject<{
  data?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  Address?: AddressResolvers<ContextType>;
  Application?: ApplicationResolvers<ContextType>;
  ApplicationExternalServiceConnection?: ApplicationExternalServiceConnectionResolvers<ContextType>;
  ApplicationExternalServiceConnectionDto?: ApplicationExternalServiceConnectionDtoResolvers<ContextType>;
  ApplicationExternalServiceDataDto?: ApplicationExternalServiceDataDtoResolvers<ContextType>;
  ApplicationList?: ApplicationListResolvers<ContextType>;
  ApplicationProcessor?: ApplicationProcessorResolvers<ContextType>;
  ApplicationStatus?: ApplicationStatusResolvers<ContextType>;
  ApplicationStatusHistory?: ApplicationStatusHistoryResolvers<ContextType>;
  ApplicationWithOffer?: ApplicationWithOfferResolvers<ContextType>;
  ApplicationWithOfferList?: ApplicationWithOfferListResolvers<ContextType>;
  AuditEvent?: AuditEventResolvers<ContextType>;
  AuditLogList?: AuditLogListResolvers<ContextType>;
  AvailableDocumentDto?: AvailableDocumentDtoResolvers<ContextType>;
  BankInfo?: BankInfoResolvers<ContextType>;
  BankInfoByRoutingNumber?: BankInfoByRoutingNumberResolvers<ContextType>;
  BankList?: BankListResolvers<ContextType>;
  BankLocation?: BankLocationResolvers<ContextType>;
  CalendarEvent?: CalendarEventResolvers<ContextType>;
  Chart?: ChartResolvers<ContextType>;
  Commission?: CommissionResolvers<ContextType>;
  CompaniesList?: CompaniesListResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  CompanyDocumentDto?: CompanyDocumentDtoResolvers<ContextType>;
  CompanyOwner?: CompanyOwnerResolvers<ContextType>;
  ConfigFee?: ConfigFeeResolvers<ContextType>;
  ConfigFeesList?: ConfigFeesListResolvers<ContextType>;
  DailyCollectionsChartPoint?: DailyCollectionsChartPointResolvers<ContextType>;
  DailyCollectionsChartSeriesItem?: DailyCollectionsChartSeriesItemResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  ExternalServiceConfiguration?: ExternalServiceConfigurationResolvers<ContextType>;
  ExternalServiceDto?: ExternalServiceDtoResolvers<ContextType>;
  FunderPortFolioDto?: FunderPortFolioDtoResolvers<ContextType>;
  FundingFee?: FundingFeeResolvers<ContextType>;
  FundingPipeLineOffersCount?: FundingPipeLineOffersCountResolvers<ContextType>;
  FundingPipelineStatusCount?: FundingPipelineStatusCountResolvers<ContextType>;
  ImportedStatsDto?: ImportedStatsDtoResolvers<ContextType>;
  ImportedTransactionDto?: ImportedTransactionDtoResolvers<ContextType>;
  Integration?: IntegrationResolvers<ContextType>;
  IntegrationHealthMonitor?: IntegrationHealthMonitorResolvers<ContextType>;
  IntegrationScheduleDto?: IntegrationScheduleDtoResolvers<ContextType>;
  IntegrationSecret?: IntegrationSecretResolvers<ContextType>;
  IntegrationsList?: IntegrationsListResolvers<ContextType>;
  InternalCompaniesList?: InternalCompaniesListResolvers<ContextType>;
  InternalCompany?: InternalCompanyResolvers<ContextType>;
  InternalCompanyDocumentsInfo?: InternalCompanyDocumentsInfoResolvers<ContextType>;
  InvestorBalanceDto?: InvestorBalanceDtoResolvers<ContextType>;
  InvestorBalanceSummaryDto?: InvestorBalanceSummaryDtoResolvers<ContextType>;
  InvestorBalanceTransactionDto?: InvestorBalanceTransactionDtoResolvers<ContextType>;
  InvestorBalanceTransactionSummaryDto?: InvestorBalanceTransactionSummaryDtoResolvers<ContextType>;
  InvestorBalanceTransactionsList?: InvestorBalanceTransactionsListResolvers<ContextType>;
  InvestorPortFolioDto?: InvestorPortFolioDtoResolvers<ContextType>;
  InvestorReconciliationBalanceDto?: InvestorReconciliationBalanceDtoResolvers<ContextType>;
  InvestorReconciliationBalanceList?: InvestorReconciliationBalanceListResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  JSONObject?: GraphQLScalarType;
  McaAverageFundingTerms?: McaAverageFundingTermsResolvers<ContextType>;
  McaDisplayAttribute?: McaDisplayAttributeResolvers<ContextType>;
  McaIntegrationsDto?: McaIntegrationsDtoResolvers<ContextType>;
  McaRefi?: McaRefiResolvers<ContextType>;
  MerchantBankAccount?: MerchantBankAccountResolvers<ContextType>;
  MerchantCashAdvance?: MerchantCashAdvanceResolvers<ContextType>;
  MerchantCashAdvanceExternalServiceConnection?: MerchantCashAdvanceExternalServiceConnectionResolvers<ContextType>;
  MerchantCashAdvanceExternalServiceConnectionDto?: MerchantCashAdvanceExternalServiceConnectionDtoResolvers<ContextType>;
  MerchantCashAdvanceExternalServiceDataDto?: MerchantCashAdvanceExternalServiceDataDtoResolvers<ContextType>;
  MerchantCashAdvanceStatusHistory?: MerchantCashAdvanceStatusHistoryResolvers<ContextType>;
  MerchantCashAdvanceSummary?: MerchantCashAdvanceSummaryResolvers<ContextType>;
  MerchantCashAdvancesList?: MerchantCashAdvancesListResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NonWorkingDay?: NonWorkingDayResolvers<ContextType>;
  Offer?: OfferResolvers<ContextType>;
  OfferApplicationsCount?: OfferApplicationsCountResolvers<ContextType>;
  OfferEmail?: OfferEmailResolvers<ContextType>;
  OfferFeeCommissionJson?: OfferFeeCommissionJsonResolvers<ContextType>;
  OfferList?: OfferListResolvers<ContextType>;
  OfferMerchantCashAdvanceDto?: OfferMerchantCashAdvanceDtoResolvers<ContextType>;
  OffersLinkToFiles?: OffersLinkToFilesResolvers<ContextType>;
  Owner?: OwnerResolvers<ContextType>;
  PaymentMethod?: PaymentMethodResolvers<ContextType>;
  Permission?: PermissionResolvers<ContextType>;
  PermissionsList?: PermissionsListResolvers<ContextType>;
  PortFolioChartDto?: PortFolioChartDtoResolvers<ContextType>;
  PortFolioSummaryDto?: PortFolioSummaryDtoResolvers<ContextType>;
  PortfoliosCollectionsChartPoint?: PortfoliosCollectionsChartPointResolvers<ContextType>;
  PortfoliosCollectionsChartSeriesItem?: PortfoliosCollectionsChartSeriesItemResolvers<ContextType>;
  PostFundingFee?: PostFundingFeeResolvers<ContextType>;
  PullCreditReportResultDto?: PullCreditReportResultDtoResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Reconciliation?: ReconciliationResolvers<ContextType>;
  Recurrency?: RecurrencyResolvers<ContextType>;
  RecurrencyProcessorData?: RecurrencyProcessorDataResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RoleRightsMapping?: RoleRightsMappingResolvers<ContextType>;
  RolesList?: RolesListResolvers<ContextType>;
  RoutingNumber?: RoutingNumberResolvers<ContextType>;
  RoutingNumberAssignment?: RoutingNumberAssignmentResolvers<ContextType>;
  SecretAchProc?: SecretAchProcResolvers<ContextType>;
  SecretClearAchBot?: SecretClearAchBotResolvers<ContextType>;
  SecretDevNull?: SecretDevNullResolvers<ContextType>;
  SecretGoAch?: SecretGoAchResolvers<ContextType>;
  SecretGoAchBot?: SecretGoAchBotResolvers<ContextType>;
  SecretLiftoffCard?: SecretLiftoffCardResolvers<ContextType>;
  Settings?: SettingsResolvers<ContextType>;
  Stipulation?: StipulationResolvers<ContextType>;
  SubfolderFileInfo?: SubfolderFileInfoResolvers<ContextType>;
  Syndication?: SyndicationResolvers<ContextType>;
  SyndicationDetailsDto?: SyndicationDetailsDtoResolvers<ContextType>;
  SyndicationDetailsList?: SyndicationDetailsListResolvers<ContextType>;
  SyndicationDetailsSummaryDto?: SyndicationDetailsSummaryDtoResolvers<ContextType>;
  TodaysCollectionDto?: TodaysCollectionDtoResolvers<ContextType>;
  TodaysCollectionSeriesItem?: TodaysCollectionSeriesItemResolvers<ContextType>;
  Transaction?: TransactionResolvers<ContextType>;
  TransactionsList?: TransactionsListResolvers<ContextType>;
  TransactionsSummaryDto?: TransactionsSummaryDtoResolvers<ContextType>;
  Underwriter?: UnderwriterResolvers<ContextType>;
  UnderwriterMemberInfo?: UnderwriterMemberInfoResolvers<ContextType>;
  UnderwritersList?: UnderwritersListResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserBankAccount?: UserBankAccountResolvers<ContextType>;
  UserData?: UserDataResolvers<ContextType>;
  UserFunderConnections?: UserFunderConnectionsResolvers<ContextType>;
  UserGridPreferences?: UserGridPreferencesResolvers<ContextType>;
  UserPortfolioConnections?: UserPortfolioConnectionsResolvers<ContextType>;
  UserPreferences?: UserPreferencesResolvers<ContextType>;
  UsersList?: UsersListResolvers<ContextType>;
}>;



export const ApplicationStatusHistoryDocument = gql`
    query applicationStatusHistory($id: ID!) {
  applicationStatusHistory(id: $id) {
    fromStatus {
      id
    }
    toStatus {
      id
    }
    user {
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
    createdAt
  }
}
    `;

/**
 * __useApplicationStatusHistoryQuery__
 *
 * To run a query within a React component, call `useApplicationStatusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStatusHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStatusHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationStatusHistoryQuery(baseOptions: Apollo.QueryHookOptions<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables> & ({ variables: ApplicationStatusHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>(ApplicationStatusHistoryDocument, options);
      }
export function useApplicationStatusHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>(ApplicationStatusHistoryDocument, options);
        }
// @ts-ignore
export function useApplicationStatusHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>;
export function useApplicationStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStatusHistoryQuery | undefined, ApplicationStatusHistoryQueryVariables>;
export function useApplicationStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>(ApplicationStatusHistoryDocument, options);
        }
export type ApplicationStatusHistoryQueryHookResult = ReturnType<typeof useApplicationStatusHistoryQuery>;
export type ApplicationStatusHistoryLazyQueryHookResult = ReturnType<typeof useApplicationStatusHistoryLazyQuery>;
export type ApplicationStatusHistorySuspenseQueryHookResult = ReturnType<typeof useApplicationStatusHistorySuspenseQuery>;
export type ApplicationStatusHistoryQueryResult = Apollo.QueryResult<ApplicationStatusHistoryQuery, ApplicationStatusHistoryQueryVariables>;
export const CreateApplicationDocument = gql`
    mutation createApplication($createApplicationInput: CreateApplicationInput!) {
  createApplication(createApplicationInput: $createApplicationInput) {
    id
  }
}
    `;
export type CreateApplicationMutationFn = Apollo.MutationFunction<CreateApplicationMutation, CreateApplicationMutationVariables>;

/**
 * __useCreateApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationMutation, { data, loading, error }] = useCreateApplicationMutation({
 *   variables: {
 *      createApplicationInput: // value for 'createApplicationInput'
 *   },
 * });
 */
export function useCreateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationMutation, CreateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationMutation, CreateApplicationMutationVariables>(CreateApplicationDocument, options);
      }
export type CreateApplicationMutationHookResult = ReturnType<typeof useCreateApplicationMutation>;
export type CreateApplicationMutationResult = Apollo.MutationResult<CreateApplicationMutation>;
export type CreateApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicationMutation, CreateApplicationMutationVariables>;
export const UpdateApplicationDocument = gql`
    mutation updateApplication($id: ID!, $updateApplicationInput: UpdateApplicationInput!) {
  updateApplication(id: $id, updateApplicationInput: $updateApplicationInput) {
    id
  }
}
    `;
export type UpdateApplicationMutationFn = Apollo.MutationFunction<UpdateApplicationMutation, UpdateApplicationMutationVariables>;

/**
 * __useUpdateApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApplicationMutation, { data, loading, error }] = useUpdateApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateApplicationInput: // value for 'updateApplicationInput'
 *   },
 * });
 */
export function useUpdateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApplicationMutation, UpdateApplicationMutationVariables>(UpdateApplicationDocument, options);
      }
export type UpdateApplicationMutationHookResult = ReturnType<typeof useUpdateApplicationMutation>;
export type UpdateApplicationMutationResult = Apollo.MutationResult<UpdateApplicationMutation>;
export type UpdateApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateApplicationMutation, UpdateApplicationMutationVariables>;
export const DeleteApplicationDocument = gql`
    mutation deleteApplication($id: ID!) {
  deleteApplication(id: $id)
}
    `;
export type DeleteApplicationMutationFn = Apollo.MutationFunction<DeleteApplicationMutation, DeleteApplicationMutationVariables>;

/**
 * __useDeleteApplicationMutation__
 *
 * To run a mutation, you first call `useDeleteApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApplicationMutation, { data, loading, error }] = useDeleteApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApplicationMutation, DeleteApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApplicationMutation, DeleteApplicationMutationVariables>(DeleteApplicationDocument, options);
      }
export type DeleteApplicationMutationHookResult = ReturnType<typeof useDeleteApplicationMutation>;
export type DeleteApplicationMutationResult = Apollo.MutationResult<DeleteApplicationMutation>;
export type DeleteApplicationMutationOptions = Apollo.BaseMutationOptions<DeleteApplicationMutation, DeleteApplicationMutationVariables>;
export const CountApplicationOfferStatsDocument = gql`
    query countApplicationOfferStats {
  countApplicationOfferStats {
    countOfferApplications
    countTodayOfferSentApplications
  }
}
    `;

/**
 * __useCountApplicationOfferStatsQuery__
 *
 * To run a query within a React component, call `useCountApplicationOfferStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountApplicationOfferStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountApplicationOfferStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountApplicationOfferStatsQuery(baseOptions?: Apollo.QueryHookOptions<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>(CountApplicationOfferStatsDocument, options);
      }
export function useCountApplicationOfferStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>(CountApplicationOfferStatsDocument, options);
        }
// @ts-ignore
export function useCountApplicationOfferStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>;
export function useCountApplicationOfferStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CountApplicationOfferStatsQuery | undefined, CountApplicationOfferStatsQueryVariables>;
export function useCountApplicationOfferStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>(CountApplicationOfferStatsDocument, options);
        }
export type CountApplicationOfferStatsQueryHookResult = ReturnType<typeof useCountApplicationOfferStatsQuery>;
export type CountApplicationOfferStatsLazyQueryHookResult = ReturnType<typeof useCountApplicationOfferStatsLazyQuery>;
export type CountApplicationOfferStatsSuspenseQueryHookResult = ReturnType<typeof useCountApplicationOfferStatsSuspenseQuery>;
export type CountApplicationOfferStatsQueryResult = Apollo.QueryResult<CountApplicationOfferStatsQuery, CountApplicationOfferStatsQueryVariables>;
export const GetApplicationDocument = gql`
    query getApplication($id: ID!) {
  getApplication(id: $id) {
    id
    number
    currentUserRights
    fundingAmount
    term
    totalOffers
    linkToFiles
    status {
      id
      color
      description
    }
    processor {
      id
      name
      logo
      order
    }
    merchantCompanyLegalName
    merchantBizEmails
    merchantCompanyDba
    merchantBizPhones
    merchantBizWeb
    merchantTaxId
    owners {
      cellPhone
      bizPhone
      bizEmail
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
    broker {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
      manager {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
    }
    manager {
      id
      name
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
    }
    funder {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
      manager {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
    }
    notes
    createdBy {
      id
      name
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
    }
    offers {
      id
      number
      type
      rehabLineTitle
      rehabGroupId
      lineOrder
      term
      offerDate
      type
      fundingAmount
      factorRate
      term
      createdAt
      manager {
        id
      }
    }
    offerDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetApplicationQuery__
 *
 * To run a query within a React component, call `useGetApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables> & ({ variables: GetApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
      }
export function useGetApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
        }
// @ts-ignore
export function useGetApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationQuery, GetApplicationQueryVariables>;
export function useGetApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<GetApplicationQuery | undefined, GetApplicationQueryVariables>;
export function useGetApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApplicationQuery, GetApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApplicationQuery, GetApplicationQueryVariables>(GetApplicationDocument, options);
        }
export type GetApplicationQueryHookResult = ReturnType<typeof useGetApplicationQuery>;
export type GetApplicationLazyQueryHookResult = ReturnType<typeof useGetApplicationLazyQuery>;
export type GetApplicationSuspenseQueryHookResult = ReturnType<typeof useGetApplicationSuspenseQuery>;
export type GetApplicationQueryResult = Apollo.QueryResult<GetApplicationQuery, GetApplicationQueryVariables>;
export const ApplicationsDocument = gql`
    query applications($search: String, $statuses: [String!], $offset: Int, $limit: Int, $sortArgs: [SortArgs!]) {
  applications(
    search: $search
    statuses: $statuses
    offset: $offset
    limit: $limit
    sortArgs: $sortArgs
  ) {
    data {
      id
      number
      currentUserRights
      fundingAmount
      term
      totalOffers
      status {
        id
        color
        description
      }
      processor {
        id
        name
        logo
        order
      }
      merchantCompanyLegalName
      merchantCompanyDba
      merchantBizWeb
      merchantBizEmails
      merchantTaxId
      merchantBizPhones
      owners {
        cellPhone
        bizPhone
        bizEmail
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
      broker {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
        company {
          id
          legalName
          dba
          type
          logo
        }
        manager {
          id
          name
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
      }
      funder {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
        company {
          id
          legalName
          dba
          type
          logo
        }
        manager {
          id
          name
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
      }
      manager {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
        company {
          id
          legalName
          dba
          type
          logo
        }
      }
      notes
      linkToFiles
      offers {
        id
        number
        type
        rehabLineTitle
        rehabGroupId
        lineOrder
        term
        offerDate
        type
        fundingAmount
        factorRate
        term
      }
      offerDate
      createdAt
      updatedAt
      createdBy {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
      modifiedBy {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useApplicationsQuery__
 *
 * To run a query within a React component, call `useApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
      }
export function useApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
        }
// @ts-ignore
export function useApplicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationsQuery, ApplicationsQueryVariables>;
export function useApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationsQuery | undefined, ApplicationsQueryVariables>;
export function useApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
        }
export type ApplicationsQueryHookResult = ReturnType<typeof useApplicationsQuery>;
export type ApplicationsLazyQueryHookResult = ReturnType<typeof useApplicationsLazyQuery>;
export type ApplicationsSuspenseQueryHookResult = ReturnType<typeof useApplicationsSuspenseQuery>;
export type ApplicationsQueryResult = Apollo.QueryResult<ApplicationsQuery, ApplicationsQueryVariables>;
export const ApplicationStatusListDocument = gql`
    query applicationStatusList {
  applicationStatusList {
    id
    color
    description
    order
  }
}
    `;

/**
 * __useApplicationStatusListQuery__
 *
 * To run a query within a React component, call `useApplicationStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationStatusListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationStatusListQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationStatusListQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>(ApplicationStatusListDocument, options);
      }
export function useApplicationStatusListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>(ApplicationStatusListDocument, options);
        }
// @ts-ignore
export function useApplicationStatusListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>;
export function useApplicationStatusListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationStatusListQuery | undefined, ApplicationStatusListQueryVariables>;
export function useApplicationStatusListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>(ApplicationStatusListDocument, options);
        }
export type ApplicationStatusListQueryHookResult = ReturnType<typeof useApplicationStatusListQuery>;
export type ApplicationStatusListLazyQueryHookResult = ReturnType<typeof useApplicationStatusListLazyQuery>;
export type ApplicationStatusListSuspenseQueryHookResult = ReturnType<typeof useApplicationStatusListSuspenseQuery>;
export type ApplicationStatusListQueryResult = Apollo.QueryResult<ApplicationStatusListQuery, ApplicationStatusListQueryVariables>;
export const OfferStatusListDocument = gql`
    query offerStatusList {
  offerStatusList {
    id
    color
    description
    order
  }
}
    `;

/**
 * __useOfferStatusListQuery__
 *
 * To run a query within a React component, call `useOfferStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferStatusListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferStatusListQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferStatusListQuery(baseOptions?: Apollo.QueryHookOptions<OfferStatusListQuery, OfferStatusListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferStatusListQuery, OfferStatusListQueryVariables>(OfferStatusListDocument, options);
      }
export function useOfferStatusListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferStatusListQuery, OfferStatusListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferStatusListQuery, OfferStatusListQueryVariables>(OfferStatusListDocument, options);
        }
// @ts-ignore
export function useOfferStatusListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OfferStatusListQuery, OfferStatusListQueryVariables>): Apollo.UseSuspenseQueryResult<OfferStatusListQuery, OfferStatusListQueryVariables>;
export function useOfferStatusListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferStatusListQuery, OfferStatusListQueryVariables>): Apollo.UseSuspenseQueryResult<OfferStatusListQuery | undefined, OfferStatusListQueryVariables>;
export function useOfferStatusListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferStatusListQuery, OfferStatusListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferStatusListQuery, OfferStatusListQueryVariables>(OfferStatusListDocument, options);
        }
export type OfferStatusListQueryHookResult = ReturnType<typeof useOfferStatusListQuery>;
export type OfferStatusListLazyQueryHookResult = ReturnType<typeof useOfferStatusListLazyQuery>;
export type OfferStatusListSuspenseQueryHookResult = ReturnType<typeof useOfferStatusListSuspenseQuery>;
export type OfferStatusListQueryResult = Apollo.QueryResult<OfferStatusListQuery, OfferStatusListQueryVariables>;
export const ChangeApplicationStatusDocument = gql`
    mutation changeApplicationStatus($applicationId: ID!, $statusId: String!) {
  changeApplicationStatus(applicationId: $applicationId, statusId: $statusId) {
    id
  }
}
    `;
export type ChangeApplicationStatusMutationFn = Apollo.MutationFunction<ChangeApplicationStatusMutation, ChangeApplicationStatusMutationVariables>;

/**
 * __useChangeApplicationStatusMutation__
 *
 * To run a mutation, you first call `useChangeApplicationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeApplicationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeApplicationStatusMutation, { data, loading, error }] = useChangeApplicationStatusMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      statusId: // value for 'statusId'
 *   },
 * });
 */
export function useChangeApplicationStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeApplicationStatusMutation, ChangeApplicationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeApplicationStatusMutation, ChangeApplicationStatusMutationVariables>(ChangeApplicationStatusDocument, options);
      }
export type ChangeApplicationStatusMutationHookResult = ReturnType<typeof useChangeApplicationStatusMutation>;
export type ChangeApplicationStatusMutationResult = Apollo.MutationResult<ChangeApplicationStatusMutation>;
export type ChangeApplicationStatusMutationOptions = Apollo.BaseMutationOptions<ChangeApplicationStatusMutation, ChangeApplicationStatusMutationVariables>;
export const ApplicationsWithSelectedOffersDocument = gql`
    query applicationsWithSelectedOffers($offset: Int, $limit: Int, $search: String, $applicationStatuses: [String!], $userId: ID, $funderIds: [ID!], $sortArgs: [SortArgs!]) {
  applicationsWithSelectedOffers(
    offset: $offset
    limit: $limit
    search: $search
    applicationStatuses: $applicationStatuses
    userId: $userId
    funderIds: $funderIds
    sortArgs: $sortArgs
  ) {
    data {
      application {
        id
        number
        currentUserRights
        fundingAmount
        term
        totalOffers
        status {
          id
          color
          description
        }
        latestStatusHistory {
          createdAt
          fromStatus {
            id
          }
          toStatus {
            id
            description
          }
          user {
            data {
              firstName
              lastName
              avatar
            }
          }
        }
        processor {
          id
          name
          logo
          order
        }
        merchantCompanyLegalName
        merchantCompanyDba
        merchantBizWeb
        merchantBizEmails
        merchantTaxId
        merchantBizPhones
        owners {
          cellPhone
          bizPhone
          bizEmail
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        broker {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
          company {
            id
            legalName
            dba
            type
            logo
          }
          manager {
            id
            name
            isActive
            data {
              cellPhone
              bizPhone
              firstName
              lastName
              avatar
            }
          }
        }
        funder {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
          company {
            id
            legalName
            dba
            type
            logo
          }
          manager {
            id
            name
            isActive
            data {
              cellPhone
              bizPhone
              firstName
              lastName
              avatar
            }
          }
        }
        manager {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
          company {
            id
            legalName
            dba
            type
            logo
          }
        }
        notes
        offerDate
        createdAt
        updatedAt
        createdBy {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
        modifiedBy {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
      }
      offer {
        id
        number
        currentUserRights
        type
        fundingAmount
        factorRate
        term
        offerDate
        rehabGroupId
        rehabLineTitle
        lineOrder
        broker {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
          company {
            id
            legalName
            dba
            type
            logo
          }
          manager {
            id
            name
            isActive
            data {
              cellPhone
              bizPhone
              firstName
              lastName
              avatar
            }
          }
        }
        funder {
          id
          name
          code
          logo
        }
        secondaryFunders {
          id
          code
          name
          logo
        }
        company {
          id
          legalName
          dba
          logo
        }
        manager {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
        integration {
          id
          name
          logo
          type
          company {
            id
            legalName
            dba
            logo
          }
        }
        notes
        stipulations
        createdBy {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
        modifiedBy {
          id
          name
          email
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
        linkToFilesData {
          linkToFiles
        }
        isSelected
        isActive
        createdAt
        updatedAt
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useApplicationsWithSelectedOffersQuery__
 *
 * To run a query within a React component, call `useApplicationsWithSelectedOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsWithSelectedOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsWithSelectedOffersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      applicationStatuses: // value for 'applicationStatuses'
 *      userId: // value for 'userId'
 *      funderIds: // value for 'funderIds'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useApplicationsWithSelectedOffersQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>(ApplicationsWithSelectedOffersDocument, options);
      }
export function useApplicationsWithSelectedOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>(ApplicationsWithSelectedOffersDocument, options);
        }
// @ts-ignore
export function useApplicationsWithSelectedOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>;
export function useApplicationsWithSelectedOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationsWithSelectedOffersQuery | undefined, ApplicationsWithSelectedOffersQueryVariables>;
export function useApplicationsWithSelectedOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>(ApplicationsWithSelectedOffersDocument, options);
        }
export type ApplicationsWithSelectedOffersQueryHookResult = ReturnType<typeof useApplicationsWithSelectedOffersQuery>;
export type ApplicationsWithSelectedOffersLazyQueryHookResult = ReturnType<typeof useApplicationsWithSelectedOffersLazyQuery>;
export type ApplicationsWithSelectedOffersSuspenseQueryHookResult = ReturnType<typeof useApplicationsWithSelectedOffersSuspenseQuery>;
export type ApplicationsWithSelectedOffersQueryResult = Apollo.QueryResult<ApplicationsWithSelectedOffersQuery, ApplicationsWithSelectedOffersQueryVariables>;
export const ApplicationProcessorListDocument = gql`
    query applicationProcessorList {
  applicationProcessorList {
    id
    name
    logo
    order
  }
}
    `;

/**
 * __useApplicationProcessorListQuery__
 *
 * To run a query within a React component, call `useApplicationProcessorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationProcessorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationProcessorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useApplicationProcessorListQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>(ApplicationProcessorListDocument, options);
      }
export function useApplicationProcessorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>(ApplicationProcessorListDocument, options);
        }
// @ts-ignore
export function useApplicationProcessorListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>;
export function useApplicationProcessorListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationProcessorListQuery | undefined, ApplicationProcessorListQueryVariables>;
export function useApplicationProcessorListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>(ApplicationProcessorListDocument, options);
        }
export type ApplicationProcessorListQueryHookResult = ReturnType<typeof useApplicationProcessorListQuery>;
export type ApplicationProcessorListLazyQueryHookResult = ReturnType<typeof useApplicationProcessorListLazyQuery>;
export type ApplicationProcessorListSuspenseQueryHookResult = ReturnType<typeof useApplicationProcessorListSuspenseQuery>;
export type ApplicationProcessorListQueryResult = Apollo.QueryResult<ApplicationProcessorListQuery, ApplicationProcessorListQueryVariables>;
export const ApplicationsForMerchantDocument = gql`
    query applicationsForMerchant($merchantLegalName: String!) {
  applicationsForMerchant(merchantLegalName: $merchantLegalName) {
    id
    number
    offerDate
    status {
      id
      color
      description
    }
    offers {
      id
      mcaId
      isActive
      isSelected
      company {
        id
        legalName
        dba
        logo
      }
      integration {
        id
        name
        type
        logo
        company {
          id
          legalName
          dba
          logo
        }
      }
      broker {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        company {
          id
          legalName
          dba
          type
          logo
          email
          phone
        }
      }
      manager {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      funder {
        id
        code
        name
        logo
      }
      secondaryFunders {
        id
        code
        name
        logo
      }
      offerDate
      fundingAmount
      factorRate
      term
      rehabGroupId
      lineOrder
      mca {
        number
      }
    }
  }
}
    `;

/**
 * __useApplicationsForMerchantQuery__
 *
 * To run a query within a React component, call `useApplicationsForMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsForMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsForMerchantQuery({
 *   variables: {
 *      merchantLegalName: // value for 'merchantLegalName'
 *   },
 * });
 */
export function useApplicationsForMerchantQuery(baseOptions: Apollo.QueryHookOptions<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables> & ({ variables: ApplicationsForMerchantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>(ApplicationsForMerchantDocument, options);
      }
export function useApplicationsForMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>(ApplicationsForMerchantDocument, options);
        }
// @ts-ignore
export function useApplicationsForMerchantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>;
export function useApplicationsForMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationsForMerchantQuery | undefined, ApplicationsForMerchantQueryVariables>;
export function useApplicationsForMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>(ApplicationsForMerchantDocument, options);
        }
export type ApplicationsForMerchantQueryHookResult = ReturnType<typeof useApplicationsForMerchantQuery>;
export type ApplicationsForMerchantLazyQueryHookResult = ReturnType<typeof useApplicationsForMerchantLazyQuery>;
export type ApplicationsForMerchantSuspenseQueryHookResult = ReturnType<typeof useApplicationsForMerchantSuspenseQuery>;
export type ApplicationsForMerchantQueryResult = Apollo.QueryResult<ApplicationsForMerchantQuery, ApplicationsForMerchantQueryVariables>;
export const AuditLogsDocument = gql`
    query auditLogs($search: String, $eventTypes: [String!], $userId: ID, $fromDate: String, $toDate: String, $offset: Int, $limit: Int, $sortArgs: [SortArgs!]) {
  auditLogs(
    search: $search
    eventTypes: $eventTypes
    userId: $userId
    fromDate: $fromDate
    toDate: $toDate
    offset: $offset
    limit: $limit
    sortArgs: $sortArgs
  ) {
    data {
      type
      description
      ipAddress
      payload
      createdAt
      user {
        id
        name
        email
        isActive
        role
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
        company {
          id
          legalName
          dba
          type
          logo
        }
      }
      mca {
        id
        number
        status
      }
      application {
        id
        number
        status {
          id
          color
          description
        }
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      eventTypes: // value for 'eventTypes'
 *      userId: // value for 'userId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useAuditLogsQuery(baseOptions?: Apollo.QueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
      }
export function useAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
// @ts-ignore
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<AuditLogsQuery, AuditLogsQueryVariables>;
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>): Apollo.UseSuspenseQueryResult<AuditLogsQuery | undefined, AuditLogsQueryVariables>;
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>;
export type AuditLogsLazyQueryHookResult = ReturnType<typeof useAuditLogsLazyQuery>;
export type AuditLogsSuspenseQueryHookResult = ReturnType<typeof useAuditLogsSuspenseQuery>;
export type AuditLogsQueryResult = Apollo.QueryResult<AuditLogsQuery, AuditLogsQueryVariables>;
export const BankByRoutingNumberDocument = gql`
    query bankByRoutingNumber($routingNumber: String!) {
  bankByRoutingNumber(routingNumber: $routingNumber) {
    bankName
    logo
    locationName
  }
}
    `;

/**
 * __useBankByRoutingNumberQuery__
 *
 * To run a query within a React component, call `useBankByRoutingNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankByRoutingNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankByRoutingNumberQuery({
 *   variables: {
 *      routingNumber: // value for 'routingNumber'
 *   },
 * });
 */
export function useBankByRoutingNumberQuery(baseOptions: Apollo.QueryHookOptions<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables> & ({ variables: BankByRoutingNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>(BankByRoutingNumberDocument, options);
      }
export function useBankByRoutingNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>(BankByRoutingNumberDocument, options);
        }
// @ts-ignore
export function useBankByRoutingNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>): Apollo.UseSuspenseQueryResult<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>;
export function useBankByRoutingNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>): Apollo.UseSuspenseQueryResult<BankByRoutingNumberQuery | undefined, BankByRoutingNumberQueryVariables>;
export function useBankByRoutingNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>(BankByRoutingNumberDocument, options);
        }
export type BankByRoutingNumberQueryHookResult = ReturnType<typeof useBankByRoutingNumberQuery>;
export type BankByRoutingNumberLazyQueryHookResult = ReturnType<typeof useBankByRoutingNumberLazyQuery>;
export type BankByRoutingNumberSuspenseQueryHookResult = ReturnType<typeof useBankByRoutingNumberSuspenseQuery>;
export type BankByRoutingNumberQueryResult = Apollo.QueryResult<BankByRoutingNumberQuery, BankByRoutingNumberQueryVariables>;
export const BanksDocument = gql`
    query banks($offset: Int = 0, $limit: Int = 10, $search: String, $sortArgs: [SortArgs!] = []) {
  banks(offset: $offset, limit: $limit, search: $search, sortArgs: $sortArgs) {
    data {
      bankName
      logo
      web
      fdic
      locations {
        id
        locationName
        routingNumbers {
          routingNumber
        }
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useBanksQuery__
 *
 * To run a query within a React component, call `useBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBanksQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useBanksQuery(baseOptions?: Apollo.QueryHookOptions<BanksQuery, BanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BanksQuery, BanksQueryVariables>(BanksDocument, options);
      }
export function useBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BanksQuery, BanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BanksQuery, BanksQueryVariables>(BanksDocument, options);
        }
// @ts-ignore
export function useBanksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BanksQuery, BanksQueryVariables>): Apollo.UseSuspenseQueryResult<BanksQuery, BanksQueryVariables>;
export function useBanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BanksQuery, BanksQueryVariables>): Apollo.UseSuspenseQueryResult<BanksQuery | undefined, BanksQueryVariables>;
export function useBanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BanksQuery, BanksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BanksQuery, BanksQueryVariables>(BanksDocument, options);
        }
export type BanksQueryHookResult = ReturnType<typeof useBanksQuery>;
export type BanksLazyQueryHookResult = ReturnType<typeof useBanksLazyQuery>;
export type BanksSuspenseQueryHookResult = ReturnType<typeof useBanksSuspenseQuery>;
export type BanksQueryResult = Apollo.QueryResult<BanksQuery, BanksQueryVariables>;
export const BankDocument = gql`
    query bank($bankName: String!) {
  bank(bankName: $bankName) {
    bankName
    logo
    web
    fdic
    locations {
      id
      locationName
      routingNumbers {
        routingNumber
      }
    }
  }
}
    `;

/**
 * __useBankQuery__
 *
 * To run a query within a React component, call `useBankQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankQuery({
 *   variables: {
 *      bankName: // value for 'bankName'
 *   },
 * });
 */
export function useBankQuery(baseOptions: Apollo.QueryHookOptions<BankQuery, BankQueryVariables> & ({ variables: BankQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankQuery, BankQueryVariables>(BankDocument, options);
      }
export function useBankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankQuery, BankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankQuery, BankQueryVariables>(BankDocument, options);
        }
// @ts-ignore
export function useBankSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BankQuery, BankQueryVariables>): Apollo.UseSuspenseQueryResult<BankQuery, BankQueryVariables>;
export function useBankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankQuery, BankQueryVariables>): Apollo.UseSuspenseQueryResult<BankQuery | undefined, BankQueryVariables>;
export function useBankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BankQuery, BankQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BankQuery, BankQueryVariables>(BankDocument, options);
        }
export type BankQueryHookResult = ReturnType<typeof useBankQuery>;
export type BankLazyQueryHookResult = ReturnType<typeof useBankLazyQuery>;
export type BankSuspenseQueryHookResult = ReturnType<typeof useBankSuspenseQuery>;
export type BankQueryResult = Apollo.QueryResult<BankQuery, BankQueryVariables>;
export const SaveBankDocument = gql`
    mutation saveBank($input: SaveBankInput!) {
  saveBank(input: $input) {
    bankName
    logo
    web
    fdic
  }
}
    `;
export type SaveBankMutationFn = Apollo.MutationFunction<SaveBankMutation, SaveBankMutationVariables>;

/**
 * __useSaveBankMutation__
 *
 * To run a mutation, you first call `useSaveBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBankMutation, { data, loading, error }] = useSaveBankMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBankMutation(baseOptions?: Apollo.MutationHookOptions<SaveBankMutation, SaveBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBankMutation, SaveBankMutationVariables>(SaveBankDocument, options);
      }
export type SaveBankMutationHookResult = ReturnType<typeof useSaveBankMutation>;
export type SaveBankMutationResult = Apollo.MutationResult<SaveBankMutation>;
export type SaveBankMutationOptions = Apollo.BaseMutationOptions<SaveBankMutation, SaveBankMutationVariables>;
export const SaveBankLocationDocument = gql`
    mutation saveBankLocation($input: SaveBankLocationInput!) {
  saveBankLocation(input: $input) {
    id
    locationName
    routingNumbers {
      routingNumber
    }
  }
}
    `;
export type SaveBankLocationMutationFn = Apollo.MutationFunction<SaveBankLocationMutation, SaveBankLocationMutationVariables>;

/**
 * __useSaveBankLocationMutation__
 *
 * To run a mutation, you first call `useSaveBankLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBankLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBankLocationMutation, { data, loading, error }] = useSaveBankLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBankLocationMutation(baseOptions?: Apollo.MutationHookOptions<SaveBankLocationMutation, SaveBankLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBankLocationMutation, SaveBankLocationMutationVariables>(SaveBankLocationDocument, options);
      }
export type SaveBankLocationMutationHookResult = ReturnType<typeof useSaveBankLocationMutation>;
export type SaveBankLocationMutationResult = Apollo.MutationResult<SaveBankLocationMutation>;
export type SaveBankLocationMutationOptions = Apollo.BaseMutationOptions<SaveBankLocationMutation, SaveBankLocationMutationVariables>;
export const SaveLocationRoutingNumbersDocument = gql`
    mutation saveLocationRoutingNumbers($input: SaveLocationRoutingNumbersInput!) {
  saveLocationRoutingNumbers(input: $input) {
    id
    locationName
    routingNumbers {
      routingNumber
    }
  }
}
    `;
export type SaveLocationRoutingNumbersMutationFn = Apollo.MutationFunction<SaveLocationRoutingNumbersMutation, SaveLocationRoutingNumbersMutationVariables>;

/**
 * __useSaveLocationRoutingNumbersMutation__
 *
 * To run a mutation, you first call `useSaveLocationRoutingNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLocationRoutingNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLocationRoutingNumbersMutation, { data, loading, error }] = useSaveLocationRoutingNumbersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLocationRoutingNumbersMutation(baseOptions?: Apollo.MutationHookOptions<SaveLocationRoutingNumbersMutation, SaveLocationRoutingNumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveLocationRoutingNumbersMutation, SaveLocationRoutingNumbersMutationVariables>(SaveLocationRoutingNumbersDocument, options);
      }
export type SaveLocationRoutingNumbersMutationHookResult = ReturnType<typeof useSaveLocationRoutingNumbersMutation>;
export type SaveLocationRoutingNumbersMutationResult = Apollo.MutationResult<SaveLocationRoutingNumbersMutation>;
export type SaveLocationRoutingNumbersMutationOptions = Apollo.BaseMutationOptions<SaveLocationRoutingNumbersMutation, SaveLocationRoutingNumbersMutationVariables>;
export const AddBankLocationDocument = gql`
    mutation addBankLocation($input: AddBankLocationInput!) {
  addBankLocation(input: $input) {
    id
    locationName
    routingNumbers {
      routingNumber
    }
  }
}
    `;
export type AddBankLocationMutationFn = Apollo.MutationFunction<AddBankLocationMutation, AddBankLocationMutationVariables>;

/**
 * __useAddBankLocationMutation__
 *
 * To run a mutation, you first call `useAddBankLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBankLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBankLocationMutation, { data, loading, error }] = useAddBankLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddBankLocationMutation(baseOptions?: Apollo.MutationHookOptions<AddBankLocationMutation, AddBankLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddBankLocationMutation, AddBankLocationMutationVariables>(AddBankLocationDocument, options);
      }
export type AddBankLocationMutationHookResult = ReturnType<typeof useAddBankLocationMutation>;
export type AddBankLocationMutationResult = Apollo.MutationResult<AddBankLocationMutation>;
export type AddBankLocationMutationOptions = Apollo.BaseMutationOptions<AddBankLocationMutation, AddBankLocationMutationVariables>;
export const DeleteBankLocationDocument = gql`
    mutation deleteBankLocation($id: Int!) {
  deleteBankLocation(id: $id)
}
    `;
export type DeleteBankLocationMutationFn = Apollo.MutationFunction<DeleteBankLocationMutation, DeleteBankLocationMutationVariables>;

/**
 * __useDeleteBankLocationMutation__
 *
 * To run a mutation, you first call `useDeleteBankLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankLocationMutation, { data, loading, error }] = useDeleteBankLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBankLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankLocationMutation, DeleteBankLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankLocationMutation, DeleteBankLocationMutationVariables>(DeleteBankLocationDocument, options);
      }
export type DeleteBankLocationMutationHookResult = ReturnType<typeof useDeleteBankLocationMutation>;
export type DeleteBankLocationMutationResult = Apollo.MutationResult<DeleteBankLocationMutation>;
export type DeleteBankLocationMutationOptions = Apollo.BaseMutationOptions<DeleteBankLocationMutation, DeleteBankLocationMutationVariables>;
export const CheckDuplicateRoutingNumbersDocument = gql`
    query checkDuplicateRoutingNumbers($routingNumbers: [String!]!, $excludeLocationId: Int) {
  checkDuplicateRoutingNumbers(
    routingNumbers: $routingNumbers
    excludeLocationId: $excludeLocationId
  ) {
    routingNumber
    locationId
    locationName
    bankName
  }
}
    `;

/**
 * __useCheckDuplicateRoutingNumbersQuery__
 *
 * To run a query within a React component, call `useCheckDuplicateRoutingNumbersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDuplicateRoutingNumbersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDuplicateRoutingNumbersQuery({
 *   variables: {
 *      routingNumbers: // value for 'routingNumbers'
 *      excludeLocationId: // value for 'excludeLocationId'
 *   },
 * });
 */
export function useCheckDuplicateRoutingNumbersQuery(baseOptions: Apollo.QueryHookOptions<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables> & ({ variables: CheckDuplicateRoutingNumbersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>(CheckDuplicateRoutingNumbersDocument, options);
      }
export function useCheckDuplicateRoutingNumbersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>(CheckDuplicateRoutingNumbersDocument, options);
        }
// @ts-ignore
export function useCheckDuplicateRoutingNumbersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>;
export function useCheckDuplicateRoutingNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDuplicateRoutingNumbersQuery | undefined, CheckDuplicateRoutingNumbersQueryVariables>;
export function useCheckDuplicateRoutingNumbersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>(CheckDuplicateRoutingNumbersDocument, options);
        }
export type CheckDuplicateRoutingNumbersQueryHookResult = ReturnType<typeof useCheckDuplicateRoutingNumbersQuery>;
export type CheckDuplicateRoutingNumbersLazyQueryHookResult = ReturnType<typeof useCheckDuplicateRoutingNumbersLazyQuery>;
export type CheckDuplicateRoutingNumbersSuspenseQueryHookResult = ReturnType<typeof useCheckDuplicateRoutingNumbersSuspenseQuery>;
export type CheckDuplicateRoutingNumbersQueryResult = Apollo.QueryResult<CheckDuplicateRoutingNumbersQuery, CheckDuplicateRoutingNumbersQueryVariables>;
export const DeleteBankDocument = gql`
    mutation deleteBank($bankName: String!) {
  deleteBank(bankName: $bankName)
}
    `;
export type DeleteBankMutationFn = Apollo.MutationFunction<DeleteBankMutation, DeleteBankMutationVariables>;

/**
 * __useDeleteBankMutation__
 *
 * To run a mutation, you first call `useDeleteBankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBankMutation, { data, loading, error }] = useDeleteBankMutation({
 *   variables: {
 *      bankName: // value for 'bankName'
 *   },
 * });
 */
export function useDeleteBankMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBankMutation, DeleteBankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBankMutation, DeleteBankMutationVariables>(DeleteBankDocument, options);
      }
export type DeleteBankMutationHookResult = ReturnType<typeof useDeleteBankMutation>;
export type DeleteBankMutationResult = Apollo.MutationResult<DeleteBankMutation>;
export type DeleteBankMutationOptions = Apollo.BaseMutationOptions<DeleteBankMutation, DeleteBankMutationVariables>;
export const NonWorkingDaysDocument = gql`
    query nonWorkingDays {
  nonWorkingDays {
    date
    description
  }
}
    `;

/**
 * __useNonWorkingDaysQuery__
 *
 * To run a query within a React component, call `useNonWorkingDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonWorkingDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonWorkingDaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useNonWorkingDaysQuery(baseOptions?: Apollo.QueryHookOptions<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>(NonWorkingDaysDocument, options);
      }
export function useNonWorkingDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>(NonWorkingDaysDocument, options);
        }
// @ts-ignore
export function useNonWorkingDaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>): Apollo.UseSuspenseQueryResult<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>;
export function useNonWorkingDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>): Apollo.UseSuspenseQueryResult<NonWorkingDaysQuery | undefined, NonWorkingDaysQueryVariables>;
export function useNonWorkingDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>(NonWorkingDaysDocument, options);
        }
export type NonWorkingDaysQueryHookResult = ReturnType<typeof useNonWorkingDaysQuery>;
export type NonWorkingDaysLazyQueryHookResult = ReturnType<typeof useNonWorkingDaysLazyQuery>;
export type NonWorkingDaysSuspenseQueryHookResult = ReturnType<typeof useNonWorkingDaysSuspenseQuery>;
export type NonWorkingDaysQueryResult = Apollo.QueryResult<NonWorkingDaysQuery, NonWorkingDaysQueryVariables>;
export const SaveCommissionDocument = gql`
    mutation saveCommission($id: ID!, $mcaId: ID!, $commission: CommissionDto!) {
  saveCommission(id: $id, mcaId: $mcaId, commission: $commission) {
    id
  }
}
    `;
export type SaveCommissionMutationFn = Apollo.MutationFunction<SaveCommissionMutation, SaveCommissionMutationVariables>;

/**
 * __useSaveCommissionMutation__
 *
 * To run a mutation, you first call `useSaveCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommissionMutation, { data, loading, error }] = useSaveCommissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *      commission: // value for 'commission'
 *   },
 * });
 */
export function useSaveCommissionMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommissionMutation, SaveCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommissionMutation, SaveCommissionMutationVariables>(SaveCommissionDocument, options);
      }
export type SaveCommissionMutationHookResult = ReturnType<typeof useSaveCommissionMutation>;
export type SaveCommissionMutationResult = Apollo.MutationResult<SaveCommissionMutation>;
export type SaveCommissionMutationOptions = Apollo.BaseMutationOptions<SaveCommissionMutation, SaveCommissionMutationVariables>;
export const SaveCommissionsDocument = gql`
    mutation saveCommissions($mcaId: ID!, $commissions: [CommissionDto!]!) {
  saveCommissions(mcaId: $mcaId, commissions: $commissions) {
    id
  }
}
    `;
export type SaveCommissionsMutationFn = Apollo.MutationFunction<SaveCommissionsMutation, SaveCommissionsMutationVariables>;

/**
 * __useSaveCommissionsMutation__
 *
 * To run a mutation, you first call `useSaveCommissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommissionsMutation, { data, loading, error }] = useSaveCommissionsMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      commissions: // value for 'commissions'
 *   },
 * });
 */
export function useSaveCommissionsMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommissionsMutation, SaveCommissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommissionsMutation, SaveCommissionsMutationVariables>(SaveCommissionsDocument, options);
      }
export type SaveCommissionsMutationHookResult = ReturnType<typeof useSaveCommissionsMutation>;
export type SaveCommissionsMutationResult = Apollo.MutationResult<SaveCommissionsMutation>;
export type SaveCommissionsMutationOptions = Apollo.BaseMutationOptions<SaveCommissionsMutation, SaveCommissionsMutationVariables>;
export const DeleteCommissionDocument = gql`
    mutation deleteCommission($id: ID!, $mcaId: ID!) {
  deleteCommission(id: $id, mcaId: $mcaId)
}
    `;
export type DeleteCommissionMutationFn = Apollo.MutationFunction<DeleteCommissionMutation, DeleteCommissionMutationVariables>;

/**
 * __useDeleteCommissionMutation__
 *
 * To run a mutation, you first call `useDeleteCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommissionMutation, { data, loading, error }] = useDeleteCommissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useDeleteCommissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommissionMutation, DeleteCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommissionMutation, DeleteCommissionMutationVariables>(DeleteCommissionDocument, options);
      }
export type DeleteCommissionMutationHookResult = ReturnType<typeof useDeleteCommissionMutation>;
export type DeleteCommissionMutationResult = Apollo.MutationResult<DeleteCommissionMutation>;
export type DeleteCommissionMutationOptions = Apollo.BaseMutationOptions<DeleteCommissionMutation, DeleteCommissionMutationVariables>;
export const CommissionsForMcaDocument = gql`
    query commissionsForMca($mcaId: ID!) {
  commissionsForMca(mcaId: $mcaId) {
    id
    comment
    amount
    config {
      name
      id
    }
    createdAt
    modifiedAt
    isPaid
    paidOn
    notes
    modifiedBy {
      id
      name
      role
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
  }
}
    `;

/**
 * __useCommissionsForMcaQuery__
 *
 * To run a query within a React component, call `useCommissionsForMcaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommissionsForMcaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommissionsForMcaQuery({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useCommissionsForMcaQuery(baseOptions: Apollo.QueryHookOptions<CommissionsForMcaQuery, CommissionsForMcaQueryVariables> & ({ variables: CommissionsForMcaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>(CommissionsForMcaDocument, options);
      }
export function useCommissionsForMcaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>(CommissionsForMcaDocument, options);
        }
// @ts-ignore
export function useCommissionsForMcaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>): Apollo.UseSuspenseQueryResult<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>;
export function useCommissionsForMcaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>): Apollo.UseSuspenseQueryResult<CommissionsForMcaQuery | undefined, CommissionsForMcaQueryVariables>;
export function useCommissionsForMcaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>(CommissionsForMcaDocument, options);
        }
export type CommissionsForMcaQueryHookResult = ReturnType<typeof useCommissionsForMcaQuery>;
export type CommissionsForMcaLazyQueryHookResult = ReturnType<typeof useCommissionsForMcaLazyQuery>;
export type CommissionsForMcaSuspenseQueryHookResult = ReturnType<typeof useCommissionsForMcaSuspenseQuery>;
export type CommissionsForMcaQueryResult = Apollo.QueryResult<CommissionsForMcaQuery, CommissionsForMcaQueryVariables>;
export const InternalCompaniesDocument = gql`
    query internalCompanies($offset: Int = 0, $limit: Int = 100, $search: String, $sortArgs: [SortArgs!] = []) {
  internalCompanies(
    offset: $offset
    limit: $limit
    search: $search
    sortArgs: $sortArgs
  ) {
    data {
      id
      legalName
      dba
      phone
      email
      taxId
      logo
      signature
      createdAt
      modifiedAt
      createdBy {
        id
        name
      }
      modifiedBy {
        id
        name
      }
      isDefault
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useInternalCompaniesQuery__
 *
 * To run a query within a React component, call `useInternalCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalCompaniesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useInternalCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<InternalCompaniesQuery, InternalCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalCompaniesQuery, InternalCompaniesQueryVariables>(InternalCompaniesDocument, options);
      }
export function useInternalCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalCompaniesQuery, InternalCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalCompaniesQuery, InternalCompaniesQueryVariables>(InternalCompaniesDocument, options);
        }
// @ts-ignore
export function useInternalCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalCompaniesQuery, InternalCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<InternalCompaniesQuery, InternalCompaniesQueryVariables>;
export function useInternalCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalCompaniesQuery, InternalCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<InternalCompaniesQuery | undefined, InternalCompaniesQueryVariables>;
export function useInternalCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalCompaniesQuery, InternalCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalCompaniesQuery, InternalCompaniesQueryVariables>(InternalCompaniesDocument, options);
        }
export type InternalCompaniesQueryHookResult = ReturnType<typeof useInternalCompaniesQuery>;
export type InternalCompaniesLazyQueryHookResult = ReturnType<typeof useInternalCompaniesLazyQuery>;
export type InternalCompaniesSuspenseQueryHookResult = ReturnType<typeof useInternalCompaniesSuspenseQuery>;
export type InternalCompaniesQueryResult = Apollo.QueryResult<InternalCompaniesQuery, InternalCompaniesQueryVariables>;
export const InternalCompanyDocument = gql`
    query internalCompany($id: ID!) {
  internalCompany(id: $id) {
    id
    legalName
    dba
    phone
    email
    taxId
    logo
    signature
    isDefault
  }
}
    `;

/**
 * __useInternalCompanyQuery__
 *
 * To run a query within a React component, call `useInternalCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInternalCompanyQuery(baseOptions: Apollo.QueryHookOptions<InternalCompanyQuery, InternalCompanyQueryVariables> & ({ variables: InternalCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalCompanyQuery, InternalCompanyQueryVariables>(InternalCompanyDocument, options);
      }
export function useInternalCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalCompanyQuery, InternalCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalCompanyQuery, InternalCompanyQueryVariables>(InternalCompanyDocument, options);
        }
// @ts-ignore
export function useInternalCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalCompanyQuery, InternalCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<InternalCompanyQuery, InternalCompanyQueryVariables>;
export function useInternalCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalCompanyQuery, InternalCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<InternalCompanyQuery | undefined, InternalCompanyQueryVariables>;
export function useInternalCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalCompanyQuery, InternalCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalCompanyQuery, InternalCompanyQueryVariables>(InternalCompanyDocument, options);
        }
export type InternalCompanyQueryHookResult = ReturnType<typeof useInternalCompanyQuery>;
export type InternalCompanyLazyQueryHookResult = ReturnType<typeof useInternalCompanyLazyQuery>;
export type InternalCompanySuspenseQueryHookResult = ReturnType<typeof useInternalCompanySuspenseQuery>;
export type InternalCompanyQueryResult = Apollo.QueryResult<InternalCompanyQuery, InternalCompanyQueryVariables>;
export const SaveInternalCompanyDocument = gql`
    mutation saveInternalCompany($dto: InternalCompanyDto!) {
  saveInternalCompany(company: $dto) {
    id
    legalName
    dba
    phone
    email
    taxId
    logo
    signature
  }
}
    `;
export type SaveInternalCompanyMutationFn = Apollo.MutationFunction<SaveInternalCompanyMutation, SaveInternalCompanyMutationVariables>;

/**
 * __useSaveInternalCompanyMutation__
 *
 * To run a mutation, you first call `useSaveInternalCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInternalCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInternalCompanyMutation, { data, loading, error }] = useSaveInternalCompanyMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveInternalCompanyMutation(baseOptions?: Apollo.MutationHookOptions<SaveInternalCompanyMutation, SaveInternalCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInternalCompanyMutation, SaveInternalCompanyMutationVariables>(SaveInternalCompanyDocument, options);
      }
export type SaveInternalCompanyMutationHookResult = ReturnType<typeof useSaveInternalCompanyMutation>;
export type SaveInternalCompanyMutationResult = Apollo.MutationResult<SaveInternalCompanyMutation>;
export type SaveInternalCompanyMutationOptions = Apollo.BaseMutationOptions<SaveInternalCompanyMutation, SaveInternalCompanyMutationVariables>;
export const DeleteInternalCompanyDocument = gql`
    mutation deleteInternalCompany($id: ID!) {
  deleteInternalCompany(id: $id)
}
    `;
export type DeleteInternalCompanyMutationFn = Apollo.MutationFunction<DeleteInternalCompanyMutation, DeleteInternalCompanyMutationVariables>;

/**
 * __useDeleteInternalCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteInternalCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalCompanyMutation, { data, loading, error }] = useDeleteInternalCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInternalCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInternalCompanyMutation, DeleteInternalCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInternalCompanyMutation, DeleteInternalCompanyMutationVariables>(DeleteInternalCompanyDocument, options);
      }
export type DeleteInternalCompanyMutationHookResult = ReturnType<typeof useDeleteInternalCompanyMutation>;
export type DeleteInternalCompanyMutationResult = Apollo.MutationResult<DeleteInternalCompanyMutation>;
export type DeleteInternalCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteInternalCompanyMutation, DeleteInternalCompanyMutationVariables>;
export const SetDefaultCompanyDocument = gql`
    mutation setDefaultCompany($companyId: ID!) {
  setDefaultCompany(companyId: $companyId)
}
    `;
export type SetDefaultCompanyMutationFn = Apollo.MutationFunction<SetDefaultCompanyMutation, SetDefaultCompanyMutationVariables>;

/**
 * __useSetDefaultCompanyMutation__
 *
 * To run a mutation, you first call `useSetDefaultCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultCompanyMutation, { data, loading, error }] = useSetDefaultCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useSetDefaultCompanyMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultCompanyMutation, SetDefaultCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultCompanyMutation, SetDefaultCompanyMutationVariables>(SetDefaultCompanyDocument, options);
      }
export type SetDefaultCompanyMutationHookResult = ReturnType<typeof useSetDefaultCompanyMutation>;
export type SetDefaultCompanyMutationResult = Apollo.MutationResult<SetDefaultCompanyMutation>;
export type SetDefaultCompanyMutationOptions = Apollo.BaseMutationOptions<SetDefaultCompanyMutation, SetDefaultCompanyMutationVariables>;
export const MerchantsDocument = gql`
    query merchants($offset: Int = 0, $limit: Int = 10, $search: String, $sortArgs: [SortArgs!] = []) {
  merchants(offset: $offset, limit: $limit, search: $search, sortArgs: $sortArgs) {
    data {
      id
      legalName
      dba
      type
      phone
      email
      taxId
      logo
      createdAt
      modifiedAt
      linkToFiles
      createdBy {
        id
        name
      }
      modifiedBy {
        id
        name
      }
      mcas {
        id
        number
      }
      bankAccounts {
        id
        routingNumber
        accountNumber
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useMerchantsQuery__
 *
 * To run a query within a React component, call `useMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useMerchantsQuery(baseOptions?: Apollo.QueryHookOptions<MerchantsQuery, MerchantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantsQuery, MerchantsQueryVariables>(MerchantsDocument, options);
      }
export function useMerchantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantsQuery, MerchantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantsQuery, MerchantsQueryVariables>(MerchantsDocument, options);
        }
// @ts-ignore
export function useMerchantsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantsQuery, MerchantsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantsQuery, MerchantsQueryVariables>;
export function useMerchantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantsQuery, MerchantsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantsQuery | undefined, MerchantsQueryVariables>;
export function useMerchantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantsQuery, MerchantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantsQuery, MerchantsQueryVariables>(MerchantsDocument, options);
        }
export type MerchantsQueryHookResult = ReturnType<typeof useMerchantsQuery>;
export type MerchantsLazyQueryHookResult = ReturnType<typeof useMerchantsLazyQuery>;
export type MerchantsSuspenseQueryHookResult = ReturnType<typeof useMerchantsSuspenseQuery>;
export type MerchantsQueryResult = Apollo.QueryResult<MerchantsQuery, MerchantsQueryVariables>;
export const AllCompaniesDocument = gql`
    query allCompanies($offset: Int = 0, $limit: Int = 10, $search: String, $type: [CompanyType!] = [], $sortArgs: [SortArgs!] = []) {
  allCompanies(
    offset: $offset
    limit: $limit
    search: $search
    type: $type
    sortArgs: $sortArgs
  ) {
    data {
      id
      legalName
      dba
      phone
      email
      taxId
      logo
      createdAt
      modifiedAt
      type
      www
      linkToFiles
      totalUsers
      createdBy {
        id
        name
      }
      modifiedBy {
        id
        name
      }
      mcas {
        id
        number
        status
        merchant {
          id
          legalName
        }
      }
      bankAccounts {
        id
        routingNumber
        accountNumber
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useAllCompaniesQuery__
 *
 * To run a query within a React component, call `useAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
      }
export function useAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
// @ts-ignore
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompaniesQuery, AllCompaniesQueryVariables>;
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<AllCompaniesQuery | undefined, AllCompaniesQueryVariables>;
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
export type AllCompaniesQueryHookResult = ReturnType<typeof useAllCompaniesQuery>;
export type AllCompaniesLazyQueryHookResult = ReturnType<typeof useAllCompaniesLazyQuery>;
export type AllCompaniesSuspenseQueryHookResult = ReturnType<typeof useAllCompaniesSuspenseQuery>;
export type AllCompaniesQueryResult = Apollo.QueryResult<AllCompaniesQuery, AllCompaniesQueryVariables>;
export const IsCompanyAddedDocument = gql`
    query isCompanyAdded($legalName: String!) {
  isCompanyAdded(legalName: $legalName)
}
    `;

/**
 * __useIsCompanyAddedQuery__
 *
 * To run a query within a React component, call `useIsCompanyAddedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCompanyAddedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCompanyAddedQuery({
 *   variables: {
 *      legalName: // value for 'legalName'
 *   },
 * });
 */
export function useIsCompanyAddedQuery(baseOptions: Apollo.QueryHookOptions<IsCompanyAddedQuery, IsCompanyAddedQueryVariables> & ({ variables: IsCompanyAddedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>(IsCompanyAddedDocument, options);
      }
export function useIsCompanyAddedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>(IsCompanyAddedDocument, options);
        }
// @ts-ignore
export function useIsCompanyAddedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>): Apollo.UseSuspenseQueryResult<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>;
export function useIsCompanyAddedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>): Apollo.UseSuspenseQueryResult<IsCompanyAddedQuery | undefined, IsCompanyAddedQueryVariables>;
export function useIsCompanyAddedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>(IsCompanyAddedDocument, options);
        }
export type IsCompanyAddedQueryHookResult = ReturnType<typeof useIsCompanyAddedQuery>;
export type IsCompanyAddedLazyQueryHookResult = ReturnType<typeof useIsCompanyAddedLazyQuery>;
export type IsCompanyAddedSuspenseQueryHookResult = ReturnType<typeof useIsCompanyAddedSuspenseQuery>;
export type IsCompanyAddedQueryResult = Apollo.QueryResult<IsCompanyAddedQuery, IsCompanyAddedQueryVariables>;
export const IsInternalCompanyAddedDocument = gql`
    query isInternalCompanyAdded($legalName: String!) {
  isInternalCompanyAdded(legalName: $legalName)
}
    `;

/**
 * __useIsInternalCompanyAddedQuery__
 *
 * To run a query within a React component, call `useIsInternalCompanyAddedQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsInternalCompanyAddedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsInternalCompanyAddedQuery({
 *   variables: {
 *      legalName: // value for 'legalName'
 *   },
 * });
 */
export function useIsInternalCompanyAddedQuery(baseOptions: Apollo.QueryHookOptions<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables> & ({ variables: IsInternalCompanyAddedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>(IsInternalCompanyAddedDocument, options);
      }
export function useIsInternalCompanyAddedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>(IsInternalCompanyAddedDocument, options);
        }
// @ts-ignore
export function useIsInternalCompanyAddedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>): Apollo.UseSuspenseQueryResult<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>;
export function useIsInternalCompanyAddedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>): Apollo.UseSuspenseQueryResult<IsInternalCompanyAddedQuery | undefined, IsInternalCompanyAddedQueryVariables>;
export function useIsInternalCompanyAddedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>(IsInternalCompanyAddedDocument, options);
        }
export type IsInternalCompanyAddedQueryHookResult = ReturnType<typeof useIsInternalCompanyAddedQuery>;
export type IsInternalCompanyAddedLazyQueryHookResult = ReturnType<typeof useIsInternalCompanyAddedLazyQuery>;
export type IsInternalCompanyAddedSuspenseQueryHookResult = ReturnType<typeof useIsInternalCompanyAddedSuspenseQuery>;
export type IsInternalCompanyAddedQueryResult = Apollo.QueryResult<IsInternalCompanyAddedQuery, IsInternalCompanyAddedQueryVariables>;
export const MerchantDocument = gql`
    query merchant($id: ID!) {
  merchant(id: $id) {
    id
    legalName
    dba
    type
    phone
    email
    taxId
    logo
    linkToFiles
    mcas {
      id
      number
    }
    bankAccounts {
      id
      routingNumber
      accountNumber
    }
  }
}
    `;

/**
 * __useMerchantQuery__
 *
 * To run a query within a React component, call `useMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantQuery(baseOptions: Apollo.QueryHookOptions<MerchantQuery, MerchantQueryVariables> & ({ variables: MerchantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
      }
export function useMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantQuery, MerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
        }
// @ts-ignore
export function useMerchantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantQuery, MerchantQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantQuery, MerchantQueryVariables>;
export function useMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantQuery, MerchantQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantQuery | undefined, MerchantQueryVariables>;
export function useMerchantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantQuery, MerchantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantQuery, MerchantQueryVariables>(MerchantDocument, options);
        }
export type MerchantQueryHookResult = ReturnType<typeof useMerchantQuery>;
export type MerchantLazyQueryHookResult = ReturnType<typeof useMerchantLazyQuery>;
export type MerchantSuspenseQueryHookResult = ReturnType<typeof useMerchantSuspenseQuery>;
export type MerchantQueryResult = Apollo.QueryResult<MerchantQuery, MerchantQueryVariables>;
export const SaveMerchantDocument = gql`
    mutation saveMerchant($dto: MerchantDto!) {
  saveMerchant(merchant: $dto) {
    id
    legalName
    dba
    phone
    email
    taxId
    linkToFiles
    logo
    www
  }
}
    `;
export type SaveMerchantMutationFn = Apollo.MutationFunction<SaveMerchantMutation, SaveMerchantMutationVariables>;

/**
 * __useSaveMerchantMutation__
 *
 * To run a mutation, you first call `useSaveMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMerchantMutation, { data, loading, error }] = useSaveMerchantMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveMerchantMutation(baseOptions?: Apollo.MutationHookOptions<SaveMerchantMutation, SaveMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMerchantMutation, SaveMerchantMutationVariables>(SaveMerchantDocument, options);
      }
export type SaveMerchantMutationHookResult = ReturnType<typeof useSaveMerchantMutation>;
export type SaveMerchantMutationResult = Apollo.MutationResult<SaveMerchantMutation>;
export type SaveMerchantMutationOptions = Apollo.BaseMutationOptions<SaveMerchantMutation, SaveMerchantMutationVariables>;
export const SaveCompanyDocument = gql`
    mutation saveCompany($dto: CompanyDto!) {
  saveCompany(company: $dto) {
    id
    legalName
    dba
    phone
    email
    taxId
    logo
    linkToFiles
    type
    www
  }
}
    `;
export type SaveCompanyMutationFn = Apollo.MutationFunction<SaveCompanyMutation, SaveCompanyMutationVariables>;

/**
 * __useSaveCompanyMutation__
 *
 * To run a mutation, you first call `useSaveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCompanyMutation, { data, loading, error }] = useSaveCompanyMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<SaveCompanyMutation, SaveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCompanyMutation, SaveCompanyMutationVariables>(SaveCompanyDocument, options);
      }
export type SaveCompanyMutationHookResult = ReturnType<typeof useSaveCompanyMutation>;
export type SaveCompanyMutationResult = Apollo.MutationResult<SaveCompanyMutation>;
export type SaveCompanyMutationOptions = Apollo.BaseMutationOptions<SaveCompanyMutation, SaveCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation deleteCompany($id: ID!) {
  deleteCompany(id: $id)
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const DeleteMerchantDocument = gql`
    mutation deleteMerchant($id: ID!) {
  deleteMerchant(id: $id)
}
    `;
export type DeleteMerchantMutationFn = Apollo.MutationFunction<DeleteMerchantMutation, DeleteMerchantMutationVariables>;

/**
 * __useDeleteMerchantMutation__
 *
 * To run a mutation, you first call `useDeleteMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMerchantMutation, { data, loading, error }] = useDeleteMerchantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMerchantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMerchantMutation, DeleteMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMerchantMutation, DeleteMerchantMutationVariables>(DeleteMerchantDocument, options);
      }
export type DeleteMerchantMutationHookResult = ReturnType<typeof useDeleteMerchantMutation>;
export type DeleteMerchantMutationResult = Apollo.MutationResult<DeleteMerchantMutation>;
export type DeleteMerchantMutationOptions = Apollo.BaseMutationOptions<DeleteMerchantMutation, DeleteMerchantMutationVariables>;
export const BrokersDocument = gql`
    query brokers($offset: Int = 0, $limit: Int = 10, $search: String, $sortArgs: [SortArgs!] = []) {
  brokers(offset: $offset, limit: $limit, search: $search, sortArgs: $sortArgs) {
    data {
      id
      legalName
      dba
      phone
      email
      taxId
      logo
      createdAt
      modifiedAt
      linkToFiles
      createdBy {
        id
        name
      }
      modifiedBy {
        id
        name
      }
      mcas {
        id
        number
      }
      bankAccounts {
        id
        routingNumber
        accountNumber
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useBrokersQuery__
 *
 * To run a query within a React component, call `useBrokersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useBrokersQuery(baseOptions?: Apollo.QueryHookOptions<BrokersQuery, BrokersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokersQuery, BrokersQueryVariables>(BrokersDocument, options);
      }
export function useBrokersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokersQuery, BrokersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokersQuery, BrokersQueryVariables>(BrokersDocument, options);
        }
// @ts-ignore
export function useBrokersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BrokersQuery, BrokersQueryVariables>): Apollo.UseSuspenseQueryResult<BrokersQuery, BrokersQueryVariables>;
export function useBrokersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrokersQuery, BrokersQueryVariables>): Apollo.UseSuspenseQueryResult<BrokersQuery | undefined, BrokersQueryVariables>;
export function useBrokersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrokersQuery, BrokersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrokersQuery, BrokersQueryVariables>(BrokersDocument, options);
        }
export type BrokersQueryHookResult = ReturnType<typeof useBrokersQuery>;
export type BrokersLazyQueryHookResult = ReturnType<typeof useBrokersLazyQuery>;
export type BrokersSuspenseQueryHookResult = ReturnType<typeof useBrokersSuspenseQuery>;
export type BrokersQueryResult = Apollo.QueryResult<BrokersQuery, BrokersQueryVariables>;
export const SaveBrokerDocument = gql`
    mutation saveBroker($dto: BrokerDto!) {
  saveBroker(broker: $dto) {
    id
    legalName
    dba
    phone
    email
    taxId
    logo
    linkToFiles
    www
  }
}
    `;
export type SaveBrokerMutationFn = Apollo.MutationFunction<SaveBrokerMutation, SaveBrokerMutationVariables>;

/**
 * __useSaveBrokerMutation__
 *
 * To run a mutation, you first call `useSaveBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBrokerMutation, { data, loading, error }] = useSaveBrokerMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveBrokerMutation(baseOptions?: Apollo.MutationHookOptions<SaveBrokerMutation, SaveBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBrokerMutation, SaveBrokerMutationVariables>(SaveBrokerDocument, options);
      }
export type SaveBrokerMutationHookResult = ReturnType<typeof useSaveBrokerMutation>;
export type SaveBrokerMutationResult = Apollo.MutationResult<SaveBrokerMutation>;
export type SaveBrokerMutationOptions = Apollo.BaseMutationOptions<SaveBrokerMutation, SaveBrokerMutationVariables>;
export const InternalCompanyDocumentsInfoDocument = gql`
    query internalCompanyDocumentsInfo($id: ID!) {
  internalCompany(id: $id) {
    id
    legalName
    documentsInfo {
      companyFolderConnected
      companyFolderId
      subfolderId
      subfolderDocuments {
        id
      }
      subfolderFiles {
        id
        fileName
      }
    }
  }
}
    `;

/**
 * __useInternalCompanyDocumentsInfoQuery__
 *
 * To run a query within a React component, call `useInternalCompanyDocumentsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalCompanyDocumentsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalCompanyDocumentsInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInternalCompanyDocumentsInfoQuery(baseOptions: Apollo.QueryHookOptions<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables> & ({ variables: InternalCompanyDocumentsInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>(InternalCompanyDocumentsInfoDocument, options);
      }
export function useInternalCompanyDocumentsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>(InternalCompanyDocumentsInfoDocument, options);
        }
// @ts-ignore
export function useInternalCompanyDocumentsInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>;
export function useInternalCompanyDocumentsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>): Apollo.UseSuspenseQueryResult<InternalCompanyDocumentsInfoQuery | undefined, InternalCompanyDocumentsInfoQueryVariables>;
export function useInternalCompanyDocumentsInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>(InternalCompanyDocumentsInfoDocument, options);
        }
export type InternalCompanyDocumentsInfoQueryHookResult = ReturnType<typeof useInternalCompanyDocumentsInfoQuery>;
export type InternalCompanyDocumentsInfoLazyQueryHookResult = ReturnType<typeof useInternalCompanyDocumentsInfoLazyQuery>;
export type InternalCompanyDocumentsInfoSuspenseQueryHookResult = ReturnType<typeof useInternalCompanyDocumentsInfoSuspenseQuery>;
export type InternalCompanyDocumentsInfoQueryResult = Apollo.QueryResult<InternalCompanyDocumentsInfoQuery, InternalCompanyDocumentsInfoQueryVariables>;
export const ConfigFeesDocument = gql`
    query configFees {
  configFees {
    data {
      id
      name
      defaultComment
      defaultAmount
      isPostFunding
      isPercentage
      isPreFunding
      isCommission
      rank
      createdAt
      modifiedAt
      createdBy {
        id
        name
      }
      modifiedBy {
        id
        name
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useConfigFeesQuery__
 *
 * To run a query within a React component, call `useConfigFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigFeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigFeesQuery(baseOptions?: Apollo.QueryHookOptions<ConfigFeesQuery, ConfigFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigFeesQuery, ConfigFeesQueryVariables>(ConfigFeesDocument, options);
      }
export function useConfigFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigFeesQuery, ConfigFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigFeesQuery, ConfigFeesQueryVariables>(ConfigFeesDocument, options);
        }
// @ts-ignore
export function useConfigFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConfigFeesQuery, ConfigFeesQueryVariables>): Apollo.UseSuspenseQueryResult<ConfigFeesQuery, ConfigFeesQueryVariables>;
export function useConfigFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigFeesQuery, ConfigFeesQueryVariables>): Apollo.UseSuspenseQueryResult<ConfigFeesQuery | undefined, ConfigFeesQueryVariables>;
export function useConfigFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigFeesQuery, ConfigFeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigFeesQuery, ConfigFeesQueryVariables>(ConfigFeesDocument, options);
        }
export type ConfigFeesQueryHookResult = ReturnType<typeof useConfigFeesQuery>;
export type ConfigFeesLazyQueryHookResult = ReturnType<typeof useConfigFeesLazyQuery>;
export type ConfigFeesSuspenseQueryHookResult = ReturnType<typeof useConfigFeesSuspenseQuery>;
export type ConfigFeesQueryResult = Apollo.QueryResult<ConfigFeesQuery, ConfigFeesQueryVariables>;
export const ConfigFeeDocument = gql`
    query configFee($id: ID!) {
  configFee(id: $id) {
    id
    name
    defaultComment
    defaultAmount
    isPostFunding
    isPercentage
    isPreFunding
    isCommission
    rank
  }
}
    `;

/**
 * __useConfigFeeQuery__
 *
 * To run a query within a React component, call `useConfigFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigFeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConfigFeeQuery(baseOptions: Apollo.QueryHookOptions<ConfigFeeQuery, ConfigFeeQueryVariables> & ({ variables: ConfigFeeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigFeeQuery, ConfigFeeQueryVariables>(ConfigFeeDocument, options);
      }
export function useConfigFeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigFeeQuery, ConfigFeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigFeeQuery, ConfigFeeQueryVariables>(ConfigFeeDocument, options);
        }
// @ts-ignore
export function useConfigFeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ConfigFeeQuery, ConfigFeeQueryVariables>): Apollo.UseSuspenseQueryResult<ConfigFeeQuery, ConfigFeeQueryVariables>;
export function useConfigFeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigFeeQuery, ConfigFeeQueryVariables>): Apollo.UseSuspenseQueryResult<ConfigFeeQuery | undefined, ConfigFeeQueryVariables>;
export function useConfigFeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConfigFeeQuery, ConfigFeeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConfigFeeQuery, ConfigFeeQueryVariables>(ConfigFeeDocument, options);
        }
export type ConfigFeeQueryHookResult = ReturnType<typeof useConfigFeeQuery>;
export type ConfigFeeLazyQueryHookResult = ReturnType<typeof useConfigFeeLazyQuery>;
export type ConfigFeeSuspenseQueryHookResult = ReturnType<typeof useConfigFeeSuspenseQuery>;
export type ConfigFeeQueryResult = Apollo.QueryResult<ConfigFeeQuery, ConfigFeeQueryVariables>;
export const SaveConfigFeeDocument = gql`
    mutation saveConfigFee($id: ID, $dto: ConfigFeeDto!) {
  saveConfigFee(id: $id, configFee: $dto) {
    id
  }
}
    `;
export type SaveConfigFeeMutationFn = Apollo.MutationFunction<SaveConfigFeeMutation, SaveConfigFeeMutationVariables>;

/**
 * __useSaveConfigFeeMutation__
 *
 * To run a mutation, you first call `useSaveConfigFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConfigFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConfigFeeMutation, { data, loading, error }] = useSaveConfigFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveConfigFeeMutation(baseOptions?: Apollo.MutationHookOptions<SaveConfigFeeMutation, SaveConfigFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConfigFeeMutation, SaveConfigFeeMutationVariables>(SaveConfigFeeDocument, options);
      }
export type SaveConfigFeeMutationHookResult = ReturnType<typeof useSaveConfigFeeMutation>;
export type SaveConfigFeeMutationResult = Apollo.MutationResult<SaveConfigFeeMutation>;
export type SaveConfigFeeMutationOptions = Apollo.BaseMutationOptions<SaveConfigFeeMutation, SaveConfigFeeMutationVariables>;
export const DeleteConfigFeeDocument = gql`
    mutation deleteConfigFee($id: ID!) {
  deleteConfigFee(id: $id)
}
    `;
export type DeleteConfigFeeMutationFn = Apollo.MutationFunction<DeleteConfigFeeMutation, DeleteConfigFeeMutationVariables>;

/**
 * __useDeleteConfigFeeMutation__
 *
 * To run a mutation, you first call `useDeleteConfigFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConfigFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConfigFeeMutation, { data, loading, error }] = useDeleteConfigFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteConfigFeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConfigFeeMutation, DeleteConfigFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConfigFeeMutation, DeleteConfigFeeMutationVariables>(DeleteConfigFeeDocument, options);
      }
export type DeleteConfigFeeMutationHookResult = ReturnType<typeof useDeleteConfigFeeMutation>;
export type DeleteConfigFeeMutationResult = Apollo.MutationResult<DeleteConfigFeeMutation>;
export type DeleteConfigFeeMutationOptions = Apollo.BaseMutationOptions<DeleteConfigFeeMutation, DeleteConfigFeeMutationVariables>;
export const SaveExternalServiceConfigurationDocument = gql`
    mutation saveExternalServiceConfiguration($dto: ExternalServiceInputDto!) {
  saveExternalServiceConfiguration(externalServiceInputDto: $dto) {
    id
    name
    type
    description
    logo
    company {
      id
      legalName
      dba
      logo
    }
    configurationSchema
    dataSchema
  }
}
    `;
export type SaveExternalServiceConfigurationMutationFn = Apollo.MutationFunction<SaveExternalServiceConfigurationMutation, SaveExternalServiceConfigurationMutationVariables>;

/**
 * __useSaveExternalServiceConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveExternalServiceConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExternalServiceConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExternalServiceConfigurationMutation, { data, loading, error }] = useSaveExternalServiceConfigurationMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveExternalServiceConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveExternalServiceConfigurationMutation, SaveExternalServiceConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveExternalServiceConfigurationMutation, SaveExternalServiceConfigurationMutationVariables>(SaveExternalServiceConfigurationDocument, options);
      }
export type SaveExternalServiceConfigurationMutationHookResult = ReturnType<typeof useSaveExternalServiceConfigurationMutation>;
export type SaveExternalServiceConfigurationMutationResult = Apollo.MutationResult<SaveExternalServiceConfigurationMutation>;
export type SaveExternalServiceConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveExternalServiceConfigurationMutation, SaveExternalServiceConfigurationMutationVariables>;
export const DeleteExternalServiceConfigurationDocument = gql`
    mutation deleteExternalServiceConfiguration($id: ID!) {
  deleteExternalServiceConfiguration(id: $id)
}
    `;
export type DeleteExternalServiceConfigurationMutationFn = Apollo.MutationFunction<DeleteExternalServiceConfigurationMutation, DeleteExternalServiceConfigurationMutationVariables>;

/**
 * __useDeleteExternalServiceConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteExternalServiceConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExternalServiceConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExternalServiceConfigurationMutation, { data, loading, error }] = useDeleteExternalServiceConfigurationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExternalServiceConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExternalServiceConfigurationMutation, DeleteExternalServiceConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExternalServiceConfigurationMutation, DeleteExternalServiceConfigurationMutationVariables>(DeleteExternalServiceConfigurationDocument, options);
      }
export type DeleteExternalServiceConfigurationMutationHookResult = ReturnType<typeof useDeleteExternalServiceConfigurationMutation>;
export type DeleteExternalServiceConfigurationMutationResult = Apollo.MutationResult<DeleteExternalServiceConfigurationMutation>;
export type DeleteExternalServiceConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteExternalServiceConfigurationMutation, DeleteExternalServiceConfigurationMutationVariables>;
export const IsExisitingExternalServiceDocument = gql`
    query isExisitingExternalService($name: String!) {
  isExisitingExternalService(name: $name)
}
    `;

/**
 * __useIsExisitingExternalServiceQuery__
 *
 * To run a query within a React component, call `useIsExisitingExternalServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsExisitingExternalServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsExisitingExternalServiceQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useIsExisitingExternalServiceQuery(baseOptions: Apollo.QueryHookOptions<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables> & ({ variables: IsExisitingExternalServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>(IsExisitingExternalServiceDocument, options);
      }
export function useIsExisitingExternalServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>(IsExisitingExternalServiceDocument, options);
        }
// @ts-ignore
export function useIsExisitingExternalServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>): Apollo.UseSuspenseQueryResult<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>;
export function useIsExisitingExternalServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>): Apollo.UseSuspenseQueryResult<IsExisitingExternalServiceQuery | undefined, IsExisitingExternalServiceQueryVariables>;
export function useIsExisitingExternalServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>(IsExisitingExternalServiceDocument, options);
        }
export type IsExisitingExternalServiceQueryHookResult = ReturnType<typeof useIsExisitingExternalServiceQuery>;
export type IsExisitingExternalServiceLazyQueryHookResult = ReturnType<typeof useIsExisitingExternalServiceLazyQuery>;
export type IsExisitingExternalServiceSuspenseQueryHookResult = ReturnType<typeof useIsExisitingExternalServiceSuspenseQuery>;
export type IsExisitingExternalServiceQueryResult = Apollo.QueryResult<IsExisitingExternalServiceQuery, IsExisitingExternalServiceQueryVariables>;
export const GetAllExternalServiceSecretSchemaDefinitionsDocument = gql`
    query getAllExternalServiceSecretSchemaDefinitions {
  getAllExternalServiceSecretSchemaDefinitions
}
    `;

/**
 * __useGetAllExternalServiceSecretSchemaDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetAllExternalServiceSecretSchemaDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExternalServiceSecretSchemaDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExternalServiceSecretSchemaDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllExternalServiceSecretSchemaDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>(GetAllExternalServiceSecretSchemaDefinitionsDocument, options);
      }
export function useGetAllExternalServiceSecretSchemaDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>(GetAllExternalServiceSecretSchemaDefinitionsDocument, options);
        }
// @ts-ignore
export function useGetAllExternalServiceSecretSchemaDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>;
export function useGetAllExternalServiceSecretSchemaDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExternalServiceSecretSchemaDefinitionsQuery | undefined, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>;
export function useGetAllExternalServiceSecretSchemaDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>(GetAllExternalServiceSecretSchemaDefinitionsDocument, options);
        }
export type GetAllExternalServiceSecretSchemaDefinitionsQueryHookResult = ReturnType<typeof useGetAllExternalServiceSecretSchemaDefinitionsQuery>;
export type GetAllExternalServiceSecretSchemaDefinitionsLazyQueryHookResult = ReturnType<typeof useGetAllExternalServiceSecretSchemaDefinitionsLazyQuery>;
export type GetAllExternalServiceSecretSchemaDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetAllExternalServiceSecretSchemaDefinitionsSuspenseQuery>;
export type GetAllExternalServiceSecretSchemaDefinitionsQueryResult = Apollo.QueryResult<GetAllExternalServiceSecretSchemaDefinitionsQuery, GetAllExternalServiceSecretSchemaDefinitionsQueryVariables>;
export const GetAllExternalServiceLogosDocument = gql`
    query getAllExternalServiceLogos {
  getAllExternalServiceLogos
}
    `;

/**
 * __useGetAllExternalServiceLogosQuery__
 *
 * To run a query within a React component, call `useGetAllExternalServiceLogosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllExternalServiceLogosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllExternalServiceLogosQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllExternalServiceLogosQuery(baseOptions?: Apollo.QueryHookOptions<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>(GetAllExternalServiceLogosDocument, options);
      }
export function useGetAllExternalServiceLogosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>(GetAllExternalServiceLogosDocument, options);
        }
// @ts-ignore
export function useGetAllExternalServiceLogosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>;
export function useGetAllExternalServiceLogosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllExternalServiceLogosQuery | undefined, GetAllExternalServiceLogosQueryVariables>;
export function useGetAllExternalServiceLogosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>(GetAllExternalServiceLogosDocument, options);
        }
export type GetAllExternalServiceLogosQueryHookResult = ReturnType<typeof useGetAllExternalServiceLogosQuery>;
export type GetAllExternalServiceLogosLazyQueryHookResult = ReturnType<typeof useGetAllExternalServiceLogosLazyQuery>;
export type GetAllExternalServiceLogosSuspenseQueryHookResult = ReturnType<typeof useGetAllExternalServiceLogosSuspenseQuery>;
export type GetAllExternalServiceLogosQueryResult = Apollo.QueryResult<GetAllExternalServiceLogosQuery, GetAllExternalServiceLogosQueryVariables>;
export const ActiveExternalServicesDocument = gql`
    query activeExternalServices {
  activeExternalServices {
    id
    name
    type
    description
    logo
    company {
      id
      legalName
      dba
      logo
    }
    configurationSchema
    dataSchema
    secret
  }
}
    `;

/**
 * __useActiveExternalServicesQuery__
 *
 * To run a query within a React component, call `useActiveExternalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveExternalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveExternalServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveExternalServicesQuery(baseOptions?: Apollo.QueryHookOptions<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>(ActiveExternalServicesDocument, options);
      }
export function useActiveExternalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>(ActiveExternalServicesDocument, options);
        }
// @ts-ignore
export function useActiveExternalServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>;
export function useActiveExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<ActiveExternalServicesQuery | undefined, ActiveExternalServicesQueryVariables>;
export function useActiveExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>(ActiveExternalServicesDocument, options);
        }
export type ActiveExternalServicesQueryHookResult = ReturnType<typeof useActiveExternalServicesQuery>;
export type ActiveExternalServicesLazyQueryHookResult = ReturnType<typeof useActiveExternalServicesLazyQuery>;
export type ActiveExternalServicesSuspenseQueryHookResult = ReturnType<typeof useActiveExternalServicesSuspenseQuery>;
export type ActiveExternalServicesQueryResult = Apollo.QueryResult<ActiveExternalServicesQuery, ActiveExternalServicesQueryVariables>;
export const MerchantCashAdvanceExternalServiceConnectionsDocument = gql`
    query merchantCashAdvanceExternalServiceConnections($mcaId: ID!) {
  merchantCashAdvanceExternalServiceConnections(mcaId: $mcaId) {
    id
    mcaId
    externalServiceConfigurationId
    configuration
    isActive
    createdAt
    modifiedAt
    fetchedAt
    externalServiceConfiguration {
      id
      name
      type
      description
      logo
      company {
        id
        legalName
        dba
        logo
      }
      configurationSchema
      dataSchema
    }
  }
}
    `;

/**
 * __useMerchantCashAdvanceExternalServiceConnectionsQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvanceExternalServiceConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvanceExternalServiceConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvanceExternalServiceConnectionsQuery({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useMerchantCashAdvanceExternalServiceConnectionsQuery(baseOptions: Apollo.QueryHookOptions<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables> & ({ variables: MerchantCashAdvanceExternalServiceConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>(MerchantCashAdvanceExternalServiceConnectionsDocument, options);
      }
export function useMerchantCashAdvanceExternalServiceConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>(MerchantCashAdvanceExternalServiceConnectionsDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvanceExternalServiceConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>;
export function useMerchantCashAdvanceExternalServiceConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceExternalServiceConnectionsQuery | undefined, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>;
export function useMerchantCashAdvanceExternalServiceConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>(MerchantCashAdvanceExternalServiceConnectionsDocument, options);
        }
export type MerchantCashAdvanceExternalServiceConnectionsQueryHookResult = ReturnType<typeof useMerchantCashAdvanceExternalServiceConnectionsQuery>;
export type MerchantCashAdvanceExternalServiceConnectionsLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvanceExternalServiceConnectionsLazyQuery>;
export type MerchantCashAdvanceExternalServiceConnectionsSuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvanceExternalServiceConnectionsSuspenseQuery>;
export type MerchantCashAdvanceExternalServiceConnectionsQueryResult = Apollo.QueryResult<MerchantCashAdvanceExternalServiceConnectionsQuery, MerchantCashAdvanceExternalServiceConnectionsQueryVariables>;
export const SaveMerchantCashAdvanceExternalServiceConnectionDocument = gql`
    mutation saveMerchantCashAdvanceExternalServiceConnection($mcaId: ID!, $externalServiceConfigurationId: ID!, $configuration: JSON!) {
  saveMerchantCashAdvanceExternalServiceConnection(
    mcaId: $mcaId
    externalServiceConfigurationId: $externalServiceConfigurationId
    configuration: $configuration
  ) {
    id
    mcaId
    externalServiceConfigurationId
    configuration
    isActive
    createdAt
    modifiedAt
    fetchedAt
    externalServiceConfiguration {
      id
      name
      type
      description
      logo
      company {
        id
        legalName
        dba
        logo
      }
      configurationSchema
      dataSchema
    }
  }
}
    `;
export type SaveMerchantCashAdvanceExternalServiceConnectionMutationFn = Apollo.MutationFunction<SaveMerchantCashAdvanceExternalServiceConnectionMutation, SaveMerchantCashAdvanceExternalServiceConnectionMutationVariables>;

/**
 * __useSaveMerchantCashAdvanceExternalServiceConnectionMutation__
 *
 * To run a mutation, you first call `useSaveMerchantCashAdvanceExternalServiceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMerchantCashAdvanceExternalServiceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMerchantCashAdvanceExternalServiceConnectionMutation, { data, loading, error }] = useSaveMerchantCashAdvanceExternalServiceConnectionMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      externalServiceConfigurationId: // value for 'externalServiceConfigurationId'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useSaveMerchantCashAdvanceExternalServiceConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SaveMerchantCashAdvanceExternalServiceConnectionMutation, SaveMerchantCashAdvanceExternalServiceConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMerchantCashAdvanceExternalServiceConnectionMutation, SaveMerchantCashAdvanceExternalServiceConnectionMutationVariables>(SaveMerchantCashAdvanceExternalServiceConnectionDocument, options);
      }
export type SaveMerchantCashAdvanceExternalServiceConnectionMutationHookResult = ReturnType<typeof useSaveMerchantCashAdvanceExternalServiceConnectionMutation>;
export type SaveMerchantCashAdvanceExternalServiceConnectionMutationResult = Apollo.MutationResult<SaveMerchantCashAdvanceExternalServiceConnectionMutation>;
export type SaveMerchantCashAdvanceExternalServiceConnectionMutationOptions = Apollo.BaseMutationOptions<SaveMerchantCashAdvanceExternalServiceConnectionMutation, SaveMerchantCashAdvanceExternalServiceConnectionMutationVariables>;
export const UpdateMerchantCashAdvanceExternalServiceConnectionDocument = gql`
    mutation updateMerchantCashAdvanceExternalServiceConnection($id: ID!, $configuration: JSON!) {
  updateMerchantCashAdvanceExternalServiceConnection(
    id: $id
    configuration: $configuration
  ) {
    id
    mcaId
    externalServiceConfigurationId
    configuration
    isActive
    createdAt
    modifiedAt
    fetchedAt
    externalServiceConfiguration {
      id
      name
      type
      description
      logo
      company {
        id
        legalName
        dba
        logo
      }
      configurationSchema
      dataSchema
    }
  }
}
    `;
export type UpdateMerchantCashAdvanceExternalServiceConnectionMutationFn = Apollo.MutationFunction<UpdateMerchantCashAdvanceExternalServiceConnectionMutation, UpdateMerchantCashAdvanceExternalServiceConnectionMutationVariables>;

/**
 * __useUpdateMerchantCashAdvanceExternalServiceConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateMerchantCashAdvanceExternalServiceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMerchantCashAdvanceExternalServiceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMerchantCashAdvanceExternalServiceConnectionMutation, { data, loading, error }] = useUpdateMerchantCashAdvanceExternalServiceConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useUpdateMerchantCashAdvanceExternalServiceConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMerchantCashAdvanceExternalServiceConnectionMutation, UpdateMerchantCashAdvanceExternalServiceConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMerchantCashAdvanceExternalServiceConnectionMutation, UpdateMerchantCashAdvanceExternalServiceConnectionMutationVariables>(UpdateMerchantCashAdvanceExternalServiceConnectionDocument, options);
      }
export type UpdateMerchantCashAdvanceExternalServiceConnectionMutationHookResult = ReturnType<typeof useUpdateMerchantCashAdvanceExternalServiceConnectionMutation>;
export type UpdateMerchantCashAdvanceExternalServiceConnectionMutationResult = Apollo.MutationResult<UpdateMerchantCashAdvanceExternalServiceConnectionMutation>;
export type UpdateMerchantCashAdvanceExternalServiceConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateMerchantCashAdvanceExternalServiceConnectionMutation, UpdateMerchantCashAdvanceExternalServiceConnectionMutationVariables>;
export const DeleteMerchantCashAdvanceExternalServiceConnectionDocument = gql`
    mutation deleteMerchantCashAdvanceExternalServiceConnection($id: ID!) {
  deleteMerchantCashAdvanceExternalServiceConnection(id: $id)
}
    `;
export type DeleteMerchantCashAdvanceExternalServiceConnectionMutationFn = Apollo.MutationFunction<DeleteMerchantCashAdvanceExternalServiceConnectionMutation, DeleteMerchantCashAdvanceExternalServiceConnectionMutationVariables>;

/**
 * __useDeleteMerchantCashAdvanceExternalServiceConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteMerchantCashAdvanceExternalServiceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMerchantCashAdvanceExternalServiceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMerchantCashAdvanceExternalServiceConnectionMutation, { data, loading, error }] = useDeleteMerchantCashAdvanceExternalServiceConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMerchantCashAdvanceExternalServiceConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMerchantCashAdvanceExternalServiceConnectionMutation, DeleteMerchantCashAdvanceExternalServiceConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMerchantCashAdvanceExternalServiceConnectionMutation, DeleteMerchantCashAdvanceExternalServiceConnectionMutationVariables>(DeleteMerchantCashAdvanceExternalServiceConnectionDocument, options);
      }
export type DeleteMerchantCashAdvanceExternalServiceConnectionMutationHookResult = ReturnType<typeof useDeleteMerchantCashAdvanceExternalServiceConnectionMutation>;
export type DeleteMerchantCashAdvanceExternalServiceConnectionMutationResult = Apollo.MutationResult<DeleteMerchantCashAdvanceExternalServiceConnectionMutation>;
export type DeleteMerchantCashAdvanceExternalServiceConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteMerchantCashAdvanceExternalServiceConnectionMutation, DeleteMerchantCashAdvanceExternalServiceConnectionMutationVariables>;
export const MerchantCashAdvanceExternalServiceDataByConnectionDocument = gql`
    query merchantCashAdvanceExternalServiceDataByConnection($connectionId: ID!) {
  merchantCashAdvanceExternalServiceDataByConnection(connectionId: $connectionId) {
    id
    connectionId
    data
    externalId
  }
}
    `;

/**
 * __useMerchantCashAdvanceExternalServiceDataByConnectionQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvanceExternalServiceDataByConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvanceExternalServiceDataByConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvanceExternalServiceDataByConnectionQuery({
 *   variables: {
 *      connectionId: // value for 'connectionId'
 *   },
 * });
 */
export function useMerchantCashAdvanceExternalServiceDataByConnectionQuery(baseOptions: Apollo.QueryHookOptions<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables> & ({ variables: MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>(MerchantCashAdvanceExternalServiceDataByConnectionDocument, options);
      }
export function useMerchantCashAdvanceExternalServiceDataByConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>(MerchantCashAdvanceExternalServiceDataByConnectionDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvanceExternalServiceDataByConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>;
export function useMerchantCashAdvanceExternalServiceDataByConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceExternalServiceDataByConnectionQuery | undefined, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>;
export function useMerchantCashAdvanceExternalServiceDataByConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>(MerchantCashAdvanceExternalServiceDataByConnectionDocument, options);
        }
export type MerchantCashAdvanceExternalServiceDataByConnectionQueryHookResult = ReturnType<typeof useMerchantCashAdvanceExternalServiceDataByConnectionQuery>;
export type MerchantCashAdvanceExternalServiceDataByConnectionLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvanceExternalServiceDataByConnectionLazyQuery>;
export type MerchantCashAdvanceExternalServiceDataByConnectionSuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvanceExternalServiceDataByConnectionSuspenseQuery>;
export type MerchantCashAdvanceExternalServiceDataByConnectionQueryResult = Apollo.QueryResult<MerchantCashAdvanceExternalServiceDataByConnectionQuery, MerchantCashAdvanceExternalServiceDataByConnectionQueryVariables>;
export const SyncMerchantCashAdvanceExternalServiceConnectionDocument = gql`
    mutation syncMerchantCashAdvanceExternalServiceConnection($id: ID!) {
  syncMerchantCashAdvanceExternalServiceConnection(id: $id)
}
    `;
export type SyncMerchantCashAdvanceExternalServiceConnectionMutationFn = Apollo.MutationFunction<SyncMerchantCashAdvanceExternalServiceConnectionMutation, SyncMerchantCashAdvanceExternalServiceConnectionMutationVariables>;

/**
 * __useSyncMerchantCashAdvanceExternalServiceConnectionMutation__
 *
 * To run a mutation, you first call `useSyncMerchantCashAdvanceExternalServiceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncMerchantCashAdvanceExternalServiceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncMerchantCashAdvanceExternalServiceConnectionMutation, { data, loading, error }] = useSyncMerchantCashAdvanceExternalServiceConnectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncMerchantCashAdvanceExternalServiceConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SyncMerchantCashAdvanceExternalServiceConnectionMutation, SyncMerchantCashAdvanceExternalServiceConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncMerchantCashAdvanceExternalServiceConnectionMutation, SyncMerchantCashAdvanceExternalServiceConnectionMutationVariables>(SyncMerchantCashAdvanceExternalServiceConnectionDocument, options);
      }
export type SyncMerchantCashAdvanceExternalServiceConnectionMutationHookResult = ReturnType<typeof useSyncMerchantCashAdvanceExternalServiceConnectionMutation>;
export type SyncMerchantCashAdvanceExternalServiceConnectionMutationResult = Apollo.MutationResult<SyncMerchantCashAdvanceExternalServiceConnectionMutation>;
export type SyncMerchantCashAdvanceExternalServiceConnectionMutationOptions = Apollo.BaseMutationOptions<SyncMerchantCashAdvanceExternalServiceConnectionMutation, SyncMerchantCashAdvanceExternalServiceConnectionMutationVariables>;
export const AvailableExternalServicesDocument = gql`
    query availableExternalServices {
  availableExternalServices
}
    `;

/**
 * __useAvailableExternalServicesQuery__
 *
 * To run a query within a React component, call `useAvailableExternalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableExternalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableExternalServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableExternalServicesQuery(baseOptions?: Apollo.QueryHookOptions<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>(AvailableExternalServicesDocument, options);
      }
export function useAvailableExternalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>(AvailableExternalServicesDocument, options);
        }
// @ts-ignore
export function useAvailableExternalServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>;
export function useAvailableExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<AvailableExternalServicesQuery | undefined, AvailableExternalServicesQueryVariables>;
export function useAvailableExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>(AvailableExternalServicesDocument, options);
        }
export type AvailableExternalServicesQueryHookResult = ReturnType<typeof useAvailableExternalServicesQuery>;
export type AvailableExternalServicesLazyQueryHookResult = ReturnType<typeof useAvailableExternalServicesLazyQuery>;
export type AvailableExternalServicesSuspenseQueryHookResult = ReturnType<typeof useAvailableExternalServicesSuspenseQuery>;
export type AvailableExternalServicesQueryResult = Apollo.QueryResult<AvailableExternalServicesQuery, AvailableExternalServicesQueryVariables>;
export const ApplicationExternalServiceConnectionsDocument = gql`
    query applicationExternalServiceConnections($applicationId: ID!) {
  applicationExternalServiceConnections(applicationId: $applicationId) {
    id
    applicationId
    externalServiceConfigurationId
    configuration
    isActive
    createdAt
    modifiedAt
    fetchedAt
    externalServiceConfiguration {
      id
      name
      type
      description
      logo
      company {
        id
        legalName
        dba
        logo
      }
      configurationSchema
      dataSchema
    }
  }
}
    `;

/**
 * __useApplicationExternalServiceConnectionsQuery__
 *
 * To run a query within a React component, call `useApplicationExternalServiceConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationExternalServiceConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationExternalServiceConnectionsQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationExternalServiceConnectionsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables> & ({ variables: ApplicationExternalServiceConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>(ApplicationExternalServiceConnectionsDocument, options);
      }
export function useApplicationExternalServiceConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>(ApplicationExternalServiceConnectionsDocument, options);
        }
// @ts-ignore
export function useApplicationExternalServiceConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>;
export function useApplicationExternalServiceConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationExternalServiceConnectionsQuery | undefined, ApplicationExternalServiceConnectionsQueryVariables>;
export function useApplicationExternalServiceConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>(ApplicationExternalServiceConnectionsDocument, options);
        }
export type ApplicationExternalServiceConnectionsQueryHookResult = ReturnType<typeof useApplicationExternalServiceConnectionsQuery>;
export type ApplicationExternalServiceConnectionsLazyQueryHookResult = ReturnType<typeof useApplicationExternalServiceConnectionsLazyQuery>;
export type ApplicationExternalServiceConnectionsSuspenseQueryHookResult = ReturnType<typeof useApplicationExternalServiceConnectionsSuspenseQuery>;
export type ApplicationExternalServiceConnectionsQueryResult = Apollo.QueryResult<ApplicationExternalServiceConnectionsQuery, ApplicationExternalServiceConnectionsQueryVariables>;
export const SaveApplicationExternalServiceConnectionDocument = gql`
    mutation saveApplicationExternalServiceConnection($applicationId: ID!, $externalServiceConfigurationId: ID!, $configuration: JSON!) {
  saveApplicationExternalServiceConnection(
    applicationId: $applicationId
    externalServiceConfigurationId: $externalServiceConfigurationId
    configuration: $configuration
  ) {
    id
    applicationId
    externalServiceConfigurationId
    configuration
    isActive
  }
}
    `;
export type SaveApplicationExternalServiceConnectionMutationFn = Apollo.MutationFunction<SaveApplicationExternalServiceConnectionMutation, SaveApplicationExternalServiceConnectionMutationVariables>;

/**
 * __useSaveApplicationExternalServiceConnectionMutation__
 *
 * To run a mutation, you first call `useSaveApplicationExternalServiceConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveApplicationExternalServiceConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveApplicationExternalServiceConnectionMutation, { data, loading, error }] = useSaveApplicationExternalServiceConnectionMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      externalServiceConfigurationId: // value for 'externalServiceConfigurationId'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useSaveApplicationExternalServiceConnectionMutation(baseOptions?: Apollo.MutationHookOptions<SaveApplicationExternalServiceConnectionMutation, SaveApplicationExternalServiceConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveApplicationExternalServiceConnectionMutation, SaveApplicationExternalServiceConnectionMutationVariables>(SaveApplicationExternalServiceConnectionDocument, options);
      }
export type SaveApplicationExternalServiceConnectionMutationHookResult = ReturnType<typeof useSaveApplicationExternalServiceConnectionMutation>;
export type SaveApplicationExternalServiceConnectionMutationResult = Apollo.MutationResult<SaveApplicationExternalServiceConnectionMutation>;
export type SaveApplicationExternalServiceConnectionMutationOptions = Apollo.BaseMutationOptions<SaveApplicationExternalServiceConnectionMutation, SaveApplicationExternalServiceConnectionMutationVariables>;
export const ApplicationExternalServiceDataByApplicationDocument = gql`
    query applicationExternalServiceDataByApplication($applicationId: ID!) {
  applicationExternalServiceDataByApplication(applicationId: $applicationId) {
    id
    connectionId
    searchParamsHash
    searchParams
    externalId
    data
    validUntil
    createdAt
    modifiedAt
    isCacheValid
    downloadCount
    connection {
      id
      applicationId
      externalServiceConfigurationId
      externalServiceConfiguration {
        id
        name
        type
        logo
      }
    }
  }
}
    `;

/**
 * __useApplicationExternalServiceDataByApplicationQuery__
 *
 * To run a query within a React component, call `useApplicationExternalServiceDataByApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationExternalServiceDataByApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationExternalServiceDataByApplicationQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useApplicationExternalServiceDataByApplicationQuery(baseOptions: Apollo.QueryHookOptions<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables> & ({ variables: ApplicationExternalServiceDataByApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>(ApplicationExternalServiceDataByApplicationDocument, options);
      }
export function useApplicationExternalServiceDataByApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>(ApplicationExternalServiceDataByApplicationDocument, options);
        }
// @ts-ignore
export function useApplicationExternalServiceDataByApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>;
export function useApplicationExternalServiceDataByApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<ApplicationExternalServiceDataByApplicationQuery | undefined, ApplicationExternalServiceDataByApplicationQueryVariables>;
export function useApplicationExternalServiceDataByApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>(ApplicationExternalServiceDataByApplicationDocument, options);
        }
export type ApplicationExternalServiceDataByApplicationQueryHookResult = ReturnType<typeof useApplicationExternalServiceDataByApplicationQuery>;
export type ApplicationExternalServiceDataByApplicationLazyQueryHookResult = ReturnType<typeof useApplicationExternalServiceDataByApplicationLazyQuery>;
export type ApplicationExternalServiceDataByApplicationSuspenseQueryHookResult = ReturnType<typeof useApplicationExternalServiceDataByApplicationSuspenseQuery>;
export type ApplicationExternalServiceDataByApplicationQueryResult = Apollo.QueryResult<ApplicationExternalServiceDataByApplicationQuery, ApplicationExternalServiceDataByApplicationQueryVariables>;
export const PullExperianCreditReportDocument = gql`
    mutation pullExperianCreditReport($applicationId: ID!, $externalServiceConfigurationId: ID!, $consumerPii: ConsumerPiiInputDto!) {
  pullExperianCreditReport(
    applicationId: $applicationId
    externalServiceConfigurationId: $externalServiceConfigurationId
    consumerPii: $consumerPii
  ) {
    success
    fromCache
    errors
    data {
      id
      connectionId
      searchParamsHash
      searchParams
      externalId
      data
      validUntil
      createdAt
      isCacheValid
    }
  }
}
    `;
export type PullExperianCreditReportMutationFn = Apollo.MutationFunction<PullExperianCreditReportMutation, PullExperianCreditReportMutationVariables>;

/**
 * __usePullExperianCreditReportMutation__
 *
 * To run a mutation, you first call `usePullExperianCreditReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePullExperianCreditReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pullExperianCreditReportMutation, { data, loading, error }] = usePullExperianCreditReportMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      externalServiceConfigurationId: // value for 'externalServiceConfigurationId'
 *      consumerPii: // value for 'consumerPii'
 *   },
 * });
 */
export function usePullExperianCreditReportMutation(baseOptions?: Apollo.MutationHookOptions<PullExperianCreditReportMutation, PullExperianCreditReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PullExperianCreditReportMutation, PullExperianCreditReportMutationVariables>(PullExperianCreditReportDocument, options);
      }
export type PullExperianCreditReportMutationHookResult = ReturnType<typeof usePullExperianCreditReportMutation>;
export type PullExperianCreditReportMutationResult = Apollo.MutationResult<PullExperianCreditReportMutation>;
export type PullExperianCreditReportMutationOptions = Apollo.BaseMutationOptions<PullExperianCreditReportMutation, PullExperianCreditReportMutationVariables>;
export const ExperianExternalServicesDocument = gql`
    query experianExternalServices {
  activeExternalServices {
    id
    name
    type
    description
    logo
    company {
      id
      legalName
      dba
      logo
    }
  }
}
    `;

/**
 * __useExperianExternalServicesQuery__
 *
 * To run a query within a React component, call `useExperianExternalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperianExternalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperianExternalServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExperianExternalServicesQuery(baseOptions?: Apollo.QueryHookOptions<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>(ExperianExternalServicesDocument, options);
      }
export function useExperianExternalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>(ExperianExternalServicesDocument, options);
        }
// @ts-ignore
export function useExperianExternalServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>;
export function useExperianExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<ExperianExternalServicesQuery | undefined, ExperianExternalServicesQueryVariables>;
export function useExperianExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>(ExperianExternalServicesDocument, options);
        }
export type ExperianExternalServicesQueryHookResult = ReturnType<typeof useExperianExternalServicesQuery>;
export type ExperianExternalServicesLazyQueryHookResult = ReturnType<typeof useExperianExternalServicesLazyQuery>;
export type ExperianExternalServicesSuspenseQueryHookResult = ReturnType<typeof useExperianExternalServicesSuspenseQuery>;
export type ExperianExternalServicesQueryResult = Apollo.QueryResult<ExperianExternalServicesQuery, ExperianExternalServicesQueryVariables>;
export const PullClearPersonReportDocument = gql`
    mutation pullClearPersonReport($applicationId: ID!, $externalServiceConfigurationId: ID!, $consumerPii: ConsumerPiiInputDto!) {
  pullClearPersonReport(
    applicationId: $applicationId
    externalServiceConfigurationId: $externalServiceConfigurationId
    consumerPii: $consumerPii
  ) {
    success
    fromCache
    errors
    data {
      id
      connectionId
      searchParamsHash
      searchParams
      externalId
      data
      validUntil
      createdAt
      isCacheValid
    }
  }
}
    `;
export type PullClearPersonReportMutationFn = Apollo.MutationFunction<PullClearPersonReportMutation, PullClearPersonReportMutationVariables>;

/**
 * __usePullClearPersonReportMutation__
 *
 * To run a mutation, you first call `usePullClearPersonReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePullClearPersonReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pullClearPersonReportMutation, { data, loading, error }] = usePullClearPersonReportMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      externalServiceConfigurationId: // value for 'externalServiceConfigurationId'
 *      consumerPii: // value for 'consumerPii'
 *   },
 * });
 */
export function usePullClearPersonReportMutation(baseOptions?: Apollo.MutationHookOptions<PullClearPersonReportMutation, PullClearPersonReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PullClearPersonReportMutation, PullClearPersonReportMutationVariables>(PullClearPersonReportDocument, options);
      }
export type PullClearPersonReportMutationHookResult = ReturnType<typeof usePullClearPersonReportMutation>;
export type PullClearPersonReportMutationResult = Apollo.MutationResult<PullClearPersonReportMutation>;
export type PullClearPersonReportMutationOptions = Apollo.BaseMutationOptions<PullClearPersonReportMutation, PullClearPersonReportMutationVariables>;
export const ClearExternalServicesDocument = gql`
    query clearExternalServices {
  activeExternalServices {
    id
    name
    type
    description
    logo
    company {
      id
      legalName
      dba
      logo
    }
  }
}
    `;

/**
 * __useClearExternalServicesQuery__
 *
 * To run a query within a React component, call `useClearExternalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClearExternalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClearExternalServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClearExternalServicesQuery(baseOptions?: Apollo.QueryHookOptions<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>(ClearExternalServicesDocument, options);
      }
export function useClearExternalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>(ClearExternalServicesDocument, options);
        }
// @ts-ignore
export function useClearExternalServicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>;
export function useClearExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>): Apollo.UseSuspenseQueryResult<ClearExternalServicesQuery | undefined, ClearExternalServicesQueryVariables>;
export function useClearExternalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>(ClearExternalServicesDocument, options);
        }
export type ClearExternalServicesQueryHookResult = ReturnType<typeof useClearExternalServicesQuery>;
export type ClearExternalServicesLazyQueryHookResult = ReturnType<typeof useClearExternalServicesLazyQuery>;
export type ClearExternalServicesSuspenseQueryHookResult = ReturnType<typeof useClearExternalServicesSuspenseQuery>;
export type ClearExternalServicesQueryResult = Apollo.QueryResult<ClearExternalServicesQuery, ClearExternalServicesQueryVariables>;
export const SaveFeeDocument = gql`
    mutation saveFee($id: ID!, $mcaId: ID!, $fee: FeeDto!) {
  saveFee(id: $id, mcaId: $mcaId, fee: $fee) {
    id
  }
}
    `;
export type SaveFeeMutationFn = Apollo.MutationFunction<SaveFeeMutation, SaveFeeMutationVariables>;

/**
 * __useSaveFeeMutation__
 *
 * To run a mutation, you first call `useSaveFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFeeMutation, { data, loading, error }] = useSaveFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *      fee: // value for 'fee'
 *   },
 * });
 */
export function useSaveFeeMutation(baseOptions?: Apollo.MutationHookOptions<SaveFeeMutation, SaveFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFeeMutation, SaveFeeMutationVariables>(SaveFeeDocument, options);
      }
export type SaveFeeMutationHookResult = ReturnType<typeof useSaveFeeMutation>;
export type SaveFeeMutationResult = Apollo.MutationResult<SaveFeeMutation>;
export type SaveFeeMutationOptions = Apollo.BaseMutationOptions<SaveFeeMutation, SaveFeeMutationVariables>;
export const SaveFeesDocument = gql`
    mutation saveFees($mcaId: ID!, $fees: [FeeDto!]!) {
  saveFees(mcaId: $mcaId, fees: $fees) {
    id
  }
}
    `;
export type SaveFeesMutationFn = Apollo.MutationFunction<SaveFeesMutation, SaveFeesMutationVariables>;

/**
 * __useSaveFeesMutation__
 *
 * To run a mutation, you first call `useSaveFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFeesMutation, { data, loading, error }] = useSaveFeesMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      fees: // value for 'fees'
 *   },
 * });
 */
export function useSaveFeesMutation(baseOptions?: Apollo.MutationHookOptions<SaveFeesMutation, SaveFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFeesMutation, SaveFeesMutationVariables>(SaveFeesDocument, options);
      }
export type SaveFeesMutationHookResult = ReturnType<typeof useSaveFeesMutation>;
export type SaveFeesMutationResult = Apollo.MutationResult<SaveFeesMutation>;
export type SaveFeesMutationOptions = Apollo.BaseMutationOptions<SaveFeesMutation, SaveFeesMutationVariables>;
export const DeleteFeeDocument = gql`
    mutation deleteFee($id: ID!, $mcaId: ID!) {
  deleteFee(id: $id, mcaId: $mcaId)
}
    `;
export type DeleteFeeMutationFn = Apollo.MutationFunction<DeleteFeeMutation, DeleteFeeMutationVariables>;

/**
 * __useDeleteFeeMutation__
 *
 * To run a mutation, you first call `useDeleteFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeeMutation, { data, loading, error }] = useDeleteFeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useDeleteFeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeeMutation, DeleteFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeeMutation, DeleteFeeMutationVariables>(DeleteFeeDocument, options);
      }
export type DeleteFeeMutationHookResult = ReturnType<typeof useDeleteFeeMutation>;
export type DeleteFeeMutationResult = Apollo.MutationResult<DeleteFeeMutation>;
export type DeleteFeeMutationOptions = Apollo.BaseMutationOptions<DeleteFeeMutation, DeleteFeeMutationVariables>;
export const FinesByMcaIdDocument = gql`
    query finesByMcaId($mcaId: ID!) {
  finesByMcaId(mcaId: $mcaId) {
    id
    comment
    amount
    config {
      name
      id
    }
    status
    transactionId
    createdAt
    modifiedAt
    status
    modifiedBy {
      id
      name
      role
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
  }
}
    `;

/**
 * __useFinesByMcaIdQuery__
 *
 * To run a query within a React component, call `useFinesByMcaIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinesByMcaIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinesByMcaIdQuery({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useFinesByMcaIdQuery(baseOptions: Apollo.QueryHookOptions<FinesByMcaIdQuery, FinesByMcaIdQueryVariables> & ({ variables: FinesByMcaIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>(FinesByMcaIdDocument, options);
      }
export function useFinesByMcaIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>(FinesByMcaIdDocument, options);
        }
// @ts-ignore
export function useFinesByMcaIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>): Apollo.UseSuspenseQueryResult<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>;
export function useFinesByMcaIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>): Apollo.UseSuspenseQueryResult<FinesByMcaIdQuery | undefined, FinesByMcaIdQueryVariables>;
export function useFinesByMcaIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>(FinesByMcaIdDocument, options);
        }
export type FinesByMcaIdQueryHookResult = ReturnType<typeof useFinesByMcaIdQuery>;
export type FinesByMcaIdLazyQueryHookResult = ReturnType<typeof useFinesByMcaIdLazyQuery>;
export type FinesByMcaIdSuspenseQueryHookResult = ReturnType<typeof useFinesByMcaIdSuspenseQuery>;
export type FinesByMcaIdQueryResult = Apollo.QueryResult<FinesByMcaIdQuery, FinesByMcaIdQueryVariables>;
export const SaveFineDocument = gql`
    mutation saveFine($id: ID!, $mcaId: ID!, $fine: FineDto!) {
  saveFine(id: $id, mcaId: $mcaId, fine: $fine) {
    id
  }
}
    `;
export type SaveFineMutationFn = Apollo.MutationFunction<SaveFineMutation, SaveFineMutationVariables>;

/**
 * __useSaveFineMutation__
 *
 * To run a mutation, you first call `useSaveFineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFineMutation, { data, loading, error }] = useSaveFineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *      fine: // value for 'fine'
 *   },
 * });
 */
export function useSaveFineMutation(baseOptions?: Apollo.MutationHookOptions<SaveFineMutation, SaveFineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFineMutation, SaveFineMutationVariables>(SaveFineDocument, options);
      }
export type SaveFineMutationHookResult = ReturnType<typeof useSaveFineMutation>;
export type SaveFineMutationResult = Apollo.MutationResult<SaveFineMutation>;
export type SaveFineMutationOptions = Apollo.BaseMutationOptions<SaveFineMutation, SaveFineMutationVariables>;
export const SaveFinesDocument = gql`
    mutation saveFines($mcaId: ID!, $fines: [FineDto!]!) {
  saveFines(mcaId: $mcaId, fines: $fines) {
    id
  }
}
    `;
export type SaveFinesMutationFn = Apollo.MutationFunction<SaveFinesMutation, SaveFinesMutationVariables>;

/**
 * __useSaveFinesMutation__
 *
 * To run a mutation, you first call `useSaveFinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFinesMutation, { data, loading, error }] = useSaveFinesMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      fines: // value for 'fines'
 *   },
 * });
 */
export function useSaveFinesMutation(baseOptions?: Apollo.MutationHookOptions<SaveFinesMutation, SaveFinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFinesMutation, SaveFinesMutationVariables>(SaveFinesDocument, options);
      }
export type SaveFinesMutationHookResult = ReturnType<typeof useSaveFinesMutation>;
export type SaveFinesMutationResult = Apollo.MutationResult<SaveFinesMutation>;
export type SaveFinesMutationOptions = Apollo.BaseMutationOptions<SaveFinesMutation, SaveFinesMutationVariables>;
export const DeleteFineDocument = gql`
    mutation deleteFine($id: ID!, $mcaId: ID!) {
  deleteFine(id: $id, mcaId: $mcaId)
}
    `;
export type DeleteFineMutationFn = Apollo.MutationFunction<DeleteFineMutation, DeleteFineMutationVariables>;

/**
 * __useDeleteFineMutation__
 *
 * To run a mutation, you first call `useDeleteFineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFineMutation, { data, loading, error }] = useDeleteFineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useDeleteFineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFineMutation, DeleteFineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFineMutation, DeleteFineMutationVariables>(DeleteFineDocument, options);
      }
export type DeleteFineMutationHookResult = ReturnType<typeof useDeleteFineMutation>;
export type DeleteFineMutationResult = Apollo.MutationResult<DeleteFineMutation>;
export type DeleteFineMutationOptions = Apollo.BaseMutationOptions<DeleteFineMutation, DeleteFineMutationVariables>;
export const IntegrationsDocument = gql`
    query integrations {
  integrations {
    data {
      id
      name
      type
      environment
      description
      schedule
      autostart
      logo
      company {
        id
        legalName
        dba
        logo
      }
      secret {
        ... on SecretDevNull {
          zero
        }
        ... on SecretGoAch {
          apikey
          vendorName
        }
        ... on SecretAchProc {
          apikey
          username
          password
          customerInfoKey
        }
        ... on SecretClearAchBot {
          apikey
          username
          password
          companyId
        }
        ... on SecretGoAchBot {
          username
          password
          originatorId
          originatorAccountId
        }
        ... on SecretLiftoffCard {
          bankAccountId
          username
          password
        }
      }
      settings {
        loadTransactionsForLastDays
        colorCode
        hideFromChart
        enableRefresh
      }
      lastRefreshResult {
        lastImportedTransactionsDate
        lastImportedTransactionsStats {
          imported
          deleted
          updated
          inserted
        }
      }
      createdAt
      modifiedAt
      createdBy {
        id
        name
      }
      modifiedBy {
        id
        name
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useIntegrationsQuery__
 *
 * To run a query within a React component, call `useIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
      }
export function useIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
// @ts-ignore
export function useIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export function useIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationsQuery | undefined, IntegrationsQueryVariables>;
export function useIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationsQuery, IntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationsQuery, IntegrationsQueryVariables>(IntegrationsDocument, options);
        }
export type IntegrationsQueryHookResult = ReturnType<typeof useIntegrationsQuery>;
export type IntegrationsLazyQueryHookResult = ReturnType<typeof useIntegrationsLazyQuery>;
export type IntegrationsSuspenseQueryHookResult = ReturnType<typeof useIntegrationsSuspenseQuery>;
export type IntegrationsQueryResult = Apollo.QueryResult<IntegrationsQuery, IntegrationsQueryVariables>;
export const IntegrationDocument = gql`
    query integration($id: ID!) {
  integration(id: $id) {
    id
    name
    type
    environment
    description
    schedule
    autostart
    logo
    company {
      id
      legalName
      dba
      logo
    }
    secret {
      ... on SecretDevNull {
        zero
      }
      ... on SecretGoAch {
        apikey
        vendorName
      }
      ... on SecretAchProc {
        apikey
        username
        password
        customerInfoKey
      }
      ... on SecretClearAchBot {
        apikey
        username
        password
        companyId
      }
      ... on SecretGoAchBot {
        username
        password
        originatorId
        originatorAccountId
      }
      ... on SecretLiftoffCard {
        bankAccountId
        username
        password
      }
    }
    settings {
      loadTransactionsForLastDays
      colorCode
      hideFromChart
      enableRefresh
    }
    lastRefreshResult {
      lastImportedTransactionsDate
      lastImportedTransactionsStats {
        imported
        deleted
        updated
        inserted
      }
    }
  }
}
    `;

/**
 * __useIntegrationQuery__
 *
 * To run a query within a React component, call `useIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationQuery(baseOptions: Apollo.QueryHookOptions<IntegrationQuery, IntegrationQueryVariables> & ({ variables: IntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
      }
export function useIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
        }
// @ts-ignore
export function useIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationQuery, IntegrationQueryVariables>;
export function useIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationQuery | undefined, IntegrationQueryVariables>;
export function useIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationQuery, IntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationQuery, IntegrationQueryVariables>(IntegrationDocument, options);
        }
export type IntegrationQueryHookResult = ReturnType<typeof useIntegrationQuery>;
export type IntegrationLazyQueryHookResult = ReturnType<typeof useIntegrationLazyQuery>;
export type IntegrationSuspenseQueryHookResult = ReturnType<typeof useIntegrationSuspenseQuery>;
export type IntegrationQueryResult = Apollo.QueryResult<IntegrationQuery, IntegrationQueryVariables>;
export const UpdateAutoStartDocument = gql`
    mutation updateAutoStart($id: ID!, $autostart: Boolean = true) {
  updateAutoStart(id: $id, autostart: $autostart) {
    id
    autostart
  }
}
    `;
export type UpdateAutoStartMutationFn = Apollo.MutationFunction<UpdateAutoStartMutation, UpdateAutoStartMutationVariables>;

/**
 * __useUpdateAutoStartMutation__
 *
 * To run a mutation, you first call `useUpdateAutoStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutoStartMutation, { data, loading, error }] = useUpdateAutoStartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      autostart: // value for 'autostart'
 *   },
 * });
 */
export function useUpdateAutoStartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutoStartMutation, UpdateAutoStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutoStartMutation, UpdateAutoStartMutationVariables>(UpdateAutoStartDocument, options);
      }
export type UpdateAutoStartMutationHookResult = ReturnType<typeof useUpdateAutoStartMutation>;
export type UpdateAutoStartMutationResult = Apollo.MutationResult<UpdateAutoStartMutation>;
export type UpdateAutoStartMutationOptions = Apollo.BaseMutationOptions<UpdateAutoStartMutation, UpdateAutoStartMutationVariables>;
export const SaveIntegrationDocument = gql`
    mutation saveIntegration($dto: IntegrationDto!) {
  saveIntegration(integration: $dto) {
    id
    name
    type
    environment
    description
    schedule
    autostart
    logo
    company {
      id
      legalName
      dba
      logo
    }
    secret {
      ... on SecretDevNull {
        zero
      }
      ... on SecretGoAch {
        apikey
        vendorName
      }
      ... on SecretAchProc {
        apikey
        username
        password
        customerInfoKey
      }
      ... on SecretClearAchBot {
        apikey
        username
        password
        companyId
      }
      ... on SecretGoAchBot {
        username
        password
        originatorId
        originatorAccountId
      }
      ... on SecretLiftoffCard {
        bankAccountId
        username
        password
      }
    }
    settings {
      loadTransactionsForLastDays
      colorCode
      hideFromChart
      enableRefresh
    }
    lastRefreshResult {
      lastImportedTransactionsDate
      lastImportedTransactionsStats {
        imported
        deleted
        updated
        inserted
      }
    }
  }
}
    `;
export type SaveIntegrationMutationFn = Apollo.MutationFunction<SaveIntegrationMutation, SaveIntegrationMutationVariables>;

/**
 * __useSaveIntegrationMutation__
 *
 * To run a mutation, you first call `useSaveIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveIntegrationMutation, { data, loading, error }] = useSaveIntegrationMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SaveIntegrationMutation, SaveIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveIntegrationMutation, SaveIntegrationMutationVariables>(SaveIntegrationDocument, options);
      }
export type SaveIntegrationMutationHookResult = ReturnType<typeof useSaveIntegrationMutation>;
export type SaveIntegrationMutationResult = Apollo.MutationResult<SaveIntegrationMutation>;
export type SaveIntegrationMutationOptions = Apollo.BaseMutationOptions<SaveIntegrationMutation, SaveIntegrationMutationVariables>;
export const ImportDocument = gql`
    mutation import($integrationId: ID!, $dateStart: DateTime!, $dateEnd: DateTime!) {
  importTransactions(
    integrationId: $integrationId
    dateStart: $dateStart
    dateEnd: $dateEnd
  ) {
    account
    amount
    depositDate
    effectiveDate
    externalId
    name
    notes
    originationDate
    returnCode
    returnDate
    status
    to
    type
  }
}
    `;
export type ImportMutationFn = Apollo.MutationFunction<ImportMutation, ImportMutationVariables>;

/**
 * __useImportMutation__
 *
 * To run a mutation, you first call `useImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importMutation, { data, loading, error }] = useImportMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      dateStart: // value for 'dateStart'
 *      dateEnd: // value for 'dateEnd'
 *   },
 * });
 */
export function useImportMutation(baseOptions?: Apollo.MutationHookOptions<ImportMutation, ImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportMutation, ImportMutationVariables>(ImportDocument, options);
      }
export type ImportMutationHookResult = ReturnType<typeof useImportMutation>;
export type ImportMutationResult = Apollo.MutationResult<ImportMutation>;
export type ImportMutationOptions = Apollo.BaseMutationOptions<ImportMutation, ImportMutationVariables>;
export const IntegrationScheduleDocument = gql`
    query integrationSchedule($id: ID!) {
  integrationsSchedule(id: $id) {
    id
    running
    nextDate
  }
}
    `;

/**
 * __useIntegrationScheduleQuery__
 *
 * To run a query within a React component, call `useIntegrationScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationScheduleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrationScheduleQuery(baseOptions: Apollo.QueryHookOptions<IntegrationScheduleQuery, IntegrationScheduleQueryVariables> & ({ variables: IntegrationScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>(IntegrationScheduleDocument, options);
      }
export function useIntegrationScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>(IntegrationScheduleDocument, options);
        }
// @ts-ignore
export function useIntegrationScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>;
export function useIntegrationScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<IntegrationScheduleQuery | undefined, IntegrationScheduleQueryVariables>;
export function useIntegrationScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>(IntegrationScheduleDocument, options);
        }
export type IntegrationScheduleQueryHookResult = ReturnType<typeof useIntegrationScheduleQuery>;
export type IntegrationScheduleLazyQueryHookResult = ReturnType<typeof useIntegrationScheduleLazyQuery>;
export type IntegrationScheduleSuspenseQueryHookResult = ReturnType<typeof useIntegrationScheduleSuspenseQuery>;
export type IntegrationScheduleQueryResult = Apollo.QueryResult<IntegrationScheduleQuery, IntegrationScheduleQueryVariables>;
export const ScheduleIntegrationDocument = gql`
    mutation scheduleIntegration($id: ID!) {
  scheduleIntegration(id: $id)
}
    `;
export type ScheduleIntegrationMutationFn = Apollo.MutationFunction<ScheduleIntegrationMutation, ScheduleIntegrationMutationVariables>;

/**
 * __useScheduleIntegrationMutation__
 *
 * To run a mutation, you first call `useScheduleIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleIntegrationMutation, { data, loading, error }] = useScheduleIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useScheduleIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleIntegrationMutation, ScheduleIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleIntegrationMutation, ScheduleIntegrationMutationVariables>(ScheduleIntegrationDocument, options);
      }
export type ScheduleIntegrationMutationHookResult = ReturnType<typeof useScheduleIntegrationMutation>;
export type ScheduleIntegrationMutationResult = Apollo.MutationResult<ScheduleIntegrationMutation>;
export type ScheduleIntegrationMutationOptions = Apollo.BaseMutationOptions<ScheduleIntegrationMutation, ScheduleIntegrationMutationVariables>;
export const UnscheduleIntegrationDocument = gql`
    mutation unscheduleIntegration($id: ID!) {
  unscheduleIntegration(id: $id)
}
    `;
export type UnscheduleIntegrationMutationFn = Apollo.MutationFunction<UnscheduleIntegrationMutation, UnscheduleIntegrationMutationVariables>;

/**
 * __useUnscheduleIntegrationMutation__
 *
 * To run a mutation, you first call `useUnscheduleIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleIntegrationMutation, { data, loading, error }] = useUnscheduleIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnscheduleIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleIntegrationMutation, UnscheduleIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleIntegrationMutation, UnscheduleIntegrationMutationVariables>(UnscheduleIntegrationDocument, options);
      }
export type UnscheduleIntegrationMutationHookResult = ReturnType<typeof useUnscheduleIntegrationMutation>;
export type UnscheduleIntegrationMutationResult = Apollo.MutationResult<UnscheduleIntegrationMutation>;
export type UnscheduleIntegrationMutationOptions = Apollo.BaseMutationOptions<UnscheduleIntegrationMutation, UnscheduleIntegrationMutationVariables>;
export const RefreshTransactionsDocument = gql`
    mutation refreshTransactions($integrationId: ID!) {
  refreshTransactions(integrationId: $integrationId) {
    integrationId
    lastImportedTransactionsDate
    lastImportedTransactionsStats {
      imported
      deleted
      updated
      inserted
    }
  }
}
    `;
export type RefreshTransactionsMutationFn = Apollo.MutationFunction<RefreshTransactionsMutation, RefreshTransactionsMutationVariables>;

/**
 * __useRefreshTransactionsMutation__
 *
 * To run a mutation, you first call `useRefreshTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTransactionsMutation, { data, loading, error }] = useRefreshTransactionsMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useRefreshTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTransactionsMutation, RefreshTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTransactionsMutation, RefreshTransactionsMutationVariables>(RefreshTransactionsDocument, options);
      }
export type RefreshTransactionsMutationHookResult = ReturnType<typeof useRefreshTransactionsMutation>;
export type RefreshTransactionsMutationResult = Apollo.MutationResult<RefreshTransactionsMutation>;
export type RefreshTransactionsMutationOptions = Apollo.BaseMutationOptions<RefreshTransactionsMutation, RefreshTransactionsMutationVariables>;
export const RefreshMerchantCashAdvanceTransactionsDocument = gql`
    mutation refreshMerchantCashAdvanceTransactions($mcaId: ID!) {
  refreshMerchantCashAdvanceTransactions(mcaId: $mcaId)
}
    `;
export type RefreshMerchantCashAdvanceTransactionsMutationFn = Apollo.MutationFunction<RefreshMerchantCashAdvanceTransactionsMutation, RefreshMerchantCashAdvanceTransactionsMutationVariables>;

/**
 * __useRefreshMerchantCashAdvanceTransactionsMutation__
 *
 * To run a mutation, you first call `useRefreshMerchantCashAdvanceTransactionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshMerchantCashAdvanceTransactionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshMerchantCashAdvanceTransactionsMutation, { data, loading, error }] = useRefreshMerchantCashAdvanceTransactionsMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useRefreshMerchantCashAdvanceTransactionsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshMerchantCashAdvanceTransactionsMutation, RefreshMerchantCashAdvanceTransactionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshMerchantCashAdvanceTransactionsMutation, RefreshMerchantCashAdvanceTransactionsMutationVariables>(RefreshMerchantCashAdvanceTransactionsDocument, options);
      }
export type RefreshMerchantCashAdvanceTransactionsMutationHookResult = ReturnType<typeof useRefreshMerchantCashAdvanceTransactionsMutation>;
export type RefreshMerchantCashAdvanceTransactionsMutationResult = Apollo.MutationResult<RefreshMerchantCashAdvanceTransactionsMutation>;
export type RefreshMerchantCashAdvanceTransactionsMutationOptions = Apollo.BaseMutationOptions<RefreshMerchantCashAdvanceTransactionsMutation, RefreshMerchantCashAdvanceTransactionsMutationVariables>;
export const LookupScheduleDocument = gql`
    query lookupSchedule($integrationId: ID!, $external: String!) {
  lookupSchedule(integrationId: $integrationId, external: $external) {
    isStopped
    isPaused
    isActive
    name
    description
    startDate
    accountNumber
    routingNumber
    amount
    totalAmount
    processorReference
  }
}
    `;

/**
 * __useLookupScheduleQuery__
 *
 * To run a query within a React component, call `useLookupScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLookupScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLookupScheduleQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      external: // value for 'external'
 *   },
 * });
 */
export function useLookupScheduleQuery(baseOptions: Apollo.QueryHookOptions<LookupScheduleQuery, LookupScheduleQueryVariables> & ({ variables: LookupScheduleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LookupScheduleQuery, LookupScheduleQueryVariables>(LookupScheduleDocument, options);
      }
export function useLookupScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LookupScheduleQuery, LookupScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LookupScheduleQuery, LookupScheduleQueryVariables>(LookupScheduleDocument, options);
        }
// @ts-ignore
export function useLookupScheduleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LookupScheduleQuery, LookupScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<LookupScheduleQuery, LookupScheduleQueryVariables>;
export function useLookupScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LookupScheduleQuery, LookupScheduleQueryVariables>): Apollo.UseSuspenseQueryResult<LookupScheduleQuery | undefined, LookupScheduleQueryVariables>;
export function useLookupScheduleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LookupScheduleQuery, LookupScheduleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LookupScheduleQuery, LookupScheduleQueryVariables>(LookupScheduleDocument, options);
        }
export type LookupScheduleQueryHookResult = ReturnType<typeof useLookupScheduleQuery>;
export type LookupScheduleLazyQueryHookResult = ReturnType<typeof useLookupScheduleLazyQuery>;
export type LookupScheduleSuspenseQueryHookResult = ReturnType<typeof useLookupScheduleSuspenseQuery>;
export type LookupScheduleQueryResult = Apollo.QueryResult<LookupScheduleQuery, LookupScheduleQueryVariables>;
export const AvailableIntegrationsDocument = gql`
    query availableIntegrations {
  availableIntegrations
}
    `;

/**
 * __useAvailableIntegrationsQuery__
 *
 * To run a query within a React component, call `useAvailableIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
      }
export function useAvailableIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
        }
// @ts-ignore
export function useAvailableIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>;
export function useAvailableIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<AvailableIntegrationsQuery | undefined, AvailableIntegrationsQueryVariables>;
export function useAvailableIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>(AvailableIntegrationsDocument, options);
        }
export type AvailableIntegrationsQueryHookResult = ReturnType<typeof useAvailableIntegrationsQuery>;
export type AvailableIntegrationsLazyQueryHookResult = ReturnType<typeof useAvailableIntegrationsLazyQuery>;
export type AvailableIntegrationsSuspenseQueryHookResult = ReturnType<typeof useAvailableIntegrationsSuspenseQuery>;
export type AvailableIntegrationsQueryResult = Apollo.QueryResult<AvailableIntegrationsQuery, AvailableIntegrationsQueryVariables>;
export const MerchantCashAdvanceStatusHistoryDocument = gql`
    query merchantCashAdvanceStatusHistory($id: ID!) {
  merchantCashAdvanceStatusHistory(id: $id) {
    fromStatus
    toStatus
    user {
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
    createdAt
    reason
  }
}
    `;

/**
 * __useMerchantCashAdvanceStatusHistoryQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvanceStatusHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvanceStatusHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvanceStatusHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantCashAdvanceStatusHistoryQuery(baseOptions: Apollo.QueryHookOptions<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables> & ({ variables: MerchantCashAdvanceStatusHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>(MerchantCashAdvanceStatusHistoryDocument, options);
      }
export function useMerchantCashAdvanceStatusHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>(MerchantCashAdvanceStatusHistoryDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvanceStatusHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>;
export function useMerchantCashAdvanceStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceStatusHistoryQuery | undefined, MerchantCashAdvanceStatusHistoryQueryVariables>;
export function useMerchantCashAdvanceStatusHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>(MerchantCashAdvanceStatusHistoryDocument, options);
        }
export type MerchantCashAdvanceStatusHistoryQueryHookResult = ReturnType<typeof useMerchantCashAdvanceStatusHistoryQuery>;
export type MerchantCashAdvanceStatusHistoryLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvanceStatusHistoryLazyQuery>;
export type MerchantCashAdvanceStatusHistorySuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvanceStatusHistorySuspenseQuery>;
export type MerchantCashAdvanceStatusHistoryQueryResult = Apollo.QueryResult<MerchantCashAdvanceStatusHistoryQuery, MerchantCashAdvanceStatusHistoryQueryVariables>;
export const MerchantCashAdvancesPreAggregatedDocument = gql`
    query merchantCashAdvancesPreAggregated($offset: Int = 0, $limit: Int = 10, $search: String, $dateFrom: Date, $dateTo: Date, $fundingDateFrom: Date, $fundingDateTo: Date, $status: [MerchantCashAdvanceStatus!], $merchatId: ID = null, $investorId: ID = null, $funderIds: [ID!], $sortArgs: [SortArgs!] = []) {
  merchantCashAdvancesPreAggregated(
    offset: $offset
    limit: $limit
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    fundingDateFrom: $fundingDateFrom
    fundingDateTo: $fundingDateTo
    status: $status
    merchantId: $merchatId
    investorId: $investorId
    funderIds: $funderIds
    sortArgs: $sortArgs
  ) {
    data {
      id
      number
      merchant {
        id
        legalName
        dba
        logo
        phone
        email
        logo
        www
        linkToFiles
        taxId
      }
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      funder {
        id
        code
        name
        logo
      }
      broker {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        company {
          id
          legalName
          dba
          type
          logo
          email
          phone
        }
      }
      legal {
        id
        name
        email
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        company {
          id
          email
          phone
          legalName
          dba
          type
          logo
        }
      }
      manager {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      company {
        id
        legalName
        dba
        logo
      }
      syndications {
        userId
        amount
        type
        calculationType
        brkCommissionPercentage
        isoCommissionPercentage
        orgFeeCommissionPercentage
        serviceFeePercentage
        wireFee
        crmFee
        otherFee
        syndicationPercentage
      }
      fundingFee {
        id
        comment
        amount
        config {
          id
          name
          isPercentage
        }
      }
      commissions {
        id
        comment
        isPaid
        amount
        config {
          id
          name
          isPercentage
        }
      }
      recurrencies {
        id
        amount
        routingNumber
        accountNumber
        startDate
        term
        referenceMca
        referenceRecurrence
        recurrenceNumber
        stateNotes
        state
      }
      secondaryFunders {
        id
        code
        name
        logo
      }
      externalConnections {
        id
        mcaId
        isActive
        configuration
        externalServiceConfiguration {
          id
          name
          type
          createdAt
          logo
          company {
            id
            legalName
            dba
            logo
          }
        }
      }
      status
      position
      referenceMca
      amount
      payback
      paybackWFee
      createdAt
      modifiedAt
      factorRate
      term
      displayAttributes
      refis {
        id
        number
        referenceMca
        pendingBalance
        totalFees
        clearedBalance
        type
        merchantId
        merchantLogo
        merchantLegalName
        amount
      }
      commissionPercentage
      startDate
      fundingDate
      endDate
      routingNumber
      accountNumber
      amtpaidclr
      amtpaidpnd
      balanceclr
      npt
      nft
      pmt
      nrt
      perfTerm
      perfEndDate
      completion
      currentUserRights
      statusManagementType
      statusChangedAt
      balanceClrWFees
      balancePnd
      balancePndWFees
      totalfees
      totalfines
      totalclrfines
      payoff
      netWire
      pnlNet
      pnlGross
      lastPmtDay
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useMerchantCashAdvancesPreAggregatedQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvancesPreAggregatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvancesPreAggregatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvancesPreAggregatedQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      fundingDateFrom: // value for 'fundingDateFrom'
 *      fundingDateTo: // value for 'fundingDateTo'
 *      status: // value for 'status'
 *      merchatId: // value for 'merchatId'
 *      investorId: // value for 'investorId'
 *      funderIds: // value for 'funderIds'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useMerchantCashAdvancesPreAggregatedQuery(baseOptions?: Apollo.QueryHookOptions<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>(MerchantCashAdvancesPreAggregatedDocument, options);
      }
export function useMerchantCashAdvancesPreAggregatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>(MerchantCashAdvancesPreAggregatedDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvancesPreAggregatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>;
export function useMerchantCashAdvancesPreAggregatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvancesPreAggregatedQuery | undefined, MerchantCashAdvancesPreAggregatedQueryVariables>;
export function useMerchantCashAdvancesPreAggregatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>(MerchantCashAdvancesPreAggregatedDocument, options);
        }
export type MerchantCashAdvancesPreAggregatedQueryHookResult = ReturnType<typeof useMerchantCashAdvancesPreAggregatedQuery>;
export type MerchantCashAdvancesPreAggregatedLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvancesPreAggregatedLazyQuery>;
export type MerchantCashAdvancesPreAggregatedSuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvancesPreAggregatedSuspenseQuery>;
export type MerchantCashAdvancesPreAggregatedQueryResult = Apollo.QueryResult<MerchantCashAdvancesPreAggregatedQuery, MerchantCashAdvancesPreAggregatedQueryVariables>;
export const MerchantCashAdvancesDocument = gql`
    query merchantCashAdvances($offset: Int = 0, $limit: Int = 10, $search: String, $status: [MerchantCashAdvanceStatus!], $merchatId: ID = null, $sortArgs: [SortArgs!] = []) {
  merchantCashAdvances(
    offset: $offset
    limit: $limit
    search: $search
    status: $status
    merchantId: $merchatId
    sortArgs: $sortArgs
  ) {
    data {
      id
      number
      merchant {
        id
        legalName
        dba
        logo
        linkToFiles
      }
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      funder {
        id
        code
        name
        logo
      }
      broker {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      manager {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      company {
        id
        legalName
        dba
        logo
      }
      syndications {
        userId
        amount
        type
        calculationType
        brkCommissionPercentage
        isoCommissionPercentage
        orgFeeCommissionPercentage
        serviceFeePercentage
        wireFee
        crmFee
        otherFee
        syndicationPercentage
      }
      status
      position
      referenceMca
      amount
      payback
      createdAt
      modifiedAt
      factorRate
      term
      displayAttributes
      commissionPercentage
      startDate
      fundingDate
      endDate
      routingNumber
      accountNumber
      amtpaidclr
      amtpaidpnd
      balanceclr
      npt
      nft
      pmt
      nrt
      perfTerm
      perfEndDate
      fundingFee {
        id
        comment
        amount
        config {
          id
          name
          isPercentage
        }
      }
      commissions {
        id
        comment
        isPaid
        amount
        config {
          id
          name
          isPercentage
        }
      }
      refis {
        id
        number
        pendingBalance
        totalFees
        clearedBalance
        type
        merchantId
        merchantLogo
        merchantLegalName
        amount
      }
      completion
      createdBy {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      modifiedBy {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      currentUserRights
      recurrencies {
        id
        integration {
          id
          name
          logo
          type
          autostart
          company {
            id
            legalName
            dba
            logo
          }
        }
        amount
        routingNumber
        accountNumber
        startDate
        term
        referenceMca
        referenceRecurrence
        state
      }
      statusManagementType
      statusChangedAt
      balanceClrWFees
      balancePnd
      balancePndWFees
      totalfees
      totalfines
      totalclrfines
      pnlNet
      pnlGross
      netWire
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useMerchantCashAdvancesQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvancesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      merchatId: // value for 'merchatId'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useMerchantCashAdvancesQuery(baseOptions?: Apollo.QueryHookOptions<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>(MerchantCashAdvancesDocument, options);
      }
export function useMerchantCashAdvancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>(MerchantCashAdvancesDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>;
export function useMerchantCashAdvancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvancesQuery | undefined, MerchantCashAdvancesQueryVariables>;
export function useMerchantCashAdvancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>(MerchantCashAdvancesDocument, options);
        }
export type MerchantCashAdvancesQueryHookResult = ReturnType<typeof useMerchantCashAdvancesQuery>;
export type MerchantCashAdvancesLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvancesLazyQuery>;
export type MerchantCashAdvancesSuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvancesSuspenseQuery>;
export type MerchantCashAdvancesQueryResult = Apollo.QueryResult<MerchantCashAdvancesQuery, MerchantCashAdvancesQueryVariables>;
export const MerchantCashAdvancesSummaryDocument = gql`
    query merchantCashAdvancesSummary($offset: Int = 0, $limit: Int = 10, $search: String, $dateFrom: Date, $dateTo: Date, $fundingDateFrom: Date, $fundingDateTo: Date, $status: [MerchantCashAdvanceStatus!], $merchatId: ID = null, $investorId: ID = null, $sortArgs: [SortArgs!] = []) {
  merchantCashAdvancesSummary(
    offset: $offset
    limit: $limit
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    fundingDateFrom: $fundingDateFrom
    fundingDateTo: $fundingDateTo
    status: $status
    merchantId: $merchatId
    investorId: $investorId
    sortArgs: $sortArgs
  ) {
    amountSum
    paybackSum
    paybackWFeeSum
    factorRateAvg
    pmtSum
    completionAvg
    amtPaidClrSum
    amtPaidPndSum
    pnlnetSum
    pnlgrossSum
    totalclrfines
    totalPendingPostFundingFeesSum
    totalFeesSum
    payoffSum
    netWireSum
    commissionSum
  }
}
    `;

/**
 * __useMerchantCashAdvancesSummaryQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvancesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvancesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvancesSummaryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      fundingDateFrom: // value for 'fundingDateFrom'
 *      fundingDateTo: // value for 'fundingDateTo'
 *      status: // value for 'status'
 *      merchatId: // value for 'merchatId'
 *      investorId: // value for 'investorId'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useMerchantCashAdvancesSummaryQuery(baseOptions?: Apollo.QueryHookOptions<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>(MerchantCashAdvancesSummaryDocument, options);
      }
export function useMerchantCashAdvancesSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>(MerchantCashAdvancesSummaryDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvancesSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>;
export function useMerchantCashAdvancesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvancesSummaryQuery | undefined, MerchantCashAdvancesSummaryQueryVariables>;
export function useMerchantCashAdvancesSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>(MerchantCashAdvancesSummaryDocument, options);
        }
export type MerchantCashAdvancesSummaryQueryHookResult = ReturnType<typeof useMerchantCashAdvancesSummaryQuery>;
export type MerchantCashAdvancesSummaryLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvancesSummaryLazyQuery>;
export type MerchantCashAdvancesSummarySuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvancesSummarySuspenseQuery>;
export type MerchantCashAdvancesSummaryQueryResult = Apollo.QueryResult<MerchantCashAdvancesSummaryQuery, MerchantCashAdvancesSummaryQueryVariables>;
export const MerchantCashAdvanceDocument = gql`
    query merchantCashAdvance($id: ID!) {
  merchantCashAdvance(id: $id) {
    id
    number
    merchant {
      id
      legalName
      dba
      phone
      email
      taxId
      logo
      www
      linkToFiles
    }
    integration {
      id
      name
      logo
      type
      autostart
      company {
        id
        legalName
        dba
        logo
      }
    }
    funder {
      id
      code
      name
      logo
    }
    secondaryFunders {
      id
      code
      name
      logo
    }
    company {
      id
      legalName
      dba
      logo
    }
    syndications {
      userId
      amount
      type
      calculationType
      brkCommissionPercentage
      isoCommissionPercentage
      orgFeeCommissionPercentage
      serviceFeePercentage
      wireFee
      crmFee
      otherFee
      syndicationPercentage
    }
    broker {
      id
      name
      email
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
      company {
        id
        email
        phone
        legalName
        dba
        type
        logo
      }
    }
    legal {
      id
      name
      email
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
      company {
        id
        email
        phone
        legalName
        dba
        type
        logo
      }
    }
    manager {
      id
      name
      email
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
    }
    externalConnections {
      id
      mcaId
      isActive
      configuration
      externalServiceConfiguration {
        id
        name
        type
        createdAt
        logo
      }
    }
    status
    position
    referenceMca
    amount
    payback
    paybackWFee
    createdAt
    modifiedAt
    factorRate
    term
    commissionPercentage
    startDate
    fundingDate
    endDate
    routingNumber
    accountNumber
    displayAttributes
    numberOfFeeTransactions
    numberOfInvestorTransactions
    amtpaidclr
    amtpaidpnd
    balanceclr
    npt
    nft
    nrt
    pmt
    perfTerm
    perfEndDate
    fundingFee {
      id
      comment
      amount
      createdAt
      modifiedAt
      config {
        id
        name
        isPercentage
      }
    }
    commissions {
      id
      comment
      amount
      isPaid
      config {
        id
        name
        isPercentage
      }
    }
    refis {
      id
      number
      pendingBalance
      totalFees
      clearedBalance
      type
      merchantId
      merchantLogo
      merchantLegalName
      amount
    }
    completion
    currentUserRights
    recurrencies {
      id
      integration {
        id
        name
        logo
        type
        autostart
        company {
          id
          legalName
          dba
          logo
        }
      }
      amount
      routingNumber
      accountNumber
      startDate
      term
      referenceMca
      referenceRecurrence
      recurrenceNumber
      stateNotes
      state
    }
    statusManagementType
    statusChangedAt
    balanceClrWFees
    balancePnd
    balancePndWFees
    totalfees
    totalfines
    totalclrfines
    totalpendingfines
    pnlNet
    pnlGross
    netWire
    lastPmtDay
  }
}
    `;

/**
 * __useMerchantCashAdvanceQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantCashAdvanceQuery(baseOptions: Apollo.QueryHookOptions<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables> & ({ variables: MerchantCashAdvanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>(MerchantCashAdvanceDocument, options);
      }
export function useMerchantCashAdvanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>(MerchantCashAdvanceDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>;
export function useMerchantCashAdvanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceQuery | undefined, MerchantCashAdvanceQueryVariables>;
export function useMerchantCashAdvanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>(MerchantCashAdvanceDocument, options);
        }
export type MerchantCashAdvanceQueryHookResult = ReturnType<typeof useMerchantCashAdvanceQuery>;
export type MerchantCashAdvanceLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvanceLazyQuery>;
export type MerchantCashAdvanceSuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvanceSuspenseQuery>;
export type MerchantCashAdvanceQueryResult = Apollo.QueryResult<MerchantCashAdvanceQuery, MerchantCashAdvanceQueryVariables>;
export const MerchantCashAdvanceDocumentsDocument = gql`
    query merchantCashAdvanceDocuments($id: ID!) {
  merchantCashAdvance(id: $id) {
    id
    number
    documents {
      id
      documentName
    }
  }
}
    `;

/**
 * __useMerchantCashAdvanceDocumentsQuery__
 *
 * To run a query within a React component, call `useMerchantCashAdvanceDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCashAdvanceDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCashAdvanceDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMerchantCashAdvanceDocumentsQuery(baseOptions: Apollo.QueryHookOptions<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables> & ({ variables: MerchantCashAdvanceDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>(MerchantCashAdvanceDocumentsDocument, options);
      }
export function useMerchantCashAdvanceDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>(MerchantCashAdvanceDocumentsDocument, options);
        }
// @ts-ignore
export function useMerchantCashAdvanceDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>;
export function useMerchantCashAdvanceDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantCashAdvanceDocumentsQuery | undefined, MerchantCashAdvanceDocumentsQueryVariables>;
export function useMerchantCashAdvanceDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>(MerchantCashAdvanceDocumentsDocument, options);
        }
export type MerchantCashAdvanceDocumentsQueryHookResult = ReturnType<typeof useMerchantCashAdvanceDocumentsQuery>;
export type MerchantCashAdvanceDocumentsLazyQueryHookResult = ReturnType<typeof useMerchantCashAdvanceDocumentsLazyQuery>;
export type MerchantCashAdvanceDocumentsSuspenseQueryHookResult = ReturnType<typeof useMerchantCashAdvanceDocumentsSuspenseQuery>;
export type MerchantCashAdvanceDocumentsQueryResult = Apollo.QueryResult<MerchantCashAdvanceDocumentsQuery, MerchantCashAdvanceDocumentsQueryVariables>;
export const SaveMerchantCashAdvanceDocument = gql`
    mutation saveMerchantCashAdvance($merchantId: ID!, $integrationId: ID, $lenderId: ID, $secondaryFunderIds: [ID!], $brokerId: ID, $managerId: ID, $legalId: ID, $dto: MerchantCashAdvanceDto!) {
  saveMerchantCashAdvance(
    merchantId: $merchantId
    integrationId: $integrationId
    lenderId: $lenderId
    secondaryFunderIds: $secondaryFunderIds
    brokerId: $brokerId
    managerId: $managerId
    legalId: $legalId
    mca: $dto
  ) {
    id
    status
    amount
    factorRate
    routingNumber
    accountNumber
    term
    startDate
    fundingDate
    commissionPercentage
    payback
  }
}
    `;
export type SaveMerchantCashAdvanceMutationFn = Apollo.MutationFunction<SaveMerchantCashAdvanceMutation, SaveMerchantCashAdvanceMutationVariables>;

/**
 * __useSaveMerchantCashAdvanceMutation__
 *
 * To run a mutation, you first call `useSaveMerchantCashAdvanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMerchantCashAdvanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMerchantCashAdvanceMutation, { data, loading, error }] = useSaveMerchantCashAdvanceMutation({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *      integrationId: // value for 'integrationId'
 *      lenderId: // value for 'lenderId'
 *      secondaryFunderIds: // value for 'secondaryFunderIds'
 *      brokerId: // value for 'brokerId'
 *      managerId: // value for 'managerId'
 *      legalId: // value for 'legalId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveMerchantCashAdvanceMutation(baseOptions?: Apollo.MutationHookOptions<SaveMerchantCashAdvanceMutation, SaveMerchantCashAdvanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMerchantCashAdvanceMutation, SaveMerchantCashAdvanceMutationVariables>(SaveMerchantCashAdvanceDocument, options);
      }
export type SaveMerchantCashAdvanceMutationHookResult = ReturnType<typeof useSaveMerchantCashAdvanceMutation>;
export type SaveMerchantCashAdvanceMutationResult = Apollo.MutationResult<SaveMerchantCashAdvanceMutation>;
export type SaveMerchantCashAdvanceMutationOptions = Apollo.BaseMutationOptions<SaveMerchantCashAdvanceMutation, SaveMerchantCashAdvanceMutationVariables>;
export const ChangeMerchantCashAdvanceStatusDocument = gql`
    mutation changeMerchantCashAdvanceStatus($mcaId: ID!, $status: MerchantCashAdvanceStatus!) {
  changeMerchantCashAdvanceStatus(mcaId: $mcaId, status: $status)
}
    `;
export type ChangeMerchantCashAdvanceStatusMutationFn = Apollo.MutationFunction<ChangeMerchantCashAdvanceStatusMutation, ChangeMerchantCashAdvanceStatusMutationVariables>;

/**
 * __useChangeMerchantCashAdvanceStatusMutation__
 *
 * To run a mutation, you first call `useChangeMerchantCashAdvanceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMerchantCashAdvanceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMerchantCashAdvanceStatusMutation, { data, loading, error }] = useChangeMerchantCashAdvanceStatusMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useChangeMerchantCashAdvanceStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMerchantCashAdvanceStatusMutation, ChangeMerchantCashAdvanceStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMerchantCashAdvanceStatusMutation, ChangeMerchantCashAdvanceStatusMutationVariables>(ChangeMerchantCashAdvanceStatusDocument, options);
      }
export type ChangeMerchantCashAdvanceStatusMutationHookResult = ReturnType<typeof useChangeMerchantCashAdvanceStatusMutation>;
export type ChangeMerchantCashAdvanceStatusMutationResult = Apollo.MutationResult<ChangeMerchantCashAdvanceStatusMutation>;
export type ChangeMerchantCashAdvanceStatusMutationOptions = Apollo.BaseMutationOptions<ChangeMerchantCashAdvanceStatusMutation, ChangeMerchantCashAdvanceStatusMutationVariables>;
export const ToggleMcaManagementTypeDocument = gql`
    mutation toggleMcaManagementType($mcaId: ID!) {
  toggleMcaManagementType(mcaId: $mcaId)
}
    `;
export type ToggleMcaManagementTypeMutationFn = Apollo.MutationFunction<ToggleMcaManagementTypeMutation, ToggleMcaManagementTypeMutationVariables>;

/**
 * __useToggleMcaManagementTypeMutation__
 *
 * To run a mutation, you first call `useToggleMcaManagementTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMcaManagementTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMcaManagementTypeMutation, { data, loading, error }] = useToggleMcaManagementTypeMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useToggleMcaManagementTypeMutation(baseOptions?: Apollo.MutationHookOptions<ToggleMcaManagementTypeMutation, ToggleMcaManagementTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleMcaManagementTypeMutation, ToggleMcaManagementTypeMutationVariables>(ToggleMcaManagementTypeDocument, options);
      }
export type ToggleMcaManagementTypeMutationHookResult = ReturnType<typeof useToggleMcaManagementTypeMutation>;
export type ToggleMcaManagementTypeMutationResult = Apollo.MutationResult<ToggleMcaManagementTypeMutation>;
export type ToggleMcaManagementTypeMutationOptions = Apollo.BaseMutationOptions<ToggleMcaManagementTypeMutation, ToggleMcaManagementTypeMutationVariables>;
export const MerchantBankAccountsDocument = gql`
    query merchantBankAccounts($merchantId: ID!) {
  merchantBankAccounts(merchantId: $merchantId) {
    id
    routingNumber
    accountNumber
  }
}
    `;

/**
 * __useMerchantBankAccountsQuery__
 *
 * To run a query within a React component, call `useMerchantBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantBankAccountsQuery({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *   },
 * });
 */
export function useMerchantBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables> & ({ variables: MerchantBankAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>(MerchantBankAccountsDocument, options);
      }
export function useMerchantBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>(MerchantBankAccountsDocument, options);
        }
// @ts-ignore
export function useMerchantBankAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>;
export function useMerchantBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MerchantBankAccountsQuery | undefined, MerchantBankAccountsQueryVariables>;
export function useMerchantBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>(MerchantBankAccountsDocument, options);
        }
export type MerchantBankAccountsQueryHookResult = ReturnType<typeof useMerchantBankAccountsQuery>;
export type MerchantBankAccountsLazyQueryHookResult = ReturnType<typeof useMerchantBankAccountsLazyQuery>;
export type MerchantBankAccountsSuspenseQueryHookResult = ReturnType<typeof useMerchantBankAccountsSuspenseQuery>;
export type MerchantBankAccountsQueryResult = Apollo.QueryResult<MerchantBankAccountsQuery, MerchantBankAccountsQueryVariables>;
export const SaveMerchantBankAccountDocument = gql`
    mutation saveMerchantBankAccount($merchantId: ID!, $dto: MerchantBankAccountDto!) {
  saveMerchantBankAccount(merchantId: $merchantId, bankAccount: $dto) {
    id
    routingNumber
    accountNumber
  }
}
    `;
export type SaveMerchantBankAccountMutationFn = Apollo.MutationFunction<SaveMerchantBankAccountMutation, SaveMerchantBankAccountMutationVariables>;

/**
 * __useSaveMerchantBankAccountMutation__
 *
 * To run a mutation, you first call `useSaveMerchantBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMerchantBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMerchantBankAccountMutation, { data, loading, error }] = useSaveMerchantBankAccountMutation({
 *   variables: {
 *      merchantId: // value for 'merchantId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveMerchantBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<SaveMerchantBankAccountMutation, SaveMerchantBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMerchantBankAccountMutation, SaveMerchantBankAccountMutationVariables>(SaveMerchantBankAccountDocument, options);
      }
export type SaveMerchantBankAccountMutationHookResult = ReturnType<typeof useSaveMerchantBankAccountMutation>;
export type SaveMerchantBankAccountMutationResult = Apollo.MutationResult<SaveMerchantBankAccountMutation>;
export type SaveMerchantBankAccountMutationOptions = Apollo.BaseMutationOptions<SaveMerchantBankAccountMutation, SaveMerchantBankAccountMutationVariables>;
export const DeleteMerchantBankAccountDocument = gql`
    mutation deleteMerchantBankAccount($id: ID!) {
  deleteMerchantBankAccount(id: $id)
}
    `;
export type DeleteMerchantBankAccountMutationFn = Apollo.MutationFunction<DeleteMerchantBankAccountMutation, DeleteMerchantBankAccountMutationVariables>;

/**
 * __useDeleteMerchantBankAccountMutation__
 *
 * To run a mutation, you first call `useDeleteMerchantBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMerchantBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMerchantBankAccountMutation, { data, loading, error }] = useDeleteMerchantBankAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMerchantBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMerchantBankAccountMutation, DeleteMerchantBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMerchantBankAccountMutation, DeleteMerchantBankAccountMutationVariables>(DeleteMerchantBankAccountDocument, options);
      }
export type DeleteMerchantBankAccountMutationHookResult = ReturnType<typeof useDeleteMerchantBankAccountMutation>;
export type DeleteMerchantBankAccountMutationResult = Apollo.MutationResult<DeleteMerchantBankAccountMutation>;
export type DeleteMerchantBankAccountMutationOptions = Apollo.BaseMutationOptions<DeleteMerchantBankAccountMutation, DeleteMerchantBankAccountMutationVariables>;
export const CountTodayMcasDocument = gql`
    query countTodayMcas {
  countTodayMCAs
}
    `;

/**
 * __useCountTodayMcasQuery__
 *
 * To run a query within a React component, call `useCountTodayMcasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountTodayMcasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountTodayMcasQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountTodayMcasQuery(baseOptions?: Apollo.QueryHookOptions<CountTodayMcasQuery, CountTodayMcasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountTodayMcasQuery, CountTodayMcasQueryVariables>(CountTodayMcasDocument, options);
      }
export function useCountTodayMcasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountTodayMcasQuery, CountTodayMcasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountTodayMcasQuery, CountTodayMcasQueryVariables>(CountTodayMcasDocument, options);
        }
// @ts-ignore
export function useCountTodayMcasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountTodayMcasQuery, CountTodayMcasQueryVariables>): Apollo.UseSuspenseQueryResult<CountTodayMcasQuery, CountTodayMcasQueryVariables>;
export function useCountTodayMcasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTodayMcasQuery, CountTodayMcasQueryVariables>): Apollo.UseSuspenseQueryResult<CountTodayMcasQuery | undefined, CountTodayMcasQueryVariables>;
export function useCountTodayMcasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountTodayMcasQuery, CountTodayMcasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountTodayMcasQuery, CountTodayMcasQueryVariables>(CountTodayMcasDocument, options);
        }
export type CountTodayMcasQueryHookResult = ReturnType<typeof useCountTodayMcasQuery>;
export type CountTodayMcasLazyQueryHookResult = ReturnType<typeof useCountTodayMcasLazyQuery>;
export type CountTodayMcasSuspenseQueryHookResult = ReturnType<typeof useCountTodayMcasSuspenseQuery>;
export type CountTodayMcasQueryResult = Apollo.QueryResult<CountTodayMcasQuery, CountTodayMcasQueryVariables>;
export const GetMerchantCashAdvanceDocument = gql`
    query GetMerchantCashAdvance($id: ID!) {
  merchantCashAdvance(id: $id) {
    documents {
      id
      documentName
    }
  }
}
    `;

/**
 * __useGetMerchantCashAdvanceQuery__
 *
 * To run a query within a React component, call `useGetMerchantCashAdvanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMerchantCashAdvanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMerchantCashAdvanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMerchantCashAdvanceQuery(baseOptions: Apollo.QueryHookOptions<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables> & ({ variables: GetMerchantCashAdvanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>(GetMerchantCashAdvanceDocument, options);
      }
export function useGetMerchantCashAdvanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>(GetMerchantCashAdvanceDocument, options);
        }
// @ts-ignore
export function useGetMerchantCashAdvanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>;
export function useGetMerchantCashAdvanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetMerchantCashAdvanceQuery | undefined, GetMerchantCashAdvanceQueryVariables>;
export function useGetMerchantCashAdvanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>(GetMerchantCashAdvanceDocument, options);
        }
export type GetMerchantCashAdvanceQueryHookResult = ReturnType<typeof useGetMerchantCashAdvanceQuery>;
export type GetMerchantCashAdvanceLazyQueryHookResult = ReturnType<typeof useGetMerchantCashAdvanceLazyQuery>;
export type GetMerchantCashAdvanceSuspenseQueryHookResult = ReturnType<typeof useGetMerchantCashAdvanceSuspenseQuery>;
export type GetMerchantCashAdvanceQueryResult = Apollo.QueryResult<GetMerchantCashAdvanceQuery, GetMerchantCashAdvanceQueryVariables>;
export const McaDisplayAttributesDocument = gql`
    query mcaDisplayAttributes {
  mcaDisplayAttributes {
    key
    type
    name
    displayOrder
    color
    description
  }
}
    `;

/**
 * __useMcaDisplayAttributesQuery__
 *
 * To run a query within a React component, call `useMcaDisplayAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcaDisplayAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcaDisplayAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMcaDisplayAttributesQuery(baseOptions?: Apollo.QueryHookOptions<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>(McaDisplayAttributesDocument, options);
      }
export function useMcaDisplayAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>(McaDisplayAttributesDocument, options);
        }
// @ts-ignore
export function useMcaDisplayAttributesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>): Apollo.UseSuspenseQueryResult<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>;
export function useMcaDisplayAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>): Apollo.UseSuspenseQueryResult<McaDisplayAttributesQuery | undefined, McaDisplayAttributesQueryVariables>;
export function useMcaDisplayAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>(McaDisplayAttributesDocument, options);
        }
export type McaDisplayAttributesQueryHookResult = ReturnType<typeof useMcaDisplayAttributesQuery>;
export type McaDisplayAttributesLazyQueryHookResult = ReturnType<typeof useMcaDisplayAttributesLazyQuery>;
export type McaDisplayAttributesSuspenseQueryHookResult = ReturnType<typeof useMcaDisplayAttributesSuspenseQuery>;
export type McaDisplayAttributesQueryResult = Apollo.QueryResult<McaDisplayAttributesQuery, McaDisplayAttributesQueryVariables>;
export const CreateOfferDocument = gql`
    mutation createOffer($createOfferInput: CreateOfferInput!) {
  createOffer(createOfferInput: $createOfferInput) {
    id
  }
}
    `;
export type CreateOfferMutationFn = Apollo.MutationFunction<CreateOfferMutation, CreateOfferMutationVariables>;

/**
 * __useCreateOfferMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferMutation, { data, loading, error }] = useCreateOfferMutation({
 *   variables: {
 *      createOfferInput: // value for 'createOfferInput'
 *   },
 * });
 */
export function useCreateOfferMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferMutation, CreateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferMutation, CreateOfferMutationVariables>(CreateOfferDocument, options);
      }
export type CreateOfferMutationHookResult = ReturnType<typeof useCreateOfferMutation>;
export type CreateOfferMutationResult = Apollo.MutationResult<CreateOfferMutation>;
export type CreateOfferMutationOptions = Apollo.BaseMutationOptions<CreateOfferMutation, CreateOfferMutationVariables>;
export const UpdateOfferDocument = gql`
    mutation updateOffer($id: ID!, $updateOfferInput: UpdateOfferInput!) {
  updateOffer(id: $id, updateOfferInput: $updateOfferInput) {
    id
  }
}
    `;
export type UpdateOfferMutationFn = Apollo.MutationFunction<UpdateOfferMutation, UpdateOfferMutationVariables>;

/**
 * __useUpdateOfferMutation__
 *
 * To run a mutation, you first call `useUpdateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferMutation, { data, loading, error }] = useUpdateOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      updateOfferInput: // value for 'updateOfferInput'
 *   },
 * });
 */
export function useUpdateOfferMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOfferMutation, UpdateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOfferMutation, UpdateOfferMutationVariables>(UpdateOfferDocument, options);
      }
export type UpdateOfferMutationHookResult = ReturnType<typeof useUpdateOfferMutation>;
export type UpdateOfferMutationResult = Apollo.MutationResult<UpdateOfferMutation>;
export type UpdateOfferMutationOptions = Apollo.BaseMutationOptions<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const DeleteOfferDocument = gql`
    mutation deleteOffer($id: ID!) {
  deleteOffer(id: $id)
}
    `;
export type DeleteOfferMutationFn = Apollo.MutationFunction<DeleteOfferMutation, DeleteOfferMutationVariables>;

/**
 * __useDeleteOfferMutation__
 *
 * To run a mutation, you first call `useDeleteOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfferMutation, { data, loading, error }] = useDeleteOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOfferMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOfferMutation, DeleteOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOfferMutation, DeleteOfferMutationVariables>(DeleteOfferDocument, options);
      }
export type DeleteOfferMutationHookResult = ReturnType<typeof useDeleteOfferMutation>;
export type DeleteOfferMutationResult = Apollo.MutationResult<DeleteOfferMutation>;
export type DeleteOfferMutationOptions = Apollo.BaseMutationOptions<DeleteOfferMutation, DeleteOfferMutationVariables>;
export const DeleteOffersByGroupIdDocument = gql`
    mutation deleteOffersByGroupId($rehabGroupId: ID!) {
  deleteOffersByGroupId(rehabGroupId: $rehabGroupId)
}
    `;
export type DeleteOffersByGroupIdMutationFn = Apollo.MutationFunction<DeleteOffersByGroupIdMutation, DeleteOffersByGroupIdMutationVariables>;

/**
 * __useDeleteOffersByGroupIdMutation__
 *
 * To run a mutation, you first call `useDeleteOffersByGroupIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOffersByGroupIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOffersByGroupIdMutation, { data, loading, error }] = useDeleteOffersByGroupIdMutation({
 *   variables: {
 *      rehabGroupId: // value for 'rehabGroupId'
 *   },
 * });
 */
export function useDeleteOffersByGroupIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOffersByGroupIdMutation, DeleteOffersByGroupIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOffersByGroupIdMutation, DeleteOffersByGroupIdMutationVariables>(DeleteOffersByGroupIdDocument, options);
      }
export type DeleteOffersByGroupIdMutationHookResult = ReturnType<typeof useDeleteOffersByGroupIdMutation>;
export type DeleteOffersByGroupIdMutationResult = Apollo.MutationResult<DeleteOffersByGroupIdMutation>;
export type DeleteOffersByGroupIdMutationOptions = Apollo.BaseMutationOptions<DeleteOffersByGroupIdMutation, DeleteOffersByGroupIdMutationVariables>;
export const SetActiveOfferDocument = gql`
    mutation setActiveOffer($offerId: ID!) {
  setActiveOffer(offerId: $offerId) {
    id
    isActive
  }
}
    `;
export type SetActiveOfferMutationFn = Apollo.MutationFunction<SetActiveOfferMutation, SetActiveOfferMutationVariables>;

/**
 * __useSetActiveOfferMutation__
 *
 * To run a mutation, you first call `useSetActiveOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveOfferMutation, { data, loading, error }] = useSetActiveOfferMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useSetActiveOfferMutation(baseOptions?: Apollo.MutationHookOptions<SetActiveOfferMutation, SetActiveOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetActiveOfferMutation, SetActiveOfferMutationVariables>(SetActiveOfferDocument, options);
      }
export type SetActiveOfferMutationHookResult = ReturnType<typeof useSetActiveOfferMutation>;
export type SetActiveOfferMutationResult = Apollo.MutationResult<SetActiveOfferMutation>;
export type SetActiveOfferMutationOptions = Apollo.BaseMutationOptions<SetActiveOfferMutation, SetActiveOfferMutationVariables>;
export const CountFundingPipelineOfferStatsDocument = gql`
    query countFundingPipelineOfferStats {
  countFundingPipelineOfferStats {
    statusCounts {
      statusId
      count
    }
  }
}
    `;

/**
 * __useCountFundingPipelineOfferStatsQuery__
 *
 * To run a query within a React component, call `useCountFundingPipelineOfferStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountFundingPipelineOfferStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountFundingPipelineOfferStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountFundingPipelineOfferStatsQuery(baseOptions?: Apollo.QueryHookOptions<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>(CountFundingPipelineOfferStatsDocument, options);
      }
export function useCountFundingPipelineOfferStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>(CountFundingPipelineOfferStatsDocument, options);
        }
// @ts-ignore
export function useCountFundingPipelineOfferStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>;
export function useCountFundingPipelineOfferStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>): Apollo.UseSuspenseQueryResult<CountFundingPipelineOfferStatsQuery | undefined, CountFundingPipelineOfferStatsQueryVariables>;
export function useCountFundingPipelineOfferStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>(CountFundingPipelineOfferStatsDocument, options);
        }
export type CountFundingPipelineOfferStatsQueryHookResult = ReturnType<typeof useCountFundingPipelineOfferStatsQuery>;
export type CountFundingPipelineOfferStatsLazyQueryHookResult = ReturnType<typeof useCountFundingPipelineOfferStatsLazyQuery>;
export type CountFundingPipelineOfferStatsSuspenseQueryHookResult = ReturnType<typeof useCountFundingPipelineOfferStatsSuspenseQuery>;
export type CountFundingPipelineOfferStatsQueryResult = Apollo.QueryResult<CountFundingPipelineOfferStatsQuery, CountFundingPipelineOfferStatsQueryVariables>;
export const LinkActiveOfferToMcaDocument = gql`
    mutation linkActiveOfferToMca($mcaId: ID!, $applicationId: ID!) {
  linkActiveOfferToMca(mcaId: $mcaId, applicationId: $applicationId)
}
    `;
export type LinkActiveOfferToMcaMutationFn = Apollo.MutationFunction<LinkActiveOfferToMcaMutation, LinkActiveOfferToMcaMutationVariables>;

/**
 * __useLinkActiveOfferToMcaMutation__
 *
 * To run a mutation, you first call `useLinkActiveOfferToMcaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkActiveOfferToMcaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkActiveOfferToMcaMutation, { data, loading, error }] = useLinkActiveOfferToMcaMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useLinkActiveOfferToMcaMutation(baseOptions?: Apollo.MutationHookOptions<LinkActiveOfferToMcaMutation, LinkActiveOfferToMcaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkActiveOfferToMcaMutation, LinkActiveOfferToMcaMutationVariables>(LinkActiveOfferToMcaDocument, options);
      }
export type LinkActiveOfferToMcaMutationHookResult = ReturnType<typeof useLinkActiveOfferToMcaMutation>;
export type LinkActiveOfferToMcaMutationResult = Apollo.MutationResult<LinkActiveOfferToMcaMutation>;
export type LinkActiveOfferToMcaMutationOptions = Apollo.BaseMutationOptions<LinkActiveOfferToMcaMutation, LinkActiveOfferToMcaMutationVariables>;
export const DuplicateApplicationDocument = gql`
    mutation duplicateApplication($applicationId: ID!, $offerId: ID!) {
  duplicateApplication(applicationId: $applicationId, offerId: $offerId) {
    id
    offers {
      id
      isSelected
    }
  }
}
    `;
export type DuplicateApplicationMutationFn = Apollo.MutationFunction<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>;

/**
 * __useDuplicateApplicationMutation__
 *
 * To run a mutation, you first call `useDuplicateApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateApplicationMutation, { data, loading, error }] = useDuplicateApplicationMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useDuplicateApplicationMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>(DuplicateApplicationDocument, options);
      }
export type DuplicateApplicationMutationHookResult = ReturnType<typeof useDuplicateApplicationMutation>;
export type DuplicateApplicationMutationResult = Apollo.MutationResult<DuplicateApplicationMutation>;
export type DuplicateApplicationMutationOptions = Apollo.BaseMutationOptions<DuplicateApplicationMutation, DuplicateApplicationMutationVariables>;
export const GetOfferDocument = gql`
    query getOffer($id: ID!) {
  getOffer(id: $id) {
    id
    number
    currentUserRights
    type
    fundingAmount
    factorRate
    term
    offerDate
    rehabGroupId
    rehabLineTitle
    lineOrder
    broker {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
      manager {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
    }
    integration {
      id
      name
      logo
      type
      company {
        id
        legalName
        dba
        logo
      }
    }
    funder {
      id
      name
      code
      logo
    }
    secondaryFunders {
      id
      code
      name
      logo
    }
    company {
      id
      legalName
      dba
      logo
    }
    manager {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
    }
    notes
    stipulations
    createdBy {
      id
      name
      email
    }
    modifiedBy {
      id
      name
      email
    }
    linkToFilesData {
      linkToFiles
    }
    isSelected
    isActive
    createdAt
    updatedAt
    fundingFees {
      id
      configId
      amount
      comment
    }
    commissions {
      id
      configId
      amount
      comment
    }
    application {
      id
      number
    }
    offerEmails {
      id
      number
      recipient
      recipientCC
      recipientBCC
      comment
      sentAt
      isSent
      createdBy {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables> & ({ variables: GetOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
      }
export function useGetOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
// @ts-ignore
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferQuery, GetOfferQueryVariables>;
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>): Apollo.UseSuspenseQueryResult<GetOfferQuery | undefined, GetOfferQueryVariables>;
export function useGetOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<typeof useGetOfferLazyQuery>;
export type GetOfferSuspenseQueryHookResult = ReturnType<typeof useGetOfferSuspenseQuery>;
export type GetOfferQueryResult = Apollo.QueryResult<GetOfferQuery, GetOfferQueryVariables>;
export const OffersForApplicationDocument = gql`
    query offersForApplication($id: ID!) {
  offersForApplication(applicationId: $id) {
    id
    number
    currentUserRights
    type
    fundingAmount
    factorRate
    term
    offerDate
    rehabGroupId
    rehabLineTitle
    lineOrder
    broker {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
      manager {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
    }
    funder {
      id
      name
      code
      logo
    }
    secondaryFunders {
      id
      code
      name
      logo
    }
    company {
      id
      legalName
      dba
      logo
    }
    manager {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
    }
    integration {
      id
      name
      logo
      type
      company {
        id
        legalName
        dba
        logo
      }
    }
    application {
      merchantCompanyLegalName
      merchantCompanyDba
      merchantBizEmails
      merchantBizWeb
      merchantBizPhones
      merchantTaxId
    }
    notes
    stipulations
    createdBy {
      id
      name
      email
    }
    modifiedBy {
      id
      name
      email
    }
    linkToFilesData {
      linkToFiles
    }
    isSelected
    isActive
    createdAt
    updatedAt
    fundingFees {
      id
      configId
      amount
      comment
    }
    commissions {
      id
      configId
      amount
      comment
    }
  }
}
    `;

/**
 * __useOffersForApplicationQuery__
 *
 * To run a query within a React component, call `useOffersForApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersForApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersForApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOffersForApplicationQuery(baseOptions: Apollo.QueryHookOptions<OffersForApplicationQuery, OffersForApplicationQueryVariables> & ({ variables: OffersForApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffersForApplicationQuery, OffersForApplicationQueryVariables>(OffersForApplicationDocument, options);
      }
export function useOffersForApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersForApplicationQuery, OffersForApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffersForApplicationQuery, OffersForApplicationQueryVariables>(OffersForApplicationDocument, options);
        }
// @ts-ignore
export function useOffersForApplicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OffersForApplicationQuery, OffersForApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<OffersForApplicationQuery, OffersForApplicationQueryVariables>;
export function useOffersForApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersForApplicationQuery, OffersForApplicationQueryVariables>): Apollo.UseSuspenseQueryResult<OffersForApplicationQuery | undefined, OffersForApplicationQueryVariables>;
export function useOffersForApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersForApplicationQuery, OffersForApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffersForApplicationQuery, OffersForApplicationQueryVariables>(OffersForApplicationDocument, options);
        }
export type OffersForApplicationQueryHookResult = ReturnType<typeof useOffersForApplicationQuery>;
export type OffersForApplicationLazyQueryHookResult = ReturnType<typeof useOffersForApplicationLazyQuery>;
export type OffersForApplicationSuspenseQueryHookResult = ReturnType<typeof useOffersForApplicationSuspenseQuery>;
export type OffersForApplicationQueryResult = Apollo.QueryResult<OffersForApplicationQuery, OffersForApplicationQueryVariables>;
export const GetRehabOffersDocument = gql`
    query getRehabOffers($id: ID!) {
  getRehabOffers(rehabGroupId: $id) {
    id
    number
    currentUserRights
    type
    fundingAmount
    factorRate
    term
    offerDate
    rehabGroupId
    rehabLineTitle
    lineOrder
    broker {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
      manager {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
    }
    funder {
      id
      name
      code
      logo
    }
    secondaryFunders {
      id
      code
      name
      logo
    }
    integration {
      id
      name
      logo
      type
      company {
        id
        legalName
        dba
        logo
      }
    }
    company {
      id
      legalName
      dba
      logo
    }
    manager {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
    }
    application {
      merchantCompanyLegalName
      merchantCompanyDba
      merchantBizEmails
      merchantBizWeb
      merchantBizPhones
      merchantTaxId
    }
    notes
    stipulations
    createdBy {
      id
      name
      email
    }
    modifiedBy {
      id
      name
      email
    }
    linkToFilesData {
      linkToFiles
    }
    isSelected
    isActive
    createdAt
    updatedAt
    fundingFees {
      id
      configId
      amount
      comment
    }
    commissions {
      id
      configId
      amount
      comment
    }
  }
}
    `;

/**
 * __useGetRehabOffersQuery__
 *
 * To run a query within a React component, call `useGetRehabOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRehabOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRehabOffersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRehabOffersQuery(baseOptions: Apollo.QueryHookOptions<GetRehabOffersQuery, GetRehabOffersQueryVariables> & ({ variables: GetRehabOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRehabOffersQuery, GetRehabOffersQueryVariables>(GetRehabOffersDocument, options);
      }
export function useGetRehabOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRehabOffersQuery, GetRehabOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRehabOffersQuery, GetRehabOffersQueryVariables>(GetRehabOffersDocument, options);
        }
// @ts-ignore
export function useGetRehabOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRehabOffersQuery, GetRehabOffersQueryVariables>): Apollo.UseSuspenseQueryResult<GetRehabOffersQuery, GetRehabOffersQueryVariables>;
export function useGetRehabOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRehabOffersQuery, GetRehabOffersQueryVariables>): Apollo.UseSuspenseQueryResult<GetRehabOffersQuery | undefined, GetRehabOffersQueryVariables>;
export function useGetRehabOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRehabOffersQuery, GetRehabOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRehabOffersQuery, GetRehabOffersQueryVariables>(GetRehabOffersDocument, options);
        }
export type GetRehabOffersQueryHookResult = ReturnType<typeof useGetRehabOffersQuery>;
export type GetRehabOffersLazyQueryHookResult = ReturnType<typeof useGetRehabOffersLazyQuery>;
export type GetRehabOffersSuspenseQueryHookResult = ReturnType<typeof useGetRehabOffersSuspenseQuery>;
export type GetRehabOffersQueryResult = Apollo.QueryResult<GetRehabOffersQuery, GetRehabOffersQueryVariables>;
export const OffersForFundingPipelineDocument = gql`
    query offersForFundingPipeline($offset: Int = 0, $limit: Int = 10, $search: String, $statuses: [String!], $offerId: String, $applicationId: String, $sortArgs: [SortArgs!] = []) {
  offersForFundingPipeline(
    offset: $offset
    limit: $limit
    search: $search
    statuses: $statuses
    offerId: $offerId
    applicationId: $applicationId
    sortArgs: $sortArgs
  ) {
    data {
      id
      number
      currentUserRights
      type
      fundingAmount
      factorRate
      term
      offerDate
      rehabGroupId
      rehabLineTitle
      lineOrder
      stipulations
      notes
      isSelected
      isActive
      createdAt
      updatedAt
      linkToFilesData {
        linkToFiles
      }
      createdBy {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
      modifiedBy {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
      broker {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
        company {
          id
          legalName
          dba
          type
          logo
        }
        manager {
          id
          name
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
      }
      funder {
        id
        name
        code
        logo
      }
      secondaryFunders {
        id
        code
        name
        logo
      }
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      company {
        id
        legalName
        dba
        logo
      }
      manager {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
      application {
        id
        number
        merchantCompanyLegalName
        merchantCompanyDba
        merchantBizEmails
        merchantBizWeb
        merchantBizPhones
        merchantTaxId
        status {
          id
          color
          description
        }
        owners {
          cellPhone
          bizPhone
          bizEmail
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      mca {
        id
        number
        status
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useOffersForFundingPipelineQuery__
 *
 * To run a query within a React component, call `useOffersForFundingPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersForFundingPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersForFundingPipelineQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      offerId: // value for 'offerId'
 *      applicationId: // value for 'applicationId'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useOffersForFundingPipelineQuery(baseOptions?: Apollo.QueryHookOptions<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>(OffersForFundingPipelineDocument, options);
      }
export function useOffersForFundingPipelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>(OffersForFundingPipelineDocument, options);
        }
// @ts-ignore
export function useOffersForFundingPipelineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>): Apollo.UseSuspenseQueryResult<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>;
export function useOffersForFundingPipelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>): Apollo.UseSuspenseQueryResult<OffersForFundingPipelineQuery | undefined, OffersForFundingPipelineQueryVariables>;
export function useOffersForFundingPipelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>(OffersForFundingPipelineDocument, options);
        }
export type OffersForFundingPipelineQueryHookResult = ReturnType<typeof useOffersForFundingPipelineQuery>;
export type OffersForFundingPipelineLazyQueryHookResult = ReturnType<typeof useOffersForFundingPipelineLazyQuery>;
export type OffersForFundingPipelineSuspenseQueryHookResult = ReturnType<typeof useOffersForFundingPipelineSuspenseQuery>;
export type OffersForFundingPipelineQueryResult = Apollo.QueryResult<OffersForFundingPipelineQuery, OffersForFundingPipelineQueryVariables>;
export const FundingPipelineStatusDocument = gql`
    query fundingPipelineStatus {
  fundingPipelineStatus {
    id
    color
    description
    order
  }
}
    `;

/**
 * __useFundingPipelineStatusQuery__
 *
 * To run a query within a React component, call `useFundingPipelineStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingPipelineStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingPipelineStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingPipelineStatusQuery(baseOptions?: Apollo.QueryHookOptions<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>(FundingPipelineStatusDocument, options);
      }
export function useFundingPipelineStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>(FundingPipelineStatusDocument, options);
        }
// @ts-ignore
export function useFundingPipelineStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>): Apollo.UseSuspenseQueryResult<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>;
export function useFundingPipelineStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>): Apollo.UseSuspenseQueryResult<FundingPipelineStatusQuery | undefined, FundingPipelineStatusQueryVariables>;
export function useFundingPipelineStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>(FundingPipelineStatusDocument, options);
        }
export type FundingPipelineStatusQueryHookResult = ReturnType<typeof useFundingPipelineStatusQuery>;
export type FundingPipelineStatusLazyQueryHookResult = ReturnType<typeof useFundingPipelineStatusLazyQuery>;
export type FundingPipelineStatusSuspenseQueryHookResult = ReturnType<typeof useFundingPipelineStatusSuspenseQuery>;
export type FundingPipelineStatusQueryResult = Apollo.QueryResult<FundingPipelineStatusQuery, FundingPipelineStatusQueryVariables>;
export const SendOfferEmailDocument = gql`
    mutation sendOfferEmail($sendEmailInput: SendEmailInput!) {
  sendOfferEmail(sendEmailInput: $sendEmailInput) {
    id
    sentAt
  }
}
    `;
export type SendOfferEmailMutationFn = Apollo.MutationFunction<SendOfferEmailMutation, SendOfferEmailMutationVariables>;

/**
 * __useSendOfferEmailMutation__
 *
 * To run a mutation, you first call `useSendOfferEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOfferEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOfferEmailMutation, { data, loading, error }] = useSendOfferEmailMutation({
 *   variables: {
 *      sendEmailInput: // value for 'sendEmailInput'
 *   },
 * });
 */
export function useSendOfferEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendOfferEmailMutation, SendOfferEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOfferEmailMutation, SendOfferEmailMutationVariables>(SendOfferEmailDocument, options);
      }
export type SendOfferEmailMutationHookResult = ReturnType<typeof useSendOfferEmailMutation>;
export type SendOfferEmailMutationResult = Apollo.MutationResult<SendOfferEmailMutation>;
export type SendOfferEmailMutationOptions = Apollo.BaseMutationOptions<SendOfferEmailMutation, SendOfferEmailMutationVariables>;
export const SaveUnsentOfferEmailDocument = gql`
    mutation saveUnsentOfferEmail($sendEmailInput: SendEmailInput!) {
  saveUnsentOfferEmail(sendEmailInput: $sendEmailInput) {
    id
    sentAt
  }
}
    `;
export type SaveUnsentOfferEmailMutationFn = Apollo.MutationFunction<SaveUnsentOfferEmailMutation, SaveUnsentOfferEmailMutationVariables>;

/**
 * __useSaveUnsentOfferEmailMutation__
 *
 * To run a mutation, you first call `useSaveUnsentOfferEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnsentOfferEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnsentOfferEmailMutation, { data, loading, error }] = useSaveUnsentOfferEmailMutation({
 *   variables: {
 *      sendEmailInput: // value for 'sendEmailInput'
 *   },
 * });
 */
export function useSaveUnsentOfferEmailMutation(baseOptions?: Apollo.MutationHookOptions<SaveUnsentOfferEmailMutation, SaveUnsentOfferEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUnsentOfferEmailMutation, SaveUnsentOfferEmailMutationVariables>(SaveUnsentOfferEmailDocument, options);
      }
export type SaveUnsentOfferEmailMutationHookResult = ReturnType<typeof useSaveUnsentOfferEmailMutation>;
export type SaveUnsentOfferEmailMutationResult = Apollo.MutationResult<SaveUnsentOfferEmailMutation>;
export type SaveUnsentOfferEmailMutationOptions = Apollo.BaseMutationOptions<SaveUnsentOfferEmailMutation, SaveUnsentOfferEmailMutationVariables>;
export const MapOfferToMcaDocument = gql`
    query mapOfferToMCA($offerId: ID!) {
  mapOfferToMCA(offerId: $offerId) {
    id
    status
    description
    amount
    factorRate
    term
    startDate
    fundingDate
    commissionPercentage
    merchant {
      id
      legalName
      dba
      taxId
      email
      phone
      www
      logo
      type
      linkToFiles
    }
    company {
      id
      legalName
      dba
      logo
      signature
    }
    integration {
      id
      name
      logo
      type
      company {
        id
        legalName
        dba
        logo
      }
    }
    broker {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
      manager {
        id
        name
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
    }
    manager {
      id
      name
      email
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        avatar
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
    }
    funder {
      id
      name
      code
      logo
    }
    secondaryFunders {
      id
      name
      code
      logo
    }
    fundingFee {
      id
      configId
      amount
      comment
    }
    commissions {
      id
      configId
      amount
      comment
    }
  }
}
    `;

/**
 * __useMapOfferToMcaQuery__
 *
 * To run a query within a React component, call `useMapOfferToMcaQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapOfferToMcaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapOfferToMcaQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useMapOfferToMcaQuery(baseOptions: Apollo.QueryHookOptions<MapOfferToMcaQuery, MapOfferToMcaQueryVariables> & ({ variables: MapOfferToMcaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>(MapOfferToMcaDocument, options);
      }
export function useMapOfferToMcaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>(MapOfferToMcaDocument, options);
        }
// @ts-ignore
export function useMapOfferToMcaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>): Apollo.UseSuspenseQueryResult<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>;
export function useMapOfferToMcaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>): Apollo.UseSuspenseQueryResult<MapOfferToMcaQuery | undefined, MapOfferToMcaQueryVariables>;
export function useMapOfferToMcaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>(MapOfferToMcaDocument, options);
        }
export type MapOfferToMcaQueryHookResult = ReturnType<typeof useMapOfferToMcaQuery>;
export type MapOfferToMcaLazyQueryHookResult = ReturnType<typeof useMapOfferToMcaLazyQuery>;
export type MapOfferToMcaSuspenseQueryHookResult = ReturnType<typeof useMapOfferToMcaSuspenseQuery>;
export type MapOfferToMcaQueryResult = Apollo.QueryResult<MapOfferToMcaQuery, MapOfferToMcaQueryVariables>;
export const OffersDocument = gql`
    query offers($offset: Int, $limit: Int, $search: String, $sortArgs: [SortArgs!]) {
  offers(offset: $offset, limit: $limit, search: $search, sortArgs: $sortArgs) {
    data {
      id
      number
      currentUserRights
      type
      fundingAmount
      factorRate
      term
      offerDate
      rehabGroupId
      rehabLineTitle
      lineOrder
      broker {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
        company {
          id
          legalName
          dba
          type
          logo
        }
        manager {
          id
          name
          isActive
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            avatar
          }
        }
      }
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      funder {
        id
        name
        code
        logo
      }
      secondaryFunders {
        id
        code
        name
        logo
      }
      company {
        id
        legalName
        dba
        logo
      }
      manager {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
      application {
        id
        number
        merchantCompanyLegalName
        merchantCompanyDba
        merchantBizEmails
        merchantBizWeb
        merchantBizPhones
        merchantTaxId
        status {
          id
          color
          description
        }
        owners {
          cellPhone
          bizPhone
          bizEmail
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        offers {
          id
          number
          type
          rehabLineTitle
          rehabGroupId
          lineOrder
          term
          offerDate
          type
          fundingAmount
          factorRate
          term
        }
      }
      notes
      stipulations
      createdBy {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
      modifiedBy {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          avatar
        }
      }
      isSelected
      isActive
      createdAt
      updatedAt
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useOffersQuery__
 *
 * To run a query within a React component, call `useOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOffersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useOffersQuery(baseOptions?: Apollo.QueryHookOptions<OffersQuery, OffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
      }
export function useOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OffersQuery, OffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
        }
// @ts-ignore
export function useOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OffersQuery, OffersQueryVariables>): Apollo.UseSuspenseQueryResult<OffersQuery, OffersQueryVariables>;
export function useOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersQuery, OffersQueryVariables>): Apollo.UseSuspenseQueryResult<OffersQuery | undefined, OffersQueryVariables>;
export function useOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OffersQuery, OffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OffersQuery, OffersQueryVariables>(OffersDocument, options);
        }
export type OffersQueryHookResult = ReturnType<typeof useOffersQuery>;
export type OffersLazyQueryHookResult = ReturnType<typeof useOffersLazyQuery>;
export type OffersSuspenseQueryHookResult = ReturnType<typeof useOffersSuspenseQuery>;
export type OffersQueryResult = Apollo.QueryResult<OffersQuery, OffersQueryVariables>;
export const PreviewOfferEmailDocument = gql`
    query previewOfferEmail($offerId: String!) {
  previewOfferEmail(offerId: $offerId)
}
    `;

/**
 * __usePreviewOfferEmailQuery__
 *
 * To run a query within a React component, call `usePreviewOfferEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewOfferEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewOfferEmailQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function usePreviewOfferEmailQuery(baseOptions: Apollo.QueryHookOptions<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables> & ({ variables: PreviewOfferEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>(PreviewOfferEmailDocument, options);
      }
export function usePreviewOfferEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>(PreviewOfferEmailDocument, options);
        }
// @ts-ignore
export function usePreviewOfferEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>;
export function usePreviewOfferEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewOfferEmailQuery | undefined, PreviewOfferEmailQueryVariables>;
export function usePreviewOfferEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>(PreviewOfferEmailDocument, options);
        }
export type PreviewOfferEmailQueryHookResult = ReturnType<typeof usePreviewOfferEmailQuery>;
export type PreviewOfferEmailLazyQueryHookResult = ReturnType<typeof usePreviewOfferEmailLazyQuery>;
export type PreviewOfferEmailSuspenseQueryHookResult = ReturnType<typeof usePreviewOfferEmailSuspenseQuery>;
export type PreviewOfferEmailQueryResult = Apollo.QueryResult<PreviewOfferEmailQuery, PreviewOfferEmailQueryVariables>;
export const SaveFundingPipelineMcaDocument = gql`
    mutation saveFundingPipelineMca($offerId: ID!, $merchantId: ID!, $integrationId: ID, $lenderId: ID, $secondaryFunderIds: [ID!], $brokerId: ID, $managerId: ID, $legalId: ID, $applicationId: ID!, $dto: MerchantCashAdvanceDto!) {
  saveFundingPipelineMca(
    offerId: $offerId
    merchantId: $merchantId
    integrationId: $integrationId
    lenderId: $lenderId
    secondaryFunderIds: $secondaryFunderIds
    brokerId: $brokerId
    managerId: $managerId
    legalId: $legalId
    applicationId: $applicationId
    mca: $dto
  ) {
    id
    status
    amount
    factorRate
    routingNumber
    accountNumber
    term
    startDate
    fundingDate
    commissionPercentage
    payback
  }
}
    `;
export type SaveFundingPipelineMcaMutationFn = Apollo.MutationFunction<SaveFundingPipelineMcaMutation, SaveFundingPipelineMcaMutationVariables>;

/**
 * __useSaveFundingPipelineMcaMutation__
 *
 * To run a mutation, you first call `useSaveFundingPipelineMcaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFundingPipelineMcaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFundingPipelineMcaMutation, { data, loading, error }] = useSaveFundingPipelineMcaMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      merchantId: // value for 'merchantId'
 *      integrationId: // value for 'integrationId'
 *      lenderId: // value for 'lenderId'
 *      secondaryFunderIds: // value for 'secondaryFunderIds'
 *      brokerId: // value for 'brokerId'
 *      managerId: // value for 'managerId'
 *      legalId: // value for 'legalId'
 *      applicationId: // value for 'applicationId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveFundingPipelineMcaMutation(baseOptions?: Apollo.MutationHookOptions<SaveFundingPipelineMcaMutation, SaveFundingPipelineMcaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFundingPipelineMcaMutation, SaveFundingPipelineMcaMutationVariables>(SaveFundingPipelineMcaDocument, options);
      }
export type SaveFundingPipelineMcaMutationHookResult = ReturnType<typeof useSaveFundingPipelineMcaMutation>;
export type SaveFundingPipelineMcaMutationResult = Apollo.MutationResult<SaveFundingPipelineMcaMutation>;
export type SaveFundingPipelineMcaMutationOptions = Apollo.BaseMutationOptions<SaveFundingPipelineMcaMutation, SaveFundingPipelineMcaMutationVariables>;
export const OfferByMcaIdDocument = gql`
    query offerByMcaId($mcaId: ID!) {
  offerByMcaId(mcaId: $mcaId) {
    id
    application {
      id
      number
      status {
        id
        color
        description
      }
    }
  }
}
    `;

/**
 * __useOfferByMcaIdQuery__
 *
 * To run a query within a React component, call `useOfferByMcaIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferByMcaIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferByMcaIdQuery({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useOfferByMcaIdQuery(baseOptions: Apollo.QueryHookOptions<OfferByMcaIdQuery, OfferByMcaIdQueryVariables> & ({ variables: OfferByMcaIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>(OfferByMcaIdDocument, options);
      }
export function useOfferByMcaIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>(OfferByMcaIdDocument, options);
        }
// @ts-ignore
export function useOfferByMcaIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>): Apollo.UseSuspenseQueryResult<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>;
export function useOfferByMcaIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>): Apollo.UseSuspenseQueryResult<OfferByMcaIdQuery | undefined, OfferByMcaIdQueryVariables>;
export function useOfferByMcaIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>(OfferByMcaIdDocument, options);
        }
export type OfferByMcaIdQueryHookResult = ReturnType<typeof useOfferByMcaIdQuery>;
export type OfferByMcaIdLazyQueryHookResult = ReturnType<typeof useOfferByMcaIdLazyQuery>;
export type OfferByMcaIdSuspenseQueryHookResult = ReturnType<typeof useOfferByMcaIdSuspenseQuery>;
export type OfferByMcaIdQueryResult = Apollo.QueryResult<OfferByMcaIdQuery, OfferByMcaIdQueryVariables>;
export const CompanyOwnersDocument = gql`
    query companyOwners($companyId: ID!) {
  companyOwners(companyId: $companyId) {
    id
    firstName
    middleName
    lastName
    dateOfBirth
    ssn
    ssnNormalized
    description
    cellPhone
    bizPhone
    bizEmail
    avatar
    address {
      line1
      city
      state
      zip
    }
    createdBy {
      id
      name
      data {
        firstName
        lastName
        avatar
      }
    }
    modifiedBy {
      id
      name
      data {
        firstName
        lastName
        avatar
      }
    }
  }
}
    `;

/**
 * __useCompanyOwnersQuery__
 *
 * To run a query within a React component, call `useCompanyOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyOwnersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyOwnersQuery(baseOptions: Apollo.QueryHookOptions<CompanyOwnersQuery, CompanyOwnersQueryVariables> & ({ variables: CompanyOwnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyOwnersQuery, CompanyOwnersQueryVariables>(CompanyOwnersDocument, options);
      }
export function useCompanyOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyOwnersQuery, CompanyOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyOwnersQuery, CompanyOwnersQueryVariables>(CompanyOwnersDocument, options);
        }
// @ts-ignore
export function useCompanyOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CompanyOwnersQuery, CompanyOwnersQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyOwnersQuery, CompanyOwnersQueryVariables>;
export function useCompanyOwnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyOwnersQuery, CompanyOwnersQueryVariables>): Apollo.UseSuspenseQueryResult<CompanyOwnersQuery | undefined, CompanyOwnersQueryVariables>;
export function useCompanyOwnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyOwnersQuery, CompanyOwnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyOwnersQuery, CompanyOwnersQueryVariables>(CompanyOwnersDocument, options);
        }
export type CompanyOwnersQueryHookResult = ReturnType<typeof useCompanyOwnersQuery>;
export type CompanyOwnersLazyQueryHookResult = ReturnType<typeof useCompanyOwnersLazyQuery>;
export type CompanyOwnersSuspenseQueryHookResult = ReturnType<typeof useCompanyOwnersSuspenseQuery>;
export type CompanyOwnersQueryResult = Apollo.QueryResult<CompanyOwnersQuery, CompanyOwnersQueryVariables>;
export const OwnerDocument = gql`
    query owner($id: ID!) {
  owner(id: $id) {
    id
    firstName
    middleName
    lastName
    dateOfBirth
    ssn
    ssnNormalized
    description
    cellPhone
    bizPhone
    bizEmail
    avatar
    address {
      line1
      city
      state
      zip
    }
    createdBy {
      id
      name
      data {
        firstName
        lastName
        avatar
      }
    }
    modifiedBy {
      id
      name
      data {
        firstName
        lastName
        avatar
      }
    }
  }
}
    `;

/**
 * __useOwnerQuery__
 *
 * To run a query within a React component, call `useOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOwnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOwnerQuery(baseOptions: Apollo.QueryHookOptions<OwnerQuery, OwnerQueryVariables> & ({ variables: OwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OwnerQuery, OwnerQueryVariables>(OwnerDocument, options);
      }
export function useOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OwnerQuery, OwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OwnerQuery, OwnerQueryVariables>(OwnerDocument, options);
        }
// @ts-ignore
export function useOwnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OwnerQuery, OwnerQueryVariables>): Apollo.UseSuspenseQueryResult<OwnerQuery, OwnerQueryVariables>;
export function useOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OwnerQuery, OwnerQueryVariables>): Apollo.UseSuspenseQueryResult<OwnerQuery | undefined, OwnerQueryVariables>;
export function useOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OwnerQuery, OwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OwnerQuery, OwnerQueryVariables>(OwnerDocument, options);
        }
export type OwnerQueryHookResult = ReturnType<typeof useOwnerQuery>;
export type OwnerLazyQueryHookResult = ReturnType<typeof useOwnerLazyQuery>;
export type OwnerSuspenseQueryHookResult = ReturnType<typeof useOwnerSuspenseQuery>;
export type OwnerQueryResult = Apollo.QueryResult<OwnerQuery, OwnerQueryVariables>;
export const SaveOwnerDocument = gql`
    mutation saveOwner($companyId: ID!, $owner: OwnerDto!) {
  saveOwner(companyId: $companyId, owner: $owner) {
    id
    firstName
    middleName
    lastName
    dateOfBirth
    ssn
    ssnNormalized
    description
    cellPhone
    bizPhone
    bizEmail
    avatar
    address {
      line1
      city
      state
      zip
    }
    createdBy {
      id
      name
      data {
        firstName
        lastName
        avatar
      }
    }
    modifiedBy {
      id
      name
      data {
        firstName
        lastName
        avatar
      }
    }
  }
}
    `;
export type SaveOwnerMutationFn = Apollo.MutationFunction<SaveOwnerMutation, SaveOwnerMutationVariables>;

/**
 * __useSaveOwnerMutation__
 *
 * To run a mutation, you first call `useSaveOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOwnerMutation, { data, loading, error }] = useSaveOwnerMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      owner: // value for 'owner'
 *   },
 * });
 */
export function useSaveOwnerMutation(baseOptions?: Apollo.MutationHookOptions<SaveOwnerMutation, SaveOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOwnerMutation, SaveOwnerMutationVariables>(SaveOwnerDocument, options);
      }
export type SaveOwnerMutationHookResult = ReturnType<typeof useSaveOwnerMutation>;
export type SaveOwnerMutationResult = Apollo.MutationResult<SaveOwnerMutation>;
export type SaveOwnerMutationOptions = Apollo.BaseMutationOptions<SaveOwnerMutation, SaveOwnerMutationVariables>;
export const DeleteOwnerDocument = gql`
    mutation deleteOwner($id: ID!) {
  deleteOwner(id: $id)
}
    `;
export type DeleteOwnerMutationFn = Apollo.MutationFunction<DeleteOwnerMutation, DeleteOwnerMutationVariables>;

/**
 * __useDeleteOwnerMutation__
 *
 * To run a mutation, you first call `useDeleteOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOwnerMutation, { data, loading, error }] = useDeleteOwnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOwnerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOwnerMutation, DeleteOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOwnerMutation, DeleteOwnerMutationVariables>(DeleteOwnerDocument, options);
      }
export type DeleteOwnerMutationHookResult = ReturnType<typeof useDeleteOwnerMutation>;
export type DeleteOwnerMutationResult = Apollo.MutationResult<DeleteOwnerMutation>;
export type DeleteOwnerMutationOptions = Apollo.BaseMutationOptions<DeleteOwnerMutation, DeleteOwnerMutationVariables>;
export const SaveCompanyOwnersDocument = gql`
    mutation saveCompanyOwners($companyId: ID!, $owners: [OwnerDto!]!) {
  saveCompanyOwners(companyId: $companyId, owners: $owners) {
    id
    firstName
    middleName
    lastName
    dateOfBirth
    ssn
    cellPhone
    bizPhone
    bizEmail
    address {
      line1
      line2
      city
      state
      zip
    }
  }
}
    `;
export type SaveCompanyOwnersMutationFn = Apollo.MutationFunction<SaveCompanyOwnersMutation, SaveCompanyOwnersMutationVariables>;

/**
 * __useSaveCompanyOwnersMutation__
 *
 * To run a mutation, you first call `useSaveCompanyOwnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompanyOwnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCompanyOwnersMutation, { data, loading, error }] = useSaveCompanyOwnersMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      owners: // value for 'owners'
 *   },
 * });
 */
export function useSaveCompanyOwnersMutation(baseOptions?: Apollo.MutationHookOptions<SaveCompanyOwnersMutation, SaveCompanyOwnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCompanyOwnersMutation, SaveCompanyOwnersMutationVariables>(SaveCompanyOwnersDocument, options);
      }
export type SaveCompanyOwnersMutationHookResult = ReturnType<typeof useSaveCompanyOwnersMutation>;
export type SaveCompanyOwnersMutationResult = Apollo.MutationResult<SaveCompanyOwnersMutation>;
export type SaveCompanyOwnersMutationOptions = Apollo.BaseMutationOptions<SaveCompanyOwnersMutation, SaveCompanyOwnersMutationVariables>;
export const PermissionsDocument = gql`
    query permissions($offset: Int = 0, $limit: Int = 50, $search: String, $roleFilter: Roles, $mcaDynamicRoleFilter: McaDynamicRole) {
  permissions(
    offset: $offset
    limit: $limit
    search: $search
    roleFilter: $roleFilter
    mcaDynamicRoleFilter: $mcaDynamicRoleFilter
  ) {
    total
    offset
    limit
    data {
      name
      area
      description
      roles
      mcaDynamicRoles
      modifiedBy
      modifiedAt
    }
  }
}
    `;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      roleFilter: // value for 'roleFilter'
 *      mcaDynamicRoleFilter: // value for 'mcaDynamicRoleFilter'
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
// @ts-ignore
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionsQuery, PermissionsQueryVariables>;
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionsQuery | undefined, PermissionsQueryVariables>;
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsSuspenseQueryHookResult = ReturnType<typeof usePermissionsSuspenseQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const PermissionDocument = gql`
    query permission($name: String!) {
  permission(name: $name) {
    name
    area
    description
    roles
    mcaDynamicRoles
    modifiedBy
    modifiedAt
  }
}
    `;

/**
 * __usePermissionQuery__
 *
 * To run a query within a React component, call `usePermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePermissionQuery(baseOptions: Apollo.QueryHookOptions<PermissionQuery, PermissionQueryVariables> & ({ variables: PermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionQuery, PermissionQueryVariables>(PermissionDocument, options);
      }
export function usePermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionQuery, PermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionQuery, PermissionQueryVariables>(PermissionDocument, options);
        }
// @ts-ignore
export function usePermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionQuery, PermissionQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionQuery, PermissionQueryVariables>;
export function usePermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionQuery, PermissionQueryVariables>): Apollo.UseSuspenseQueryResult<PermissionQuery | undefined, PermissionQueryVariables>;
export function usePermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionQuery, PermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionQuery, PermissionQueryVariables>(PermissionDocument, options);
        }
export type PermissionQueryHookResult = ReturnType<typeof usePermissionQuery>;
export type PermissionLazyQueryHookResult = ReturnType<typeof usePermissionLazyQuery>;
export type PermissionSuspenseQueryHookResult = ReturnType<typeof usePermissionSuspenseQuery>;
export type PermissionQueryResult = Apollo.QueryResult<PermissionQuery, PermissionQueryVariables>;
export const UpdatePermissionDocument = gql`
    mutation updatePermission($name: String!, $input: UpdatePermissionInput!) {
  updatePermission(name: $name, input: $input) {
    name
    area
    description
    roles
    mcaDynamicRoles
    modifiedBy
    modifiedAt
  }
}
    `;
export type UpdatePermissionMutationFn = Apollo.MutationFunction<UpdatePermissionMutation, UpdatePermissionMutationVariables>;

/**
 * __useUpdatePermissionMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionMutation, { data, loading, error }] = useUpdatePermissionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionMutation, UpdatePermissionMutationVariables>(UpdatePermissionDocument, options);
      }
export type UpdatePermissionMutationHookResult = ReturnType<typeof useUpdatePermissionMutation>;
export type UpdatePermissionMutationResult = Apollo.MutationResult<UpdatePermissionMutation>;
export type UpdatePermissionMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>;
export const PortFolioChartDocument = gql`
    query portFolioChart($months: Float = 12) {
  portFolioChart(months: $months) {
    attorney
    notPaying
    resumed
    inHouseLegal
    open
    slow
    collections
    verySlow
    completed
    writtenOff
    settled
    date
    profitAndLoss
    totalMcaCount
    totalAmount
    totalPayback
    totalAmtPaidClr
    monthTotal
    originationPerformanceAmount
  }
}
    `;

/**
 * __usePortFolioChartQuery__
 *
 * To run a query within a React component, call `usePortFolioChartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortFolioChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortFolioChartQuery({
 *   variables: {
 *      months: // value for 'months'
 *   },
 * });
 */
export function usePortFolioChartQuery(baseOptions?: Apollo.QueryHookOptions<PortFolioChartQuery, PortFolioChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortFolioChartQuery, PortFolioChartQueryVariables>(PortFolioChartDocument, options);
      }
export function usePortFolioChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortFolioChartQuery, PortFolioChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortFolioChartQuery, PortFolioChartQueryVariables>(PortFolioChartDocument, options);
        }
// @ts-ignore
export function usePortFolioChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortFolioChartQuery, PortFolioChartQueryVariables>): Apollo.UseSuspenseQueryResult<PortFolioChartQuery, PortFolioChartQueryVariables>;
export function usePortFolioChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortFolioChartQuery, PortFolioChartQueryVariables>): Apollo.UseSuspenseQueryResult<PortFolioChartQuery | undefined, PortFolioChartQueryVariables>;
export function usePortFolioChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortFolioChartQuery, PortFolioChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortFolioChartQuery, PortFolioChartQueryVariables>(PortFolioChartDocument, options);
        }
export type PortFolioChartQueryHookResult = ReturnType<typeof usePortFolioChartQuery>;
export type PortFolioChartLazyQueryHookResult = ReturnType<typeof usePortFolioChartLazyQuery>;
export type PortFolioChartSuspenseQueryHookResult = ReturnType<typeof usePortFolioChartSuspenseQuery>;
export type PortFolioChartQueryResult = Apollo.QueryResult<PortFolioChartQuery, PortFolioChartQueryVariables>;
export const PortFolioSummaryDocument = gql`
    query portFolioSummary {
  portFolioSummary {
    collections
    verySlow
    notPaying
    resumed
    resumedCount
    inHouseLegal
    open
    slow
    attorney
    verySlowCount
    openCount
    attorneyCount
    collectionsCount
    notPayingCount
    inHouseLegalCount
    slowCount
    portFolioValue
    totalPortFolio
    portFolioCount
    totalPortFolioCount
    activeReceivables
    activeReceivablesCount
    totalReceivables
    totalReceivablesCount
    totalCompleted
    totalCompletedCount
    totalAccumulated
    totalAccumulatedCount
    completed
    settled
    writtenOff
    completedCount
    writtenOffCount
    settledCount
  }
}
    `;

/**
 * __usePortFolioSummaryQuery__
 *
 * To run a query within a React component, call `usePortFolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortFolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortFolioSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortFolioSummaryQuery(baseOptions?: Apollo.QueryHookOptions<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>(PortFolioSummaryDocument, options);
      }
export function usePortFolioSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>(PortFolioSummaryDocument, options);
        }
// @ts-ignore
export function usePortFolioSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>;
export function usePortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<PortFolioSummaryQuery | undefined, PortFolioSummaryQueryVariables>;
export function usePortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>(PortFolioSummaryDocument, options);
        }
export type PortFolioSummaryQueryHookResult = ReturnType<typeof usePortFolioSummaryQuery>;
export type PortFolioSummaryLazyQueryHookResult = ReturnType<typeof usePortFolioSummaryLazyQuery>;
export type PortFolioSummarySuspenseQueryHookResult = ReturnType<typeof usePortFolioSummarySuspenseQuery>;
export type PortFolioSummaryQueryResult = Apollo.QueryResult<PortFolioSummaryQuery, PortFolioSummaryQueryVariables>;
export const PortfolioMerchantCashAdvancesDocument = gql`
    query portfolioMerchantCashAdvances($offset: Int = 0, $limit: Int = 50, $search: String, $status: [MerchantCashAdvanceStatus!], $excludeStatus: [MerchantCashAdvanceStatus!], $lastTransactionStatus: [TransactionStatus!], $merchatId: ID = null, $investorId: ID = null, $sortArgs: [SortArgs!] = []) {
  portfolioMerchantCashAdvances(
    offset: $offset
    limit: $limit
    search: $search
    status: $status
    excludeStatus: $excludeStatus
    lastTransactionStatus: $lastTransactionStatus
    merchantId: $merchatId
    investorId: $investorId
    sortArgs: $sortArgs
  ) {
    data {
      id
      number
      merchant {
        id
        legalName
        dba
        logo
      }
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      funder {
        id
        code
        name
        logo
      }
      company {
        id
        legalName
        dba
        logo
      }
      status
      amount
      payback
      factorRate
      term
      commissionPercentage
      startDate
      fundingDate
      endDate
      lastPmtDay
      completion
      amtpaidclr
      amtpaidpnd
      balanceclr
      lastTransaction {
        status
        type
        originationDate
        effectiveDate
        depositDate
        returnDate
        returnCode
        amount
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __usePortfolioMerchantCashAdvancesQuery__
 *
 * To run a query within a React component, call `usePortfolioMerchantCashAdvancesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioMerchantCashAdvancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioMerchantCashAdvancesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      excludeStatus: // value for 'excludeStatus'
 *      lastTransactionStatus: // value for 'lastTransactionStatus'
 *      merchatId: // value for 'merchatId'
 *      investorId: // value for 'investorId'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function usePortfolioMerchantCashAdvancesQuery(baseOptions?: Apollo.QueryHookOptions<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>(PortfolioMerchantCashAdvancesDocument, options);
      }
export function usePortfolioMerchantCashAdvancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>(PortfolioMerchantCashAdvancesDocument, options);
        }
// @ts-ignore
export function usePortfolioMerchantCashAdvancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>): Apollo.UseSuspenseQueryResult<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>;
export function usePortfolioMerchantCashAdvancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>): Apollo.UseSuspenseQueryResult<PortfolioMerchantCashAdvancesQuery | undefined, PortfolioMerchantCashAdvancesQueryVariables>;
export function usePortfolioMerchantCashAdvancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>(PortfolioMerchantCashAdvancesDocument, options);
        }
export type PortfolioMerchantCashAdvancesQueryHookResult = ReturnType<typeof usePortfolioMerchantCashAdvancesQuery>;
export type PortfolioMerchantCashAdvancesLazyQueryHookResult = ReturnType<typeof usePortfolioMerchantCashAdvancesLazyQuery>;
export type PortfolioMerchantCashAdvancesSuspenseQueryHookResult = ReturnType<typeof usePortfolioMerchantCashAdvancesSuspenseQuery>;
export type PortfolioMerchantCashAdvancesQueryResult = Apollo.QueryResult<PortfolioMerchantCashAdvancesQuery, PortfolioMerchantCashAdvancesQueryVariables>;
export const FundersPortFolioSummaryDocument = gql`
    query fundersPortFolioSummary {
  fundersPortFolioSummary {
    collections
    verySlow
    notPaying
    inHouseLegal
    open
    slow
    attorney
    completed
    writtenOff
    settled
    total
    totalMcaCount
    totalAmount
    totalPayback
    poolNetValue
    poolGrossValue
    profitAndLoss
    funder {
      id
      code
      name
      logo
    }
  }
}
    `;

/**
 * __useFundersPortFolioSummaryQuery__
 *
 * To run a query within a React component, call `useFundersPortFolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundersPortFolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundersPortFolioSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundersPortFolioSummaryQuery(baseOptions?: Apollo.QueryHookOptions<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>(FundersPortFolioSummaryDocument, options);
      }
export function useFundersPortFolioSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>(FundersPortFolioSummaryDocument, options);
        }
// @ts-ignore
export function useFundersPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>;
export function useFundersPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<FundersPortFolioSummaryQuery | undefined, FundersPortFolioSummaryQueryVariables>;
export function useFundersPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>(FundersPortFolioSummaryDocument, options);
        }
export type FundersPortFolioSummaryQueryHookResult = ReturnType<typeof useFundersPortFolioSummaryQuery>;
export type FundersPortFolioSummaryLazyQueryHookResult = ReturnType<typeof useFundersPortFolioSummaryLazyQuery>;
export type FundersPortFolioSummarySuspenseQueryHookResult = ReturnType<typeof useFundersPortFolioSummarySuspenseQuery>;
export type FundersPortFolioSummaryQueryResult = Apollo.QueryResult<FundersPortFolioSummaryQuery, FundersPortFolioSummaryQueryVariables>;
export const InvestorsPortFolioSummaryDocument = gql`
    query investorsPortFolioSummary($forAssignedPortfolios: Boolean = false, $months: Int) {
  investorsPortFolioSummary(
    forAssignedPortfolios: $forAssignedPortfolios
    months: $months
  ) {
    collections
    verySlow
    notPaying
    inHouseLegal
    open
    slow
    attorney
    completed
    writtenOff
    resumed
    settled
    total
    userId
    name
    avatar
    role
    totalMcaCount
    totalAmount
    totalPayback
    totalAmtPaidClr
    poolNetValue
    poolGrossValue
    profitAndLoss
    originationPerformanceAmount
  }
}
    `;

/**
 * __useInvestorsPortFolioSummaryQuery__
 *
 * To run a query within a React component, call `useInvestorsPortFolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorsPortFolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorsPortFolioSummaryQuery({
 *   variables: {
 *      forAssignedPortfolios: // value for 'forAssignedPortfolios'
 *      months: // value for 'months'
 *   },
 * });
 */
export function useInvestorsPortFolioSummaryQuery(baseOptions?: Apollo.QueryHookOptions<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>(InvestorsPortFolioSummaryDocument, options);
      }
export function useInvestorsPortFolioSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>(InvestorsPortFolioSummaryDocument, options);
        }
// @ts-ignore
export function useInvestorsPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>;
export function useInvestorsPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorsPortFolioSummaryQuery | undefined, InvestorsPortFolioSummaryQueryVariables>;
export function useInvestorsPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>(InvestorsPortFolioSummaryDocument, options);
        }
export type InvestorsPortFolioSummaryQueryHookResult = ReturnType<typeof useInvestorsPortFolioSummaryQuery>;
export type InvestorsPortFolioSummaryLazyQueryHookResult = ReturnType<typeof useInvestorsPortFolioSummaryLazyQuery>;
export type InvestorsPortFolioSummarySuspenseQueryHookResult = ReturnType<typeof useInvestorsPortFolioSummarySuspenseQuery>;
export type InvestorsPortFolioSummaryQueryResult = Apollo.QueryResult<InvestorsPortFolioSummaryQuery, InvestorsPortFolioSummaryQueryVariables>;
export const MyPortFolioSummaryChartDocument = gql`
    query myPortFolioSummaryChart($months: Int = 12) {
  myPortFolioSummaryChart(months: $months) {
    date
    collections
    verySlow
    notPaying
    inHouseLegal
    open
    slow
    attorney
    completed
    writtenOff
    settled
    total
    userId
    name
    avatar
    role
    totalMcaCount
    totalAmount
    totalPayback
    poolNetValue
    poolGrossValue
    profitAndLoss
  }
}
    `;

/**
 * __useMyPortFolioSummaryChartQuery__
 *
 * To run a query within a React component, call `useMyPortFolioSummaryChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPortFolioSummaryChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPortFolioSummaryChartQuery({
 *   variables: {
 *      months: // value for 'months'
 *   },
 * });
 */
export function useMyPortFolioSummaryChartQuery(baseOptions?: Apollo.QueryHookOptions<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>(MyPortFolioSummaryChartDocument, options);
      }
export function useMyPortFolioSummaryChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>(MyPortFolioSummaryChartDocument, options);
        }
// @ts-ignore
export function useMyPortFolioSummaryChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>): Apollo.UseSuspenseQueryResult<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>;
export function useMyPortFolioSummaryChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>): Apollo.UseSuspenseQueryResult<MyPortFolioSummaryChartQuery | undefined, MyPortFolioSummaryChartQueryVariables>;
export function useMyPortFolioSummaryChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>(MyPortFolioSummaryChartDocument, options);
        }
export type MyPortFolioSummaryChartQueryHookResult = ReturnType<typeof useMyPortFolioSummaryChartQuery>;
export type MyPortFolioSummaryChartLazyQueryHookResult = ReturnType<typeof useMyPortFolioSummaryChartLazyQuery>;
export type MyPortFolioSummaryChartSuspenseQueryHookResult = ReturnType<typeof useMyPortFolioSummaryChartSuspenseQuery>;
export type MyPortFolioSummaryChartQueryResult = Apollo.QueryResult<MyPortFolioSummaryChartQuery, MyPortFolioSummaryChartQueryVariables>;
export const MyPortFolioSummaryDocument = gql`
    query myPortFolioSummary {
  myPortFolioSummary {
    name
    avatar
    role
    openCount
    slowCount
    verySlowCount
    attorneyCount
    notPayingCount
    inHouseLegalCount
    collectionsCount
    completedCount
    writtenOffCount
    settledCount
    open
    notPaying
    inHouseLegal
    attorney
    slow
    collections
    verySlow
    writtenOff
    completed
    settled
    totalMcaCount
    totalAmount
    totalPayback
    profitAndLoss
    total
    poolNetValue
    poolGrossValue
    portFolioCount
    portFolioValue
  }
}
    `;

/**
 * __useMyPortFolioSummaryQuery__
 *
 * To run a query within a React component, call `useMyPortFolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPortFolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPortFolioSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPortFolioSummaryQuery(baseOptions?: Apollo.QueryHookOptions<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>(MyPortFolioSummaryDocument, options);
      }
export function useMyPortFolioSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>(MyPortFolioSummaryDocument, options);
        }
// @ts-ignore
export function useMyPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>;
export function useMyPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<MyPortFolioSummaryQuery | undefined, MyPortFolioSummaryQueryVariables>;
export function useMyPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>(MyPortFolioSummaryDocument, options);
        }
export type MyPortFolioSummaryQueryHookResult = ReturnType<typeof useMyPortFolioSummaryQuery>;
export type MyPortFolioSummaryLazyQueryHookResult = ReturnType<typeof useMyPortFolioSummaryLazyQuery>;
export type MyPortFolioSummarySuspenseQueryHookResult = ReturnType<typeof useMyPortFolioSummarySuspenseQuery>;
export type MyPortFolioSummaryQueryResult = Apollo.QueryResult<MyPortFolioSummaryQuery, MyPortFolioSummaryQueryVariables>;
export const InvestorPortFolioSummaryChartDocument = gql`
    query investorPortFolioSummaryChart($months: Int = 12, $userId: ID!) {
  investorPortFolioSummaryChart(months: $months, userId: $userId) {
    date
    collections
    verySlow
    notPaying
    inHouseLegal
    open
    slow
    attorney
    completed
    writtenOff
    settled
    resumed
    total
    userId
    name
    avatar
    role
    totalMcaCount
    totalAmount
    totalPayback
    totalAmtPaidClr
    poolNetValue
    poolGrossValue
    profitAndLoss
    originationPerformanceAmount
  }
}
    `;

/**
 * __useInvestorPortFolioSummaryChartQuery__
 *
 * To run a query within a React component, call `useInvestorPortFolioSummaryChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorPortFolioSummaryChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorPortFolioSummaryChartQuery({
 *   variables: {
 *      months: // value for 'months'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInvestorPortFolioSummaryChartQuery(baseOptions: Apollo.QueryHookOptions<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables> & ({ variables: InvestorPortFolioSummaryChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>(InvestorPortFolioSummaryChartDocument, options);
      }
export function useInvestorPortFolioSummaryChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>(InvestorPortFolioSummaryChartDocument, options);
        }
// @ts-ignore
export function useInvestorPortFolioSummaryChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>;
export function useInvestorPortFolioSummaryChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorPortFolioSummaryChartQuery | undefined, InvestorPortFolioSummaryChartQueryVariables>;
export function useInvestorPortFolioSummaryChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>(InvestorPortFolioSummaryChartDocument, options);
        }
export type InvestorPortFolioSummaryChartQueryHookResult = ReturnType<typeof useInvestorPortFolioSummaryChartQuery>;
export type InvestorPortFolioSummaryChartLazyQueryHookResult = ReturnType<typeof useInvestorPortFolioSummaryChartLazyQuery>;
export type InvestorPortFolioSummaryChartSuspenseQueryHookResult = ReturnType<typeof useInvestorPortFolioSummaryChartSuspenseQuery>;
export type InvestorPortFolioSummaryChartQueryResult = Apollo.QueryResult<InvestorPortFolioSummaryChartQuery, InvestorPortFolioSummaryChartQueryVariables>;
export const InvestorPortFolioSummaryDocument = gql`
    query investorPortFolioSummary($userId: ID!) {
  investorPortFolioSummary(userId: $userId) {
    userId
    name
    avatar
    role
    openCount
    slowCount
    verySlowCount
    resumedCount
    attorneyCount
    notPayingCount
    inHouseLegalCount
    collectionsCount
    completedCount
    writtenOffCount
    settledCount
    open
    notPaying
    inHouseLegal
    attorney
    slow
    collections
    verySlow
    writtenOff
    completed
    settled
    resumed
    totalMcaCount
    totalAmount
    totalPayback
    profitAndLoss
    total
    poolNetValue
    poolGrossValue
    portFolioCount
    portFolioValue
    totalPortFolioCount
    totalPortFolioValue
    activeReceivablesFunder
    activeReceivablesFunderCount
    activeReceivablesInvestor
    activeReceivablesInvestorCount
    totalReceivables
    totalReceivablesCount
    totalCompleted
    totalCompletedCount
    totalAccumulated
    totalAccumulatedCount
  }
}
    `;

/**
 * __useInvestorPortFolioSummaryQuery__
 *
 * To run a query within a React component, call `useInvestorPortFolioSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorPortFolioSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorPortFolioSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInvestorPortFolioSummaryQuery(baseOptions: Apollo.QueryHookOptions<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables> & ({ variables: InvestorPortFolioSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>(InvestorPortFolioSummaryDocument, options);
      }
export function useInvestorPortFolioSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>(InvestorPortFolioSummaryDocument, options);
        }
// @ts-ignore
export function useInvestorPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>;
export function useInvestorPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorPortFolioSummaryQuery | undefined, InvestorPortFolioSummaryQueryVariables>;
export function useInvestorPortFolioSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>(InvestorPortFolioSummaryDocument, options);
        }
export type InvestorPortFolioSummaryQueryHookResult = ReturnType<typeof useInvestorPortFolioSummaryQuery>;
export type InvestorPortFolioSummaryLazyQueryHookResult = ReturnType<typeof useInvestorPortFolioSummaryLazyQuery>;
export type InvestorPortFolioSummarySuspenseQueryHookResult = ReturnType<typeof useInvestorPortFolioSummarySuspenseQuery>;
export type InvestorPortFolioSummaryQueryResult = Apollo.QueryResult<InvestorPortFolioSummaryQuery, InvestorPortFolioSummaryQueryVariables>;
export const McaAverageFundingTermsDocument = gql`
    query mcaAverageFundingTerms {
  mcaAverageFundingTerms {
    amountAvg
    factorRateAvg
    paybackAvg
    dailyPmtAvg
    termAvg
    payoffAvg
    netWireAvg
    feesPercentageAvg
    commissionPercentageAvg
  }
}
    `;

/**
 * __useMcaAverageFundingTermsQuery__
 *
 * To run a query within a React component, call `useMcaAverageFundingTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcaAverageFundingTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcaAverageFundingTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMcaAverageFundingTermsQuery(baseOptions?: Apollo.QueryHookOptions<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>(McaAverageFundingTermsDocument, options);
      }
export function useMcaAverageFundingTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>(McaAverageFundingTermsDocument, options);
        }
// @ts-ignore
export function useMcaAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>): Apollo.UseSuspenseQueryResult<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>;
export function useMcaAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>): Apollo.UseSuspenseQueryResult<McaAverageFundingTermsQuery | undefined, McaAverageFundingTermsQueryVariables>;
export function useMcaAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>(McaAverageFundingTermsDocument, options);
        }
export type McaAverageFundingTermsQueryHookResult = ReturnType<typeof useMcaAverageFundingTermsQuery>;
export type McaAverageFundingTermsLazyQueryHookResult = ReturnType<typeof useMcaAverageFundingTermsLazyQuery>;
export type McaAverageFundingTermsSuspenseQueryHookResult = ReturnType<typeof useMcaAverageFundingTermsSuspenseQuery>;
export type McaAverageFundingTermsQueryResult = Apollo.QueryResult<McaAverageFundingTermsQuery, McaAverageFundingTermsQueryVariables>;
export const InvestorAverageFundingTermsDocument = gql`
    query investorAverageFundingTerms($userId: ID!) {
  investorAverageFundingTerms(userId: $userId) {
    amountAvg
    factorRateAvg
    paybackAvg
    dailyPmtAvg
    termAvg
    payoffAvg
    netWireAvg
    feesPercentageAvg
    commissionPercentageAvg
  }
}
    `;

/**
 * __useInvestorAverageFundingTermsQuery__
 *
 * To run a query within a React component, call `useInvestorAverageFundingTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorAverageFundingTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorAverageFundingTermsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInvestorAverageFundingTermsQuery(baseOptions: Apollo.QueryHookOptions<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables> & ({ variables: InvestorAverageFundingTermsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>(InvestorAverageFundingTermsDocument, options);
      }
export function useInvestorAverageFundingTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>(InvestorAverageFundingTermsDocument, options);
        }
// @ts-ignore
export function useInvestorAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>;
export function useInvestorAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorAverageFundingTermsQuery | undefined, InvestorAverageFundingTermsQueryVariables>;
export function useInvestorAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>(InvestorAverageFundingTermsDocument, options);
        }
export type InvestorAverageFundingTermsQueryHookResult = ReturnType<typeof useInvestorAverageFundingTermsQuery>;
export type InvestorAverageFundingTermsLazyQueryHookResult = ReturnType<typeof useInvestorAverageFundingTermsLazyQuery>;
export type InvestorAverageFundingTermsSuspenseQueryHookResult = ReturnType<typeof useInvestorAverageFundingTermsSuspenseQuery>;
export type InvestorAverageFundingTermsQueryResult = Apollo.QueryResult<InvestorAverageFundingTermsQuery, InvestorAverageFundingTermsQueryVariables>;
export const PortfoliosAverageFundingTermsDocument = gql`
    query portfoliosAverageFundingTerms {
  portfoliosAverageFundingTerms {
    amountAvg
    factorRateAvg
    paybackAvg
    dailyPmtAvg
    termAvg
    payoffAvg
    netWireAvg
    feesPercentageAvg
    commissionPercentageAvg
  }
}
    `;

/**
 * __usePortfoliosAverageFundingTermsQuery__
 *
 * To run a query within a React component, call `usePortfoliosAverageFundingTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfoliosAverageFundingTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfoliosAverageFundingTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortfoliosAverageFundingTermsQuery(baseOptions?: Apollo.QueryHookOptions<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>(PortfoliosAverageFundingTermsDocument, options);
      }
export function usePortfoliosAverageFundingTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>(PortfoliosAverageFundingTermsDocument, options);
        }
// @ts-ignore
export function usePortfoliosAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>): Apollo.UseSuspenseQueryResult<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>;
export function usePortfoliosAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>): Apollo.UseSuspenseQueryResult<PortfoliosAverageFundingTermsQuery | undefined, PortfoliosAverageFundingTermsQueryVariables>;
export function usePortfoliosAverageFundingTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>(PortfoliosAverageFundingTermsDocument, options);
        }
export type PortfoliosAverageFundingTermsQueryHookResult = ReturnType<typeof usePortfoliosAverageFundingTermsQuery>;
export type PortfoliosAverageFundingTermsLazyQueryHookResult = ReturnType<typeof usePortfoliosAverageFundingTermsLazyQuery>;
export type PortfoliosAverageFundingTermsSuspenseQueryHookResult = ReturnType<typeof usePortfoliosAverageFundingTermsSuspenseQuery>;
export type PortfoliosAverageFundingTermsQueryResult = Apollo.QueryResult<PortfoliosAverageFundingTermsQuery, PortfoliosAverageFundingTermsQueryVariables>;
export const ListSyndicationDetailsDocument = gql`
    query listSyndicationDetails($offset: Int = 0, $limit: Int = 10, $search: String, $status: [MerchantCashAdvanceStatus!], $dateFrom: Date, $dateTo: Date, $fundingDateFrom: Date, $fundingDateTo: Date, $sortArgs: [SortArgs!] = [], $userId: ID!) {
  listSyndicationDetails(
    offset: $offset
    limit: $limit
    search: $search
    status: $status
    dateFrom: $dateFrom
    dateTo: $dateTo
    fundingDateFrom: $fundingDateFrom
    fundingDateTo: $fundingDateTo
    sortArgs: $sortArgs
    userId: $userId
  ) {
    data {
      id
      mcaId
      amount
      fundingAmount
      type
      mcaNumber
      mcaStatus
      mcaLoanAmount
      mcaFactorRate
      mcaTerm
      mcaStartDate
      mcaFundingDate
      mcaEndDate
      completion
      perfTerm
      nrt
      mcaPerfEndDate
      syndicationPayback
      syndicationPmt
      syndicationPercentage
      serviceFeePercentage
      syndicationAmtPaidClr
      syndicationBalanceClr
      syndicationAmtPaidPnd
      syndicationBalanceClrWFees
      syndicationBalancePnd
      syndicationBalancePndWFees
      syndicationPnlNet
      syndicationPnlGross
      syndicationNetInvested
      brkCommissionAmount
      isoCommissionAmount
      syndicationType
      orgFeeAmount
      serviceFeeAmount
      wireFee
      crmFee
      otherFee
      syndicationPayoff
      syndicationNetWire
      syndicationGrossProfit
      syndicationNetProfit
      syndicationPnL
      pmt
      lastPmtDay
      payback
      amtPaidPnd
      amtPaidClr
      balanceClr
      balanceClrWFees
      balancePnd
      balancePndWFees
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      merchant {
        id
        legalName
        dba
        logo
      }
      funder {
        id
        code
        name
        logo
      }
      broker {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        company {
          id
          email
          phone
          legalName
          dba
          type
          logo
        }
      }
      legal {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        company {
          id
          email
          phone
          legalName
          dba
          type
          logo
        }
      }
      manager {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      externalConnections {
        id
        isActive
        configuration
        externalServiceConfiguration {
          id
          name
          type
          createdAt
          logo
          company {
            id
            legalName
            dba
            logo
          }
        }
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useListSyndicationDetailsQuery__
 *
 * To run a query within a React component, call `useListSyndicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSyndicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSyndicationDetailsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      fundingDateFrom: // value for 'fundingDateFrom'
 *      fundingDateTo: // value for 'fundingDateTo'
 *      sortArgs: // value for 'sortArgs'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useListSyndicationDetailsQuery(baseOptions: Apollo.QueryHookOptions<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables> & ({ variables: ListSyndicationDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>(ListSyndicationDetailsDocument, options);
      }
export function useListSyndicationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>(ListSyndicationDetailsDocument, options);
        }
// @ts-ignore
export function useListSyndicationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>;
export function useListSyndicationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSyndicationDetailsQuery | undefined, ListSyndicationDetailsQueryVariables>;
export function useListSyndicationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>(ListSyndicationDetailsDocument, options);
        }
export type ListSyndicationDetailsQueryHookResult = ReturnType<typeof useListSyndicationDetailsQuery>;
export type ListSyndicationDetailsLazyQueryHookResult = ReturnType<typeof useListSyndicationDetailsLazyQuery>;
export type ListSyndicationDetailsSuspenseQueryHookResult = ReturnType<typeof useListSyndicationDetailsSuspenseQuery>;
export type ListSyndicationDetailsQueryResult = Apollo.QueryResult<ListSyndicationDetailsQuery, ListSyndicationDetailsQueryVariables>;
export const SyndicationDetailsSummaryDocument = gql`
    query syndicationDetailsSummary($offset: Int = 0, $limit: Int = 10, $search: String, $status: [MerchantCashAdvanceStatus!], $dateFrom: Date, $dateTo: Date, $fundingDateFrom: Date, $fundingDateTo: Date, $sortArgs: [SortArgs!] = [], $userId: ID!) {
  syndicationDetailsSummary(
    offset: $offset
    limit: $limit
    search: $search
    status: $status
    dateFrom: $dateFrom
    dateTo: $dateTo
    fundingDateFrom: $fundingDateFrom
    fundingDateTo: $fundingDateTo
    sortArgs: $sortArgs
    userId: $userId
  ) {
    amount
    syndicationAmtPaidClr
    syndicationBalanceClr
    syndicationAmtPaidPnd
    syndicationBalanceClrWFees
    syndicationBalancePnd
    syndicationBalancePndWFees
    syndicationPayback
    fundingAmount
    completion
    nrt
    syndicationNetInvested
    payback
    amtPaidPnd
    amtPaidClr
    balanceClr
    balancePnd
    syndicationPayoff
    syndicationNetWire
    brkCommissionAmount
    isoCommissionAmount
    orgFeeAmount
    wireFee
    crmFee
    otherFee
    syndicationGrossProfit
    syndicationNetProfit
    syndicationPnL
    SyndicationNetInvested
  }
}
    `;

/**
 * __useSyndicationDetailsSummaryQuery__
 *
 * To run a query within a React component, call `useSyndicationDetailsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyndicationDetailsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyndicationDetailsSummaryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      fundingDateFrom: // value for 'fundingDateFrom'
 *      fundingDateTo: // value for 'fundingDateTo'
 *      sortArgs: // value for 'sortArgs'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSyndicationDetailsSummaryQuery(baseOptions: Apollo.QueryHookOptions<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables> & ({ variables: SyndicationDetailsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>(SyndicationDetailsSummaryDocument, options);
      }
export function useSyndicationDetailsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>(SyndicationDetailsSummaryDocument, options);
        }
// @ts-ignore
export function useSyndicationDetailsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>;
export function useSyndicationDetailsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<SyndicationDetailsSummaryQuery | undefined, SyndicationDetailsSummaryQueryVariables>;
export function useSyndicationDetailsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>(SyndicationDetailsSummaryDocument, options);
        }
export type SyndicationDetailsSummaryQueryHookResult = ReturnType<typeof useSyndicationDetailsSummaryQuery>;
export type SyndicationDetailsSummaryLazyQueryHookResult = ReturnType<typeof useSyndicationDetailsSummaryLazyQuery>;
export type SyndicationDetailsSummarySuspenseQueryHookResult = ReturnType<typeof useSyndicationDetailsSummarySuspenseQuery>;
export type SyndicationDetailsSummaryQueryResult = Apollo.QueryResult<SyndicationDetailsSummaryQuery, SyndicationDetailsSummaryQueryVariables>;
export const ListAllSyndicationDetailsDocument = gql`
    query listAllSyndicationDetails($offset: Int = 0, $limit: Int = 10, $search: String, $status: [MerchantCashAdvanceStatus!], $dateFrom: Date, $dateTo: Date, $fundingDateFrom: Date, $fundingDateTo: Date, $sortArgs: [SortArgs!] = [], $investorId: ID = null) {
  listAllSyndicationDetails(
    offset: $offset
    limit: $limit
    search: $search
    status: $status
    sortArgs: $sortArgs
    dateFrom: $dateFrom
    dateTo: $dateTo
    fundingDateFrom: $fundingDateFrom
    fundingDateTo: $fundingDateTo
    investorId: $investorId
  ) {
    data {
      id
      mcaId
      investorId
      amount
      fundingAmount
      type
      mcaNumber
      mcaStatus
      mcaLoanAmount
      mcaFactorRate
      mcaTerm
      mcaStartDate
      mcaFundingDate
      mcaEndDate
      completion
      perfTerm
      nrt
      amtPaidPnd
      amtPaidClr
      balanceClr
      balancePnd
      pmt
      lastPmtDay
      payback
      mcaPerfEndDate
      syndicationPayback
      syndicationPmt
      syndicationPercentage
      syndicationAmtPaidClr
      syndicationBalanceClr
      syndicationAmtPaidPnd
      syndicationBalanceClrWFees
      syndicationBalancePnd
      syndicationBalancePndWFees
      syndicationPnlNet
      syndicationPnlGross
      syndicationNetInvested
      brkCommissionAmount
      isoCommissionAmount
      syndicationType
      orgFeeAmount
      serviceFeeAmount
      serviceFeePercentage
      wireFee
      crmFee
      otherFee
      syndicationPayoff
      syndicationNetWire
      syndicationGrossProfit
      syndicationNetProfit
      syndicationPnL
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      merchant {
        id
        legalName
        dba
        logo
      }
      funder {
        id
        code
        name
        logo
      }
      broker {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        company {
          id
          email
          phone
          legalName
          dba
          type
          logo
        }
      }
      legal {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
        company {
          id
          email
          phone
          legalName
          dba
          type
          logo
        }
      }
      manager {
        id
        name
        email
        isActive
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      externalConnections {
        id
        isActive
        configuration
        externalServiceConfiguration {
          id
          name
          type
          createdAt
          logo
          company {
            id
            legalName
            dba
            logo
          }
        }
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useListAllSyndicationDetailsQuery__
 *
 * To run a query within a React component, call `useListAllSyndicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllSyndicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllSyndicationDetailsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      fundingDateFrom: // value for 'fundingDateFrom'
 *      fundingDateTo: // value for 'fundingDateTo'
 *      sortArgs: // value for 'sortArgs'
 *      investorId: // value for 'investorId'
 *   },
 * });
 */
export function useListAllSyndicationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>(ListAllSyndicationDetailsDocument, options);
      }
export function useListAllSyndicationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>(ListAllSyndicationDetailsDocument, options);
        }
// @ts-ignore
export function useListAllSyndicationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>;
export function useListAllSyndicationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ListAllSyndicationDetailsQuery | undefined, ListAllSyndicationDetailsQueryVariables>;
export function useListAllSyndicationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>(ListAllSyndicationDetailsDocument, options);
        }
export type ListAllSyndicationDetailsQueryHookResult = ReturnType<typeof useListAllSyndicationDetailsQuery>;
export type ListAllSyndicationDetailsLazyQueryHookResult = ReturnType<typeof useListAllSyndicationDetailsLazyQuery>;
export type ListAllSyndicationDetailsSuspenseQueryHookResult = ReturnType<typeof useListAllSyndicationDetailsSuspenseQuery>;
export type ListAllSyndicationDetailsQueryResult = Apollo.QueryResult<ListAllSyndicationDetailsQuery, ListAllSyndicationDetailsQueryVariables>;
export const AllSyndicationDetailsSummaryDocument = gql`
    query allSyndicationDetailsSummary($offset: Int = 0, $limit: Int = 10, $search: String, $status: [MerchantCashAdvanceStatus!], $sortArgs: [SortArgs!] = [], $investorId: ID = null) {
  allSyndicationDetailsSummary(
    offset: $offset
    limit: $limit
    search: $search
    status: $status
    sortArgs: $sortArgs
    investorId: $investorId
  ) {
    amount
    syndicationAmtPaidClr
    syndicationBalanceClr
    syndicationAmtPaidPnd
    syndicationBalanceClrWFees
    syndicationBalancePnd
    syndicationBalancePndWFees
    syndicationPayback
    fundingAmount
    payback
    amtPaidPnd
    amtPaidClr
    balanceClr
    balancePnd
    syndicationNetInvested
    completion
    nrt
    syndicationPayoff
    syndicationNetWire
    brkCommissionAmount
    isoCommissionAmount
    orgFeeAmount
    wireFee
    crmFee
    otherFee
    syndicationGrossProfit
    syndicationNetProfit
    syndicationPnL
    syndicationNetInvested
  }
}
    `;

/**
 * __useAllSyndicationDetailsSummaryQuery__
 *
 * To run a query within a React component, call `useAllSyndicationDetailsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSyndicationDetailsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSyndicationDetailsSummaryQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      sortArgs: // value for 'sortArgs'
 *      investorId: // value for 'investorId'
 *   },
 * });
 */
export function useAllSyndicationDetailsSummaryQuery(baseOptions?: Apollo.QueryHookOptions<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>(AllSyndicationDetailsSummaryDocument, options);
      }
export function useAllSyndicationDetailsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>(AllSyndicationDetailsSummaryDocument, options);
        }
// @ts-ignore
export function useAllSyndicationDetailsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>;
export function useAllSyndicationDetailsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<AllSyndicationDetailsSummaryQuery | undefined, AllSyndicationDetailsSummaryQueryVariables>;
export function useAllSyndicationDetailsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>(AllSyndicationDetailsSummaryDocument, options);
        }
export type AllSyndicationDetailsSummaryQueryHookResult = ReturnType<typeof useAllSyndicationDetailsSummaryQuery>;
export type AllSyndicationDetailsSummaryLazyQueryHookResult = ReturnType<typeof useAllSyndicationDetailsSummaryLazyQuery>;
export type AllSyndicationDetailsSummarySuspenseQueryHookResult = ReturnType<typeof useAllSyndicationDetailsSummarySuspenseQuery>;
export type AllSyndicationDetailsSummaryQueryResult = Apollo.QueryResult<AllSyndicationDetailsSummaryQuery, AllSyndicationDetailsSummaryQueryVariables>;
export const InvestorReconciliationBalancesDocument = gql`
    query investorReconciliationBalances($investorId: ID!) {
  investorReconciliationBalances(investorId: $investorId) {
    data {
      type
      label
      amount
      transactionsCount
      lastReconciliationBy {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      lastReconciliationAt
      lastReconciliationAction
      reconciliations {
        id
        reconciliationAction
        transactionsCount
        amount
        createdAt
        createdBy {
          id
          name
          data {
            cellPhone
            bizPhone
            firstName
            lastName
            dateOfBirth
            avatar
            description
            ssn
            address {
              line1
              city
              state
              zip
            }
          }
        }
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useInvestorReconciliationBalancesQuery__
 *
 * To run a query within a React component, call `useInvestorReconciliationBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorReconciliationBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorReconciliationBalancesQuery({
 *   variables: {
 *      investorId: // value for 'investorId'
 *   },
 * });
 */
export function useInvestorReconciliationBalancesQuery(baseOptions: Apollo.QueryHookOptions<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables> & ({ variables: InvestorReconciliationBalancesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>(InvestorReconciliationBalancesDocument, options);
      }
export function useInvestorReconciliationBalancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>(InvestorReconciliationBalancesDocument, options);
        }
// @ts-ignore
export function useInvestorReconciliationBalancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>;
export function useInvestorReconciliationBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorReconciliationBalancesQuery | undefined, InvestorReconciliationBalancesQueryVariables>;
export function useInvestorReconciliationBalancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>(InvestorReconciliationBalancesDocument, options);
        }
export type InvestorReconciliationBalancesQueryHookResult = ReturnType<typeof useInvestorReconciliationBalancesQuery>;
export type InvestorReconciliationBalancesLazyQueryHookResult = ReturnType<typeof useInvestorReconciliationBalancesLazyQuery>;
export type InvestorReconciliationBalancesSuspenseQueryHookResult = ReturnType<typeof useInvestorReconciliationBalancesSuspenseQuery>;
export type InvestorReconciliationBalancesQueryResult = Apollo.QueryResult<InvestorReconciliationBalancesQuery, InvestorReconciliationBalancesQueryVariables>;
export const SaveReconciliationDocument = gql`
    mutation saveReconciliation($reconciliationType: ReconciliationType!, $investorId: ID!, $acknowledged: Boolean!) {
  saveReconciliation(
    reconciliationType: $reconciliationType
    investorId: $investorId
    acknowledged: $acknowledged
  ) {
    id
    reconciliationType
    amount
    transactionsCount
    createdAt
    notes
    investor {
      id
      email
    }
    createdBy {
      id
      email
    }
  }
}
    `;
export type SaveReconciliationMutationFn = Apollo.MutationFunction<SaveReconciliationMutation, SaveReconciliationMutationVariables>;

/**
 * __useSaveReconciliationMutation__
 *
 * To run a mutation, you first call `useSaveReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveReconciliationMutation, { data, loading, error }] = useSaveReconciliationMutation({
 *   variables: {
 *      reconciliationType: // value for 'reconciliationType'
 *      investorId: // value for 'investorId'
 *      acknowledged: // value for 'acknowledged'
 *   },
 * });
 */
export function useSaveReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<SaveReconciliationMutation, SaveReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveReconciliationMutation, SaveReconciliationMutationVariables>(SaveReconciliationDocument, options);
      }
export type SaveReconciliationMutationHookResult = ReturnType<typeof useSaveReconciliationMutation>;
export type SaveReconciliationMutationResult = Apollo.MutationResult<SaveReconciliationMutation>;
export type SaveReconciliationMutationOptions = Apollo.BaseMutationOptions<SaveReconciliationMutation, SaveReconciliationMutationVariables>;
export const PauseRecurrencyDocument = gql`
    mutation pauseRecurrency($recurrencyId: ID!, $cancelTodayTransaction: Boolean) {
  pauseRecurrency(
    recurrencyId: $recurrencyId
    cancelTodayTransaction: $cancelTodayTransaction
  )
}
    `;
export type PauseRecurrencyMutationFn = Apollo.MutationFunction<PauseRecurrencyMutation, PauseRecurrencyMutationVariables>;

/**
 * __usePauseRecurrencyMutation__
 *
 * To run a mutation, you first call `usePauseRecurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseRecurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseRecurrencyMutation, { data, loading, error }] = usePauseRecurrencyMutation({
 *   variables: {
 *      recurrencyId: // value for 'recurrencyId'
 *      cancelTodayTransaction: // value for 'cancelTodayTransaction'
 *   },
 * });
 */
export function usePauseRecurrencyMutation(baseOptions?: Apollo.MutationHookOptions<PauseRecurrencyMutation, PauseRecurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseRecurrencyMutation, PauseRecurrencyMutationVariables>(PauseRecurrencyDocument, options);
      }
export type PauseRecurrencyMutationHookResult = ReturnType<typeof usePauseRecurrencyMutation>;
export type PauseRecurrencyMutationResult = Apollo.MutationResult<PauseRecurrencyMutation>;
export type PauseRecurrencyMutationOptions = Apollo.BaseMutationOptions<PauseRecurrencyMutation, PauseRecurrencyMutationVariables>;
export const ResumeRecurrencyDocument = gql`
    mutation resumeRecurrency($recurrencyId: ID!, $tryCreateTodayTransaction: Boolean) {
  resumeRecurrency(
    recurrencyId: $recurrencyId
    tryCreateTodayTransaction: $tryCreateTodayTransaction
  )
}
    `;
export type ResumeRecurrencyMutationFn = Apollo.MutationFunction<ResumeRecurrencyMutation, ResumeRecurrencyMutationVariables>;

/**
 * __useResumeRecurrencyMutation__
 *
 * To run a mutation, you first call `useResumeRecurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeRecurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeRecurrencyMutation, { data, loading, error }] = useResumeRecurrencyMutation({
 *   variables: {
 *      recurrencyId: // value for 'recurrencyId'
 *      tryCreateTodayTransaction: // value for 'tryCreateTodayTransaction'
 *   },
 * });
 */
export function useResumeRecurrencyMutation(baseOptions?: Apollo.MutationHookOptions<ResumeRecurrencyMutation, ResumeRecurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeRecurrencyMutation, ResumeRecurrencyMutationVariables>(ResumeRecurrencyDocument, options);
      }
export type ResumeRecurrencyMutationHookResult = ReturnType<typeof useResumeRecurrencyMutation>;
export type ResumeRecurrencyMutationResult = Apollo.MutationResult<ResumeRecurrencyMutation>;
export type ResumeRecurrencyMutationOptions = Apollo.BaseMutationOptions<ResumeRecurrencyMutation, ResumeRecurrencyMutationVariables>;
export const StopRecurrencyDocument = gql`
    mutation stopRecurrency($recurrencyId: ID!, $cancelTodayTransaction: Boolean) {
  stopRecurrency(
    recurrencyId: $recurrencyId
    cancelTodayTransaction: $cancelTodayTransaction
  )
}
    `;
export type StopRecurrencyMutationFn = Apollo.MutationFunction<StopRecurrencyMutation, StopRecurrencyMutationVariables>;

/**
 * __useStopRecurrencyMutation__
 *
 * To run a mutation, you first call `useStopRecurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRecurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRecurrencyMutation, { data, loading, error }] = useStopRecurrencyMutation({
 *   variables: {
 *      recurrencyId: // value for 'recurrencyId'
 *      cancelTodayTransaction: // value for 'cancelTodayTransaction'
 *   },
 * });
 */
export function useStopRecurrencyMutation(baseOptions?: Apollo.MutationHookOptions<StopRecurrencyMutation, StopRecurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopRecurrencyMutation, StopRecurrencyMutationVariables>(StopRecurrencyDocument, options);
      }
export type StopRecurrencyMutationHookResult = ReturnType<typeof useStopRecurrencyMutation>;
export type StopRecurrencyMutationResult = Apollo.MutationResult<StopRecurrencyMutation>;
export type StopRecurrencyMutationOptions = Apollo.BaseMutationOptions<StopRecurrencyMutation, StopRecurrencyMutationVariables>;
export const StopRecurrencyTransactionDocument = gql`
    mutation stopRecurrencyTransaction($recurrencyId: ID!, $transactionId: String!) {
  stopRecurrencyTransaction(
    recurrencyId: $recurrencyId
    transactionExternalId: $transactionId
  )
}
    `;
export type StopRecurrencyTransactionMutationFn = Apollo.MutationFunction<StopRecurrencyTransactionMutation, StopRecurrencyTransactionMutationVariables>;

/**
 * __useStopRecurrencyTransactionMutation__
 *
 * To run a mutation, you first call `useStopRecurrencyTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRecurrencyTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRecurrencyTransactionMutation, { data, loading, error }] = useStopRecurrencyTransactionMutation({
 *   variables: {
 *      recurrencyId: // value for 'recurrencyId'
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useStopRecurrencyTransactionMutation(baseOptions?: Apollo.MutationHookOptions<StopRecurrencyTransactionMutation, StopRecurrencyTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopRecurrencyTransactionMutation, StopRecurrencyTransactionMutationVariables>(StopRecurrencyTransactionDocument, options);
      }
export type StopRecurrencyTransactionMutationHookResult = ReturnType<typeof useStopRecurrencyTransactionMutation>;
export type StopRecurrencyTransactionMutationResult = Apollo.MutationResult<StopRecurrencyTransactionMutation>;
export type StopRecurrencyTransactionMutationOptions = Apollo.BaseMutationOptions<StopRecurrencyTransactionMutation, StopRecurrencyTransactionMutationVariables>;
export const GetRecurrencyProcessorDataDocument = gql`
    query getRecurrencyProcessorData($recurrencyId: ID!) {
  getRecurrencyProcessorData(recurrencyId: $recurrencyId) {
    processorReference
    startDate
    description
    amount
    totalAmount
    routingNumber
    accountNumber
    isActive
    isPaused
    isStopped
  }
}
    `;

/**
 * __useGetRecurrencyProcessorDataQuery__
 *
 * To run a query within a React component, call `useGetRecurrencyProcessorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurrencyProcessorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurrencyProcessorDataQuery({
 *   variables: {
 *      recurrencyId: // value for 'recurrencyId'
 *   },
 * });
 */
export function useGetRecurrencyProcessorDataQuery(baseOptions: Apollo.QueryHookOptions<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables> & ({ variables: GetRecurrencyProcessorDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>(GetRecurrencyProcessorDataDocument, options);
      }
export function useGetRecurrencyProcessorDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>(GetRecurrencyProcessorDataDocument, options);
        }
// @ts-ignore
export function useGetRecurrencyProcessorDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>;
export function useGetRecurrencyProcessorDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecurrencyProcessorDataQuery | undefined, GetRecurrencyProcessorDataQueryVariables>;
export function useGetRecurrencyProcessorDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>(GetRecurrencyProcessorDataDocument, options);
        }
export type GetRecurrencyProcessorDataQueryHookResult = ReturnType<typeof useGetRecurrencyProcessorDataQuery>;
export type GetRecurrencyProcessorDataLazyQueryHookResult = ReturnType<typeof useGetRecurrencyProcessorDataLazyQuery>;
export type GetRecurrencyProcessorDataSuspenseQueryHookResult = ReturnType<typeof useGetRecurrencyProcessorDataSuspenseQuery>;
export type GetRecurrencyProcessorDataQueryResult = Apollo.QueryResult<GetRecurrencyProcessorDataQuery, GetRecurrencyProcessorDataQueryVariables>;
export const GetRecurrencyDocument = gql`
    query getRecurrency($id: ID!) {
  recurrency(id: $id) {
    id
    mca {
      id
    }
    state
    referenceMca
    processorReference
    referenceRecurrence
    recurrenceNumber
    stateNotes
    description
    amount
    dailyPayment
    routingNumber
    accountNumber
    term
    startDate
    integration {
      id
      name
      description
      autostart
      type
      logo
    }
  }
}
    `;

/**
 * __useGetRecurrencyQuery__
 *
 * To run a query within a React component, call `useGetRecurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurrencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecurrencyQuery(baseOptions: Apollo.QueryHookOptions<GetRecurrencyQuery, GetRecurrencyQueryVariables> & ({ variables: GetRecurrencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurrencyQuery, GetRecurrencyQueryVariables>(GetRecurrencyDocument, options);
      }
export function useGetRecurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurrencyQuery, GetRecurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurrencyQuery, GetRecurrencyQueryVariables>(GetRecurrencyDocument, options);
        }
// @ts-ignore
export function useGetRecurrencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecurrencyQuery, GetRecurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecurrencyQuery, GetRecurrencyQueryVariables>;
export function useGetRecurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecurrencyQuery, GetRecurrencyQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecurrencyQuery | undefined, GetRecurrencyQueryVariables>;
export function useGetRecurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecurrencyQuery, GetRecurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecurrencyQuery, GetRecurrencyQueryVariables>(GetRecurrencyDocument, options);
        }
export type GetRecurrencyQueryHookResult = ReturnType<typeof useGetRecurrencyQuery>;
export type GetRecurrencyLazyQueryHookResult = ReturnType<typeof useGetRecurrencyLazyQuery>;
export type GetRecurrencySuspenseQueryHookResult = ReturnType<typeof useGetRecurrencySuspenseQuery>;
export type GetRecurrencyQueryResult = Apollo.QueryResult<GetRecurrencyQuery, GetRecurrencyQueryVariables>;
export const SaveRecurrencyDocument = gql`
    mutation saveRecurrency($id: ID!, $mcaId: ID!, $integrationId: ID!, $dto: RecurrencyDto!) {
  saveRecurrency(
    id: $id
    mcaId: $mcaId
    integrationId: $integrationId
    recurrency: $dto
  ) {
    id
    state
    referenceMca
    processorReference
    referenceRecurrence
    recurrenceNumber
    stateNotes
    description
    amount
    dailyPayment
    routingNumber
    accountNumber
    term
    startDate
    integration {
      id
      name
      description
      autostart
      type
      logo
    }
  }
}
    `;
export type SaveRecurrencyMutationFn = Apollo.MutationFunction<SaveRecurrencyMutation, SaveRecurrencyMutationVariables>;

/**
 * __useSaveRecurrencyMutation__
 *
 * To run a mutation, you first call `useSaveRecurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveRecurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveRecurrencyMutation, { data, loading, error }] = useSaveRecurrencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *      integrationId: // value for 'integrationId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveRecurrencyMutation(baseOptions?: Apollo.MutationHookOptions<SaveRecurrencyMutation, SaveRecurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveRecurrencyMutation, SaveRecurrencyMutationVariables>(SaveRecurrencyDocument, options);
      }
export type SaveRecurrencyMutationHookResult = ReturnType<typeof useSaveRecurrencyMutation>;
export type SaveRecurrencyMutationResult = Apollo.MutationResult<SaveRecurrencyMutation>;
export type SaveRecurrencyMutationOptions = Apollo.BaseMutationOptions<SaveRecurrencyMutation, SaveRecurrencyMutationVariables>;
export const SubmitRecurrencyToProcessorDocument = gql`
    mutation submitRecurrencyToProcessor($recurrencyId: ID!) {
  submitRecurrencyToProcessor(recurrencyId: $recurrencyId) {
    id
    state
    referenceMca
    processorReference
    referenceRecurrence
    recurrenceNumber
    stateNotes
    description
    amount
    dailyPayment
    routingNumber
    accountNumber
    term
    startDate
    integration {
      id
      name
      description
      autostart
      autostart
      type
      logo
    }
  }
}
    `;
export type SubmitRecurrencyToProcessorMutationFn = Apollo.MutationFunction<SubmitRecurrencyToProcessorMutation, SubmitRecurrencyToProcessorMutationVariables>;

/**
 * __useSubmitRecurrencyToProcessorMutation__
 *
 * To run a mutation, you first call `useSubmitRecurrencyToProcessorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRecurrencyToProcessorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRecurrencyToProcessorMutation, { data, loading, error }] = useSubmitRecurrencyToProcessorMutation({
 *   variables: {
 *      recurrencyId: // value for 'recurrencyId'
 *   },
 * });
 */
export function useSubmitRecurrencyToProcessorMutation(baseOptions?: Apollo.MutationHookOptions<SubmitRecurrencyToProcessorMutation, SubmitRecurrencyToProcessorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitRecurrencyToProcessorMutation, SubmitRecurrencyToProcessorMutationVariables>(SubmitRecurrencyToProcessorDocument, options);
      }
export type SubmitRecurrencyToProcessorMutationHookResult = ReturnType<typeof useSubmitRecurrencyToProcessorMutation>;
export type SubmitRecurrencyToProcessorMutationResult = Apollo.MutationResult<SubmitRecurrencyToProcessorMutation>;
export type SubmitRecurrencyToProcessorMutationOptions = Apollo.BaseMutationOptions<SubmitRecurrencyToProcessorMutation, SubmitRecurrencyToProcessorMutationVariables>;
export const McaRecurrenciesDocument = gql`
    query mcaRecurrencies($id: ID!) {
  mcaRecurrencies(mcaId: $id) {
    id
    state
    referenceMca
    processorReference
    referenceRecurrence
    recurrenceNumber
    stateNotes
    description
    amount
    dailyPayment
    routingNumber
    accountNumber
    term
    startDate
    integration {
      id
      name
      description
      autostart
      type
      logo
      company {
        id
        legalName
        dba
        logo
      }
    }
  }
}
    `;

/**
 * __useMcaRecurrenciesQuery__
 *
 * To run a query within a React component, call `useMcaRecurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcaRecurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcaRecurrenciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMcaRecurrenciesQuery(baseOptions: Apollo.QueryHookOptions<McaRecurrenciesQuery, McaRecurrenciesQueryVariables> & ({ variables: McaRecurrenciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>(McaRecurrenciesDocument, options);
      }
export function useMcaRecurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>(McaRecurrenciesDocument, options);
        }
// @ts-ignore
export function useMcaRecurrenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>;
export function useMcaRecurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>): Apollo.UseSuspenseQueryResult<McaRecurrenciesQuery | undefined, McaRecurrenciesQueryVariables>;
export function useMcaRecurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>(McaRecurrenciesDocument, options);
        }
export type McaRecurrenciesQueryHookResult = ReturnType<typeof useMcaRecurrenciesQuery>;
export type McaRecurrenciesLazyQueryHookResult = ReturnType<typeof useMcaRecurrenciesLazyQuery>;
export type McaRecurrenciesSuspenseQueryHookResult = ReturnType<typeof useMcaRecurrenciesSuspenseQuery>;
export type McaRecurrenciesQueryResult = Apollo.QueryResult<McaRecurrenciesQuery, McaRecurrenciesQueryVariables>;
export const AssignExistingRecurrencyDocument = gql`
    mutation assignExistingRecurrency($mcaId: ID!, $integrationId: ID!, $processorReference: String!) {
  assignExistingRecurrency(
    mcaId: $mcaId
    integrationId: $integrationId
    processorReference: $processorReference
  ) {
    id
    state
    referenceMca
    processorReference
    referenceRecurrence
    recurrenceNumber
    stateNotes
    description
    amount
    dailyPayment
    routingNumber
    accountNumber
    term
    startDate
    integration {
      id
      name
      description
      autostart
      type
      logo
    }
  }
}
    `;
export type AssignExistingRecurrencyMutationFn = Apollo.MutationFunction<AssignExistingRecurrencyMutation, AssignExistingRecurrencyMutationVariables>;

/**
 * __useAssignExistingRecurrencyMutation__
 *
 * To run a mutation, you first call `useAssignExistingRecurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignExistingRecurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignExistingRecurrencyMutation, { data, loading, error }] = useAssignExistingRecurrencyMutation({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      integrationId: // value for 'integrationId'
 *      processorReference: // value for 'processorReference'
 *   },
 * });
 */
export function useAssignExistingRecurrencyMutation(baseOptions?: Apollo.MutationHookOptions<AssignExistingRecurrencyMutation, AssignExistingRecurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignExistingRecurrencyMutation, AssignExistingRecurrencyMutationVariables>(AssignExistingRecurrencyDocument, options);
      }
export type AssignExistingRecurrencyMutationHookResult = ReturnType<typeof useAssignExistingRecurrencyMutation>;
export type AssignExistingRecurrencyMutationResult = Apollo.MutationResult<AssignExistingRecurrencyMutation>;
export type AssignExistingRecurrencyMutationOptions = Apollo.BaseMutationOptions<AssignExistingRecurrencyMutation, AssignExistingRecurrencyMutationVariables>;
export const DeleteRecurrencyWithErrorDocument = gql`
    mutation deleteRecurrencyWithError($id: ID!) {
  deleteRecurrencyWithError(id: $id)
}
    `;
export type DeleteRecurrencyWithErrorMutationFn = Apollo.MutationFunction<DeleteRecurrencyWithErrorMutation, DeleteRecurrencyWithErrorMutationVariables>;

/**
 * __useDeleteRecurrencyWithErrorMutation__
 *
 * To run a mutation, you first call `useDeleteRecurrencyWithErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRecurrencyWithErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRecurrencyWithErrorMutation, { data, loading, error }] = useDeleteRecurrencyWithErrorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRecurrencyWithErrorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRecurrencyWithErrorMutation, DeleteRecurrencyWithErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRecurrencyWithErrorMutation, DeleteRecurrencyWithErrorMutationVariables>(DeleteRecurrencyWithErrorDocument, options);
      }
export type DeleteRecurrencyWithErrorMutationHookResult = ReturnType<typeof useDeleteRecurrencyWithErrorMutation>;
export type DeleteRecurrencyWithErrorMutationResult = Apollo.MutationResult<DeleteRecurrencyWithErrorMutation>;
export type DeleteRecurrencyWithErrorMutationOptions = Apollo.BaseMutationOptions<DeleteRecurrencyWithErrorMutation, DeleteRecurrencyWithErrorMutationVariables>;
export const GetRecurrencyAccountNumberDocument = gql`
    query getRecurrencyAccountNumber($recurrencyId: ID!) {
  getRecurrencyAccountNumber(recurrencyId: $recurrencyId)
}
    `;

/**
 * __useGetRecurrencyAccountNumberQuery__
 *
 * To run a query within a React component, call `useGetRecurrencyAccountNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurrencyAccountNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurrencyAccountNumberQuery({
 *   variables: {
 *      recurrencyId: // value for 'recurrencyId'
 *   },
 * });
 */
export function useGetRecurrencyAccountNumberQuery(baseOptions: Apollo.QueryHookOptions<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables> & ({ variables: GetRecurrencyAccountNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>(GetRecurrencyAccountNumberDocument, options);
      }
export function useGetRecurrencyAccountNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>(GetRecurrencyAccountNumberDocument, options);
        }
// @ts-ignore
export function useGetRecurrencyAccountNumberSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>;
export function useGetRecurrencyAccountNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>): Apollo.UseSuspenseQueryResult<GetRecurrencyAccountNumberQuery | undefined, GetRecurrencyAccountNumberQueryVariables>;
export function useGetRecurrencyAccountNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>(GetRecurrencyAccountNumberDocument, options);
        }
export type GetRecurrencyAccountNumberQueryHookResult = ReturnType<typeof useGetRecurrencyAccountNumberQuery>;
export type GetRecurrencyAccountNumberLazyQueryHookResult = ReturnType<typeof useGetRecurrencyAccountNumberLazyQuery>;
export type GetRecurrencyAccountNumberSuspenseQueryHookResult = ReturnType<typeof useGetRecurrencyAccountNumberSuspenseQuery>;
export type GetRecurrencyAccountNumberQueryResult = Apollo.QueryResult<GetRecurrencyAccountNumberQuery, GetRecurrencyAccountNumberQueryVariables>;
export const RolesDocument = gql`
    query roles($offset: Int = 0, $limit: Int = 10) {
  roles(offset: $offset, limit: $limit) {
    total
    data {
      id
      name
      createdAt
      modifiedAt
    }
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
// @ts-ignore
export function useRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>): Apollo.UseSuspenseQueryResult<RolesQuery, RolesQueryVariables>;
export function useRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>): Apollo.UseSuspenseQueryResult<RolesQuery | undefined, RolesQueryVariables>;
export function useRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesSuspenseQueryHookResult = ReturnType<typeof useRolesSuspenseQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const RoleDocument = gql`
    query role($id: ID!) {
  role(id: $id) {
    id
    name
    createdAt
    modifiedAt
  }
}
    `;

/**
 * __useRoleQuery__
 *
 * To run a query within a React component, call `useRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoleQuery(baseOptions: Apollo.QueryHookOptions<RoleQuery, RoleQueryVariables> & ({ variables: RoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
      }
export function useRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RoleQuery, RoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
        }
// @ts-ignore
export function useRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RoleQuery, RoleQueryVariables>): Apollo.UseSuspenseQueryResult<RoleQuery, RoleQueryVariables>;
export function useRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RoleQuery, RoleQueryVariables>): Apollo.UseSuspenseQueryResult<RoleQuery | undefined, RoleQueryVariables>;
export function useRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RoleQuery, RoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RoleQuery, RoleQueryVariables>(RoleDocument, options);
        }
export type RoleQueryHookResult = ReturnType<typeof useRoleQuery>;
export type RoleLazyQueryHookResult = ReturnType<typeof useRoleLazyQuery>;
export type RoleSuspenseQueryHookResult = ReturnType<typeof useRoleSuspenseQuery>;
export type RoleQueryResult = Apollo.QueryResult<RoleQuery, RoleQueryVariables>;
export const RolesRightsMappingDocument = gql`
    query rolesRightsMapping {
  rolesRightsMapping {
    role
    rights
  }
}
    `;

/**
 * __useRolesRightsMappingQuery__
 *
 * To run a query within a React component, call `useRolesRightsMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesRightsMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesRightsMappingQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesRightsMappingQuery(baseOptions?: Apollo.QueryHookOptions<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>(RolesRightsMappingDocument, options);
      }
export function useRolesRightsMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>(RolesRightsMappingDocument, options);
        }
// @ts-ignore
export function useRolesRightsMappingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>): Apollo.UseSuspenseQueryResult<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>;
export function useRolesRightsMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>): Apollo.UseSuspenseQueryResult<RolesRightsMappingQuery | undefined, RolesRightsMappingQueryVariables>;
export function useRolesRightsMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>(RolesRightsMappingDocument, options);
        }
export type RolesRightsMappingQueryHookResult = ReturnType<typeof useRolesRightsMappingQuery>;
export type RolesRightsMappingLazyQueryHookResult = ReturnType<typeof useRolesRightsMappingLazyQuery>;
export type RolesRightsMappingSuspenseQueryHookResult = ReturnType<typeof useRolesRightsMappingSuspenseQuery>;
export type RolesRightsMappingQueryResult = Apollo.QueryResult<RolesRightsMappingQuery, RolesRightsMappingQueryVariables>;
export const CreateStipulationDocument = gql`
    mutation createStipulation($input: CreateStipulationInput!) {
  createStipulation(input: $input) {
    id
    name
    description
  }
}
    `;
export type CreateStipulationMutationFn = Apollo.MutationFunction<CreateStipulationMutation, CreateStipulationMutationVariables>;

/**
 * __useCreateStipulationMutation__
 *
 * To run a mutation, you first call `useCreateStipulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStipulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStipulationMutation, { data, loading, error }] = useCreateStipulationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStipulationMutation(baseOptions?: Apollo.MutationHookOptions<CreateStipulationMutation, CreateStipulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStipulationMutation, CreateStipulationMutationVariables>(CreateStipulationDocument, options);
      }
export type CreateStipulationMutationHookResult = ReturnType<typeof useCreateStipulationMutation>;
export type CreateStipulationMutationResult = Apollo.MutationResult<CreateStipulationMutation>;
export type CreateStipulationMutationOptions = Apollo.BaseMutationOptions<CreateStipulationMutation, CreateStipulationMutationVariables>;
export const UpdateStipulationDocument = gql`
    mutation updateStipulation($id: ID!, $input: UpdateStipulationInput!) {
  updateStipulation(id: $id, input: $input) {
    id
    name
    description
  }
}
    `;
export type UpdateStipulationMutationFn = Apollo.MutationFunction<UpdateStipulationMutation, UpdateStipulationMutationVariables>;

/**
 * __useUpdateStipulationMutation__
 *
 * To run a mutation, you first call `useUpdateStipulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStipulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStipulationMutation, { data, loading, error }] = useUpdateStipulationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStipulationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStipulationMutation, UpdateStipulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStipulationMutation, UpdateStipulationMutationVariables>(UpdateStipulationDocument, options);
      }
export type UpdateStipulationMutationHookResult = ReturnType<typeof useUpdateStipulationMutation>;
export type UpdateStipulationMutationResult = Apollo.MutationResult<UpdateStipulationMutation>;
export type UpdateStipulationMutationOptions = Apollo.BaseMutationOptions<UpdateStipulationMutation, UpdateStipulationMutationVariables>;
export const DeleteStipulationDocument = gql`
    mutation deleteStipulation($id: ID!) {
  deleteStipulation(id: $id)
}
    `;
export type DeleteStipulationMutationFn = Apollo.MutationFunction<DeleteStipulationMutation, DeleteStipulationMutationVariables>;

/**
 * __useDeleteStipulationMutation__
 *
 * To run a mutation, you first call `useDeleteStipulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStipulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStipulationMutation, { data, loading, error }] = useDeleteStipulationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStipulationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStipulationMutation, DeleteStipulationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStipulationMutation, DeleteStipulationMutationVariables>(DeleteStipulationDocument, options);
      }
export type DeleteStipulationMutationHookResult = ReturnType<typeof useDeleteStipulationMutation>;
export type DeleteStipulationMutationResult = Apollo.MutationResult<DeleteStipulationMutation>;
export type DeleteStipulationMutationOptions = Apollo.BaseMutationOptions<DeleteStipulationMutation, DeleteStipulationMutationVariables>;
export const GetStipulationDocument = gql`
    query getStipulation($id: ID!) {
  stipulation(id: $id) {
    id
    name
    description
  }
}
    `;

/**
 * __useGetStipulationQuery__
 *
 * To run a query within a React component, call `useGetStipulationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStipulationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStipulationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStipulationQuery(baseOptions: Apollo.QueryHookOptions<GetStipulationQuery, GetStipulationQueryVariables> & ({ variables: GetStipulationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStipulationQuery, GetStipulationQueryVariables>(GetStipulationDocument, options);
      }
export function useGetStipulationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStipulationQuery, GetStipulationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStipulationQuery, GetStipulationQueryVariables>(GetStipulationDocument, options);
        }
// @ts-ignore
export function useGetStipulationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStipulationQuery, GetStipulationQueryVariables>): Apollo.UseSuspenseQueryResult<GetStipulationQuery, GetStipulationQueryVariables>;
export function useGetStipulationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStipulationQuery, GetStipulationQueryVariables>): Apollo.UseSuspenseQueryResult<GetStipulationQuery | undefined, GetStipulationQueryVariables>;
export function useGetStipulationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStipulationQuery, GetStipulationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStipulationQuery, GetStipulationQueryVariables>(GetStipulationDocument, options);
        }
export type GetStipulationQueryHookResult = ReturnType<typeof useGetStipulationQuery>;
export type GetStipulationLazyQueryHookResult = ReturnType<typeof useGetStipulationLazyQuery>;
export type GetStipulationSuspenseQueryHookResult = ReturnType<typeof useGetStipulationSuspenseQuery>;
export type GetStipulationQueryResult = Apollo.QueryResult<GetStipulationQuery, GetStipulationQueryVariables>;
export const StipulationsDocument = gql`
    query stipulations($search: String) {
  stipulations(search: $search) {
    id
    name
    description
  }
}
    `;

/**
 * __useStipulationsQuery__
 *
 * To run a query within a React component, call `useStipulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStipulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStipulationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useStipulationsQuery(baseOptions?: Apollo.QueryHookOptions<StipulationsQuery, StipulationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StipulationsQuery, StipulationsQueryVariables>(StipulationsDocument, options);
      }
export function useStipulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StipulationsQuery, StipulationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StipulationsQuery, StipulationsQueryVariables>(StipulationsDocument, options);
        }
// @ts-ignore
export function useStipulationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<StipulationsQuery, StipulationsQueryVariables>): Apollo.UseSuspenseQueryResult<StipulationsQuery, StipulationsQueryVariables>;
export function useStipulationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StipulationsQuery, StipulationsQueryVariables>): Apollo.UseSuspenseQueryResult<StipulationsQuery | undefined, StipulationsQueryVariables>;
export function useStipulationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StipulationsQuery, StipulationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StipulationsQuery, StipulationsQueryVariables>(StipulationsDocument, options);
        }
export type StipulationsQueryHookResult = ReturnType<typeof useStipulationsQuery>;
export type StipulationsLazyQueryHookResult = ReturnType<typeof useStipulationsLazyQuery>;
export type StipulationsSuspenseQueryHookResult = ReturnType<typeof useStipulationsSuspenseQuery>;
export type StipulationsQueryResult = Apollo.QueryResult<StipulationsQuery, StipulationsQueryVariables>;
export const McaSyndicationDocument = gql`
    query mcaSyndication($id: ID!) {
  mcaSyndication(mcaId: $id) {
    id
    amount
    user {
      id
      name
      isActive
      email
      role
      rights
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
    type
    calculationType
    brkCommissionPercentage
    isoCommissionPercentage
    orgFeeCommissionPercentage
    serviceFeePercentage
    wireFee
    crmFee
    otherFee
    syndicationPercentage
  }
}
    `;

/**
 * __useMcaSyndicationQuery__
 *
 * To run a query within a React component, call `useMcaSyndicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcaSyndicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcaSyndicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMcaSyndicationQuery(baseOptions: Apollo.QueryHookOptions<McaSyndicationQuery, McaSyndicationQueryVariables> & ({ variables: McaSyndicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McaSyndicationQuery, McaSyndicationQueryVariables>(McaSyndicationDocument, options);
      }
export function useMcaSyndicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McaSyndicationQuery, McaSyndicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McaSyndicationQuery, McaSyndicationQueryVariables>(McaSyndicationDocument, options);
        }
// @ts-ignore
export function useMcaSyndicationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McaSyndicationQuery, McaSyndicationQueryVariables>): Apollo.UseSuspenseQueryResult<McaSyndicationQuery, McaSyndicationQueryVariables>;
export function useMcaSyndicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaSyndicationQuery, McaSyndicationQueryVariables>): Apollo.UseSuspenseQueryResult<McaSyndicationQuery | undefined, McaSyndicationQueryVariables>;
export function useMcaSyndicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaSyndicationQuery, McaSyndicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McaSyndicationQuery, McaSyndicationQueryVariables>(McaSyndicationDocument, options);
        }
export type McaSyndicationQueryHookResult = ReturnType<typeof useMcaSyndicationQuery>;
export type McaSyndicationLazyQueryHookResult = ReturnType<typeof useMcaSyndicationLazyQuery>;
export type McaSyndicationSuspenseQueryHookResult = ReturnType<typeof useMcaSyndicationSuspenseQuery>;
export type McaSyndicationQueryResult = Apollo.QueryResult<McaSyndicationQuery, McaSyndicationQueryVariables>;
export const SaveSyndicationDocument = gql`
    mutation saveSyndication($dto: SyndicationDto!) {
  saveSyndication(syndication: $dto) {
    id
    amount
  }
}
    `;
export type SaveSyndicationMutationFn = Apollo.MutationFunction<SaveSyndicationMutation, SaveSyndicationMutationVariables>;

/**
 * __useSaveSyndicationMutation__
 *
 * To run a mutation, you first call `useSaveSyndicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSyndicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSyndicationMutation, { data, loading, error }] = useSaveSyndicationMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveSyndicationMutation(baseOptions?: Apollo.MutationHookOptions<SaveSyndicationMutation, SaveSyndicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSyndicationMutation, SaveSyndicationMutationVariables>(SaveSyndicationDocument, options);
      }
export type SaveSyndicationMutationHookResult = ReturnType<typeof useSaveSyndicationMutation>;
export type SaveSyndicationMutationResult = Apollo.MutationResult<SaveSyndicationMutation>;
export type SaveSyndicationMutationOptions = Apollo.BaseMutationOptions<SaveSyndicationMutation, SaveSyndicationMutationVariables>;
export const DeleteSyndicationDocument = gql`
    mutation deleteSyndication($id: ID!) {
  deleteSyndication(id: $id)
}
    `;
export type DeleteSyndicationMutationFn = Apollo.MutationFunction<DeleteSyndicationMutation, DeleteSyndicationMutationVariables>;

/**
 * __useDeleteSyndicationMutation__
 *
 * To run a mutation, you first call `useDeleteSyndicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSyndicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSyndicationMutation, { data, loading, error }] = useDeleteSyndicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSyndicationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSyndicationMutation, DeleteSyndicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSyndicationMutation, DeleteSyndicationMutationVariables>(DeleteSyndicationDocument, options);
      }
export type DeleteSyndicationMutationHookResult = ReturnType<typeof useDeleteSyndicationMutation>;
export type DeleteSyndicationMutationResult = Apollo.MutationResult<DeleteSyndicationMutation>;
export type DeleteSyndicationMutationOptions = Apollo.BaseMutationOptions<DeleteSyndicationMutation, DeleteSyndicationMutationVariables>;
export const McaTransactionsDocument = gql`
    query mcaTransactions($id: ID!) {
  mcaTransactions(mcaId: $id) {
    id
    externalId
    name
    to
    account
    status
    type
    originationDate
    effectiveDate
    depositDate
    returnCode
    returnDate
    amount
    notes
    recurrenceDescription
    createdAt
    modifiedAt
    number
    paymentMethod {
      id
      logo
      description
    }
    integration {
      id
      name
      logo
      type
      company {
        id
        legalName
        dba
        logo
      }
    }
  }
}
    `;

/**
 * __useMcaTransactionsQuery__
 *
 * To run a query within a React component, call `useMcaTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcaTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcaTransactionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMcaTransactionsQuery(baseOptions: Apollo.QueryHookOptions<McaTransactionsQuery, McaTransactionsQueryVariables> & ({ variables: McaTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McaTransactionsQuery, McaTransactionsQueryVariables>(McaTransactionsDocument, options);
      }
export function useMcaTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McaTransactionsQuery, McaTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McaTransactionsQuery, McaTransactionsQueryVariables>(McaTransactionsDocument, options);
        }
// @ts-ignore
export function useMcaTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McaTransactionsQuery, McaTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<McaTransactionsQuery, McaTransactionsQueryVariables>;
export function useMcaTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaTransactionsQuery, McaTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<McaTransactionsQuery | undefined, McaTransactionsQueryVariables>;
export function useMcaTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaTransactionsQuery, McaTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McaTransactionsQuery, McaTransactionsQueryVariables>(McaTransactionsDocument, options);
        }
export type McaTransactionsQueryHookResult = ReturnType<typeof useMcaTransactionsQuery>;
export type McaTransactionsLazyQueryHookResult = ReturnType<typeof useMcaTransactionsLazyQuery>;
export type McaTransactionsSuspenseQueryHookResult = ReturnType<typeof useMcaTransactionsSuspenseQuery>;
export type McaTransactionsQueryResult = Apollo.QueryResult<McaTransactionsQuery, McaTransactionsQueryVariables>;
export const McaFeeTransactionsDocument = gql`
    query mcaFeeTransactions($id: ID!) {
  mcaFeeTransactions(mcaId: $id) {
    id
    externalId
    name
    to
    account
    status
    type
    originationDate
    effectiveDate
    depositDate
    returnCode
    returnDate
    amount
    notes
    recurrenceDescription
    createdAt
    modifiedAt
    number
    paymentMethod {
      id
      logo
      description
    }
    integration {
      id
      name
      logo
      type
      company {
        id
        legalName
        dba
        logo
      }
    }
  }
}
    `;

/**
 * __useMcaFeeTransactionsQuery__
 *
 * To run a query within a React component, call `useMcaFeeTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcaFeeTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcaFeeTransactionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMcaFeeTransactionsQuery(baseOptions: Apollo.QueryHookOptions<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables> & ({ variables: McaFeeTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>(McaFeeTransactionsDocument, options);
      }
export function useMcaFeeTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>(McaFeeTransactionsDocument, options);
        }
// @ts-ignore
export function useMcaFeeTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>;
export function useMcaFeeTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<McaFeeTransactionsQuery | undefined, McaFeeTransactionsQueryVariables>;
export function useMcaFeeTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>(McaFeeTransactionsDocument, options);
        }
export type McaFeeTransactionsQueryHookResult = ReturnType<typeof useMcaFeeTransactionsQuery>;
export type McaFeeTransactionsLazyQueryHookResult = ReturnType<typeof useMcaFeeTransactionsLazyQuery>;
export type McaFeeTransactionsSuspenseQueryHookResult = ReturnType<typeof useMcaFeeTransactionsSuspenseQuery>;
export type McaFeeTransactionsQueryResult = Apollo.QueryResult<McaFeeTransactionsQuery, McaFeeTransactionsQueryVariables>;
export const GetMcaIntegrationsWithTransactionsCountDocument = gql`
    query getMcaIntegrationsWithTransactionsCount($mcaId: ID!) {
  getMcaIntegrationsWithTransactionsCount(mcaId: $mcaId) {
    transactionsCount
    integration {
      id
      name
      logo
      type
      autostart
      company {
        id
        legalName
        dba
        logo
      }
    }
  }
}
    `;

/**
 * __useGetMcaIntegrationsWithTransactionsCountQuery__
 *
 * To run a query within a React component, call `useGetMcaIntegrationsWithTransactionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcaIntegrationsWithTransactionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcaIntegrationsWithTransactionsCountQuery({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *   },
 * });
 */
export function useGetMcaIntegrationsWithTransactionsCountQuery(baseOptions: Apollo.QueryHookOptions<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables> & ({ variables: GetMcaIntegrationsWithTransactionsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>(GetMcaIntegrationsWithTransactionsCountDocument, options);
      }
export function useGetMcaIntegrationsWithTransactionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>(GetMcaIntegrationsWithTransactionsCountDocument, options);
        }
// @ts-ignore
export function useGetMcaIntegrationsWithTransactionsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>;
export function useGetMcaIntegrationsWithTransactionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcaIntegrationsWithTransactionsCountQuery | undefined, GetMcaIntegrationsWithTransactionsCountQueryVariables>;
export function useGetMcaIntegrationsWithTransactionsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>(GetMcaIntegrationsWithTransactionsCountDocument, options);
        }
export type GetMcaIntegrationsWithTransactionsCountQueryHookResult = ReturnType<typeof useGetMcaIntegrationsWithTransactionsCountQuery>;
export type GetMcaIntegrationsWithTransactionsCountLazyQueryHookResult = ReturnType<typeof useGetMcaIntegrationsWithTransactionsCountLazyQuery>;
export type GetMcaIntegrationsWithTransactionsCountSuspenseQueryHookResult = ReturnType<typeof useGetMcaIntegrationsWithTransactionsCountSuspenseQuery>;
export type GetMcaIntegrationsWithTransactionsCountQueryResult = Apollo.QueryResult<GetMcaIntegrationsWithTransactionsCountQuery, GetMcaIntegrationsWithTransactionsCountQueryVariables>;
export const SaveManualTransactionDocument = gql`
    mutation saveManualTransaction($dto: ManualTransactionDto!) {
  saveManualTransaction(manualTransactionDto: $dto) {
    id
    amount
  }
}
    `;
export type SaveManualTransactionMutationFn = Apollo.MutationFunction<SaveManualTransactionMutation, SaveManualTransactionMutationVariables>;

/**
 * __useSaveManualTransactionMutation__
 *
 * To run a mutation, you first call `useSaveManualTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveManualTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveManualTransactionMutation, { data, loading, error }] = useSaveManualTransactionMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveManualTransactionMutation(baseOptions?: Apollo.MutationHookOptions<SaveManualTransactionMutation, SaveManualTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveManualTransactionMutation, SaveManualTransactionMutationVariables>(SaveManualTransactionDocument, options);
      }
export type SaveManualTransactionMutationHookResult = ReturnType<typeof useSaveManualTransactionMutation>;
export type SaveManualTransactionMutationResult = Apollo.MutationResult<SaveManualTransactionMutation>;
export type SaveManualTransactionMutationOptions = Apollo.BaseMutationOptions<SaveManualTransactionMutation, SaveManualTransactionMutationVariables>;
export const DeleteManualTransactionDocument = gql`
    mutation deleteManualTransaction($id: ID!) {
  deleteManualTransaction(id: $id)
}
    `;
export type DeleteManualTransactionMutationFn = Apollo.MutationFunction<DeleteManualTransactionMutation, DeleteManualTransactionMutationVariables>;

/**
 * __useDeleteManualTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteManualTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManualTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManualTransactionMutation, { data, loading, error }] = useDeleteManualTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteManualTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManualTransactionMutation, DeleteManualTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManualTransactionMutation, DeleteManualTransactionMutationVariables>(DeleteManualTransactionDocument, options);
      }
export type DeleteManualTransactionMutationHookResult = ReturnType<typeof useDeleteManualTransactionMutation>;
export type DeleteManualTransactionMutationResult = Apollo.MutationResult<DeleteManualTransactionMutation>;
export type DeleteManualTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteManualTransactionMutation, DeleteManualTransactionMutationVariables>;
export const CancelTransactionDocument = gql`
    mutation cancelTransaction($id: ID!) {
  cancelTransaction(id: $id)
}
    `;
export type CancelTransactionMutationFn = Apollo.MutationFunction<CancelTransactionMutation, CancelTransactionMutationVariables>;

/**
 * __useCancelTransactionMutation__
 *
 * To run a mutation, you first call `useCancelTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTransactionMutation, { data, loading, error }] = useCancelTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelTransactionMutation(baseOptions?: Apollo.MutationHookOptions<CancelTransactionMutation, CancelTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTransactionMutation, CancelTransactionMutationVariables>(CancelTransactionDocument, options);
      }
export type CancelTransactionMutationHookResult = ReturnType<typeof useCancelTransactionMutation>;
export type CancelTransactionMutationResult = Apollo.MutationResult<CancelTransactionMutation>;
export type CancelTransactionMutationOptions = Apollo.BaseMutationOptions<CancelTransactionMutation, CancelTransactionMutationVariables>;
export const SaveTransactionNoteDocument = gql`
    mutation saveTransactionNote($id: ID!, $note: String!) {
  saveTransactionNote(id: $id, note: $note) {
    id
    notes
  }
}
    `;
export type SaveTransactionNoteMutationFn = Apollo.MutationFunction<SaveTransactionNoteMutation, SaveTransactionNoteMutationVariables>;

/**
 * __useSaveTransactionNoteMutation__
 *
 * To run a mutation, you first call `useSaveTransactionNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTransactionNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTransactionNoteMutation, { data, loading, error }] = useSaveTransactionNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSaveTransactionNoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveTransactionNoteMutation, SaveTransactionNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTransactionNoteMutation, SaveTransactionNoteMutationVariables>(SaveTransactionNoteDocument, options);
      }
export type SaveTransactionNoteMutationHookResult = ReturnType<typeof useSaveTransactionNoteMutation>;
export type SaveTransactionNoteMutationResult = Apollo.MutationResult<SaveTransactionNoteMutation>;
export type SaveTransactionNoteMutationOptions = Apollo.BaseMutationOptions<SaveTransactionNoteMutation, SaveTransactionNoteMutationVariables>;
export const SaveTransactionTypeDocument = gql`
    mutation saveTransactionType($id: ID!, $mcaId: ID!, $type: TransactionType!) {
  saveTransactionType(id: $id, mcaId: $mcaId, type: $type) {
    id
    mca {
      id
    }
    type
  }
}
    `;
export type SaveTransactionTypeMutationFn = Apollo.MutationFunction<SaveTransactionTypeMutation, SaveTransactionTypeMutationVariables>;

/**
 * __useSaveTransactionTypeMutation__
 *
 * To run a mutation, you first call `useSaveTransactionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTransactionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTransactionTypeMutation, { data, loading, error }] = useSaveTransactionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mcaId: // value for 'mcaId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSaveTransactionTypeMutation(baseOptions?: Apollo.MutationHookOptions<SaveTransactionTypeMutation, SaveTransactionTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTransactionTypeMutation, SaveTransactionTypeMutationVariables>(SaveTransactionTypeDocument, options);
      }
export type SaveTransactionTypeMutationHookResult = ReturnType<typeof useSaveTransactionTypeMutation>;
export type SaveTransactionTypeMutationResult = Apollo.MutationResult<SaveTransactionTypeMutation>;
export type SaveTransactionTypeMutationOptions = Apollo.BaseMutationOptions<SaveTransactionTypeMutation, SaveTransactionTypeMutationVariables>;
export const TodaysCollectionDocument = gql`
    query TodaysCollection {
  todaysCollection {
    date
    series {
      name
      amount
    }
  }
}
    `;

/**
 * __useTodaysCollectionQuery__
 *
 * To run a query within a React component, call `useTodaysCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodaysCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodaysCollectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useTodaysCollectionQuery(baseOptions?: Apollo.QueryHookOptions<TodaysCollectionQuery, TodaysCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodaysCollectionQuery, TodaysCollectionQueryVariables>(TodaysCollectionDocument, options);
      }
export function useTodaysCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodaysCollectionQuery, TodaysCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodaysCollectionQuery, TodaysCollectionQueryVariables>(TodaysCollectionDocument, options);
        }
// @ts-ignore
export function useTodaysCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TodaysCollectionQuery, TodaysCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<TodaysCollectionQuery, TodaysCollectionQueryVariables>;
export function useTodaysCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TodaysCollectionQuery, TodaysCollectionQueryVariables>): Apollo.UseSuspenseQueryResult<TodaysCollectionQuery | undefined, TodaysCollectionQueryVariables>;
export function useTodaysCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TodaysCollectionQuery, TodaysCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TodaysCollectionQuery, TodaysCollectionQueryVariables>(TodaysCollectionDocument, options);
        }
export type TodaysCollectionQueryHookResult = ReturnType<typeof useTodaysCollectionQuery>;
export type TodaysCollectionLazyQueryHookResult = ReturnType<typeof useTodaysCollectionLazyQuery>;
export type TodaysCollectionSuspenseQueryHookResult = ReturnType<typeof useTodaysCollectionSuspenseQuery>;
export type TodaysCollectionQueryResult = Apollo.QueryResult<TodaysCollectionQuery, TodaysCollectionQueryVariables>;
export const TransactionsChartDocument = gql`
    query TransactionsChart($forLastMonths: Int!, $integrationId: String, $isManual: Boolean) {
  transactionsChart(
    forLastMonths: $forLastMonths
    integrationId: $integrationId
    isManual: $isManual
  ) {
    date
    value
  }
}
    `;

/**
 * __useTransactionsChartQuery__
 *
 * To run a query within a React component, call `useTransactionsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsChartQuery({
 *   variables: {
 *      forLastMonths: // value for 'forLastMonths'
 *      integrationId: // value for 'integrationId'
 *      isManual: // value for 'isManual'
 *   },
 * });
 */
export function useTransactionsChartQuery(baseOptions: Apollo.QueryHookOptions<TransactionsChartQuery, TransactionsChartQueryVariables> & ({ variables: TransactionsChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsChartQuery, TransactionsChartQueryVariables>(TransactionsChartDocument, options);
      }
export function useTransactionsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsChartQuery, TransactionsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsChartQuery, TransactionsChartQueryVariables>(TransactionsChartDocument, options);
        }
// @ts-ignore
export function useTransactionsChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionsChartQuery, TransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsChartQuery, TransactionsChartQueryVariables>;
export function useTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsChartQuery, TransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsChartQuery | undefined, TransactionsChartQueryVariables>;
export function useTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsChartQuery, TransactionsChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsChartQuery, TransactionsChartQueryVariables>(TransactionsChartDocument, options);
        }
export type TransactionsChartQueryHookResult = ReturnType<typeof useTransactionsChartQuery>;
export type TransactionsChartLazyQueryHookResult = ReturnType<typeof useTransactionsChartLazyQuery>;
export type TransactionsChartSuspenseQueryHookResult = ReturnType<typeof useTransactionsChartSuspenseQuery>;
export type TransactionsChartQueryResult = Apollo.QueryResult<TransactionsChartQuery, TransactionsChartQueryVariables>;
export const MyTransactionsChartDocument = gql`
    query myTransactionsChart($forLastMonths: Int!) {
  myTransactionsChart(forLastMonths: $forLastMonths) {
    date
    value
  }
}
    `;

/**
 * __useMyTransactionsChartQuery__
 *
 * To run a query within a React component, call `useMyTransactionsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTransactionsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTransactionsChartQuery({
 *   variables: {
 *      forLastMonths: // value for 'forLastMonths'
 *   },
 * });
 */
export function useMyTransactionsChartQuery(baseOptions: Apollo.QueryHookOptions<MyTransactionsChartQuery, MyTransactionsChartQueryVariables> & ({ variables: MyTransactionsChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>(MyTransactionsChartDocument, options);
      }
export function useMyTransactionsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>(MyTransactionsChartDocument, options);
        }
// @ts-ignore
export function useMyTransactionsChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>;
export function useMyTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<MyTransactionsChartQuery | undefined, MyTransactionsChartQueryVariables>;
export function useMyTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>(MyTransactionsChartDocument, options);
        }
export type MyTransactionsChartQueryHookResult = ReturnType<typeof useMyTransactionsChartQuery>;
export type MyTransactionsChartLazyQueryHookResult = ReturnType<typeof useMyTransactionsChartLazyQuery>;
export type MyTransactionsChartSuspenseQueryHookResult = ReturnType<typeof useMyTransactionsChartSuspenseQuery>;
export type MyTransactionsChartQueryResult = Apollo.QueryResult<MyTransactionsChartQuery, MyTransactionsChartQueryVariables>;
export const PortfoliosTransactionsChartDocument = gql`
    query portfoliosTransactionsChart($forLastMonths: Int!) {
  portfoliosTransactionsChart(forLastMonths: $forLastMonths) {
    date
    value
  }
}
    `;

/**
 * __usePortfoliosTransactionsChartQuery__
 *
 * To run a query within a React component, call `usePortfoliosTransactionsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfoliosTransactionsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfoliosTransactionsChartQuery({
 *   variables: {
 *      forLastMonths: // value for 'forLastMonths'
 *   },
 * });
 */
export function usePortfoliosTransactionsChartQuery(baseOptions: Apollo.QueryHookOptions<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables> & ({ variables: PortfoliosTransactionsChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>(PortfoliosTransactionsChartDocument, options);
      }
export function usePortfoliosTransactionsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>(PortfoliosTransactionsChartDocument, options);
        }
// @ts-ignore
export function usePortfoliosTransactionsChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>;
export function usePortfoliosTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<PortfoliosTransactionsChartQuery | undefined, PortfoliosTransactionsChartQueryVariables>;
export function usePortfoliosTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>(PortfoliosTransactionsChartDocument, options);
        }
export type PortfoliosTransactionsChartQueryHookResult = ReturnType<typeof usePortfoliosTransactionsChartQuery>;
export type PortfoliosTransactionsChartLazyQueryHookResult = ReturnType<typeof usePortfoliosTransactionsChartLazyQuery>;
export type PortfoliosTransactionsChartSuspenseQueryHookResult = ReturnType<typeof usePortfoliosTransactionsChartSuspenseQuery>;
export type PortfoliosTransactionsChartQueryResult = Apollo.QueryResult<PortfoliosTransactionsChartQuery, PortfoliosTransactionsChartQueryVariables>;
export const InvestorTransactionsChartDocument = gql`
    query investorTransactionsChart($userId: ID!, $forLastMonths: Int!) {
  investorTransactionsChart(userId: $userId, forLastMonths: $forLastMonths) {
    date
    value
  }
}
    `;

/**
 * __useInvestorTransactionsChartQuery__
 *
 * To run a query within a React component, call `useInvestorTransactionsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorTransactionsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorTransactionsChartQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      forLastMonths: // value for 'forLastMonths'
 *   },
 * });
 */
export function useInvestorTransactionsChartQuery(baseOptions: Apollo.QueryHookOptions<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables> & ({ variables: InvestorTransactionsChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>(InvestorTransactionsChartDocument, options);
      }
export function useInvestorTransactionsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>(InvestorTransactionsChartDocument, options);
        }
// @ts-ignore
export function useInvestorTransactionsChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>;
export function useInvestorTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorTransactionsChartQuery | undefined, InvestorTransactionsChartQueryVariables>;
export function useInvestorTransactionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>(InvestorTransactionsChartDocument, options);
        }
export type InvestorTransactionsChartQueryHookResult = ReturnType<typeof useInvestorTransactionsChartQuery>;
export type InvestorTransactionsChartLazyQueryHookResult = ReturnType<typeof useInvestorTransactionsChartLazyQuery>;
export type InvestorTransactionsChartSuspenseQueryHookResult = ReturnType<typeof useInvestorTransactionsChartSuspenseQuery>;
export type InvestorTransactionsChartQueryResult = Apollo.QueryResult<InvestorTransactionsChartQuery, InvestorTransactionsChartQueryVariables>;
export const DailyCollectionsChartDocument = gql`
    query DailyCollectionsChart($forLastMonths: Int!) {
  dailyCollectionsChart(forLastMonths: $forLastMonths) {
    date
    series {
      seriesKey
      value
    }
  }
}
    `;

/**
 * __useDailyCollectionsChartQuery__
 *
 * To run a query within a React component, call `useDailyCollectionsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyCollectionsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDailyCollectionsChartQuery({
 *   variables: {
 *      forLastMonths: // value for 'forLastMonths'
 *   },
 * });
 */
export function useDailyCollectionsChartQuery(baseOptions: Apollo.QueryHookOptions<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables> & ({ variables: DailyCollectionsChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>(DailyCollectionsChartDocument, options);
      }
export function useDailyCollectionsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>(DailyCollectionsChartDocument, options);
        }
// @ts-ignore
export function useDailyCollectionsChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>;
export function useDailyCollectionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<DailyCollectionsChartQuery | undefined, DailyCollectionsChartQueryVariables>;
export function useDailyCollectionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>(DailyCollectionsChartDocument, options);
        }
export type DailyCollectionsChartQueryHookResult = ReturnType<typeof useDailyCollectionsChartQuery>;
export type DailyCollectionsChartLazyQueryHookResult = ReturnType<typeof useDailyCollectionsChartLazyQuery>;
export type DailyCollectionsChartSuspenseQueryHookResult = ReturnType<typeof useDailyCollectionsChartSuspenseQuery>;
export type DailyCollectionsChartQueryResult = Apollo.QueryResult<DailyCollectionsChartQuery, DailyCollectionsChartQueryVariables>;
export const PortfoliosCollectionsChartDocument = gql`
    query PortfoliosCollectionsChart($forLastMonths: Int!) {
  portfoliosCollectionsChart(forLastMonths: $forLastMonths) {
    date
    series {
      userId
      value
    }
  }
}
    `;

/**
 * __usePortfoliosCollectionsChartQuery__
 *
 * To run a query within a React component, call `usePortfoliosCollectionsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfoliosCollectionsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfoliosCollectionsChartQuery({
 *   variables: {
 *      forLastMonths: // value for 'forLastMonths'
 *   },
 * });
 */
export function usePortfoliosCollectionsChartQuery(baseOptions: Apollo.QueryHookOptions<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables> & ({ variables: PortfoliosCollectionsChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>(PortfoliosCollectionsChartDocument, options);
      }
export function usePortfoliosCollectionsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>(PortfoliosCollectionsChartDocument, options);
        }
// @ts-ignore
export function usePortfoliosCollectionsChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>;
export function usePortfoliosCollectionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>): Apollo.UseSuspenseQueryResult<PortfoliosCollectionsChartQuery | undefined, PortfoliosCollectionsChartQueryVariables>;
export function usePortfoliosCollectionsChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>(PortfoliosCollectionsChartDocument, options);
        }
export type PortfoliosCollectionsChartQueryHookResult = ReturnType<typeof usePortfoliosCollectionsChartQuery>;
export type PortfoliosCollectionsChartLazyQueryHookResult = ReturnType<typeof usePortfoliosCollectionsChartLazyQuery>;
export type PortfoliosCollectionsChartSuspenseQueryHookResult = ReturnType<typeof usePortfoliosCollectionsChartSuspenseQuery>;
export type PortfoliosCollectionsChartQueryResult = Apollo.QueryResult<PortfoliosCollectionsChartQuery, PortfoliosCollectionsChartQueryVariables>;
export const RecurrencyTransactionsDocument = gql`
    query recurrencyTransactions($id: ID!) {
  recurrencyTransactions(recurrencyId: $id) {
    id
    externalId
    name
    to
    account
    status
    type
    originationDate
    effectiveDate
    depositDate
    returnCode
    returnDate
    amount
    notes
    recurrenceDescription
    createdAt
    modifiedAt
    number
    paymentMethod {
      id
      logo
      description
    }
  }
}
    `;

/**
 * __useRecurrencyTransactionsQuery__
 *
 * To run a query within a React component, call `useRecurrencyTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurrencyTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurrencyTransactionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecurrencyTransactionsQuery(baseOptions: Apollo.QueryHookOptions<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables> & ({ variables: RecurrencyTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>(RecurrencyTransactionsDocument, options);
      }
export function useRecurrencyTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>(RecurrencyTransactionsDocument, options);
        }
// @ts-ignore
export function useRecurrencyTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>;
export function useRecurrencyTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<RecurrencyTransactionsQuery | undefined, RecurrencyTransactionsQueryVariables>;
export function useRecurrencyTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>(RecurrencyTransactionsDocument, options);
        }
export type RecurrencyTransactionsQueryHookResult = ReturnType<typeof useRecurrencyTransactionsQuery>;
export type RecurrencyTransactionsLazyQueryHookResult = ReturnType<typeof useRecurrencyTransactionsLazyQuery>;
export type RecurrencyTransactionsSuspenseQueryHookResult = ReturnType<typeof useRecurrencyTransactionsSuspenseQuery>;
export type RecurrencyTransactionsQueryResult = Apollo.QueryResult<RecurrencyTransactionsQuery, RecurrencyTransactionsQueryVariables>;
export const McaIntegrationTransactionsDocument = gql`
    query mcaIntegrationTransactions($mcaId: ID!, $integrationId: ID!) {
  mcaIntegrationTransactions(mcaId: $mcaId, integrationId: $integrationId) {
    id
    externalId
    name
    to
    account
    status
    type
    originationDate
    effectiveDate
    depositDate
    returnCode
    returnDate
    amount
    notes
    recurrenceDescription
    createdAt
    modifiedAt
    number
    paymentMethod {
      id
      logo
      description
    }
  }
}
    `;

/**
 * __useMcaIntegrationTransactionsQuery__
 *
 * To run a query within a React component, call `useMcaIntegrationTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcaIntegrationTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcaIntegrationTransactionsQuery({
 *   variables: {
 *      mcaId: // value for 'mcaId'
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useMcaIntegrationTransactionsQuery(baseOptions: Apollo.QueryHookOptions<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables> & ({ variables: McaIntegrationTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>(McaIntegrationTransactionsDocument, options);
      }
export function useMcaIntegrationTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>(McaIntegrationTransactionsDocument, options);
        }
// @ts-ignore
export function useMcaIntegrationTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>;
export function useMcaIntegrationTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<McaIntegrationTransactionsQuery | undefined, McaIntegrationTransactionsQueryVariables>;
export function useMcaIntegrationTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>(McaIntegrationTransactionsDocument, options);
        }
export type McaIntegrationTransactionsQueryHookResult = ReturnType<typeof useMcaIntegrationTransactionsQuery>;
export type McaIntegrationTransactionsLazyQueryHookResult = ReturnType<typeof useMcaIntegrationTransactionsLazyQuery>;
export type McaIntegrationTransactionsSuspenseQueryHookResult = ReturnType<typeof useMcaIntegrationTransactionsSuspenseQuery>;
export type McaIntegrationTransactionsQueryResult = Apollo.QueryResult<McaIntegrationTransactionsQuery, McaIntegrationTransactionsQueryVariables>;
export const StopTransactionDocument = gql`
    mutation stopTransaction($transactionId: ID!) {
  stopTransaction(transactionId: $transactionId)
}
    `;
export type StopTransactionMutationFn = Apollo.MutationFunction<StopTransactionMutation, StopTransactionMutationVariables>;

/**
 * __useStopTransactionMutation__
 *
 * To run a mutation, you first call `useStopTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopTransactionMutation, { data, loading, error }] = useStopTransactionMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useStopTransactionMutation(baseOptions?: Apollo.MutationHookOptions<StopTransactionMutation, StopTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopTransactionMutation, StopTransactionMutationVariables>(StopTransactionDocument, options);
      }
export type StopTransactionMutationHookResult = ReturnType<typeof useStopTransactionMutation>;
export type StopTransactionMutationResult = Apollo.MutationResult<StopTransactionMutation>;
export type StopTransactionMutationOptions = Apollo.BaseMutationOptions<StopTransactionMutation, StopTransactionMutationVariables>;
export const ListTransactionsDocument = gql`
    query listTransactions($offset: Int = 0, $limit: Int = 10, $integrationId: ID, $search: String, $fromDate: String!, $toDate: String!, $statuses: [TransactionStatus!], $types: [TransactionType!], $sortArgs: [SortArgs!] = []) {
  listTransactions(
    offset: $offset
    limit: $limit
    integrationId: $integrationId
    search: $search
    fromDate: $fromDate
    toDate: $toDate
    statuses: $statuses
    types: $types
    sortArgs: $sortArgs
  ) {
    data {
      id
      externalId
      name
      to
      account
      status
      type
      originationDate
      effectiveDate
      depositDate
      returnCode
      returnDate
      amount
      notes
      recurrenceDescription
      createdAt
      modifiedAt
      paymentMethod {
        id
        logo
        description
      }
      integration {
        id
        name
        logo
        type
        company {
          id
          legalName
          dba
          logo
        }
      }
      mca {
        id
        number
        status
        referenceMca
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useListTransactionsQuery__
 *
 * To run a query within a React component, call `useListTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      integrationId: // value for 'integrationId'
 *      search: // value for 'search'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useListTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables> & ({ variables: ListTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
      }
export function useListTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
        }
// @ts-ignore
export function useListTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListTransactionsQuery, ListTransactionsQueryVariables>;
export function useListTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListTransactionsQuery | undefined, ListTransactionsQueryVariables>;
export function useListTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
        }
export type ListTransactionsQueryHookResult = ReturnType<typeof useListTransactionsQuery>;
export type ListTransactionsLazyQueryHookResult = ReturnType<typeof useListTransactionsLazyQuery>;
export type ListTransactionsSuspenseQueryHookResult = ReturnType<typeof useListTransactionsSuspenseQuery>;
export type ListTransactionsQueryResult = Apollo.QueryResult<ListTransactionsQuery, ListTransactionsQueryVariables>;
export const TransactionsSummaryDocument = gql`
    query transactionsSummary($integrationId: ID, $search: String, $fromDate: String!, $toDate: String!, $statuses: [TransactionStatus!], $types: [TransactionType!]) {
  transactionsSummary(
    integrationId: $integrationId
    search: $search
    fromDate: $fromDate
    toDate: $toDate
    statuses: $statuses
    types: $types
  ) {
    amount
  }
}
    `;

/**
 * __useTransactionsSummaryQuery__
 *
 * To run a query within a React component, call `useTransactionsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsSummaryQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      search: // value for 'search'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *   },
 * });
 */
export function useTransactionsSummaryQuery(baseOptions: Apollo.QueryHookOptions<TransactionsSummaryQuery, TransactionsSummaryQueryVariables> & ({ variables: TransactionsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>(TransactionsSummaryDocument, options);
      }
export function useTransactionsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>(TransactionsSummaryDocument, options);
        }
// @ts-ignore
export function useTransactionsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>;
export function useTransactionsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<TransactionsSummaryQuery | undefined, TransactionsSummaryQueryVariables>;
export function useTransactionsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>(TransactionsSummaryDocument, options);
        }
export type TransactionsSummaryQueryHookResult = ReturnType<typeof useTransactionsSummaryQuery>;
export type TransactionsSummaryLazyQueryHookResult = ReturnType<typeof useTransactionsSummaryLazyQuery>;
export type TransactionsSummarySuspenseQueryHookResult = ReturnType<typeof useTransactionsSummarySuspenseQuery>;
export type TransactionsSummaryQueryResult = Apollo.QueryResult<TransactionsSummaryQuery, TransactionsSummaryQueryVariables>;
export const InvestorBalanceTransactionsDocument = gql`
    query investorBalanceTransactions($investorId: ID!, $offset: Int = 0, $limit: Int = 10, $statuses: [TransactionStatus!], $types: [TransactionType!], $paymentMethods: [String!], $search: String, $sortArgs: [SortArgs!] = []) {
  investorBalanceTransactions(
    investorId: $investorId
    offset: $offset
    limit: $limit
    statuses: $statuses
    types: $types
    paymentMethods: $paymentMethods
    search: $search
    sortArgs: $sortArgs
  ) {
    data {
      id
      externalId
      name
      notes
      mcaId
      mcaNumber
      mcaStatus
      merchantName
      originationDate
      effectiveDate
      depositDate
      status
      type
      number
      amount
      runningBalance
      paymentMethodId
    }
    total
    offset
    limit
    summary {
      debit
      credit
    }
  }
}
    `;

/**
 * __useInvestorBalanceTransactionsQuery__
 *
 * To run a query within a React component, call `useInvestorBalanceTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorBalanceTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorBalanceTransactionsQuery({
 *   variables: {
 *      investorId: // value for 'investorId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *      paymentMethods: // value for 'paymentMethods'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useInvestorBalanceTransactionsQuery(baseOptions: Apollo.QueryHookOptions<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables> & ({ variables: InvestorBalanceTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>(InvestorBalanceTransactionsDocument, options);
      }
export function useInvestorBalanceTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>(InvestorBalanceTransactionsDocument, options);
        }
// @ts-ignore
export function useInvestorBalanceTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>;
export function useInvestorBalanceTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorBalanceTransactionsQuery | undefined, InvestorBalanceTransactionsQueryVariables>;
export function useInvestorBalanceTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>(InvestorBalanceTransactionsDocument, options);
        }
export type InvestorBalanceTransactionsQueryHookResult = ReturnType<typeof useInvestorBalanceTransactionsQuery>;
export type InvestorBalanceTransactionsLazyQueryHookResult = ReturnType<typeof useInvestorBalanceTransactionsLazyQuery>;
export type InvestorBalanceTransactionsSuspenseQueryHookResult = ReturnType<typeof useInvestorBalanceTransactionsSuspenseQuery>;
export type InvestorBalanceTransactionsQueryResult = Apollo.QueryResult<InvestorBalanceTransactionsQuery, InvestorBalanceTransactionsQueryVariables>;
export const InvestorCashTransactionsDocument = gql`
    query investorCashTransactions($investorId: ID!, $offset: Int = 0, $limit: Int = 10, $statuses: [TransactionStatus!], $types: [TransactionType!], $search: String, $sortArgs: [SortArgs!] = []) {
  investorCashTransactions(
    investorId: $investorId
    offset: $offset
    limit: $limit
    statuses: $statuses
    types: $types
    search: $search
    sortArgs: $sortArgs
  ) {
    data {
      id
      name
      notes
      effectiveDate
      depositDate
      status
      type
      number
      amount
      runningCashInOutBalance
      paymentMethodId
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useInvestorCashTransactionsQuery__
 *
 * To run a query within a React component, call `useInvestorCashTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorCashTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorCashTransactionsQuery({
 *   variables: {
 *      investorId: // value for 'investorId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useInvestorCashTransactionsQuery(baseOptions: Apollo.QueryHookOptions<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables> & ({ variables: InvestorCashTransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>(InvestorCashTransactionsDocument, options);
      }
export function useInvestorCashTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>(InvestorCashTransactionsDocument, options);
        }
// @ts-ignore
export function useInvestorCashTransactionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>;
export function useInvestorCashTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorCashTransactionsQuery | undefined, InvestorCashTransactionsQueryVariables>;
export function useInvestorCashTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>(InvestorCashTransactionsDocument, options);
        }
export type InvestorCashTransactionsQueryHookResult = ReturnType<typeof useInvestorCashTransactionsQuery>;
export type InvestorCashTransactionsLazyQueryHookResult = ReturnType<typeof useInvestorCashTransactionsLazyQuery>;
export type InvestorCashTransactionsSuspenseQueryHookResult = ReturnType<typeof useInvestorCashTransactionsSuspenseQuery>;
export type InvestorCashTransactionsQueryResult = Apollo.QueryResult<InvestorCashTransactionsQuery, InvestorCashTransactionsQueryVariables>;
export const InvestorCashTransactionsSummaryDocument = gql`
    query investorCashTransactionsSummary($investorId: ID!, $statuses: [TransactionStatus!], $types: [TransactionType!], $search: String, $sortArgs: [SortArgs!] = []) {
  investorCashTransactionsSummary(
    investorId: $investorId
    statuses: $statuses
    types: $types
    search: $search
    sortArgs: $sortArgs
  ) {
    cashInTotal
    cashOutTotal
  }
}
    `;

/**
 * __useInvestorCashTransactionsSummaryQuery__
 *
 * To run a query within a React component, call `useInvestorCashTransactionsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorCashTransactionsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorCashTransactionsSummaryQuery({
 *   variables: {
 *      investorId: // value for 'investorId'
 *      statuses: // value for 'statuses'
 *      types: // value for 'types'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useInvestorCashTransactionsSummaryQuery(baseOptions: Apollo.QueryHookOptions<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables> & ({ variables: InvestorCashTransactionsSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>(InvestorCashTransactionsSummaryDocument, options);
      }
export function useInvestorCashTransactionsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>(InvestorCashTransactionsSummaryDocument, options);
        }
// @ts-ignore
export function useInvestorCashTransactionsSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>;
export function useInvestorCashTransactionsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorCashTransactionsSummaryQuery | undefined, InvestorCashTransactionsSummaryQueryVariables>;
export function useInvestorCashTransactionsSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>(InvestorCashTransactionsSummaryDocument, options);
        }
export type InvestorCashTransactionsSummaryQueryHookResult = ReturnType<typeof useInvestorCashTransactionsSummaryQuery>;
export type InvestorCashTransactionsSummaryLazyQueryHookResult = ReturnType<typeof useInvestorCashTransactionsSummaryLazyQuery>;
export type InvestorCashTransactionsSummarySuspenseQueryHookResult = ReturnType<typeof useInvestorCashTransactionsSummarySuspenseQuery>;
export type InvestorCashTransactionsSummaryQueryResult = Apollo.QueryResult<InvestorCashTransactionsSummaryQuery, InvestorCashTransactionsSummaryQueryVariables>;
export const SaveCashTransactionDocument = gql`
    mutation saveCashTransaction($dto: CashTransactionDto!) {
  saveCashTransaction(dto: $dto) {
    id
    amount
  }
}
    `;
export type SaveCashTransactionMutationFn = Apollo.MutationFunction<SaveCashTransactionMutation, SaveCashTransactionMutationVariables>;

/**
 * __useSaveCashTransactionMutation__
 *
 * To run a mutation, you first call `useSaveCashTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCashTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCashTransactionMutation, { data, loading, error }] = useSaveCashTransactionMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveCashTransactionMutation(baseOptions?: Apollo.MutationHookOptions<SaveCashTransactionMutation, SaveCashTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCashTransactionMutation, SaveCashTransactionMutationVariables>(SaveCashTransactionDocument, options);
      }
export type SaveCashTransactionMutationHookResult = ReturnType<typeof useSaveCashTransactionMutation>;
export type SaveCashTransactionMutationResult = Apollo.MutationResult<SaveCashTransactionMutation>;
export type SaveCashTransactionMutationOptions = Apollo.BaseMutationOptions<SaveCashTransactionMutation, SaveCashTransactionMutationVariables>;
export const DeleteCashTransactionDocument = gql`
    mutation deleteCashTransaction($id: ID!) {
  deleteCashTransaction(id: $id)
}
    `;
export type DeleteCashTransactionMutationFn = Apollo.MutationFunction<DeleteCashTransactionMutation, DeleteCashTransactionMutationVariables>;

/**
 * __useDeleteCashTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteCashTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCashTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCashTransactionMutation, { data, loading, error }] = useDeleteCashTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCashTransactionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCashTransactionMutation, DeleteCashTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCashTransactionMutation, DeleteCashTransactionMutationVariables>(DeleteCashTransactionDocument, options);
      }
export type DeleteCashTransactionMutationHookResult = ReturnType<typeof useDeleteCashTransactionMutation>;
export type DeleteCashTransactionMutationResult = Apollo.MutationResult<DeleteCashTransactionMutation>;
export type DeleteCashTransactionMutationOptions = Apollo.BaseMutationOptions<DeleteCashTransactionMutation, DeleteCashTransactionMutationVariables>;
export const InvestorBalanceDocument = gql`
    query investorBalance($userId: ID!) {
  investorBalance(userId: $userId) {
    balance
  }
}
    `;

/**
 * __useInvestorBalanceQuery__
 *
 * To run a query within a React component, call `useInvestorBalanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorBalanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorBalanceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInvestorBalanceQuery(baseOptions: Apollo.QueryHookOptions<InvestorBalanceQuery, InvestorBalanceQueryVariables> & ({ variables: InvestorBalanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorBalanceQuery, InvestorBalanceQueryVariables>(InvestorBalanceDocument, options);
      }
export function useInvestorBalanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorBalanceQuery, InvestorBalanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorBalanceQuery, InvestorBalanceQueryVariables>(InvestorBalanceDocument, options);
        }
// @ts-ignore
export function useInvestorBalanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorBalanceQuery, InvestorBalanceQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorBalanceQuery, InvestorBalanceQueryVariables>;
export function useInvestorBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorBalanceQuery, InvestorBalanceQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorBalanceQuery | undefined, InvestorBalanceQueryVariables>;
export function useInvestorBalanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorBalanceQuery, InvestorBalanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorBalanceQuery, InvestorBalanceQueryVariables>(InvestorBalanceDocument, options);
        }
export type InvestorBalanceQueryHookResult = ReturnType<typeof useInvestorBalanceQuery>;
export type InvestorBalanceLazyQueryHookResult = ReturnType<typeof useInvestorBalanceLazyQuery>;
export type InvestorBalanceSuspenseQueryHookResult = ReturnType<typeof useInvestorBalanceSuspenseQuery>;
export type InvestorBalanceQueryResult = Apollo.QueryResult<InvestorBalanceQuery, InvestorBalanceQueryVariables>;
export const InvestorBalanceChartDocument = gql`
    query investorBalanceChart($userId: ID!, $forLastMonths: Int!) {
  investorBalanceChart(userId: $userId, forLastMonths: $forLastMonths) {
    date
    value
  }
}
    `;

/**
 * __useInvestorBalanceChartQuery__
 *
 * To run a query within a React component, call `useInvestorBalanceChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorBalanceChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorBalanceChartQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      forLastMonths: // value for 'forLastMonths'
 *   },
 * });
 */
export function useInvestorBalanceChartQuery(baseOptions: Apollo.QueryHookOptions<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables> & ({ variables: InvestorBalanceChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>(InvestorBalanceChartDocument, options);
      }
export function useInvestorBalanceChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>(InvestorBalanceChartDocument, options);
        }
// @ts-ignore
export function useInvestorBalanceChartSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>;
export function useInvestorBalanceChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorBalanceChartQuery | undefined, InvestorBalanceChartQueryVariables>;
export function useInvestorBalanceChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>(InvestorBalanceChartDocument, options);
        }
export type InvestorBalanceChartQueryHookResult = ReturnType<typeof useInvestorBalanceChartQuery>;
export type InvestorBalanceChartLazyQueryHookResult = ReturnType<typeof useInvestorBalanceChartLazyQuery>;
export type InvestorBalanceChartSuspenseQueryHookResult = ReturnType<typeof useInvestorBalanceChartSuspenseQuery>;
export type InvestorBalanceChartQueryResult = Apollo.QueryResult<InvestorBalanceChartQuery, InvestorBalanceChartQueryVariables>;
export const PaymentMethodsDocument = gql`
    query paymentMethods {
  paymentMethods {
    id
    logo
    description
    order
  }
}
    `;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
// @ts-ignore
export function usePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export function usePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>): Apollo.UseSuspenseQueryResult<PaymentMethodsQuery | undefined, PaymentMethodsQueryVariables>;
export function usePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsSuspenseQueryHookResult = ReturnType<typeof usePaymentMethodsSuspenseQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const UnderwritersDocument = gql`
    query underwriters($offset: Int = 0, $limit: Int = 10, $search: String, $sortArgs: [SortArgs!] = []) {
  underwriters(
    offset: $offset
    limit: $limit
    search: $search
    sortArgs: $sortArgs
  ) {
    data {
      id
      name
      code
      logo
      description
      createdAt
      modifiedAt
      createdBy {
        id
        name
      }
      modifiedBy {
        id
        name
      }
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useUnderwritersQuery__
 *
 * To run a query within a React component, call `useUnderwritersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwritersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwritersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useUnderwritersQuery(baseOptions?: Apollo.QueryHookOptions<UnderwritersQuery, UnderwritersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderwritersQuery, UnderwritersQueryVariables>(UnderwritersDocument, options);
      }
export function useUnderwritersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderwritersQuery, UnderwritersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderwritersQuery, UnderwritersQueryVariables>(UnderwritersDocument, options);
        }
// @ts-ignore
export function useUnderwritersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnderwritersQuery, UnderwritersQueryVariables>): Apollo.UseSuspenseQueryResult<UnderwritersQuery, UnderwritersQueryVariables>;
export function useUnderwritersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnderwritersQuery, UnderwritersQueryVariables>): Apollo.UseSuspenseQueryResult<UnderwritersQuery | undefined, UnderwritersQueryVariables>;
export function useUnderwritersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnderwritersQuery, UnderwritersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnderwritersQuery, UnderwritersQueryVariables>(UnderwritersDocument, options);
        }
export type UnderwritersQueryHookResult = ReturnType<typeof useUnderwritersQuery>;
export type UnderwritersLazyQueryHookResult = ReturnType<typeof useUnderwritersLazyQuery>;
export type UnderwritersSuspenseQueryHookResult = ReturnType<typeof useUnderwritersSuspenseQuery>;
export type UnderwritersQueryResult = Apollo.QueryResult<UnderwritersQuery, UnderwritersQueryVariables>;
export const UnderwriterDocument = gql`
    query underwriter($id: ID!) {
  underwriter(id: $id) {
    id
    name
    code
    logo
    createdAt
    modifiedAt
    createdBy {
      id
      name
    }
    modifiedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useUnderwriterQuery__
 *
 * To run a query within a React component, call `useUnderwriterQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwriterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwriterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnderwriterQuery(baseOptions: Apollo.QueryHookOptions<UnderwriterQuery, UnderwriterQueryVariables> & ({ variables: UnderwriterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderwriterQuery, UnderwriterQueryVariables>(UnderwriterDocument, options);
      }
export function useUnderwriterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderwriterQuery, UnderwriterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderwriterQuery, UnderwriterQueryVariables>(UnderwriterDocument, options);
        }
// @ts-ignore
export function useUnderwriterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UnderwriterQuery, UnderwriterQueryVariables>): Apollo.UseSuspenseQueryResult<UnderwriterQuery, UnderwriterQueryVariables>;
export function useUnderwriterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnderwriterQuery, UnderwriterQueryVariables>): Apollo.UseSuspenseQueryResult<UnderwriterQuery | undefined, UnderwriterQueryVariables>;
export function useUnderwriterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnderwriterQuery, UnderwriterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnderwriterQuery, UnderwriterQueryVariables>(UnderwriterDocument, options);
        }
export type UnderwriterQueryHookResult = ReturnType<typeof useUnderwriterQuery>;
export type UnderwriterLazyQueryHookResult = ReturnType<typeof useUnderwriterLazyQuery>;
export type UnderwriterSuspenseQueryHookResult = ReturnType<typeof useUnderwriterSuspenseQuery>;
export type UnderwriterQueryResult = Apollo.QueryResult<UnderwriterQuery, UnderwriterQueryVariables>;
export const SaveUnderwriterDocument = gql`
    mutation saveUnderwriter($dto: UnderwriterDto!) {
  saveUnderwriter(underwriter: $dto) {
    id
    name
    logo
    description
  }
}
    `;
export type SaveUnderwriterMutationFn = Apollo.MutationFunction<SaveUnderwriterMutation, SaveUnderwriterMutationVariables>;

/**
 * __useSaveUnderwriterMutation__
 *
 * To run a mutation, you first call `useSaveUnderwriterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnderwriterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnderwriterMutation, { data, loading, error }] = useSaveUnderwriterMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveUnderwriterMutation(baseOptions?: Apollo.MutationHookOptions<SaveUnderwriterMutation, SaveUnderwriterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUnderwriterMutation, SaveUnderwriterMutationVariables>(SaveUnderwriterDocument, options);
      }
export type SaveUnderwriterMutationHookResult = ReturnType<typeof useSaveUnderwriterMutation>;
export type SaveUnderwriterMutationResult = Apollo.MutationResult<SaveUnderwriterMutation>;
export type SaveUnderwriterMutationOptions = Apollo.BaseMutationOptions<SaveUnderwriterMutation, SaveUnderwriterMutationVariables>;
export const DeleteUnderwriterDocument = gql`
    mutation deleteUnderwriter($id: ID!) {
  deleteUnderwriter(id: $id)
}
    `;
export type DeleteUnderwriterMutationFn = Apollo.MutationFunction<DeleteUnderwriterMutation, DeleteUnderwriterMutationVariables>;

/**
 * __useDeleteUnderwriterMutation__
 *
 * To run a mutation, you first call `useDeleteUnderwriterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUnderwriterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUnderwriterMutation, { data, loading, error }] = useDeleteUnderwriterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUnderwriterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUnderwriterMutation, DeleteUnderwriterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUnderwriterMutation, DeleteUnderwriterMutationVariables>(DeleteUnderwriterDocument, options);
      }
export type DeleteUnderwriterMutationHookResult = ReturnType<typeof useDeleteUnderwriterMutation>;
export type DeleteUnderwriterMutationResult = Apollo.MutationResult<DeleteUnderwriterMutation>;
export type DeleteUnderwriterMutationOptions = Apollo.BaseMutationOptions<DeleteUnderwriterMutation, DeleteUnderwriterMutationVariables>;
export const AddUserToUnderwriterDocument = gql`
    mutation addUserToUnderwriter($userId: ID!, $underwriterId: ID!) {
  addUserToUnderwriter(userId: $userId, underwriterId: $underwriterId) {
    user {
      id
      name
      email
    }
    funder {
      id
      name
      code
    }
  }
}
    `;
export type AddUserToUnderwriterMutationFn = Apollo.MutationFunction<AddUserToUnderwriterMutation, AddUserToUnderwriterMutationVariables>;

/**
 * __useAddUserToUnderwriterMutation__
 *
 * To run a mutation, you first call `useAddUserToUnderwriterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToUnderwriterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToUnderwriterMutation, { data, loading, error }] = useAddUserToUnderwriterMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      underwriterId: // value for 'underwriterId'
 *   },
 * });
 */
export function useAddUserToUnderwriterMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToUnderwriterMutation, AddUserToUnderwriterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToUnderwriterMutation, AddUserToUnderwriterMutationVariables>(AddUserToUnderwriterDocument, options);
      }
export type AddUserToUnderwriterMutationHookResult = ReturnType<typeof useAddUserToUnderwriterMutation>;
export type AddUserToUnderwriterMutationResult = Apollo.MutationResult<AddUserToUnderwriterMutation>;
export type AddUserToUnderwriterMutationOptions = Apollo.BaseMutationOptions<AddUserToUnderwriterMutation, AddUserToUnderwriterMutationVariables>;
export const RemoveUserFromUnderwriterDocument = gql`
    mutation removeUserFromUnderwriter($underwriterId: ID!, $userId: ID!) {
  removeUserFromUnderwriter(underwriterId: $underwriterId, userId: $userId)
}
    `;
export type RemoveUserFromUnderwriterMutationFn = Apollo.MutationFunction<RemoveUserFromUnderwriterMutation, RemoveUserFromUnderwriterMutationVariables>;

/**
 * __useRemoveUserFromUnderwriterMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromUnderwriterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromUnderwriterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromUnderwriterMutation, { data, loading, error }] = useRemoveUserFromUnderwriterMutation({
 *   variables: {
 *      underwriterId: // value for 'underwriterId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromUnderwriterMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromUnderwriterMutation, RemoveUserFromUnderwriterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromUnderwriterMutation, RemoveUserFromUnderwriterMutationVariables>(RemoveUserFromUnderwriterDocument, options);
      }
export type RemoveUserFromUnderwriterMutationHookResult = ReturnType<typeof useRemoveUserFromUnderwriterMutation>;
export type RemoveUserFromUnderwriterMutationResult = Apollo.MutationResult<RemoveUserFromUnderwriterMutation>;
export type RemoveUserFromUnderwriterMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromUnderwriterMutation, RemoveUserFromUnderwriterMutationVariables>;
export const GetUsersForUnderwriterDocument = gql`
    query getUsersForUnderwriter($underwriterId: ID!) {
  getUsersForUnderwriter(underwriterId: $underwriterId) {
    id
    name
    data {
      cellPhone
      bizPhone
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
  }
}
    `;

/**
 * __useGetUsersForUnderwriterQuery__
 *
 * To run a query within a React component, call `useGetUsersForUnderwriterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersForUnderwriterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersForUnderwriterQuery({
 *   variables: {
 *      underwriterId: // value for 'underwriterId'
 *   },
 * });
 */
export function useGetUsersForUnderwriterQuery(baseOptions: Apollo.QueryHookOptions<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables> & ({ variables: GetUsersForUnderwriterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>(GetUsersForUnderwriterDocument, options);
      }
export function useGetUsersForUnderwriterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>(GetUsersForUnderwriterDocument, options);
        }
// @ts-ignore
export function useGetUsersForUnderwriterSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>;
export function useGetUsersForUnderwriterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersForUnderwriterQuery | undefined, GetUsersForUnderwriterQueryVariables>;
export function useGetUsersForUnderwriterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>(GetUsersForUnderwriterDocument, options);
        }
export type GetUsersForUnderwriterQueryHookResult = ReturnType<typeof useGetUsersForUnderwriterQuery>;
export type GetUsersForUnderwriterLazyQueryHookResult = ReturnType<typeof useGetUsersForUnderwriterLazyQuery>;
export type GetUsersForUnderwriterSuspenseQueryHookResult = ReturnType<typeof useGetUsersForUnderwriterSuspenseQuery>;
export type GetUsersForUnderwriterQueryResult = Apollo.QueryResult<GetUsersForUnderwriterQuery, GetUsersForUnderwriterQueryVariables>;
export const GetAllUnderwritersDocument = gql`
    query getAllUnderwriters {
  getAllUnderwriters {
    id
    name
    code
    logo
    connectedUsers {
      user {
        id
        name
        data {
          avatar
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllUnderwritersQuery__
 *
 * To run a query within a React component, call `useGetAllUnderwritersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUnderwritersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUnderwritersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUnderwritersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>(GetAllUnderwritersDocument, options);
      }
export function useGetAllUnderwritersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>(GetAllUnderwritersDocument, options);
        }
// @ts-ignore
export function useGetAllUnderwritersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>;
export function useGetAllUnderwritersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllUnderwritersQuery | undefined, GetAllUnderwritersQueryVariables>;
export function useGetAllUnderwritersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>(GetAllUnderwritersDocument, options);
        }
export type GetAllUnderwritersQueryHookResult = ReturnType<typeof useGetAllUnderwritersQuery>;
export type GetAllUnderwritersLazyQueryHookResult = ReturnType<typeof useGetAllUnderwritersLazyQuery>;
export type GetAllUnderwritersSuspenseQueryHookResult = ReturnType<typeof useGetAllUnderwritersSuspenseQuery>;
export type GetAllUnderwritersQueryResult = Apollo.QueryResult<GetAllUnderwritersQuery, GetAllUnderwritersQueryVariables>;
export const GetUnderwriterMemberInfoDocument = gql`
    query getUnderwriterMemberInfo($underwriterId: ID!) {
  getUnderwriterMemberInfo(underwriterId: $underwriterId) {
    id
    name
    email
    firstName
    lastName
    avatar
    description
    bizPhone
    cellPhone
  }
}
    `;

/**
 * __useGetUnderwriterMemberInfoQuery__
 *
 * To run a query within a React component, call `useGetUnderwriterMemberInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnderwriterMemberInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnderwriterMemberInfoQuery({
 *   variables: {
 *      underwriterId: // value for 'underwriterId'
 *   },
 * });
 */
export function useGetUnderwriterMemberInfoQuery(baseOptions: Apollo.QueryHookOptions<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables> & ({ variables: GetUnderwriterMemberInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>(GetUnderwriterMemberInfoDocument, options);
      }
export function useGetUnderwriterMemberInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>(GetUnderwriterMemberInfoDocument, options);
        }
// @ts-ignore
export function useGetUnderwriterMemberInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>;
export function useGetUnderwriterMemberInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnderwriterMemberInfoQuery | undefined, GetUnderwriterMemberInfoQueryVariables>;
export function useGetUnderwriterMemberInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>(GetUnderwriterMemberInfoDocument, options);
        }
export type GetUnderwriterMemberInfoQueryHookResult = ReturnType<typeof useGetUnderwriterMemberInfoQuery>;
export type GetUnderwriterMemberInfoLazyQueryHookResult = ReturnType<typeof useGetUnderwriterMemberInfoLazyQuery>;
export type GetUnderwriterMemberInfoSuspenseQueryHookResult = ReturnType<typeof useGetUnderwriterMemberInfoSuspenseQuery>;
export type GetUnderwriterMemberInfoQueryResult = Apollo.QueryResult<GetUnderwriterMemberInfoQuery, GetUnderwriterMemberInfoQueryVariables>;
export const UptimeDocument = gql`
    query uptime {
  uptime
}
    `;

/**
 * __useUptimeQuery__
 *
 * To run a query within a React component, call `useUptimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUptimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUptimeQuery({
 *   variables: {
 *   },
 * });
 */
export function useUptimeQuery(baseOptions?: Apollo.QueryHookOptions<UptimeQuery, UptimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UptimeQuery, UptimeQueryVariables>(UptimeDocument, options);
      }
export function useUptimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UptimeQuery, UptimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UptimeQuery, UptimeQueryVariables>(UptimeDocument, options);
        }
// @ts-ignore
export function useUptimeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UptimeQuery, UptimeQueryVariables>): Apollo.UseSuspenseQueryResult<UptimeQuery, UptimeQueryVariables>;
export function useUptimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UptimeQuery, UptimeQueryVariables>): Apollo.UseSuspenseQueryResult<UptimeQuery | undefined, UptimeQueryVariables>;
export function useUptimeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UptimeQuery, UptimeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UptimeQuery, UptimeQueryVariables>(UptimeDocument, options);
        }
export type UptimeQueryHookResult = ReturnType<typeof useUptimeQuery>;
export type UptimeLazyQueryHookResult = ReturnType<typeof useUptimeLazyQuery>;
export type UptimeSuspenseQueryHookResult = ReturnType<typeof useUptimeSuspenseQuery>;
export type UptimeQueryResult = Apollo.QueryResult<UptimeQuery, UptimeQueryVariables>;
export const UsersDocument = gql`
    query users($offset: Int = 0, $limit: Int = 10, $search: String, $right: Rights, $role: [Roles!], $isActive: Boolean, $isLoginEnabled: Boolean, $managerId: ID = null, $companyId: ID = null, $rights: [Rights!], $sortArgs: [SortArgs!] = []) {
  users(
    offset: $offset
    limit: $limit
    search: $search
    right: $right
    role: $role
    isActive: $isActive
    isLoginEnabled: $isLoginEnabled
    managerId: $managerId
    companyId: $companyId
    rights: $rights
    sortArgs: $sortArgs
  ) {
    data {
      id
      email
      name
      phone
      locale
      isEmailConfirmed
      isPhoneConfirmed
      createdAt
      modifiedAt
      isLoginEnabled
      isActive
      cognitoSub
      mfaConfigured
      mfaEnabled
      accessTokenTtlHours
      mfaDeviceRememberingEnabled
      deviceRememberingDays
      enableReturnedTransactionsReport
      isOwner
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
      createdBy {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      modifiedBy {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      manager {
        id
        name
        email
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
      company {
        id
        legalName
        dba
        type
        logo
      }
      role
      rights
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      right: // value for 'right'
 *      role: // value for 'role'
 *      isActive: // value for 'isActive'
 *      isLoginEnabled: // value for 'isLoginEnabled'
 *      managerId: // value for 'managerId'
 *      companyId: // value for 'companyId'
 *      rights: // value for 'rights'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: Apollo.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): Apollo.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export const UserDocument = gql`
    query user($id: ID!) {
  user(id: $id) {
    id
    email
    name
    phone
    locale
    isLoginEnabled
    enableReturnedTransactionsReport
    isOwner
    isEmailConfirmed
    isPhoneConfirmed
    createdAt
    modifiedAt
    isActive
    data {
      cellPhone
      bizPhone
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
    createdBy {
      id
      name
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
    modifiedBy {
      id
      name
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
    manager {
      id
      name
      email
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
    company {
      id
      legalName
      dba
      type
      logo
    }
    role
    rights
    portfolioConnections {
      targetUser {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
    }
    portfolioConnectedTo {
      sourceUser {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const ProfileDocument = gql`
    query profile {
  profile {
    id
    email
    name
    phone
    locale
    isEmailConfirmed
    isPhoneConfirmed
    createdAt
    modifiedAt
    isLoginEnabled
    isActive
    role
    rights
    gridPreferences {
      key
      active
      name
      columnsState
      filterState
      useScroll
      rowsPerPage
    }
    preferences {
      showTrailingZeros
      hidePerformanceChart
    }
    data {
      cellPhone
      bizPhone
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
    company {
      id
      legalName
      dba
      type
      logo
    }
    portfolioConnections {
      targetUser {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
    }
    portfolioConnectedTo {
      targetUser {
        id
        name
        data {
          cellPhone
          bizPhone
          firstName
          lastName
          dateOfBirth
          avatar
          description
          ssn
          address {
            line1
            city
            state
            zip
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
// @ts-ignore
export function useProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ProfileQuery, ProfileQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileQuery, ProfileQueryVariables>;
export function useProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileQuery, ProfileQueryVariables>): Apollo.UseSuspenseQueryResult<ProfileQuery | undefined, ProfileQueryVariables>;
export function useProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileSuspenseQueryHookResult = ReturnType<typeof useProfileSuspenseQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;
export const IsEmailRegisteredDocument = gql`
    query isEmailRegistered($email: String!) {
  isEmailRegistered(email: $email)
}
    `;

/**
 * __useIsEmailRegisteredQuery__
 *
 * To run a query within a React component, call `useIsEmailRegisteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEmailRegisteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEmailRegisteredQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsEmailRegisteredQuery(baseOptions: Apollo.QueryHookOptions<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables> & ({ variables: IsEmailRegisteredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>(IsEmailRegisteredDocument, options);
      }
export function useIsEmailRegisteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>(IsEmailRegisteredDocument, options);
        }
// @ts-ignore
export function useIsEmailRegisteredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>): Apollo.UseSuspenseQueryResult<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>;
export function useIsEmailRegisteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>): Apollo.UseSuspenseQueryResult<IsEmailRegisteredQuery | undefined, IsEmailRegisteredQueryVariables>;
export function useIsEmailRegisteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>(IsEmailRegisteredDocument, options);
        }
export type IsEmailRegisteredQueryHookResult = ReturnType<typeof useIsEmailRegisteredQuery>;
export type IsEmailRegisteredLazyQueryHookResult = ReturnType<typeof useIsEmailRegisteredLazyQuery>;
export type IsEmailRegisteredSuspenseQueryHookResult = ReturnType<typeof useIsEmailRegisteredSuspenseQuery>;
export type IsEmailRegisteredQueryResult = Apollo.QueryResult<IsEmailRegisteredQuery, IsEmailRegisteredQueryVariables>;
export const SaveUserDocument = gql`
    mutation saveUser($dto: UserDto!) {
  saveUser(userDto: $dto) {
    id
    email
    role
    name
    data {
      cellPhone
      bizPhone
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
    manager {
      id
      name
      email
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
    }
  }
}
    `;
export type SaveUserMutationFn = Apollo.MutationFunction<SaveUserMutation, SaveUserMutationVariables>;

/**
 * __useSaveUserMutation__
 *
 * To run a mutation, you first call `useSaveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserMutation, { data, loading, error }] = useSaveUserMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveUserMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserMutation, SaveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserMutation, SaveUserMutationVariables>(SaveUserDocument, options);
      }
export type SaveUserMutationHookResult = ReturnType<typeof useSaveUserMutation>;
export type SaveUserMutationResult = Apollo.MutationResult<SaveUserMutation>;
export type SaveUserMutationOptions = Apollo.BaseMutationOptions<SaveUserMutation, SaveUserMutationVariables>;
export const SaveAndInviteUserDocument = gql`
    mutation saveAndInviteUser($dto: UserDto!) {
  saveAndInviteUser(userDto: $dto) {
    id
    email
    role
    name
    data {
      cellPhone
      bizPhone
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
  }
}
    `;
export type SaveAndInviteUserMutationFn = Apollo.MutationFunction<SaveAndInviteUserMutation, SaveAndInviteUserMutationVariables>;

/**
 * __useSaveAndInviteUserMutation__
 *
 * To run a mutation, you first call `useSaveAndInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAndInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAndInviteUserMutation, { data, loading, error }] = useSaveAndInviteUserMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveAndInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<SaveAndInviteUserMutation, SaveAndInviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAndInviteUserMutation, SaveAndInviteUserMutationVariables>(SaveAndInviteUserDocument, options);
      }
export type SaveAndInviteUserMutationHookResult = ReturnType<typeof useSaveAndInviteUserMutation>;
export type SaveAndInviteUserMutationResult = Apollo.MutationResult<SaveAndInviteUserMutation>;
export type SaveAndInviteUserMutationOptions = Apollo.BaseMutationOptions<SaveAndInviteUserMutation, SaveAndInviteUserMutationVariables>;
export const SaveProfileDocument = gql`
    mutation saveProfile($dto: ProfileDto!) {
  saveProfile(profileDto: $dto) {
    id
    email
    name
  }
}
    `;
export type SaveProfileMutationFn = Apollo.MutationFunction<SaveProfileMutation, SaveProfileMutationVariables>;

/**
 * __useSaveProfileMutation__
 *
 * To run a mutation, you first call `useSaveProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProfileMutation, { data, loading, error }] = useSaveProfileMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveProfileMutation, SaveProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProfileMutation, SaveProfileMutationVariables>(SaveProfileDocument, options);
      }
export type SaveProfileMutationHookResult = ReturnType<typeof useSaveProfileMutation>;
export type SaveProfileMutationResult = Apollo.MutationResult<SaveProfileMutation>;
export type SaveProfileMutationOptions = Apollo.BaseMutationOptions<SaveProfileMutation, SaveProfileMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($dto: ChangePasswordDto!) {
  changePassword(changePasswordDto: $dto) {
    id
    email
    name
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ToggleUserActivationDocument = gql`
    mutation toggleUserActivation($id: ID!) {
  toggleUserActivation(id: $id) {
    id
    email
    name
  }
}
    `;
export type ToggleUserActivationMutationFn = Apollo.MutationFunction<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>;

/**
 * __useToggleUserActivationMutation__
 *
 * To run a mutation, you first call `useToggleUserActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserActivationMutation, { data, loading, error }] = useToggleUserActivationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleUserActivationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>(ToggleUserActivationDocument, options);
      }
export type ToggleUserActivationMutationHookResult = ReturnType<typeof useToggleUserActivationMutation>;
export type ToggleUserActivationMutationResult = Apollo.MutationResult<ToggleUserActivationMutation>;
export type ToggleUserActivationMutationOptions = Apollo.BaseMutationOptions<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>;
export const SavePreferencesDocument = gql`
    mutation savePreferences($dto: UserPreferencesDto!) {
  savePreferences(userPreferencesDto: $dto) {
    gridPreferences {
      key
      active
      name
      columnsState
      filterState
      useScroll
      rowsPerPage
    }
    preferences {
      showTrailingZeros
      hidePerformanceChart
    }
  }
}
    `;
export type SavePreferencesMutationFn = Apollo.MutationFunction<SavePreferencesMutation, SavePreferencesMutationVariables>;

/**
 * __useSavePreferencesMutation__
 *
 * To run a mutation, you first call `useSavePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePreferencesMutation, { data, loading, error }] = useSavePreferencesMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSavePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<SavePreferencesMutation, SavePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePreferencesMutation, SavePreferencesMutationVariables>(SavePreferencesDocument, options);
      }
export type SavePreferencesMutationHookResult = ReturnType<typeof useSavePreferencesMutation>;
export type SavePreferencesMutationResult = Apollo.MutationResult<SavePreferencesMutation>;
export type SavePreferencesMutationOptions = Apollo.BaseMutationOptions<SavePreferencesMutation, SavePreferencesMutationVariables>;
export const ResendInvitationDocument = gql`
    mutation resendInvitation($id: ID!) {
  resendInvitation(id: $id) {
    id
  }
}
    `;
export type ResendInvitationMutationFn = Apollo.MutationFunction<ResendInvitationMutation, ResendInvitationMutationVariables>;

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendInvitationMutation(baseOptions?: Apollo.MutationHookOptions<ResendInvitationMutation, ResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendInvitationMutation, ResendInvitationMutationVariables>(ResendInvitationDocument, options);
      }
export type ResendInvitationMutationHookResult = ReturnType<typeof useResendInvitationMutation>;
export type ResendInvitationMutationResult = Apollo.MutationResult<ResendInvitationMutation>;
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<ResendInvitationMutation, ResendInvitationMutationVariables>;
export const SendCognitoSetupDocument = gql`
    mutation sendCognitoSetup($id: ID!) {
  sendCognitoSetup(id: $id) {
    id
  }
}
    `;
export type SendCognitoSetupMutationFn = Apollo.MutationFunction<SendCognitoSetupMutation, SendCognitoSetupMutationVariables>;

/**
 * __useSendCognitoSetupMutation__
 *
 * To run a mutation, you first call `useSendCognitoSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCognitoSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCognitoSetupMutation, { data, loading, error }] = useSendCognitoSetupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendCognitoSetupMutation(baseOptions?: Apollo.MutationHookOptions<SendCognitoSetupMutation, SendCognitoSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCognitoSetupMutation, SendCognitoSetupMutationVariables>(SendCognitoSetupDocument, options);
      }
export type SendCognitoSetupMutationHookResult = ReturnType<typeof useSendCognitoSetupMutation>;
export type SendCognitoSetupMutationResult = Apollo.MutationResult<SendCognitoSetupMutation>;
export type SendCognitoSetupMutationOptions = Apollo.BaseMutationOptions<SendCognitoSetupMutation, SendCognitoSetupMutationVariables>;
export const UpdateUserMfaSettingsDocument = gql`
    mutation updateUserMfaSettings($dto: MfaSettingsDto!) {
  updateUserMfaSettings(mfaSettingsDto: $dto) {
    id
    mfaEnabled
    mfaConfigured
    accessTokenTtlHours
    mfaDeviceRememberingEnabled
    deviceRememberingDays
  }
}
    `;
export type UpdateUserMfaSettingsMutationFn = Apollo.MutationFunction<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>;

/**
 * __useUpdateUserMfaSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserMfaSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMfaSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMfaSettingsMutation, { data, loading, error }] = useUpdateUserMfaSettingsMutation({
 *   variables: {
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useUpdateUserMfaSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>(UpdateUserMfaSettingsDocument, options);
      }
export type UpdateUserMfaSettingsMutationHookResult = ReturnType<typeof useUpdateUserMfaSettingsMutation>;
export type UpdateUserMfaSettingsMutationResult = Apollo.MutationResult<UpdateUserMfaSettingsMutation>;
export type UpdateUserMfaSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserMfaSettingsMutation, UpdateUserMfaSettingsMutationVariables>;
export const GetUsersWithAccessiblePortfolioDocument = gql`
    query getUsersWithAccessiblePortfolio($userId: ID!) {
  getUsersWithAccessiblePortfolio(userId: $userId) {
    id
    name
    data {
      cellPhone
      bizPhone
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
  }
}
    `;

/**
 * __useGetUsersWithAccessiblePortfolioQuery__
 *
 * To run a query within a React component, call `useGetUsersWithAccessiblePortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWithAccessiblePortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWithAccessiblePortfolioQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUsersWithAccessiblePortfolioQuery(baseOptions: Apollo.QueryHookOptions<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables> & ({ variables: GetUsersWithAccessiblePortfolioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>(GetUsersWithAccessiblePortfolioDocument, options);
      }
export function useGetUsersWithAccessiblePortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>(GetUsersWithAccessiblePortfolioDocument, options);
        }
// @ts-ignore
export function useGetUsersWithAccessiblePortfolioSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>;
export function useGetUsersWithAccessiblePortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersWithAccessiblePortfolioQuery | undefined, GetUsersWithAccessiblePortfolioQueryVariables>;
export function useGetUsersWithAccessiblePortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>(GetUsersWithAccessiblePortfolioDocument, options);
        }
export type GetUsersWithAccessiblePortfolioQueryHookResult = ReturnType<typeof useGetUsersWithAccessiblePortfolioQuery>;
export type GetUsersWithAccessiblePortfolioLazyQueryHookResult = ReturnType<typeof useGetUsersWithAccessiblePortfolioLazyQuery>;
export type GetUsersWithAccessiblePortfolioSuspenseQueryHookResult = ReturnType<typeof useGetUsersWithAccessiblePortfolioSuspenseQuery>;
export type GetUsersWithAccessiblePortfolioQueryResult = Apollo.QueryResult<GetUsersWithAccessiblePortfolioQuery, GetUsersWithAccessiblePortfolioQueryVariables>;
export const AccessiblePortfoliosDocument = gql`
    query accessiblePortfolios {
  accessiblePortfolios {
    id
    name
    rights
    data {
      cellPhone
      bizPhone
      firstName
      lastName
      dateOfBirth
      avatar
      description
      ssn
      address {
        line1
        city
        state
        zip
      }
    }
  }
}
    `;

/**
 * __useAccessiblePortfoliosQuery__
 *
 * To run a query within a React component, call `useAccessiblePortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessiblePortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessiblePortfoliosQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessiblePortfoliosQuery(baseOptions?: Apollo.QueryHookOptions<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>(AccessiblePortfoliosDocument, options);
      }
export function useAccessiblePortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>(AccessiblePortfoliosDocument, options);
        }
// @ts-ignore
export function useAccessiblePortfoliosSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>): Apollo.UseSuspenseQueryResult<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>;
export function useAccessiblePortfoliosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>): Apollo.UseSuspenseQueryResult<AccessiblePortfoliosQuery | undefined, AccessiblePortfoliosQueryVariables>;
export function useAccessiblePortfoliosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>(AccessiblePortfoliosDocument, options);
        }
export type AccessiblePortfoliosQueryHookResult = ReturnType<typeof useAccessiblePortfoliosQuery>;
export type AccessiblePortfoliosLazyQueryHookResult = ReturnType<typeof useAccessiblePortfoliosLazyQuery>;
export type AccessiblePortfoliosSuspenseQueryHookResult = ReturnType<typeof useAccessiblePortfoliosSuspenseQuery>;
export type AccessiblePortfoliosQueryResult = Apollo.QueryResult<AccessiblePortfoliosQuery, AccessiblePortfoliosQueryVariables>;
export const AssignAccessToPortfolioDocument = gql`
    mutation assignAccessToPortfolio($sourceUserId: ID!, $targetUserId: ID!) {
  assignAccessToPortfolio(
    sourceUserId: $sourceUserId
    targetUserId: $targetUserId
  ) {
    sourceUser {
      id
      name
      email
    }
    targetUser {
      id
      name
      email
    }
  }
}
    `;
export type AssignAccessToPortfolioMutationFn = Apollo.MutationFunction<AssignAccessToPortfolioMutation, AssignAccessToPortfolioMutationVariables>;

/**
 * __useAssignAccessToPortfolioMutation__
 *
 * To run a mutation, you first call `useAssignAccessToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAccessToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAccessToPortfolioMutation, { data, loading, error }] = useAssignAccessToPortfolioMutation({
 *   variables: {
 *      sourceUserId: // value for 'sourceUserId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useAssignAccessToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<AssignAccessToPortfolioMutation, AssignAccessToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAccessToPortfolioMutation, AssignAccessToPortfolioMutationVariables>(AssignAccessToPortfolioDocument, options);
      }
export type AssignAccessToPortfolioMutationHookResult = ReturnType<typeof useAssignAccessToPortfolioMutation>;
export type AssignAccessToPortfolioMutationResult = Apollo.MutationResult<AssignAccessToPortfolioMutation>;
export type AssignAccessToPortfolioMutationOptions = Apollo.BaseMutationOptions<AssignAccessToPortfolioMutation, AssignAccessToPortfolioMutationVariables>;
export const RemoveAccessToPortfolioDocument = gql`
    mutation removeAccessToPortfolio($sourceUserId: ID!, $targetUserId: ID!) {
  removeAccessToPortfolio(
    sourceUserId: $sourceUserId
    targetUserId: $targetUserId
  )
}
    `;
export type RemoveAccessToPortfolioMutationFn = Apollo.MutationFunction<RemoveAccessToPortfolioMutation, RemoveAccessToPortfolioMutationVariables>;

/**
 * __useRemoveAccessToPortfolioMutation__
 *
 * To run a mutation, you first call `useRemoveAccessToPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccessToPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccessToPortfolioMutation, { data, loading, error }] = useRemoveAccessToPortfolioMutation({
 *   variables: {
 *      sourceUserId: // value for 'sourceUserId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useRemoveAccessToPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccessToPortfolioMutation, RemoveAccessToPortfolioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccessToPortfolioMutation, RemoveAccessToPortfolioMutationVariables>(RemoveAccessToPortfolioDocument, options);
      }
export type RemoveAccessToPortfolioMutationHookResult = ReturnType<typeof useRemoveAccessToPortfolioMutation>;
export type RemoveAccessToPortfolioMutationResult = Apollo.MutationResult<RemoveAccessToPortfolioMutation>;
export type RemoveAccessToPortfolioMutationOptions = Apollo.BaseMutationOptions<RemoveAccessToPortfolioMutation, RemoveAccessToPortfolioMutationVariables>;
export const InvestorsDocument = gql`
    query investors($offset: Int = 0, $limit: Int = 10, $search: String, $right: Rights, $isActive: Boolean, $isLoginEnabled: Boolean, $rights: [Rights!], $sortArgs: [SortArgs!] = []) {
  investors(
    offset: $offset
    limit: $limit
    search: $search
    right: $right
    isActive: $isActive
    isLoginEnabled: $isLoginEnabled
    rights: $rights
    sortArgs: $sortArgs
  ) {
    data {
      id
      email
      name
      phone
      locale
      isEmailConfirmed
      isPhoneConfirmed
      createdAt
      modifiedAt
      isLoginEnabled
      isActive
      data {
        cellPhone
        bizPhone
        firstName
        lastName
        dateOfBirth
        avatar
        description
        ssn
        address {
          line1
          city
          state
          zip
        }
      }
      company {
        id
        legalName
        logo
      }
      role
      rights
      balance
      pnl
      fundingWallet
      remittance
      remittanceFee
      firstTransactionDate
    }
    total
    offset
    limit
  }
}
    `;

/**
 * __useInvestorsQuery__
 *
 * To run a query within a React component, call `useInvestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *      right: // value for 'right'
 *      isActive: // value for 'isActive'
 *      isLoginEnabled: // value for 'isLoginEnabled'
 *      rights: // value for 'rights'
 *      sortArgs: // value for 'sortArgs'
 *   },
 * });
 */
export function useInvestorsQuery(baseOptions?: Apollo.QueryHookOptions<InvestorsQuery, InvestorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorsQuery, InvestorsQueryVariables>(InvestorsDocument, options);
      }
export function useInvestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorsQuery, InvestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorsQuery, InvestorsQueryVariables>(InvestorsDocument, options);
        }
// @ts-ignore
export function useInvestorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InvestorsQuery, InvestorsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorsQuery, InvestorsQueryVariables>;
export function useInvestorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorsQuery, InvestorsQueryVariables>): Apollo.UseSuspenseQueryResult<InvestorsQuery | undefined, InvestorsQueryVariables>;
export function useInvestorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorsQuery, InvestorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorsQuery, InvestorsQueryVariables>(InvestorsDocument, options);
        }
export type InvestorsQueryHookResult = ReturnType<typeof useInvestorsQuery>;
export type InvestorsLazyQueryHookResult = ReturnType<typeof useInvestorsLazyQuery>;
export type InvestorsSuspenseQueryHookResult = ReturnType<typeof useInvestorsSuspenseQuery>;
export type InvestorsQueryResult = Apollo.QueryResult<InvestorsQuery, InvestorsQueryVariables>;
export const UserBankAccountsDocument = gql`
    query userBankAccounts($userId: ID!) {
  userBankAccounts(userId: $userId) {
    id
    routingNumber
    accountNumber
    name
  }
}
    `;

/**
 * __useUserBankAccountsQuery__
 *
 * To run a query within a React component, call `useUserBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserBankAccountsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<UserBankAccountsQuery, UserBankAccountsQueryVariables> & ({ variables: UserBankAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserBankAccountsQuery, UserBankAccountsQueryVariables>(UserBankAccountsDocument, options);
      }
export function useUserBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserBankAccountsQuery, UserBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserBankAccountsQuery, UserBankAccountsQueryVariables>(UserBankAccountsDocument, options);
        }
// @ts-ignore
export function useUserBankAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserBankAccountsQuery, UserBankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<UserBankAccountsQuery, UserBankAccountsQueryVariables>;
export function useUserBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserBankAccountsQuery, UserBankAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<UserBankAccountsQuery | undefined, UserBankAccountsQueryVariables>;
export function useUserBankAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserBankAccountsQuery, UserBankAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserBankAccountsQuery, UserBankAccountsQueryVariables>(UserBankAccountsDocument, options);
        }
export type UserBankAccountsQueryHookResult = ReturnType<typeof useUserBankAccountsQuery>;
export type UserBankAccountsLazyQueryHookResult = ReturnType<typeof useUserBankAccountsLazyQuery>;
export type UserBankAccountsSuspenseQueryHookResult = ReturnType<typeof useUserBankAccountsSuspenseQuery>;
export type UserBankAccountsQueryResult = Apollo.QueryResult<UserBankAccountsQuery, UserBankAccountsQueryVariables>;
export const SaveUserBankAccountDocument = gql`
    mutation saveUserBankAccount($userId: ID!, $dto: MerchantBankAccountDto!) {
  saveUserBankAccount(userId: $userId, bankAccount: $dto) {
    id
    routingNumber
    accountNumber
    name
  }
}
    `;
export type SaveUserBankAccountMutationFn = Apollo.MutationFunction<SaveUserBankAccountMutation, SaveUserBankAccountMutationVariables>;

/**
 * __useSaveUserBankAccountMutation__
 *
 * To run a mutation, you first call `useSaveUserBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserBankAccountMutation, { data, loading, error }] = useSaveUserBankAccountMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      dto: // value for 'dto'
 *   },
 * });
 */
export function useSaveUserBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserBankAccountMutation, SaveUserBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserBankAccountMutation, SaveUserBankAccountMutationVariables>(SaveUserBankAccountDocument, options);
      }
export type SaveUserBankAccountMutationHookResult = ReturnType<typeof useSaveUserBankAccountMutation>;
export type SaveUserBankAccountMutationResult = Apollo.MutationResult<SaveUserBankAccountMutation>;
export type SaveUserBankAccountMutationOptions = Apollo.BaseMutationOptions<SaveUserBankAccountMutation, SaveUserBankAccountMutationVariables>;
export const DeleteUserBankAccountDocument = gql`
    mutation deleteUserBankAccount($id: ID!) {
  deleteUserBankAccount(id: $id)
}
    `;
export type DeleteUserBankAccountMutationFn = Apollo.MutationFunction<DeleteUserBankAccountMutation, DeleteUserBankAccountMutationVariables>;

/**
 * __useDeleteUserBankAccountMutation__
 *
 * To run a mutation, you first call `useDeleteUserBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserBankAccountMutation, { data, loading, error }] = useDeleteUserBankAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserBankAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserBankAccountMutation, DeleteUserBankAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserBankAccountMutation, DeleteUserBankAccountMutationVariables>(DeleteUserBankAccountDocument, options);
      }
export type DeleteUserBankAccountMutationHookResult = ReturnType<typeof useDeleteUserBankAccountMutation>;
export type DeleteUserBankAccountMutationResult = Apollo.MutationResult<DeleteUserBankAccountMutation>;
export type DeleteUserBankAccountMutationOptions = Apollo.BaseMutationOptions<DeleteUserBankAccountMutation, DeleteUserBankAccountMutationVariables>;